module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "dd63");
/******/ })
/************************************************************************/
/******/ ({

/***/ "004f":
/***/ (function(module, exports, __webpack_require__) {

var isConstructor = __webpack_require__("c42f");
var tryToString = __webpack_require__("4912");

var $TypeError = TypeError;

// `Assert: IsConstructor(argument) is true`
module.exports = function (argument) {
  if (isConstructor(argument)) return argument;
  throw $TypeError(tryToString(argument) + ' is not a constructor');
};


/***/ }),

/***/ "0244":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("6b1d");
var call = __webpack_require__("b546");
var newPromiseCapabilityModule = __webpack_require__("881c");
var FORCED_PROMISE_CONSTRUCTOR = __webpack_require__("f297").CONSTRUCTOR;

// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR }, {
  reject: function reject(r) {
    var capability = newPromiseCapabilityModule.f(this);
    call(capability.reject, undefined, r);
    return capability.promise;
  }
});


/***/ }),

/***/ "0446":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("da06");
var getMethod = __webpack_require__("60de");
var Iterators = __webpack_require__("5bb7");
var wellKnownSymbol = __webpack_require__("7d53");

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (it != undefined) return getMethod(it, ITERATOR)
    || getMethod(it, '@@iterator')
    || Iterators[classof(it)];
};


/***/ }),

/***/ "0481":
/***/ (function(module, exports, __webpack_require__) {

var toLength = __webpack_require__("b495");

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function (obj) {
  return toLength(obj.length);
};


/***/ }),

/***/ "052a":
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),

/***/ "0652":
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__("ae68"),
    baseKeys = __webpack_require__("e2e2"),
    isArrayLike = __webpack_require__("f72d");

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ "06a5":
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__("1ec9"),
    equalArrays = __webpack_require__("659f"),
    equalByTag = __webpack_require__("4778"),
    equalObjects = __webpack_require__("c991"),
    getTag = __webpack_require__("9243"),
    isArray = __webpack_require__("c316"),
    isBuffer = __webpack_require__("dda8"),
    isTypedArray = __webpack_require__("41dd");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),

/***/ "083f":
/***/ (function(module, exports, __webpack_require__) {

var call = __webpack_require__("b546");
var isObject = __webpack_require__("7526");
var isSymbol = __webpack_require__("cfd1");
var getMethod = __webpack_require__("60de");
var ordinaryToPrimitive = __webpack_require__("eba0");
var wellKnownSymbol = __webpack_require__("7d53");

var $TypeError = TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call(exoticToPrim, input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw $TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};


/***/ }),

/***/ "09b2":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ "0a1e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__("5428");
var definePropertyModule = __webpack_require__("abdf");
var wellKnownSymbol = __webpack_require__("7d53");
var DESCRIPTORS = __webpack_require__("d4cb");

var SPECIES = wellKnownSymbol('species');

module.exports = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
  var defineProperty = definePropertyModule.f;

  if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
    defineProperty(Constructor, SPECIES, {
      configurable: true,
      get: function () { return this; }
    });
  }
};


/***/ }),

/***/ "0a87":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("e902");

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ "0c47":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("c91c");
var enumBugKeys = __webpack_require__("b17e");

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es-x/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),

/***/ "0d9f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var PROPER_FUNCTION_NAME = __webpack_require__("d331").PROPER;
var defineBuiltIn = __webpack_require__("ef30");
var anObject = __webpack_require__("157c");
var $toString = __webpack_require__("2a3e");
var fails = __webpack_require__("72df");
var getRegExpFlags = __webpack_require__("1b03");

var TO_STRING = 'toString';
var RegExpPrototype = RegExp.prototype;
var n$ToString = RegExpPrototype[TO_STRING];

var NOT_GENERIC = fails(function () { return n$ToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = PROPER_FUNCTION_NAME && n$ToString.name != TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  defineBuiltIn(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject(this);
    var pattern = $toString(R.source);
    var flags = $toString(getRegExpFlags(R));
    return '/' + pattern + '/' + flags;
  }, { unsafe: true });
}


/***/ }),

/***/ "0dc7":
/***/ (function(module, exports) {

var $TypeError = TypeError;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

module.exports = function (it) {
  if (it > MAX_SAFE_INTEGER) throw $TypeError('Maximum allowed index exceeded');
  return it;
};


/***/ }),

/***/ "0e19":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("4b2c"),
    getRawTag = __webpack_require__("2822"),
    objectToString = __webpack_require__("907a");

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ "0e30":
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ "0e39":
/***/ (function(module, exports, __webpack_require__) {

var hasOwn = __webpack_require__("7a25");
var isCallable = __webpack_require__("3ce8");
var toObject = __webpack_require__("37d1");
var sharedKey = __webpack_require__("332c");
var CORRECT_PROTOTYPE_GETTER = __webpack_require__("802e");

var IE_PROTO = sharedKey('IE_PROTO');
var $Object = Object;
var ObjectPrototype = $Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es-x/no-object-getprototypeof -- safe
module.exports = CORRECT_PROTOTYPE_GETTER ? $Object.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (hasOwn(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object ? ObjectPrototype : null;
};


/***/ }),

/***/ "0e93":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "11ed":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("6b1d");
var toObject = __webpack_require__("37d1");
var toAbsoluteIndex = __webpack_require__("9a0f");
var toIntegerOrInfinity = __webpack_require__("9616");
var lengthOfArrayLike = __webpack_require__("0481");
var doesNotExceedSafeInteger = __webpack_require__("0dc7");
var arraySpeciesCreate = __webpack_require__("6a86");
var createProperty = __webpack_require__("dac6");
var deletePropertyOrThrow = __webpack_require__("653f");
var arrayMethodHasSpeciesSupport = __webpack_require__("189b");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('splice');

var max = Math.max;
var min = Math.min;

// `Array.prototype.splice` method
// https://tc39.es/ecma262/#sec-array.prototype.splice
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  splice: function splice(start, deleteCount /* , ...items */) {
    var O = toObject(this);
    var len = lengthOfArrayLike(O);
    var actualStart = toAbsoluteIndex(start, len);
    var argumentsLength = arguments.length;
    var insertCount, actualDeleteCount, A, k, from, to;
    if (argumentsLength === 0) {
      insertCount = actualDeleteCount = 0;
    } else if (argumentsLength === 1) {
      insertCount = 0;
      actualDeleteCount = len - actualStart;
    } else {
      insertCount = argumentsLength - 2;
      actualDeleteCount = min(max(toIntegerOrInfinity(deleteCount), 0), len - actualStart);
    }
    doesNotExceedSafeInteger(len + insertCount - actualDeleteCount);
    A = arraySpeciesCreate(O, actualDeleteCount);
    for (k = 0; k < actualDeleteCount; k++) {
      from = actualStart + k;
      if (from in O) createProperty(A, k, O[from]);
    }
    A.length = actualDeleteCount;
    if (insertCount < actualDeleteCount) {
      for (k = actualStart; k < len - actualDeleteCount; k++) {
        from = k + actualDeleteCount;
        to = k + insertCount;
        if (from in O) O[to] = O[from];
        else deletePropertyOrThrow(O, to);
      }
      for (k = len; k > len - actualDeleteCount + insertCount; k--) deletePropertyOrThrow(O, k - 1);
    } else if (insertCount > actualDeleteCount) {
      for (k = len - actualDeleteCount; k > actualStart; k--) {
        from = k + actualDeleteCount - 1;
        to = k + insertCount - 1;
        if (from in O) O[to] = O[from];
        else deletePropertyOrThrow(O, to);
      }
    }
    for (k = 0; k < insertCount; k++) {
      O[k + actualStart] = arguments[k + 2];
    }
    O.length = len - actualDeleteCount + insertCount;
    return A;
  }
});


/***/ }),

/***/ "130d":
/***/ (function(module, exports) {

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),

/***/ "1386":
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),

/***/ "1543":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("72df");
var global = __webpack_require__("f498");

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = global.RegExp;

module.exports = fails(function () {
  var re = $RegExp('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});


/***/ }),

/***/ "157c":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("7526");

var $String = String;
var $TypeError = TypeError;

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw $TypeError($String(argument) + ' is not an object');
};


/***/ }),

/***/ "1702":
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__("abdf").f;

module.exports = function (Target, Source, key) {
  key in Target || defineProperty(Target, key, {
    configurable: true,
    get: function () { return Source[key]; },
    set: function (it) { Source[key] = it; }
  });
};


/***/ }),

/***/ "174d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("d4cb");
var uncurryThis = __webpack_require__("70b7");
var call = __webpack_require__("b546");
var fails = __webpack_require__("72df");
var objectKeys = __webpack_require__("0c47");
var getOwnPropertySymbolsModule = __webpack_require__("2402");
var propertyIsEnumerableModule = __webpack_require__("e129");
var toObject = __webpack_require__("37d1");
var IndexedObject = __webpack_require__("83a6");

// eslint-disable-next-line es-x/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
var defineProperty = Object.defineProperty;
var concat = uncurryThis([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
module.exports = !$assign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS && $assign({ b: 1 }, $assign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es-x/no-symbol -- safe
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] != 7 || objectKeys($assign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || call(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),

/***/ "185a":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("d4cb");
var call = __webpack_require__("b546");
var propertyIsEnumerableModule = __webpack_require__("e129");
var createPropertyDescriptor = __webpack_require__("9618");
var toIndexedObject = __webpack_require__("378c");
var toPropertyKey = __webpack_require__("feca");
var hasOwn = __webpack_require__("7a25");
var IE8_DOM_DEFINE = __webpack_require__("7c3f");

// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};


/***/ }),

/***/ "189b":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("72df");
var wellKnownSymbol = __webpack_require__("7d53");
var V8_VERSION = __webpack_require__("4fed");

var SPECIES = wellKnownSymbol('species');

module.exports = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};


/***/ }),

/***/ "1b03":
/***/ (function(module, exports, __webpack_require__) {

var call = __webpack_require__("b546");
var hasOwn = __webpack_require__("7a25");
var isPrototypeOf = __webpack_require__("fb9b");
var regExpFlags = __webpack_require__("abfd");

var RegExpPrototype = RegExp.prototype;

module.exports = function (R) {
  var flags = R.flags;
  return flags === undefined && !('flags' in RegExpPrototype) && !hasOwn(R, 'flags') && isPrototypeOf(RegExpPrototype, R)
    ? call(regExpFlags, R) : flags;
};


/***/ }),

/***/ "1d2e":
/***/ (function(module, exports, __webpack_require__) {

var userAgent = __webpack_require__("64e4");

module.exports = /web0s(?!.*chrome)/i.test(userAgent);


/***/ }),

/***/ "1d8a":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("70b7");

var id = 0;
var postfix = Math.random();
var toString = uncurryThis(1.0.toString);

module.exports = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};


/***/ }),

/***/ "1ec9":
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__("fa8a"),
    stackClear = __webpack_require__("44d9"),
    stackDelete = __webpack_require__("1386"),
    stackGet = __webpack_require__("052a"),
    stackHas = __webpack_require__("2fab"),
    stackSet = __webpack_require__("e3f8");

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),

/***/ "1f5e":
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__("378c");
var toAbsoluteIndex = __webpack_require__("9a0f");
var lengthOfArrayLike = __webpack_require__("0481");

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ "2007":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("6b1d");
var assign = __webpack_require__("174d");

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es-x/no-object-assign -- required for testing
$({ target: 'Object', stat: true, arity: 2, forced: Object.assign !== assign }, {
  assign: assign
});


/***/ }),

/***/ "2017":
/***/ (function(module, exports, __webpack_require__) {

var userAgent = __webpack_require__("64e4");

var webkit = userAgent.match(/AppleWebKit\/(\d+)\./);

module.exports = !!webkit && +webkit[1];


/***/ }),

/***/ "201b":
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__("7bdd");

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ "2117":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("70b7");
var aCallable = __webpack_require__("63d3");
var NATIVE_BIND = __webpack_require__("43f8");

var bind = uncurryThis(uncurryThis.bind);

// optional / simple context binding
module.exports = function (fn, that) {
  aCallable(fn);
  return that === undefined ? fn : NATIVE_BIND ? bind(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "212d":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("bf10"),
    root = __webpack_require__("201b");

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),

/***/ "2402":
/***/ (function(module, exports) {

// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "2419":
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__("872c"),
    setCacheAdd = __webpack_require__("aa31"),
    setCacheHas = __webpack_require__("7049");

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),

/***/ "2435":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("f498");
var apply = __webpack_require__("d54f");
var bind = __webpack_require__("2117");
var isCallable = __webpack_require__("3ce8");
var hasOwn = __webpack_require__("7a25");
var fails = __webpack_require__("72df");
var html = __webpack_require__("9324");
var arraySlice = __webpack_require__("de02");
var createElement = __webpack_require__("f2bf");
var validateArgumentsLength = __webpack_require__("ae5d");
var IS_IOS = __webpack_require__("e03e");
var IS_NODE = __webpack_require__("f117");

var set = global.setImmediate;
var clear = global.clearImmediate;
var process = global.process;
var Dispatch = global.Dispatch;
var Function = global.Function;
var MessageChannel = global.MessageChannel;
var String = global.String;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var location, defer, channel, port;

try {
  // Deno throws a ReferenceError on `location` access without `--location` flag
  location = global.location;
} catch (error) { /* empty */ }

var run = function (id) {
  if (hasOwn(queue, id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var listener = function (event) {
  run(event.data);
};

var post = function (id) {
  // old engines have not location.origin
  global.postMessage(String(id), location.protocol + '//' + location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(handler) {
    validateArgumentsLength(arguments.length, 1);
    var fn = isCallable(handler) ? handler : Function(handler);
    var args = arraySlice(arguments, 1);
    queue[++counter] = function () {
      apply(fn, undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (IS_NODE) {
    defer = function (id) {
      process.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = bind(port.postMessage, port);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global.addEventListener &&
    isCallable(global.postMessage) &&
    !global.importScripts &&
    location && location.protocol !== 'file:' &&
    !fails(post)
  ) {
    defer = post;
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

module.exports = {
  set: set,
  clear: clear
};


/***/ }),

/***/ "24da":
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__("e942");

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),

/***/ "2514":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("157c");
var iteratorClose = __webpack_require__("aaba");

// call something on iterator step with safe closing on error
module.exports = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  } catch (error) {
    iteratorClose(iterator, 'throw', error);
  }
};


/***/ }),

/***/ "26d3":
/***/ (function(module, exports, __webpack_require__) {

// TODO: Remove this module from `core-js@4` since it's split to modules listed below
__webpack_require__("4172");
__webpack_require__("8071");
__webpack_require__("52e2");
__webpack_require__("36b3");
__webpack_require__("0244");
__webpack_require__("27c8");


/***/ }),

/***/ "27c8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("6b1d");
var getBuiltIn = __webpack_require__("5428");
var IS_PURE = __webpack_require__("0e93");
var NativePromiseConstructor = __webpack_require__("367f");
var FORCED_PROMISE_CONSTRUCTOR = __webpack_require__("f297").CONSTRUCTOR;
var promiseResolve = __webpack_require__("9c36");

var PromiseConstructorWrapper = getBuiltIn('Promise');
var CHECK_WRAPPER = IS_PURE && !FORCED_PROMISE_CONSTRUCTOR;

// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$({ target: 'Promise', stat: true, forced: IS_PURE || FORCED_PROMISE_CONSTRUCTOR }, {
  resolve: function resolve(x) {
    return promiseResolve(CHECK_WRAPPER && this === PromiseConstructorWrapper ? NativePromiseConstructor : this, x);
  }
});


/***/ }),

/***/ "2822":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("4b2c");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ "28eb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("6b1d");
var $reduce = __webpack_require__("98f3").left;
var arrayMethodIsStrict = __webpack_require__("7f8a");
var CHROME_VERSION = __webpack_require__("4fed");
var IS_NODE = __webpack_require__("f117");

var STRICT_METHOD = arrayMethodIsStrict('reduce');
// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var CHROME_BUG = !IS_NODE && CHROME_VERSION > 79 && CHROME_VERSION < 83;

// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$({ target: 'Array', proto: true, forced: !STRICT_METHOD || CHROME_BUG }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    var length = arguments.length;
    return $reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "2a3e":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("da06");

var $String = String;

module.exports = function (argument) {
  if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return $String(argument);
};


/***/ }),

/***/ "2aa5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("6b1d");
var exec = __webpack_require__("42c5");

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});


/***/ }),

/***/ "2c3d":
/***/ (function(module, exports, __webpack_require__) {

var arraySlice = __webpack_require__("d1b2");

var floor = Math.floor;

var mergeSort = function (array, comparefn) {
  var length = array.length;
  var middle = floor(length / 2);
  return length < 8 ? insertionSort(array, comparefn) : merge(
    array,
    mergeSort(arraySlice(array, 0, middle), comparefn),
    mergeSort(arraySlice(array, middle), comparefn),
    comparefn
  );
};

var insertionSort = function (array, comparefn) {
  var length = array.length;
  var i = 1;
  var element, j;

  while (i < length) {
    j = i;
    element = array[i];
    while (j && comparefn(array[j - 1], element) > 0) {
      array[j] = array[--j];
    }
    if (j !== i++) array[j] = element;
  } return array;
};

var merge = function (array, left, right, comparefn) {
  var llength = left.length;
  var rlength = right.length;
  var lindex = 0;
  var rindex = 0;

  while (lindex < llength || rindex < rlength) {
    array[lindex + rindex] = (lindex < llength && rindex < rlength)
      ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++]
      : lindex < llength ? left[lindex++] : right[rindex++];
  } return array;
};

module.exports = mergeSort;


/***/ }),

/***/ "2ce5":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("72df");
var isCallable = __webpack_require__("3ce8");
var hasOwn = __webpack_require__("7a25");
var DESCRIPTORS = __webpack_require__("d4cb");
var CONFIGURABLE_FUNCTION_NAME = __webpack_require__("d331").CONFIGURABLE;
var inspectSource = __webpack_require__("df6f");
var InternalStateModule = __webpack_require__("cdcd");

var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

var CONFIGURABLE_LENGTH = DESCRIPTORS && !fails(function () {
  return defineProperty(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn = module.exports = function (value, name, options) {
  if (String(name).slice(0, 7) === 'Symbol(') {
    name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
    if (DESCRIPTORS) defineProperty(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn(options, 'arity') && value.length !== options.arity) {
    defineProperty(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS) defineProperty(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn(state, 'source')) {
    state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn(function toString() {
  return isCallable(this) && getInternalState(this).source || inspectSource(this);
}, 'toString');


/***/ }),

/***/ "2d4c":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("6b1d");
var setPrototypeOf = __webpack_require__("c1a2");

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
$({ target: 'Object', stat: true }, {
  setPrototypeOf: setPrototypeOf
});


/***/ }),

/***/ "2d6d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("6b1d");
var $filter = __webpack_require__("d054").filter;
var arrayMethodHasSpeciesSupport = __webpack_require__("189b");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');

// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "2df4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("6b1d");
var call = __webpack_require__("b546");
var IS_PURE = __webpack_require__("0e93");
var FunctionName = __webpack_require__("d331");
var isCallable = __webpack_require__("3ce8");
var createIteratorConstructor = __webpack_require__("2e3f");
var getPrototypeOf = __webpack_require__("0e39");
var setPrototypeOf = __webpack_require__("c1a2");
var setToStringTag = __webpack_require__("fa46");
var createNonEnumerableProperty = __webpack_require__("5b12");
var defineBuiltIn = __webpack_require__("ef30");
var wellKnownSymbol = __webpack_require__("7d53");
var Iterators = __webpack_require__("5bb7");
var IteratorsCore = __webpack_require__("ff89");

var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable(CurrentIteratorPrototype[ITERATOR])) {
          defineBuiltIn(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (!IS_PURE && CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    defineBuiltIn(IterablePrototype, ITERATOR, defaultIterator, { name: DEFAULT });
  }
  Iterators[NAME] = defaultIterator;

  return methods;
};


/***/ }),

/***/ "2e3f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IteratorPrototype = __webpack_require__("ff89").IteratorPrototype;
var create = __webpack_require__("82e8");
var createPropertyDescriptor = __webpack_require__("9618");
var setToStringTag = __webpack_require__("fa46");
var Iterators = __webpack_require__("5bb7");

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),

/***/ "2f33":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("e902");

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ "2f6a":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("72df");
var global = __webpack_require__("f498");

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp = global.RegExp;

var UNSUPPORTED_Y = fails(function () {
  var re = $RegExp('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var MISSED_STICKY = UNSUPPORTED_Y || fails(function () {
  return !$RegExp('a', 'y').sticky;
});

var BROKEN_CARET = UNSUPPORTED_Y || fails(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});

module.exports = {
  BROKEN_CARET: BROKEN_CARET,
  MISSED_STICKY: MISSED_STICKY,
  UNSUPPORTED_Y: UNSUPPORTED_Y
};


/***/ }),

/***/ "2fab":
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),

/***/ "3211":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("7d53");

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line es-x/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};


/***/ }),

/***/ "32f5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var apply = __webpack_require__("d54f");
var call = __webpack_require__("b546");
var uncurryThis = __webpack_require__("70b7");
var fixRegExpWellKnownSymbolLogic = __webpack_require__("95b2");
var fails = __webpack_require__("72df");
var anObject = __webpack_require__("157c");
var isCallable = __webpack_require__("3ce8");
var toIntegerOrInfinity = __webpack_require__("9616");
var toLength = __webpack_require__("b495");
var toString = __webpack_require__("2a3e");
var requireObjectCoercible = __webpack_require__("730c");
var advanceStringIndex = __webpack_require__("e3f6");
var getMethod = __webpack_require__("60de");
var getSubstitution = __webpack_require__("79b4");
var regExpExec = __webpack_require__("df8c");
var wellKnownSymbol = __webpack_require__("7d53");

var REPLACE = wellKnownSymbol('replace');
var max = Math.max;
var min = Math.min;
var concat = uncurryThis([].concat);
var push = uncurryThis([].push);
var stringIndexOf = uncurryThis(''.indexOf);
var stringSlice = uncurryThis(''.slice);

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
})();

// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
  return ''.replace(re, '$<a>') !== '7';
});

// @@replace logic
fixRegExpWellKnownSymbolLogic('replace', function (_, nativeReplace, maybeCallNative) {
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible(this);
      var replacer = searchValue == undefined ? undefined : getMethod(searchValue, REPLACE);
      return replacer
        ? call(replacer, searchValue, O, replaceValue)
        : call(nativeReplace, toString(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (string, replaceValue) {
      var rx = anObject(this);
      var S = toString(string);

      if (
        typeof replaceValue == 'string' &&
        stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 &&
        stringIndexOf(replaceValue, '$<') === -1
      ) {
        var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
        if (res.done) return res.value;
      }

      var functionalReplace = isCallable(replaceValue);
      if (!functionalReplace) replaceValue = toString(replaceValue);

      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;

        push(results, result);
        if (!global) break;

        var matchStr = toString(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = toString(result[0]);
        var position = max(min(toIntegerOrInfinity(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) push(captures, maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = concat([matched], captures, position, S);
          if (namedCaptures !== undefined) push(replacerArgs, namedCaptures);
          var replacement = toString(apply(replaceValue, undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += stringSlice(S, nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + stringSlice(S, nextSourcePosition);
    }
  ];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);


/***/ }),

/***/ "332c":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("4cdd");
var uid = __webpack_require__("1d8a");

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ "33ef":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("6b1d");
var isArray = __webpack_require__("c6de");
var isConstructor = __webpack_require__("c42f");
var isObject = __webpack_require__("7526");
var toAbsoluteIndex = __webpack_require__("9a0f");
var lengthOfArrayLike = __webpack_require__("0481");
var toIndexedObject = __webpack_require__("378c");
var createProperty = __webpack_require__("dac6");
var wellKnownSymbol = __webpack_require__("7d53");
var arrayMethodHasSpeciesSupport = __webpack_require__("189b");
var un$Slice = __webpack_require__("de02");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');

var SPECIES = wellKnownSymbol('species');
var $Array = Array;
var max = Math.max;

// `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = lengthOfArrayLike(O);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (isConstructor(Constructor) && (Constructor === $Array || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === $Array || Constructor === undefined) {
        return un$Slice(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? $Array : Constructor)(max(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});


/***/ }),

/***/ "3584":
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__("06a5"),
    isObjectLike = __webpack_require__("b4b4");

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),

/***/ "35bc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("6b1d");
var global = __webpack_require__("f498");
var call = __webpack_require__("b546");
var uncurryThis = __webpack_require__("70b7");
var IS_PURE = __webpack_require__("0e93");
var DESCRIPTORS = __webpack_require__("d4cb");
var NATIVE_SYMBOL = __webpack_require__("e7a0");
var fails = __webpack_require__("72df");
var hasOwn = __webpack_require__("7a25");
var isPrototypeOf = __webpack_require__("fb9b");
var anObject = __webpack_require__("157c");
var toIndexedObject = __webpack_require__("378c");
var toPropertyKey = __webpack_require__("feca");
var $toString = __webpack_require__("2a3e");
var createPropertyDescriptor = __webpack_require__("9618");
var nativeObjectCreate = __webpack_require__("82e8");
var objectKeys = __webpack_require__("0c47");
var getOwnPropertyNamesModule = __webpack_require__("65d0");
var getOwnPropertyNamesExternal = __webpack_require__("ee58");
var getOwnPropertySymbolsModule = __webpack_require__("2402");
var getOwnPropertyDescriptorModule = __webpack_require__("185a");
var definePropertyModule = __webpack_require__("abdf");
var definePropertiesModule = __webpack_require__("b99b");
var propertyIsEnumerableModule = __webpack_require__("e129");
var defineBuiltIn = __webpack_require__("ef30");
var shared = __webpack_require__("4cdd");
var sharedKey = __webpack_require__("332c");
var hiddenKeys = __webpack_require__("d687");
var uid = __webpack_require__("1d8a");
var wellKnownSymbol = __webpack_require__("7d53");
var wrappedWellKnownSymbolModule = __webpack_require__("4e41");
var defineWellKnownSymbol = __webpack_require__("6a89");
var defineSymbolToPrimitive = __webpack_require__("6367");
var setToStringTag = __webpack_require__("fa46");
var InternalStateModule = __webpack_require__("cdcd");
var $forEach = __webpack_require__("d054").forEach;

var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE = 'prototype';

var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(SYMBOL);

var ObjectPrototype = Object[PROTOTYPE];
var $Symbol = global.Symbol;
var SymbolPrototype = $Symbol && $Symbol[PROTOTYPE];
var TypeError = global.TypeError;
var QObject = global.QObject;
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var push = uncurryThis([].push);

var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var WellKnownSymbolsStore = shared('wks');

// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDescriptor = DESCRIPTORS && fails(function () {
  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
    nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate(SymbolPrototype);
  setInternalState(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!DESCRIPTORS) symbol.description = description;
  return symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPropertyKey(P);
  anObject(Attributes);
  if (hasOwn(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!hasOwn(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (hasOwn(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach(keys, function (key) {
    if (!DESCRIPTORS || call($propertyIsEnumerable, properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};

var $propertyIsEnumerable = function propertyIsEnumerable(V) {
  var P = toPropertyKey(V);
  var enumerable = call(nativePropertyIsEnumerable, this, P);
  if (this === ObjectPrototype && hasOwn(AllSymbols, P) && !hasOwn(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !hasOwn(this, P) || !hasOwn(AllSymbols, P) || hasOwn(this, HIDDEN) && this[HIDDEN][P]
    ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPropertyKey(P);
  if (it === ObjectPrototype && hasOwn(AllSymbols, key) && !hasOwn(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && hasOwn(AllSymbols, key) && !(hasOwn(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (!hasOwn(AllSymbols, key) && !hasOwn(hiddenKeys, key)) push(result, key);
  });
  return result;
};

var $getOwnPropertySymbols = function (O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (hasOwn(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || hasOwn(ObjectPrototype, key))) {
      push(result, AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL) {
  $Symbol = function Symbol() {
    if (isPrototypeOf(SymbolPrototype, this)) throw TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : $toString(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      if (this === ObjectPrototype) call(setter, ObjectPrototypeSymbols, value);
      if (hasOwn(this, HIDDEN) && hasOwn(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
    };
    if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };

  SymbolPrototype = $Symbol[PROTOTYPE];

  defineBuiltIn(SymbolPrototype, 'toString', function toString() {
    return getInternalState(this).tag;
  });

  defineBuiltIn($Symbol, 'withoutSetter', function (description) {
    return wrap(uid(description), description);
  });

  propertyIsEnumerableModule.f = $propertyIsEnumerable;
  definePropertyModule.f = $defineProperty;
  definePropertiesModule.f = $defineProperties;
  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

  wrappedWellKnownSymbolModule.f = function (name) {
    return wrap(wellKnownSymbol(name), name);
  };

  if (DESCRIPTORS) {
    // https://github.com/tc39/proposal-Symbol-description
    nativeDefineProperty(SymbolPrototype, 'description', {
      configurable: true,
      get: function description() {
        return getInternalState(this).description;
      }
    });
    if (!IS_PURE) {
      defineBuiltIn(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
    }
  }
}

$({ global: true, constructor: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
  Symbol: $Symbol
});

$forEach(objectKeys(WellKnownSymbolsStore), function (name) {
  defineWellKnownSymbol(name);
});

$({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames
});

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
defineSymbolToPrimitive();

// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);

hiddenKeys[HIDDEN] = true;


/***/ }),

/***/ "367f":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("f498");

module.exports = global.Promise;


/***/ }),

/***/ "36b3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("6b1d");
var call = __webpack_require__("b546");
var aCallable = __webpack_require__("63d3");
var newPromiseCapabilityModule = __webpack_require__("881c");
var perform = __webpack_require__("42ba");
var iterate = __webpack_require__("b578");
var PROMISE_STATICS_INCORRECT_ITERATION = __webpack_require__("c297");

// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      iterate(iterable, function (promise) {
        call($promiseResolve, C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),

/***/ "378c":
/***/ (function(module, exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__("83a6");
var requireObjectCoercible = __webpack_require__("730c");

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ "37d1":
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__("730c");

var $Object = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return $Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ "3819":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("bf10"),
    root = __webpack_require__("201b");

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),

/***/ "3ad3":
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__("4c0b");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ "3ce8":
/***/ (function(module, exports) {

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
module.exports = function (argument) {
  return typeof argument == 'function';
};


/***/ }),

/***/ "3cec":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("7d53");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),

/***/ "3e32":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("7d53");

var MATCH = wellKnownSymbol('match');

module.exports = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};


/***/ }),

/***/ "3e36":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("f498");

module.exports = global;


/***/ }),

/***/ "3f5a":
/***/ (function(module, exports, __webpack_require__) {

var call = __webpack_require__("b546");
var aCallable = __webpack_require__("63d3");
var anObject = __webpack_require__("157c");
var tryToString = __webpack_require__("4912");
var getIteratorMethod = __webpack_require__("0446");

var $TypeError = TypeError;

module.exports = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
  if (aCallable(iteratorMethod)) return anObject(call(iteratorMethod, argument));
  throw $TypeError(tryToString(argument) + ' is not iterable');
};


/***/ }),

/***/ "405b":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// addapted from the document.currentScript polyfill by Adam Miller
// MIT license
// source: https://github.com/amiller-gh/currentScript-polyfill

// added support for Firefox https://bugzilla.mozilla.org/show_bug.cgi?id=1620505

(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
}(typeof self !== 'undefined' ? self : this, function () {
  function getCurrentScript () {
    var descriptor = Object.getOwnPropertyDescriptor(document, 'currentScript')
    // for chrome
    if (!descriptor && 'currentScript' in document && document.currentScript) {
      return document.currentScript
    }

    // for other browsers with native support for currentScript
    if (descriptor && descriptor.get !== getCurrentScript && document.currentScript) {
      return document.currentScript
    }
  
    // IE 8-10 support script readyState
    // IE 11+ & Firefox support stack trace
    try {
      throw new Error();
    }
    catch (err) {
      // Find the second match for the "at" string to get file src url from stack.
      var ieStackRegExp = /.*at [^(]*\((.*):(.+):(.+)\)$/ig,
        ffStackRegExp = /@([^@]*):(\d+):(\d+)\s*$/ig,
        stackDetails = ieStackRegExp.exec(err.stack) || ffStackRegExp.exec(err.stack),
        scriptLocation = (stackDetails && stackDetails[1]) || false,
        line = (stackDetails && stackDetails[2]) || false,
        currentLocation = document.location.href.replace(document.location.hash, ''),
        pageSource,
        inlineScriptSourceRegExp,
        inlineScriptSource,
        scripts = document.getElementsByTagName('script'); // Live NodeList collection
  
      if (scriptLocation === currentLocation) {
        pageSource = document.documentElement.outerHTML;
        inlineScriptSourceRegExp = new RegExp('(?:[^\\n]+?\\n){0,' + (line - 2) + '}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*', 'i');
        inlineScriptSource = pageSource.replace(inlineScriptSourceRegExp, '$1').trim();
      }
  
      for (var i = 0; i < scripts.length; i++) {
        // If ready state is interactive, return the script tag
        if (scripts[i].readyState === 'interactive') {
          return scripts[i];
        }
  
        // If src matches, return the script tag
        if (scripts[i].src === scriptLocation) {
          return scripts[i];
        }
  
        // If inline source matches, return the script tag
        if (
          scriptLocation === currentLocation &&
          scripts[i].innerHTML &&
          scripts[i].innerHTML.trim() === inlineScriptSource
        ) {
          return scripts[i];
        }
      }
  
      // If no match, return null
      return null;
    }
  };

  return getCurrentScript
}));


/***/ }),

/***/ "405d":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("bf10"),
    root = __webpack_require__("201b");

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),

/***/ "40cc":
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__("e697");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),

/***/ "4172":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("6b1d");
var IS_PURE = __webpack_require__("0e93");
var IS_NODE = __webpack_require__("f117");
var global = __webpack_require__("f498");
var call = __webpack_require__("b546");
var defineBuiltIn = __webpack_require__("ef30");
var setPrototypeOf = __webpack_require__("c1a2");
var setToStringTag = __webpack_require__("fa46");
var setSpecies = __webpack_require__("0a1e");
var aCallable = __webpack_require__("63d3");
var isCallable = __webpack_require__("3ce8");
var isObject = __webpack_require__("7526");
var anInstance = __webpack_require__("4cce");
var speciesConstructor = __webpack_require__("433a");
var task = __webpack_require__("2435").set;
var microtask = __webpack_require__("8573");
var hostReportErrors = __webpack_require__("422d");
var perform = __webpack_require__("42ba");
var Queue = __webpack_require__("e51c");
var InternalStateModule = __webpack_require__("cdcd");
var NativePromiseConstructor = __webpack_require__("367f");
var PromiseConstructorDetection = __webpack_require__("f297");
var newPromiseCapabilityModule = __webpack_require__("881c");

var PROMISE = 'Promise';
var FORCED_PROMISE_CONSTRUCTOR = PromiseConstructorDetection.CONSTRUCTOR;
var NATIVE_PROMISE_REJECTION_EVENT = PromiseConstructorDetection.REJECTION_EVENT;
var NATIVE_PROMISE_SUBCLASSING = PromiseConstructorDetection.SUBCLASSING;
var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
var setInternalState = InternalStateModule.set;
var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
var PromiseConstructor = NativePromiseConstructor;
var PromisePrototype = NativePromisePrototype;
var TypeError = global.TypeError;
var document = global.document;
var process = global.process;
var newPromiseCapability = newPromiseCapabilityModule.f;
var newGenericPromiseCapability = newPromiseCapability;

var DISPATCH_EVENT = !!(document && document.createEvent && global.dispatchEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;

var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && isCallable(then = it.then) ? then : false;
};

var callReaction = function (reaction, state) {
  var value = state.value;
  var ok = state.state == FULFILLED;
  var handler = ok ? reaction.ok : reaction.fail;
  var resolve = reaction.resolve;
  var reject = reaction.reject;
  var domain = reaction.domain;
  var result, then, exited;
  try {
    if (handler) {
      if (!ok) {
        if (state.rejection === UNHANDLED) onHandleUnhandled(state);
        state.rejection = HANDLED;
      }
      if (handler === true) result = value;
      else {
        if (domain) domain.enter();
        result = handler(value); // can throw
        if (domain) {
          domain.exit();
          exited = true;
        }
      }
      if (result === reaction.promise) {
        reject(TypeError('Promise-chain cycle'));
      } else if (then = isThenable(result)) {
        call(then, result, resolve, reject);
      } else resolve(result);
    } else reject(value);
  } catch (error) {
    if (domain && !exited) domain.exit();
    reject(error);
  }
};

var notify = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  microtask(function () {
    var reactions = state.reactions;
    var reaction;
    while (reaction = reactions.get()) {
      callReaction(reaction, state);
    }
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_PROMISE_REJECTION_EVENT && (handler = global['on' + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (state) {
  call(task, global, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform(function () {
        if (IS_NODE) {
          process.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (state) {
  call(task, global, function () {
    var promise = state.facade;
    if (IS_NODE) {
      process.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw TypeError("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          call(then, value,
            bind(internalResolve, wrapper, state),
            bind(internalReject, wrapper, state)
          );
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED_PROMISE_CONSTRUCTOR) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromisePrototype);
    aCallable(executor);
    call(Internal, this);
    var state = getInternalPromiseState(this);
    try {
      executor(bind(internalResolve, state), bind(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };

  PromisePrototype = PromiseConstructor.prototype;

  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal = function Promise(executor) {
    setInternalState(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: new Queue(),
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };

  // `Promise.prototype.then` method
  // https://tc39.es/ecma262/#sec-promise.prototype.then
  Internal.prototype = defineBuiltIn(PromisePrototype, 'then', function then(onFulfilled, onRejected) {
    var state = getInternalPromiseState(this);
    var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
    state.parent = true;
    reaction.ok = isCallable(onFulfilled) ? onFulfilled : true;
    reaction.fail = isCallable(onRejected) && onRejected;
    reaction.domain = IS_NODE ? process.domain : undefined;
    if (state.state == PENDING) state.reactions.add(reaction);
    else microtask(function () {
      callReaction(reaction, state);
    });
    return reaction.promise;
  });

  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalPromiseState(promise);
    this.promise = promise;
    this.resolve = bind(internalResolve, state);
    this.reject = bind(internalReject, state);
  };

  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (!IS_PURE && isCallable(NativePromiseConstructor) && NativePromisePrototype !== Object.prototype) {
    nativeThen = NativePromisePrototype.then;

    if (!NATIVE_PROMISE_SUBCLASSING) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      defineBuiltIn(NativePromisePrototype, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          call(nativeThen, that, resolve, reject);
        }).then(onFulfilled, onRejected);
      // https://github.com/zloirock/core-js/issues/640
      }, { unsafe: true });
    }

    // make `.constructor === Promise` work for native promise-based APIs
    try {
      delete NativePromisePrototype.constructor;
    } catch (error) { /* empty */ }

    // make `instanceof Promise` work for native promise-based APIs
    if (setPrototypeOf) {
      setPrototypeOf(NativePromisePrototype, PromisePrototype);
    }
  }
}

$({ global: true, constructor: true, wrap: true, forced: FORCED_PROMISE_CONSTRUCTOR }, {
  Promise: PromiseConstructor
});

setToStringTag(PromiseConstructor, PROMISE, false, true);
setSpecies(PROMISE);


/***/ }),

/***/ "41dd":
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__("eff8"),
    baseUnary = __webpack_require__("494f"),
    nodeUtil = __webpack_require__("4fab");

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ "422d":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("f498");

module.exports = function (a, b) {
  var console = global.console;
  if (console && console.error) {
    arguments.length == 1 ? console.error(a) : console.error(a, b);
  }
};


/***/ }),

/***/ "42ba":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};


/***/ }),

/***/ "42c5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var call = __webpack_require__("b546");
var uncurryThis = __webpack_require__("70b7");
var toString = __webpack_require__("2a3e");
var regexpFlags = __webpack_require__("abfd");
var stickyHelpers = __webpack_require__("2f6a");
var shared = __webpack_require__("4cdd");
var create = __webpack_require__("82e8");
var getInternalState = __webpack_require__("cdcd").get;
var UNSUPPORTED_DOT_ALL = __webpack_require__("7d08");
var UNSUPPORTED_NCG = __webpack_require__("1543");

var nativeReplace = shared('native-string-replace', String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt = uncurryThis(''.charAt);
var indexOf = uncurryThis(''.indexOf);
var replace = uncurryThis(''.replace);
var stringSlice = uncurryThis(''.slice);

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  call(nativeExec, re1, 'a');
  call(nativeExec, re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;

if (PATCH) {
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState(re);
    var str = toString(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = call(patchedExec, raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = call(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = replace(flags, 'y', '');
      if (indexOf(flags, 'g') === -1) {
        flags += 'g';
      }

      strCopy = stringSlice(str, re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt(str, re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = call(nativeExec, sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = stringSlice(match.input, charsAdded);
        match[0] = stringSlice(match[0], charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
      call(nativeReplace, match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = create(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),

/***/ "433a":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("157c");
var aConstructor = __webpack_require__("004f");
var wellKnownSymbol = __webpack_require__("7d53");

var SPECIES = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
module.exports = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? defaultConstructor : aConstructor(S);
};


/***/ }),

/***/ "43f8":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("72df");

module.exports = !fails(function () {
  // eslint-disable-next-line es-x/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});


/***/ }),

/***/ "4499":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("f498");

// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

module.exports = function (key, value) {
  try {
    defineProperty(global, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ "44d9":
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__("fa8a");

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),

/***/ "4778":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("4b2c"),
    Uint8Array = __webpack_require__("986c"),
    eq = __webpack_require__("a4fc"),
    equalArrays = __webpack_require__("659f"),
    mapToArray = __webpack_require__("6944"),
    setToArray = __webpack_require__("5e52");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),

/***/ "4912":
/***/ (function(module, exports) {

var $String = String;

module.exports = function (argument) {
  try {
    return $String(argument);
  } catch (error) {
    return 'Object';
  }
};


/***/ }),

/***/ "494f":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ "4b2c":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("201b");

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ "4b48":
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),

/***/ "4c0b":
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ "4cce":
/***/ (function(module, exports, __webpack_require__) {

var isPrototypeOf = __webpack_require__("fb9b");

var $TypeError = TypeError;

module.exports = function (it, Prototype) {
  if (isPrototypeOf(Prototype, it)) return it;
  throw $TypeError('Incorrect invocation');
};


/***/ }),

/***/ "4cdd":
/***/ (function(module, exports, __webpack_require__) {

var IS_PURE = __webpack_require__("0e93");
var store = __webpack_require__("c607");

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.24.1',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2014-2022 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.24.1/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});


/***/ }),

/***/ "4db4":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es-x/no-symbol -- required for testing */
var NATIVE_SYMBOL = __webpack_require__("e7a0");

module.exports = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';


/***/ }),

/***/ "4e41":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("7d53");

exports.f = wellKnownSymbol;


/***/ }),

/***/ "4ed6":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("6b1d");
var NATIVE_SYMBOL = __webpack_require__("e7a0");
var fails = __webpack_require__("72df");
var getOwnPropertySymbolsModule = __webpack_require__("2402");
var toObject = __webpack_require__("37d1");

// V8 ~ Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FORCED = !NATIVE_SYMBOL || fails(function () { getOwnPropertySymbolsModule.f(1); });

// `Object.getOwnPropertySymbols` method
// https://tc39.es/ecma262/#sec-object.getownpropertysymbols
$({ target: 'Object', stat: true, forced: FORCED }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    var $getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
    return $getOwnPropertySymbols ? $getOwnPropertySymbols(toObject(it)) : [];
  }
});


/***/ }),

/***/ "4efd":
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__("d856"),
    hashDelete = __webpack_require__("54f6"),
    hashGet = __webpack_require__("f9f5"),
    hashHas = __webpack_require__("40cc"),
    hashSet = __webpack_require__("994b");

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),

/***/ "4fab":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__("7bdd");

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("6984")(module)))

/***/ }),

/***/ "4fed":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("f498");
var userAgent = __webpack_require__("64e4");

var process = global.process;
var Deno = global.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

module.exports = version;


/***/ }),

/***/ "5268":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__("3cec");
var classof = __webpack_require__("da06");

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),

/***/ "52e2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("6b1d");
var IS_PURE = __webpack_require__("0e93");
var FORCED_PROMISE_CONSTRUCTOR = __webpack_require__("f297").CONSTRUCTOR;
var NativePromiseConstructor = __webpack_require__("367f");
var getBuiltIn = __webpack_require__("5428");
var isCallable = __webpack_require__("3ce8");
var defineBuiltIn = __webpack_require__("ef30");

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;

// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$({ target: 'Promise', proto: true, forced: FORCED_PROMISE_CONSTRUCTOR, real: true }, {
  'catch': function (onRejected) {
    return this.then(undefined, onRejected);
  }
});

// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if (!IS_PURE && isCallable(NativePromiseConstructor)) {
  var method = getBuiltIn('Promise').prototype['catch'];
  if (NativePromisePrototype['catch'] !== method) {
    defineBuiltIn(NativePromisePrototype, 'catch', method, { unsafe: true });
  }
}


/***/ }),

/***/ "5428":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("f498");
var isCallable = __webpack_require__("3ce8");

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
};


/***/ }),

/***/ "54f6":
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),

/***/ "5637":
/***/ (function(module, exports, __webpack_require__) {

var userAgent = __webpack_require__("64e4");
var global = __webpack_require__("f498");

module.exports = /ipad|iphone|ipod/i.test(userAgent) && global.Pebble !== undefined;


/***/ }),

/***/ "57c6":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("7526");
var createNonEnumerableProperty = __webpack_require__("5b12");

// `InstallErrorCause` abstract operation
// https://tc39.es/proposal-error-cause/#sec-errorobjects-install-error-cause
module.exports = function (O, options) {
  if (isObject(options) && 'cause' in options) {
    createNonEnumerableProperty(O, 'cause', options.cause);
  }
};


/***/ }),

/***/ "58d3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var call = __webpack_require__("b546");
var fixRegExpWellKnownSymbolLogic = __webpack_require__("95b2");
var anObject = __webpack_require__("157c");
var toLength = __webpack_require__("b495");
var toString = __webpack_require__("2a3e");
var requireObjectCoercible = __webpack_require__("730c");
var getMethod = __webpack_require__("60de");
var advanceStringIndex = __webpack_require__("e3f6");
var regExpExec = __webpack_require__("df8c");

// @@match logic
fixRegExpWellKnownSymbolLogic('match', function (MATCH, nativeMatch, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.es/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = requireObjectCoercible(this);
      var matcher = regexp == undefined ? undefined : getMethod(regexp, MATCH);
      return matcher ? call(matcher, regexp, O) : new RegExp(regexp)[MATCH](toString(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
    function (string) {
      var rx = anObject(this);
      var S = toString(string);
      var res = maybeCallNative(nativeMatch, rx, S);

      if (res.done) return res.value;

      if (!rx.global) return regExpExec(rx, S);

      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = toString(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),

/***/ "5b12":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("d4cb");
var definePropertyModule = __webpack_require__("abdf");
var createPropertyDescriptor = __webpack_require__("9618");

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "5b4b":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),

/***/ "5ba0":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("70b7");

// `thisNumberValue` abstract operation
// https://tc39.es/ecma262/#sec-thisnumbervalue
module.exports = uncurryThis(1.0.valueOf);


/***/ }),

/***/ "5bb7":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "5e52":
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),

/***/ "5f28":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("6b1d");
var createHTML = __webpack_require__("8081");
var forcedStringHTMLMethod = __webpack_require__("b07c");

// `String.prototype.anchor` method
// https://tc39.es/ecma262/#sec-string.prototype.anchor
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('anchor') }, {
  anchor: function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  }
});


/***/ }),

/***/ "5f84":
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ "6009":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("d4cb");
var uncurryThis = __webpack_require__("70b7");
var objectKeys = __webpack_require__("0c47");
var toIndexedObject = __webpack_require__("378c");
var $propertyIsEnumerable = __webpack_require__("e129").f;

var propertyIsEnumerable = uncurryThis($propertyIsEnumerable);
var push = uncurryThis([].push);

// `Object.{ entries, values }` methods implementation
var createMethod = function (TO_ENTRIES) {
  return function (it) {
    var O = toIndexedObject(it);
    var keys = objectKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || propertyIsEnumerable(O, key)) {
        push(result, TO_ENTRIES ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};

module.exports = {
  // `Object.entries` method
  // https://tc39.es/ecma262/#sec-object.entries
  entries: createMethod(true),
  // `Object.values` method
  // https://tc39.es/ecma262/#sec-object.values
  values: createMethod(false)
};


/***/ }),

/***/ "60de":
/***/ (function(module, exports, __webpack_require__) {

var aCallable = __webpack_require__("63d3");

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function (V, P) {
  var func = V[P];
  return func == null ? undefined : aCallable(func);
};


/***/ }),

/***/ "61ad":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("70b7");
var requireObjectCoercible = __webpack_require__("730c");
var toString = __webpack_require__("2a3e");
var whitespaces = __webpack_require__("fbf7");

var replace = uncurryThis(''.replace);
var whitespace = '[' + whitespaces + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = toString(requireObjectCoercible($this));
    if (TYPE & 1) string = replace(string, ltrim, '');
    if (TYPE & 2) string = replace(string, rtrim, '');
    return string;
  };
};

module.exports = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};


/***/ }),

/***/ "62c8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var apply = __webpack_require__("d54f");
var call = __webpack_require__("b546");
var uncurryThis = __webpack_require__("70b7");
var fixRegExpWellKnownSymbolLogic = __webpack_require__("95b2");
var isRegExp = __webpack_require__("8e5d");
var anObject = __webpack_require__("157c");
var requireObjectCoercible = __webpack_require__("730c");
var speciesConstructor = __webpack_require__("433a");
var advanceStringIndex = __webpack_require__("e3f6");
var toLength = __webpack_require__("b495");
var toString = __webpack_require__("2a3e");
var getMethod = __webpack_require__("60de");
var arraySlice = __webpack_require__("d1b2");
var callRegExpExec = __webpack_require__("df8c");
var regexpExec = __webpack_require__("42c5");
var stickyHelpers = __webpack_require__("2f6a");
var fails = __webpack_require__("72df");

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;
var MAX_UINT32 = 0xFFFFFFFF;
var min = Math.min;
var $push = [].push;
var exec = uncurryThis(/./.exec);
var push = uncurryThis($push);
var stringSlice = uncurryThis(''.slice);

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
  // eslint-disable-next-line regexp/no-empty-group -- required for testing
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

// @@split logic
fixRegExpWellKnownSymbolLogic('split', function (SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'.split(/(b)*/)[1] == 'c' ||
    // eslint-disable-next-line regexp/no-empty-group -- required for testing
    'test'.split(/(?:)/, -1).length != 4 ||
    'ab'.split(/(?:ab)*/).length != 2 ||
    '.'.split(/(.?)(.?)/).length != 4 ||
    // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
    '.'.split(/()()/).length > 1 ||
    ''.split(/.?/).length
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = toString(requireObjectCoercible(this));
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (separator === undefined) return [string];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) {
        return call(nativeSplit, string, separator, lim);
      }
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = call(regexpExec, separatorCopy, string)) {
        lastIndex = separatorCopy.lastIndex;
        if (lastIndex > lastLastIndex) {
          push(output, stringSlice(string, lastLastIndex, match.index));
          if (match.length > 1 && match.index < string.length) apply($push, output, arraySlice(match, 1));
          lastLength = match[0].length;
          lastLastIndex = lastIndex;
          if (output.length >= lim) break;
        }
        if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
      }
      if (lastLastIndex === string.length) {
        if (lastLength || !exec(separatorCopy, '')) push(output, '');
      } else push(output, stringSlice(string, lastLastIndex));
      return output.length > lim ? arraySlice(output, 0, lim) : output;
    };
  // Chakra, V8
  } else if ('0'.split(undefined, 0).length) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : call(nativeSplit, this, separator, limit);
    };
  } else internalSplit = nativeSplit;

  return [
    // `String.prototype.split` method
    // https://tc39.es/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = requireObjectCoercible(this);
      var splitter = separator == undefined ? undefined : getMethod(separator, SPLIT);
      return splitter
        ? call(splitter, separator, O, limit)
        : call(internalSplit, toString(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (string, limit) {
      var rx = anObject(this);
      var S = toString(string);
      var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);

      if (res.done) return res.value;

      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (UNSUPPORTED_Y ? 'g' : 'y');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(UNSUPPORTED_Y ? '^(?:' + rx.source + ')' : rx, flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = UNSUPPORTED_Y ? 0 : q;
        var z = callRegExpExec(splitter, UNSUPPORTED_Y ? stringSlice(S, q) : S);
        var e;
        if (
          z === null ||
          (e = min(toLength(splitter.lastIndex + (UNSUPPORTED_Y ? q : 0)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          push(A, stringSlice(S, p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            push(A, z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      push(A, stringSlice(S, p));
      return A;
    }
  ];
}, !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, UNSUPPORTED_Y);


/***/ }),

/***/ "6367":
/***/ (function(module, exports, __webpack_require__) {

var call = __webpack_require__("b546");
var getBuiltIn = __webpack_require__("5428");
var wellKnownSymbol = __webpack_require__("7d53");
var defineBuiltIn = __webpack_require__("ef30");

module.exports = function () {
  var Symbol = getBuiltIn('Symbol');
  var SymbolPrototype = Symbol && Symbol.prototype;
  var valueOf = SymbolPrototype && SymbolPrototype.valueOf;
  var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

  if (SymbolPrototype && !SymbolPrototype[TO_PRIMITIVE]) {
    // `Symbol.prototype[@@toPrimitive]` method
    // https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
    // eslint-disable-next-line no-unused-vars -- required for .length
    defineBuiltIn(SymbolPrototype, TO_PRIMITIVE, function (hint) {
      return call(valueOf, this);
    }, { arity: 1 });
  }
};


/***/ }),

/***/ "63d3":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("3ce8");
var tryToString = __webpack_require__("4912");

var $TypeError = TypeError;

// `Assert: IsCallable(argument) is true`
module.exports = function (argument) {
  if (isCallable(argument)) return argument;
  throw $TypeError(tryToString(argument) + ' is not a function');
};


/***/ }),

/***/ "64e4":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("5428");

module.exports = getBuiltIn('navigator', 'userAgent') || '';


/***/ }),

/***/ "653f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var tryToString = __webpack_require__("4912");

var $TypeError = TypeError;

module.exports = function (O, P) {
  if (!delete O[P]) throw $TypeError('Cannot delete property ' + tryToString(P) + ' of ' + tryToString(O));
};


/***/ }),

/***/ "6559":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("6b1d");
var $entries = __webpack_require__("6009").entries;

// `Object.entries` method
// https://tc39.es/ecma262/#sec-object.entries
$({ target: 'Object', stat: true }, {
  entries: function entries(O) {
    return $entries(O);
  }
});


/***/ }),

/***/ "659f":
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__("2419"),
    arraySome = __webpack_require__("9b25"),
    cacheHas = __webpack_require__("4b48");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),

/***/ "65d0":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("c91c");
var enumBugKeys = __webpack_require__("b17e");

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es-x/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ "68b8":
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__("6a89");

// `Symbol.iterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.iterator
defineWellKnownSymbol('iterator');


/***/ }),

/***/ "6944":
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),

/***/ "6984":
/***/ (function(module, exports) {

module.exports = function(module) {
	if (!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),

/***/ "6a61":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("70b7");

var toString = uncurryThis({}.toString);
var stringSlice = uncurryThis(''.slice);

module.exports = function (it) {
  return stringSlice(toString(it), 8, -1);
};


/***/ }),

/***/ "6a86":
/***/ (function(module, exports, __webpack_require__) {

var arraySpeciesConstructor = __webpack_require__("9c1c");

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};


/***/ }),

/***/ "6a89":
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__("3e36");
var hasOwn = __webpack_require__("7a25");
var wrappedWellKnownSymbolModule = __webpack_require__("4e41");
var defineProperty = __webpack_require__("abdf").f;

module.exports = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!hasOwn(Symbol, NAME)) defineProperty(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule.f(NAME)
  });
};


/***/ }),

/***/ "6b1d":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("f498");
var getOwnPropertyDescriptor = __webpack_require__("185a").f;
var createNonEnumerableProperty = __webpack_require__("5b12");
var defineBuiltIn = __webpack_require__("ef30");
var defineGlobalProperty = __webpack_require__("4499");
var copyConstructorProperties = __webpack_require__("b634");
var isForced = __webpack_require__("ebac");

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    defineBuiltIn(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ "6efc":
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__("ff7d"),
    isObjectLike = __webpack_require__("b4b4");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ "7049":
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),

/***/ "70b7":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_BIND = __webpack_require__("43f8");

var FunctionPrototype = Function.prototype;
var bind = FunctionPrototype.bind;
var call = FunctionPrototype.call;
var uncurryThis = NATIVE_BIND && bind.bind(call, call);

module.exports = NATIVE_BIND ? function (fn) {
  return fn && uncurryThis(fn);
} : function (fn) {
  return fn && function () {
    return call.apply(fn, arguments);
  };
};


/***/ }),

/***/ "7297":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("f498");
var isCallable = __webpack_require__("3ce8");
var inspectSource = __webpack_require__("df6f");

var WeakMap = global.WeakMap;

module.exports = isCallable(WeakMap) && /native code/.test(inspectSource(WeakMap));


/***/ }),

/***/ "72df":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ "730c":
/***/ (function(module, exports) {

var $TypeError = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (it == undefined) throw $TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ "735f":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),

/***/ "7526":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("3ce8");

module.exports = function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};


/***/ }),

/***/ "7637":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("6b1d");
var hasOwn = __webpack_require__("7a25");
var isSymbol = __webpack_require__("cfd1");
var tryToString = __webpack_require__("4912");
var shared = __webpack_require__("4cdd");
var NATIVE_SYMBOL_REGISTRY = __webpack_require__("99b6");

var SymbolToStringRegistry = shared('symbol-to-string-registry');

// `Symbol.keyFor` method
// https://tc39.es/ecma262/#sec-symbol.keyfor
$({ target: 'Symbol', stat: true, forced: !NATIVE_SYMBOL_REGISTRY }, {
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(tryToString(sym) + ' is not a symbol');
    if (hasOwn(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  }
});


/***/ }),

/***/ "7745":
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__("24da");

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),

/***/ "79ab":
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__("24da");

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),

/***/ "79b4":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("70b7");
var toObject = __webpack_require__("37d1");

var floor = Math.floor;
var charAt = uncurryThis(''.charAt);
var replace = uncurryThis(''.replace);
var stringSlice = uncurryThis(''.slice);
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
module.exports = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace(replacement, symbols, function (match, ch) {
    var capture;
    switch (charAt(ch, 0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return stringSlice(str, 0, position);
      case "'": return stringSlice(str, tailPos);
      case '<':
        capture = namedCaptures[stringSlice(ch, 1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? charAt(ch, 1) : captures[f - 1] + charAt(ch, 1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};


/***/ }),

/***/ "7a25":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("70b7");
var toObject = __webpack_require__("37d1");

var hasOwnProperty = uncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es-x/no-object-hasown -- safe
module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};


/***/ }),

/***/ "7bad":
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__("24da");

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),

/***/ "7bcd":
/***/ (function(module, exports) {

module.exports = require("@fkui/logic");

/***/ }),

/***/ "7bdd":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("7d15")))

/***/ }),

/***/ "7c3f":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("d4cb");
var fails = __webpack_require__("72df");
var createElement = __webpack_require__("f2bf");

// Thanks to IE8 for its funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),

/***/ "7d08":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("72df");
var global = __webpack_require__("f498");

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp = global.RegExp;

module.exports = fails(function () {
  var re = $RegExp('.', 's');
  return !(re.dotAll && re.exec('\n') && re.flags === 's');
});


/***/ }),

/***/ "7d15":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "7d53":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("f498");
var shared = __webpack_require__("4cdd");
var hasOwn = __webpack_require__("7a25");
var uid = __webpack_require__("1d8a");
var NATIVE_SYMBOL = __webpack_require__("e7a0");
var USE_SYMBOL_AS_UID = __webpack_require__("4db4");

var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var symbolFor = Symbol && Symbol['for'];
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!hasOwn(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    var description = 'Symbol.' + name;
    if (NATIVE_SYMBOL && hasOwn(Symbol, name)) {
      WellKnownSymbolsStore[name] = Symbol[name];
    } else if (USE_SYMBOL_AS_UID && symbolFor) {
      WellKnownSymbolsStore[name] = symbolFor(description);
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
    }
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ "7f8a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("72df");

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call -- required for testing
    method.call(null, argument || function () { return 1; }, 1);
  });
};


/***/ }),

/***/ "802e":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("72df");

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es-x/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),

/***/ "8071":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("6b1d");
var call = __webpack_require__("b546");
var aCallable = __webpack_require__("63d3");
var newPromiseCapabilityModule = __webpack_require__("881c");
var perform = __webpack_require__("42ba");
var iterate = __webpack_require__("b578");
var PROMISE_STATICS_INCORRECT_ITERATION = __webpack_require__("c297");

// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call($promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),

/***/ "8081":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("70b7");
var requireObjectCoercible = __webpack_require__("730c");
var toString = __webpack_require__("2a3e");

var quot = /"/g;
var replace = uncurryThis(''.replace);

// `CreateHTML` abstract operation
// https://tc39.es/ecma262/#sec-createhtml
module.exports = function (string, tag, attribute, value) {
  var S = toString(requireObjectCoercible(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + replace(toString(value), quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};


/***/ }),

/***/ "815b":
/***/ (function(module, exports) {

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es-x/no-math-trunc -- safe
module.exports = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};


/***/ }),

/***/ "82e8":
/***/ (function(module, exports, __webpack_require__) {

/* global ActiveXObject -- old IE, WSH */
var anObject = __webpack_require__("157c");
var definePropertiesModule = __webpack_require__("b99b");
var enumBugKeys = __webpack_require__("b17e");
var hiddenKeys = __webpack_require__("d687");
var html = __webpack_require__("9324");
var documentCreateElement = __webpack_require__("f2bf");
var sharedKey = __webpack_require__("332c");

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es-x/no-object-create -- safe
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};


/***/ }),

/***/ "83a6":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("70b7");
var fails = __webpack_require__("72df");
var classof = __webpack_require__("6a61");

var $Object = Object;
var split = uncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split(it, '') : $Object(it);
} : $Object;


/***/ }),

/***/ "841a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("6b1d");
var $find = __webpack_require__("d054").find;
var addToUnscopables = __webpack_require__("ed2b");

var FIND = 'find';
var SKIPS_HOLES = true;

// Shouldn't skip holes
if (FIND in []) Array(1)[FIND](function () { SKIPS_HOLES = false; });

// `Array.prototype.find` method
// https://tc39.es/ecma262/#sec-array.prototype.find
$({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND);


/***/ }),

/***/ "8423":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("6b1d");
var from = __webpack_require__("ccae");
var checkCorrectnessOfIteration = __webpack_require__("3211");

var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
  // eslint-disable-next-line es-x/no-array-from -- required for testing
  Array.from(iterable);
});

// `Array.from` method
// https://tc39.es/ecma262/#sec-array.from
$({ target: 'Array', stat: true, forced: INCORRECT_ITERATION }, {
  from: from
});


/***/ }),

/***/ "8573":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("f498");
var bind = __webpack_require__("2117");
var getOwnPropertyDescriptor = __webpack_require__("185a").f;
var macrotask = __webpack_require__("2435").set;
var IS_IOS = __webpack_require__("e03e");
var IS_IOS_PEBBLE = __webpack_require__("5637");
var IS_WEBOS_WEBKIT = __webpack_require__("1d2e");
var IS_NODE = __webpack_require__("f117");

var MutationObserver = global.MutationObserver || global.WebKitMutationObserver;
var document = global.document;
var process = global.process;
var Promise = global.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor(global, 'queueMicrotask');
var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;

var flush, head, last, notify, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!queueMicrotask) {
  flush = function () {
    var parent, fn;
    if (IS_NODE && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (error) {
        if (head) notify();
        else last = undefined;
        throw error;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!IS_IOS && !IS_NODE && !IS_WEBOS_WEBKIT && MutationObserver && document) {
    toggle = true;
    node = document.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (!IS_IOS_PEBBLE && Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise.resolve(undefined);
    // workaround of WebKit ~ iOS Safari 10.1 bug
    promise.constructor = Promise;
    then = bind(promise.then, promise);
    notify = function () {
      then(flush);
    };
  // Node.js without promises
  } else if (IS_NODE) {
    notify = function () {
      process.nextTick(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessage
  // - onreadystatechange
  // - setTimeout
  } else {
    // strange IE + webpack dev server bug - use .bind(global)
    macrotask = bind(macrotask, global);
    notify = function () {
      macrotask(flush);
    };
  }
}

module.exports = queueMicrotask || function (fn) {
  var task = { fn: fn, next: undefined };
  if (last) last.next = task;
  if (!head) {
    head = task;
    notify();
  } last = task;
};


/***/ }),

/***/ "868d":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("d4cb");
var FUNCTION_NAME_EXISTS = __webpack_require__("d331").EXISTS;
var uncurryThis = __webpack_require__("70b7");
var defineProperty = __webpack_require__("abdf").f;

var FunctionPrototype = Function.prototype;
var functionToString = uncurryThis(FunctionPrototype.toString);
var nameRE = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/;
var regExpExec = uncurryThis(nameRE.exec);
var NAME = 'name';

// Function instances `.name` property
// https://tc39.es/ecma262/#sec-function-instances-name
if (DESCRIPTORS && !FUNCTION_NAME_EXISTS) {
  defineProperty(FunctionPrototype, NAME, {
    configurable: true,
    get: function () {
      try {
        return regExpExec(nameRE, functionToString(this))[1];
      } catch (error) {
        return '';
      }
    }
  });
}


/***/ }),

/***/ "872c":
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__("9b9a"),
    mapCacheDelete = __webpack_require__("7745"),
    mapCacheGet = __webpack_require__("79ab"),
    mapCacheHas = __webpack_require__("f522"),
    mapCacheSet = __webpack_require__("7bad");

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),

/***/ "881c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aCallable = __webpack_require__("63d3");

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aCallable(resolve);
  this.reject = aCallable(reject);
};

// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),

/***/ "8ba6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__("5428");
var hasOwn = __webpack_require__("7a25");
var createNonEnumerableProperty = __webpack_require__("5b12");
var isPrototypeOf = __webpack_require__("fb9b");
var setPrototypeOf = __webpack_require__("c1a2");
var copyConstructorProperties = __webpack_require__("b634");
var proxyAccessor = __webpack_require__("1702");
var inheritIfRequired = __webpack_require__("8fa9");
var normalizeStringArgument = __webpack_require__("aa4d");
var installErrorCause = __webpack_require__("57c6");
var clearErrorStack = __webpack_require__("c9bf");
var ERROR_STACK_INSTALLABLE = __webpack_require__("ea26");
var DESCRIPTORS = __webpack_require__("d4cb");
var IS_PURE = __webpack_require__("0e93");

module.exports = function (FULL_NAME, wrapper, FORCED, IS_AGGREGATE_ERROR) {
  var STACK_TRACE_LIMIT = 'stackTraceLimit';
  var OPTIONS_POSITION = IS_AGGREGATE_ERROR ? 2 : 1;
  var path = FULL_NAME.split('.');
  var ERROR_NAME = path[path.length - 1];
  var OriginalError = getBuiltIn.apply(null, path);

  if (!OriginalError) return;

  var OriginalErrorPrototype = OriginalError.prototype;

  // V8 9.3- bug https://bugs.chromium.org/p/v8/issues/detail?id=12006
  if (!IS_PURE && hasOwn(OriginalErrorPrototype, 'cause')) delete OriginalErrorPrototype.cause;

  if (!FORCED) return OriginalError;

  var BaseError = getBuiltIn('Error');

  var WrappedError = wrapper(function (a, b) {
    var message = normalizeStringArgument(IS_AGGREGATE_ERROR ? b : a, undefined);
    var result = IS_AGGREGATE_ERROR ? new OriginalError(a) : new OriginalError();
    if (message !== undefined) createNonEnumerableProperty(result, 'message', message);
    if (ERROR_STACK_INSTALLABLE) createNonEnumerableProperty(result, 'stack', clearErrorStack(result.stack, 2));
    if (this && isPrototypeOf(OriginalErrorPrototype, this)) inheritIfRequired(result, this, WrappedError);
    if (arguments.length > OPTIONS_POSITION) installErrorCause(result, arguments[OPTIONS_POSITION]);
    return result;
  });

  WrappedError.prototype = OriginalErrorPrototype;

  if (ERROR_NAME !== 'Error') {
    if (setPrototypeOf) setPrototypeOf(WrappedError, BaseError);
    else copyConstructorProperties(WrappedError, BaseError, { name: true });
  } else if (DESCRIPTORS && STACK_TRACE_LIMIT in OriginalError) {
    proxyAccessor(WrappedError, OriginalError, STACK_TRACE_LIMIT);
    proxyAccessor(WrappedError, OriginalError, 'prepareStackTrace');
  }

  copyConstructorProperties(WrappedError, OriginalError);

  if (!IS_PURE) try {
    // Safari 13- bug: WebAssembly errors does not have a proper `.name`
    if (OriginalErrorPrototype.name !== ERROR_NAME) {
      createNonEnumerableProperty(OriginalErrorPrototype, 'name', ERROR_NAME);
    }
    OriginalErrorPrototype.constructor = WrappedError;
  } catch (error) { /* empty */ }

  return WrappedError;
};


/***/ }),

/***/ "8bbf":
/***/ (function(module, exports) {

module.exports = require("vue");

/***/ }),

/***/ "8d0d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("6b1d");
var $includes = __webpack_require__("1f5e").includes;
var fails = __webpack_require__("72df");
var addToUnscopables = __webpack_require__("ed2b");

// FF99+ bug
var BROKEN_ON_SPARSE = fails(function () {
  return !Array(1).includes();
});

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$({ target: 'Array', proto: true, forced: BROKEN_ON_SPARSE }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');


/***/ }),

/***/ "8d0f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// `Symbol.prototype.description` getter
// https://tc39.es/ecma262/#sec-symbol.prototype.description

var $ = __webpack_require__("6b1d");
var DESCRIPTORS = __webpack_require__("d4cb");
var global = __webpack_require__("f498");
var uncurryThis = __webpack_require__("70b7");
var hasOwn = __webpack_require__("7a25");
var isCallable = __webpack_require__("3ce8");
var isPrototypeOf = __webpack_require__("fb9b");
var toString = __webpack_require__("2a3e");
var defineProperty = __webpack_require__("abdf").f;
var copyConstructorProperties = __webpack_require__("b634");

var NativeSymbol = global.Symbol;
var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;

if (DESCRIPTORS && isCallable(NativeSymbol) && (!('description' in SymbolPrototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString(arguments[0]);
    var result = isPrototypeOf(SymbolPrototype, this)
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };

  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  SymbolWrapper.prototype = SymbolPrototype;
  SymbolPrototype.constructor = SymbolWrapper;

  var NATIVE_SYMBOL = String(NativeSymbol('test')) == 'Symbol(test)';
  var symbolToString = uncurryThis(SymbolPrototype.toString);
  var symbolValueOf = uncurryThis(SymbolPrototype.valueOf);
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  var replace = uncurryThis(''.replace);
  var stringSlice = uncurryThis(''.slice);

  defineProperty(SymbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = symbolValueOf(this);
      var string = symbolToString(symbol);
      if (hasOwn(EmptyStringDescriptionStore, symbol)) return '';
      var desc = NATIVE_SYMBOL ? stringSlice(string, 7, -1) : replace(string, regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $({ global: true, constructor: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}


/***/ }),

/***/ "8e5d":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("7526");
var classof = __webpack_require__("6a61");
var wellKnownSymbol = __webpack_require__("7d53");

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) == 'RegExp');
};


/***/ }),

/***/ "8fa9":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("3ce8");
var isObject = __webpack_require__("7526");
var setPrototypeOf = __webpack_require__("c1a2");

// makes subclassing work correct for wrapped built-ins
module.exports = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    isCallable(NewTarget = dummy.constructor) &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};


/***/ }),

/***/ "907a":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ "918c":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("f498");
var DOMIterables = __webpack_require__("130d");
var DOMTokenListPrototype = __webpack_require__("95e4");
var ArrayIteratorMethods = __webpack_require__("9531");
var createNonEnumerableProperty = __webpack_require__("5b12");
var wellKnownSymbol = __webpack_require__("7d53");

var ITERATOR = wellKnownSymbol('iterator');
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');


/***/ }),

/***/ "9243":
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__("405d"),
    Map = __webpack_require__("a9e0"),
    Promise = __webpack_require__("212d"),
    Set = __webpack_require__("3819"),
    WeakMap = __webpack_require__("e3e5"),
    baseGetTag = __webpack_require__("0e19"),
    toSource = __webpack_require__("735f");

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),

/***/ "930a":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("e902");

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ "9324":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("5428");

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),

/***/ "9531":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__("378c");
var addToUnscopables = __webpack_require__("ed2b");
var Iterators = __webpack_require__("5bb7");
var InternalStateModule = __webpack_require__("cdcd");
var defineProperty = __webpack_require__("abdf").f;
var defineIterator = __webpack_require__("2df4");
var IS_PURE = __webpack_require__("0e93");
var DESCRIPTORS = __webpack_require__("d4cb");

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

// V8 ~ Chrome 45- bug
if (!IS_PURE && DESCRIPTORS && values.name !== 'values') try {
  defineProperty(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }


/***/ }),

/***/ "95b2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4` since it's moved to entry points
__webpack_require__("2aa5");
var uncurryThis = __webpack_require__("70b7");
var defineBuiltIn = __webpack_require__("ef30");
var regexpExec = __webpack_require__("42c5");
var fails = __webpack_require__("72df");
var wellKnownSymbol = __webpack_require__("7d53");
var createNonEnumerableProperty = __webpack_require__("5b12");

var SPECIES = wellKnownSymbol('species');
var RegExpPrototype = RegExp.prototype;

module.exports = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var uncurriedNativeRegExpMethod = uncurryThis(/./[SYMBOL]);
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var uncurriedNativeMethod = uncurryThis(nativeMethod);
      var $exec = regexp.exec;
      if ($exec === regexpExec || $exec === RegExpPrototype.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: uncurriedNativeRegExpMethod(regexp, str, arg2) };
        }
        return { done: true, value: uncurriedNativeMethod(str, regexp, arg2) };
      }
      return { done: false };
    });

    defineBuiltIn(String.prototype, KEY, methods[0]);
    defineBuiltIn(RegExpPrototype, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
};


/***/ }),

/***/ "95e4":
/***/ (function(module, exports, __webpack_require__) {

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = __webpack_require__("f2bf");

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;

module.exports = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;


/***/ }),

/***/ "9616":
/***/ (function(module, exports, __webpack_require__) {

var trunc = __webpack_require__("815b");

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};


/***/ }),

/***/ "9618":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "986c":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("201b");

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ "98f3":
/***/ (function(module, exports, __webpack_require__) {

var aCallable = __webpack_require__("63d3");
var toObject = __webpack_require__("37d1");
var IndexedObject = __webpack_require__("83a6");
var lengthOfArrayLike = __webpack_require__("0481");

var $TypeError = TypeError;

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    aCallable(callbackfn);
    var O = toObject(that);
    var self = IndexedObject(O);
    var length = lengthOfArrayLike(O);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw $TypeError('Reduce of empty array with no initial value');
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

module.exports = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: createMethod(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: createMethod(true)
};


/***/ }),

/***/ "994b":
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__("e697");

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),

/***/ "9951":
/***/ (function(module, exports, __webpack_require__) {

var PROPER_FUNCTION_NAME = __webpack_require__("d331").PROPER;
var fails = __webpack_require__("72df");
var whitespaces = __webpack_require__("fbf7");

var non = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
module.exports = function (METHOD_NAME) {
  return fails(function () {
    return !!whitespaces[METHOD_NAME]()
      || non[METHOD_NAME]() !== non
      || (PROPER_FUNCTION_NAME && whitespaces[METHOD_NAME].name !== METHOD_NAME);
  });
};


/***/ }),

/***/ "99b6":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_SYMBOL = __webpack_require__("e7a0");

/* eslint-disable es-x/no-symbol -- safe */
module.exports = NATIVE_SYMBOL && !!Symbol['for'] && !!Symbol.keyFor;


/***/ }),

/***/ "9a0f":
/***/ (function(module, exports, __webpack_require__) {

var toIntegerOrInfinity = __webpack_require__("9616");

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ "9b25":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),

/***/ "9b9a":
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__("4efd"),
    ListCache = __webpack_require__("fa8a"),
    Map = __webpack_require__("a9e0");

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),

/***/ "9c1c":
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__("c6de");
var isConstructor = __webpack_require__("c42f");
var isObject = __webpack_require__("7526");
var wellKnownSymbol = __webpack_require__("7d53");

var SPECIES = wellKnownSymbol('species');
var $Array = Array;

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor(C) && (C === $Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? $Array : C;
};


/***/ }),

/***/ "9c36":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("157c");
var isObject = __webpack_require__("7526");
var newPromiseCapability = __webpack_require__("881c");

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),

/***/ "9e74":
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__("3584");

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),

/***/ "9eea":
/***/ (function(module, exports, __webpack_require__) {

var isRegExp = __webpack_require__("8e5d");

var $TypeError = TypeError;

module.exports = function (it) {
  if (isRegExp(it)) {
    throw $TypeError("The method doesn't accept regular expressions");
  } return it;
};


/***/ }),

/***/ "a03e":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("5428");
var uncurryThis = __webpack_require__("70b7");
var getOwnPropertyNamesModule = __webpack_require__("65d0");
var getOwnPropertySymbolsModule = __webpack_require__("2402");
var anObject = __webpack_require__("157c");

var concat = uncurryThis([].concat);

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ "a48a":
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__("cbff"),
    isArray = __webpack_require__("c316");

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),

/***/ "a4fc":
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ "a67c":
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ "a9e0":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("bf10"),
    root = __webpack_require__("201b");

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),

/***/ "aa31":
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),

/***/ "aa4d":
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__("2a3e");

module.exports = function (argument, $default) {
  return argument === undefined ? arguments.length < 2 ? '' : $default : toString(argument);
};


/***/ }),

/***/ "aaba":
/***/ (function(module, exports, __webpack_require__) {

var call = __webpack_require__("b546");
var anObject = __webpack_require__("157c");
var getMethod = __webpack_require__("60de");

module.exports = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject(iterator);
  try {
    innerResult = getMethod(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = call(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject(innerResult);
  return value;
};


/***/ }),

/***/ "abdf":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("d4cb");
var IE8_DOM_DEFINE = __webpack_require__("7c3f");
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__("ff3b");
var anObject = __webpack_require__("157c");
var toPropertyKey = __webpack_require__("feca");

var $TypeError = TypeError;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw $TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "abfd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__("157c");

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.hasIndices) result += 'd';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.unicodeSets) result += 'v';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ "ae5d":
/***/ (function(module, exports) {

var $TypeError = TypeError;

module.exports = function (passed, required) {
  if (passed < required) throw $TypeError('Not enough arguments');
  return passed;
};


/***/ }),

/***/ "ae68":
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__("d99b"),
    isArguments = __webpack_require__("6efc"),
    isArray = __webpack_require__("c316"),
    isBuffer = __webpack_require__("dda8"),
    isIndex = __webpack_require__("a67c"),
    isTypedArray = __webpack_require__("41dd");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ "b07c":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("72df");

// check the existence of a method, lowercase
// of a tag and escaping quotes in arguments
module.exports = function (METHOD_NAME) {
  return fails(function () {
    var test = ''[METHOD_NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  });
};


/***/ }),

/***/ "b17e":
/***/ (function(module, exports) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ "b495":
/***/ (function(module, exports, __webpack_require__) {

var toIntegerOrInfinity = __webpack_require__("9616");

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ "b4b4":
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ "b506":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("6b1d");
var uncurryThis = __webpack_require__("70b7");
var aCallable = __webpack_require__("63d3");
var toObject = __webpack_require__("37d1");
var lengthOfArrayLike = __webpack_require__("0481");
var deletePropertyOrThrow = __webpack_require__("653f");
var toString = __webpack_require__("2a3e");
var fails = __webpack_require__("72df");
var internalSort = __webpack_require__("2c3d");
var arrayMethodIsStrict = __webpack_require__("7f8a");
var FF = __webpack_require__("e437");
var IE_OR_EDGE = __webpack_require__("f3f8");
var V8 = __webpack_require__("4fed");
var WEBKIT = __webpack_require__("2017");

var test = [];
var un$Sort = uncurryThis(test.sort);
var push = uncurryThis(test.push);

// IE8-
var FAILS_ON_UNDEFINED = fails(function () {
  test.sort(undefined);
});
// V8 bug
var FAILS_ON_NULL = fails(function () {
  test.sort(null);
});
// Old WebKit
var STRICT_METHOD = arrayMethodIsStrict('sort');

var STABLE_SORT = !fails(function () {
  // feature detection can be too slow, so check engines versions
  if (V8) return V8 < 70;
  if (FF && FF > 3) return;
  if (IE_OR_EDGE) return true;
  if (WEBKIT) return WEBKIT < 603;

  var result = '';
  var code, chr, value, index;

  // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
  for (code = 65; code < 76; code++) {
    chr = String.fromCharCode(code);

    switch (code) {
      case 66: case 69: case 70: case 72: value = 3; break;
      case 68: case 71: value = 4; break;
      default: value = 2;
    }

    for (index = 0; index < 47; index++) {
      test.push({ k: chr + index, v: value });
    }
  }

  test.sort(function (a, b) { return b.v - a.v; });

  for (index = 0; index < test.length; index++) {
    chr = test[index].k.charAt(0);
    if (result.charAt(result.length - 1) !== chr) result += chr;
  }

  return result !== 'DGBEFHACIJK';
});

var FORCED = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD || !STABLE_SORT;

var getSortCompare = function (comparefn) {
  return function (x, y) {
    if (y === undefined) return -1;
    if (x === undefined) return 1;
    if (comparefn !== undefined) return +comparefn(x, y) || 0;
    return toString(x) > toString(y) ? 1 : -1;
  };
};

// `Array.prototype.sort` method
// https://tc39.es/ecma262/#sec-array.prototype.sort
$({ target: 'Array', proto: true, forced: FORCED }, {
  sort: function sort(comparefn) {
    if (comparefn !== undefined) aCallable(comparefn);

    var array = toObject(this);

    if (STABLE_SORT) return comparefn === undefined ? un$Sort(array) : un$Sort(array, comparefn);

    var items = [];
    var arrayLength = lengthOfArrayLike(array);
    var itemsLength, index;

    for (index = 0; index < arrayLength; index++) {
      if (index in array) push(items, array[index]);
    }

    internalSort(items, getSortCompare(comparefn));

    itemsLength = items.length;
    index = 0;

    while (index < itemsLength) array[index] = items[index++];
    while (index < arrayLength) deletePropertyOrThrow(array, index++);

    return array;
  }
});


/***/ }),

/***/ "b5061":
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ "b546":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_BIND = __webpack_require__("43f8");

var call = Function.prototype.call;

module.exports = NATIVE_BIND ? call.bind(call) : function () {
  return call.apply(call, arguments);
};


/***/ }),

/***/ "b55a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("6b1d");
var $trim = __webpack_require__("61ad").trim;
var forcedStringTrimMethod = __webpack_require__("9951");

// `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim
$({ target: 'String', proto: true, forced: forcedStringTrimMethod('trim') }, {
  trim: function trim() {
    return $trim(this);
  }
});


/***/ }),

/***/ "b578":
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__("2117");
var call = __webpack_require__("b546");
var anObject = __webpack_require__("157c");
var tryToString = __webpack_require__("4912");
var isArrayIteratorMethod = __webpack_require__("c965");
var lengthOfArrayLike = __webpack_require__("0481");
var isPrototypeOf = __webpack_require__("fb9b");
var getIterator = __webpack_require__("3f5a");
var getIteratorMethod = __webpack_require__("0446");
var iteratorClose = __webpack_require__("aaba");

var $TypeError = TypeError;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype = Result.prototype;

module.exports = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_RECORD = !!(options && options.IS_RECORD);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_RECORD) {
    iterator = iterable.iterator;
  } else if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (!iterFn) throw $TypeError(tryToString(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = lengthOfArrayLike(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && isPrototypeOf(ResultPrototype, result)) return result;
      } return new Result(false);
    }
    iterator = getIterator(iterable, iterFn);
  }

  next = IS_RECORD ? iterable.next : iterator.next;
  while (!(step = call(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && isPrototypeOf(ResultPrototype, result)) return result;
  } return new Result(false);
};


/***/ }),

/***/ "b634":
/***/ (function(module, exports, __webpack_require__) {

var hasOwn = __webpack_require__("7a25");
var ownKeys = __webpack_require__("a03e");
var getOwnPropertyDescriptorModule = __webpack_require__("185a");
var definePropertyModule = __webpack_require__("abdf");

module.exports = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};


/***/ }),

/***/ "b650":
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__("a48a"),
    getSymbols = __webpack_require__("ef42"),
    keys = __webpack_require__("0652");

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),

/***/ "b742":
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ "b7fb":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("70b7");
var toIntegerOrInfinity = __webpack_require__("9616");
var toString = __webpack_require__("2a3e");
var requireObjectCoercible = __webpack_require__("730c");

var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);
var stringSlice = uncurryThis(''.slice);

var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString(requireObjectCoercible($this));
    var position = toIntegerOrInfinity(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),

/***/ "b99b":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("d4cb");
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__("ff3b");
var definePropertyModule = __webpack_require__("abdf");
var anObject = __webpack_require__("157c");
var toIndexedObject = __webpack_require__("378c");
var objectKeys = __webpack_require__("0c47");

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es-x/no-object-defineproperties -- safe
exports.f = DESCRIPTORS && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var props = toIndexedObject(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
  return O;
};


/***/ }),

/***/ "bdf7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("6b1d");
var $findIndex = __webpack_require__("d054").findIndex;
var addToUnscopables = __webpack_require__("ed2b");

var FIND_INDEX = 'findIndex';
var SKIPS_HOLES = true;

// Shouldn't skip holes
if (FIND_INDEX in []) Array(1)[FIND_INDEX](function () { SKIPS_HOLES = false; });

// `Array.prototype.findIndex` method
// https://tc39.es/ecma262/#sec-array.prototype.findindex
$({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $findIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND_INDEX);


/***/ }),

/***/ "bf10":
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__("e672"),
    getValue = __webpack_require__("e29f");

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),

/***/ "c1a2":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable no-proto -- safe */
var uncurryThis = __webpack_require__("70b7");
var anObject = __webpack_require__("157c");
var aPossiblePrototype = __webpack_require__("f3e4");

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es-x/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    // eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
    setter = uncurryThis(Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set);
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),

/***/ "c297":
/***/ (function(module, exports, __webpack_require__) {

var NativePromiseConstructor = __webpack_require__("367f");
var checkCorrectnessOfIteration = __webpack_require__("3211");
var FORCED_PROMISE_CONSTRUCTOR = __webpack_require__("f297").CONSTRUCTOR;

module.exports = FORCED_PROMISE_CONSTRUCTOR || !checkCorrectnessOfIteration(function (iterable) {
  NativePromiseConstructor.all(iterable).then(undefined, function () { /* empty */ });
});


/***/ }),

/***/ "c316":
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ "c32d":
/***/ (function(module, exports) {

module.exports = require("moment");

/***/ }),

/***/ "c42f":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("70b7");
var fails = __webpack_require__("72df");
var isCallable = __webpack_require__("3ce8");
var classof = __webpack_require__("da06");
var getBuiltIn = __webpack_require__("5428");
var inspectSource = __webpack_require__("df6f");

var noop = function () { /* empty */ };
var empty = [];
var construct = getBuiltIn('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = uncurryThis(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  try {
    construct(noop, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  switch (classof(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
module.exports = !construct || fails(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;


/***/ }),

/***/ "c503":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("6b1d");
var getBuiltIn = __webpack_require__("5428");
var hasOwn = __webpack_require__("7a25");
var toString = __webpack_require__("2a3e");
var shared = __webpack_require__("4cdd");
var NATIVE_SYMBOL_REGISTRY = __webpack_require__("99b6");

var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');

// `Symbol.for` method
// https://tc39.es/ecma262/#sec-symbol.for
$({ target: 'Symbol', stat: true, forced: !NATIVE_SYMBOL_REGISTRY }, {
  'for': function (key) {
    var string = toString(key);
    if (hasOwn(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = getBuiltIn('Symbol')(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  }
});


/***/ }),

/***/ "c607":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("f498");
var defineGlobalProperty = __webpack_require__("4499");

var SHARED = '__core-js_shared__';
var store = global[SHARED] || defineGlobalProperty(SHARED, {});

module.exports = store;


/***/ }),

/***/ "c6de":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("6a61");

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es-x/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(argument) {
  return classof(argument) == 'Array';
};


/***/ }),

/***/ "c78b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("6b1d");
var uncurryThis = __webpack_require__("70b7");
var notARegExp = __webpack_require__("9eea");
var requireObjectCoercible = __webpack_require__("730c");
var toString = __webpack_require__("2a3e");
var correctIsRegExpLogic = __webpack_require__("3e32");

var stringIndexOf = uncurryThis(''.indexOf);

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~stringIndexOf(
      toString(requireObjectCoercible(this)),
      toString(notARegExp(searchString)),
      arguments.length > 1 ? arguments[1] : undefined
    );
  }
});


/***/ }),

/***/ "c91c":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("70b7");
var hasOwn = __webpack_require__("7a25");
var toIndexedObject = __webpack_require__("378c");
var indexOf = __webpack_require__("1f5e").indexOf;
var hiddenKeys = __webpack_require__("d687");

var push = uncurryThis([].push);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};


/***/ }),

/***/ "c965":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("7d53");
var Iterators = __webpack_require__("5bb7");

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};


/***/ }),

/***/ "c991":
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__("b650");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),

/***/ "c9bf":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("70b7");

var $Error = Error;
var replace = uncurryThis(''.replace);

var TEST = (function (arg) { return String($Error(arg).stack); })('zxcasd');
var V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
var IS_V8_OR_CHAKRA_STACK = V8_OR_CHAKRA_STACK_ENTRY.test(TEST);

module.exports = function (stack, dropEntries) {
  if (IS_V8_OR_CHAKRA_STACK && typeof stack == 'string' && !$Error.prepareStackTrace) {
    while (dropEntries--) stack = replace(stack, V8_OR_CHAKRA_STACK_ENTRY, '');
  } return stack;
};


/***/ }),

/***/ "cbff":
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),

/***/ "ccae":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var bind = __webpack_require__("2117");
var call = __webpack_require__("b546");
var toObject = __webpack_require__("37d1");
var callWithSafeIterationClosing = __webpack_require__("2514");
var isArrayIteratorMethod = __webpack_require__("c965");
var isConstructor = __webpack_require__("c42f");
var lengthOfArrayLike = __webpack_require__("0481");
var createProperty = __webpack_require__("dac6");
var getIterator = __webpack_require__("3f5a");
var getIteratorMethod = __webpack_require__("0446");

var $Array = Array;

// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
module.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject(arrayLike);
  var IS_CONSTRUCTOR = isConstructor(this);
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
  var iteratorMethod = getIteratorMethod(O);
  var index = 0;
  var length, result, step, iterator, next, value;
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod && !(this === $Array && isArrayIteratorMethod(iteratorMethod))) {
    iterator = getIterator(O, iteratorMethod);
    next = iterator.next;
    result = IS_CONSTRUCTOR ? new this() : [];
    for (;!(step = call(next, iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
      createProperty(result, index, value);
    }
  } else {
    length = lengthOfArrayLike(O);
    result = IS_CONSTRUCTOR ? new this(length) : $Array(length);
    for (;length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty(result, index, value);
    }
  }
  result.length = index;
  return result;
};


/***/ }),

/***/ "cdcd":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__("7297");
var global = __webpack_require__("f498");
var uncurryThis = __webpack_require__("70b7");
var isObject = __webpack_require__("7526");
var createNonEnumerableProperty = __webpack_require__("5b12");
var hasOwn = __webpack_require__("7a25");
var shared = __webpack_require__("c607");
var sharedKey = __webpack_require__("332c");
var hiddenKeys = __webpack_require__("d687");

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError = global.TypeError;
var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  var wmget = uncurryThis(store.get);
  var wmhas = uncurryThis(store.has);
  var wmset = uncurryThis(store.set);
  set = function (it, metadata) {
    if (wmhas(store, it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget(store, it) || {};
  };
  has = function (it) {
    return wmhas(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ "cfce":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("6b1d");
var $map = __webpack_require__("d054").map;
var arrayMethodHasSpeciesSupport = __webpack_require__("189b");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');

// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "cfd1":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("5428");
var isCallable = __webpack_require__("3ce8");
var isPrototypeOf = __webpack_require__("fb9b");
var USE_SYMBOL_AS_UID = __webpack_require__("4db4");

var $Object = Object;

module.exports = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
};


/***/ }),

/***/ "d054":
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__("2117");
var uncurryThis = __webpack_require__("70b7");
var IndexedObject = __webpack_require__("83a6");
var toObject = __webpack_require__("37d1");
var lengthOfArrayLike = __webpack_require__("0481");
var arraySpeciesCreate = __webpack_require__("6a86");

var push = uncurryThis([].push);

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_REJECT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that);
    var length = lengthOfArrayLike(self);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push(target, value);      // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push(target, value);      // filterReject
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: createMethod(7)
};


/***/ }),

/***/ "d1b2":
/***/ (function(module, exports, __webpack_require__) {

var toAbsoluteIndex = __webpack_require__("9a0f");
var lengthOfArrayLike = __webpack_require__("0481");
var createProperty = __webpack_require__("dac6");

var $Array = Array;
var max = Math.max;

module.exports = function (O, start, end) {
  var length = lengthOfArrayLike(O);
  var k = toAbsoluteIndex(start, length);
  var fin = toAbsoluteIndex(end === undefined ? length : end, length);
  var result = $Array(max(fin - k, 0));
  for (var n = 0; k < fin; k++, n++) createProperty(result, n, O[k]);
  result.length = n;
  return result;
};


/***/ }),

/***/ "d331":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("d4cb");
var hasOwn = __webpack_require__("7a25");

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));

module.exports = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};


/***/ }),

/***/ "d331b":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("6b1d");
var getBuiltIn = __webpack_require__("5428");
var apply = __webpack_require__("d54f");
var call = __webpack_require__("b546");
var uncurryThis = __webpack_require__("70b7");
var fails = __webpack_require__("72df");
var isArray = __webpack_require__("c6de");
var isCallable = __webpack_require__("3ce8");
var isObject = __webpack_require__("7526");
var isSymbol = __webpack_require__("cfd1");
var arraySlice = __webpack_require__("de02");
var NATIVE_SYMBOL = __webpack_require__("e7a0");

var $stringify = getBuiltIn('JSON', 'stringify');
var exec = uncurryThis(/./.exec);
var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);
var replace = uncurryThis(''.replace);
var numberToString = uncurryThis(1.0.toString);

var tester = /[\uD800-\uDFFF]/g;
var low = /^[\uD800-\uDBFF]$/;
var hi = /^[\uDC00-\uDFFF]$/;

var WRONG_SYMBOLS_CONVERSION = !NATIVE_SYMBOL || fails(function () {
  var symbol = getBuiltIn('Symbol')();
  // MS Edge converts symbol values to JSON as {}
  return $stringify([symbol]) != '[null]'
    // WebKit converts symbol values to JSON as null
    || $stringify({ a: symbol }) != '{}'
    // V8 throws on boxed symbols
    || $stringify(Object(symbol)) != '{}';
});

// https://github.com/tc39/proposal-well-formed-stringify
var ILL_FORMED_UNICODE = fails(function () {
  return $stringify('\uDF06\uD834') !== '"\\udf06\\ud834"'
    || $stringify('\uDEAD') !== '"\\udead"';
});

var stringifyWithSymbolsFix = function (it, replacer) {
  var args = arraySlice(arguments);
  var $replacer = replacer;
  if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
  if (!isArray(replacer)) replacer = function (key, value) {
    if (isCallable($replacer)) value = call($replacer, this, key, value);
    if (!isSymbol(value)) return value;
  };
  args[1] = replacer;
  return apply($stringify, null, args);
};

var fixIllFormed = function (match, offset, string) {
  var prev = charAt(string, offset - 1);
  var next = charAt(string, offset + 1);
  if ((exec(low, match) && !exec(hi, next)) || (exec(hi, match) && !exec(low, prev))) {
    return '\\u' + numberToString(charCodeAt(match, 0), 16);
  } return match;
};

if ($stringify) {
  // `JSON.stringify` method
  // https://tc39.es/ecma262/#sec-json.stringify
  $({ target: 'JSON', stat: true, arity: 3, forced: WRONG_SYMBOLS_CONVERSION || ILL_FORMED_UNICODE }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      var args = arraySlice(arguments);
      var result = apply(WRONG_SYMBOLS_CONVERSION ? stringifyWithSymbolsFix : $stringify, null, args);
      return ILL_FORMED_UNICODE && typeof result == 'string' ? replace(result, tester, fixIllFormed) : result;
    }
  });
}


/***/ }),

/***/ "d48b":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("6b1d");
var $values = __webpack_require__("6009").values;

// `Object.values` method
// https://tc39.es/ecma262/#sec-object.values
$({ target: 'Object', stat: true }, {
  values: function values(O) {
    return $values(O);
  }
});


/***/ }),

/***/ "d4cb":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("72df");

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),

/***/ "d54f":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_BIND = __webpack_require__("43f8");

var FunctionPrototype = Function.prototype;
var apply = FunctionPrototype.apply;
var call = FunctionPrototype.call;

// eslint-disable-next-line es-x/no-reflect -- safe
module.exports = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND ? call.bind(apply) : function () {
  return call.apply(apply, arguments);
});


/***/ }),

/***/ "d560":
/***/ (function(module, exports) {

/* global Deno -- Deno case */
module.exports = typeof Deno == 'object' && Deno && typeof Deno.version == 'object';


/***/ }),

/***/ "d687":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "d6de":
/***/ (function(module, exports, __webpack_require__) {

// TODO: Remove this module from `core-js@4` since it's split to modules listed below
__webpack_require__("35bc");
__webpack_require__("c503");
__webpack_require__("7637");
__webpack_require__("d331b");
__webpack_require__("4ed6");


/***/ }),

/***/ "d856":
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__("e697");

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),

/***/ "d86f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("6b1d");
var fails = __webpack_require__("72df");
var isArray = __webpack_require__("c6de");
var isObject = __webpack_require__("7526");
var toObject = __webpack_require__("37d1");
var lengthOfArrayLike = __webpack_require__("0481");
var doesNotExceedSafeInteger = __webpack_require__("0dc7");
var createProperty = __webpack_require__("dac6");
var arraySpeciesCreate = __webpack_require__("6a86");
var arrayMethodHasSpeciesSupport = __webpack_require__("189b");
var wellKnownSymbol = __webpack_require__("7d53");
var V8_VERSION = __webpack_require__("4fed");

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$({ target: 'Array', proto: true, arity: 1, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function concat(arg) {
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = lengthOfArrayLike(E);
        doesNotExceedSafeInteger(n + len);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        doesNotExceedSafeInteger(n + 1);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});


/***/ }),

/***/ "d99b":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ "da06":
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__("3cec");
var isCallable = __webpack_require__("3ce8");
var classofRaw = __webpack_require__("6a61");
var wellKnownSymbol = __webpack_require__("7d53");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};


/***/ }),

/***/ "daaf":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("0e19"),
    isObject = __webpack_require__("b5061");

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ "dac6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toPropertyKey = __webpack_require__("feca");
var definePropertyModule = __webpack_require__("abdf");
var createPropertyDescriptor = __webpack_require__("9618");

module.exports = function (object, key, value) {
  var propertyKey = toPropertyKey(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};


/***/ }),

/***/ "dca0":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("201b");

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),

/***/ "dd63":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "FCalendarAddedSummaryDay", function() { return /* reexport */ FCalendarAddedSummaryDay; });
__webpack_require__.d(__webpack_exports__, "FCalendarAddedSummaryMonth", function() { return /* reexport */ FCalendarAddedSummaryMonth; });
__webpack_require__.d(__webpack_exports__, "FCalendarAddedSummary", function() { return /* reexport */ FCalendarAddedSummary; });
__webpack_require__.d(__webpack_exports__, "FCalendar", function() { return /* reexport */ FCalendar; });
__webpack_require__.d(__webpack_exports__, "FCalendarMonthDay", function() { return /* reexport */ FCalendarMonthDay; });
__webpack_require__.d(__webpack_exports__, "FCalendarEditbox", function() { return /* reexport */ FCalendarEditbox; });
__webpack_require__.d(__webpack_exports__, "FCalendarMonth", function() { return /* reexport */ FCalendarMonth; });
__webpack_require__.d(__webpack_exports__, "FCalendarYearMonthItem", function() { return /* reexport */ FCalendarYearMonthItem; });
__webpack_require__.d(__webpack_exports__, "FCalendarMonthWeek", function() { return /* reexport */ FCalendarMonthWeek; });
__webpack_require__.d(__webpack_exports__, "FCalendarYear", function() { return /* reexport */ FCalendarYear; });
__webpack_require__.d(__webpack_exports__, "FCalendarTabPeriod", function() { return /* reexport */ FCalendarTabPeriod; });
__webpack_require__.d(__webpack_exports__, "FCalendarAddedDaysOverview", function() { return /* reexport */ FCalendarAddedDaysOverview; });
__webpack_require__.d(__webpack_exports__, "CDate", function() { return /* reexport */ CDate; });
__webpack_require__.d(__webpack_exports__, "CalendarState", function() { return /* reexport */ CalendarState_CalendarState; });
__webpack_require__.d(__webpack_exports__, "FCalendarComponentOptions", function() { return /* reexport */ FCalendarComponentOptions_FCalendarComponentOptions; });
__webpack_require__.d(__webpack_exports__, "FCheckboxGroupField", function() { return /* reexport */ FCheckboxGroupField; });
__webpack_require__.d(__webpack_exports__, "FCheckboxGroup", function() { return /* reexport */ FCheckboxGroup; });
__webpack_require__.d(__webpack_exports__, "FCrudDataset", function() { return /* reexport */ FCrudDataset; });
__webpack_require__.d(__webpack_exports__, "FCrudButton", function() { return /* reexport */ FCrudButton; });
__webpack_require__.d(__webpack_exports__, "ActivateItemInjected", function() { return /* reexport */ ActivateItemInjected; });
__webpack_require__.d(__webpack_exports__, "FDataTable", function() { return /* reexport */ FDataTable; });
__webpack_require__.d(__webpack_exports__, "FDatepicker", function() { return /* reexport */ FDatepicker; });
__webpack_require__.d(__webpack_exports__, "FDatepickerComponentOptions", function() { return /* reexport */ FDatepickerComponentOptions_FDatepickerComponentOptions; });
__webpack_require__.d(__webpack_exports__, "FErrorList", function() { return /* reexport */ FErrorList; });
__webpack_require__.d(__webpack_exports__, "FExpand", function() { return /* reexport */ FExpand; });
__webpack_require__.d(__webpack_exports__, "FExpandablePanel", function() { return /* reexport */ FExpandablePanel; });
__webpack_require__.d(__webpack_exports__, "FExpandableParagraph", function() { return /* reexport */ FExpandableParagraph; });
__webpack_require__.d(__webpack_exports__, "FFieldset", function() { return /* reexport */ FFieldset; });
__webpack_require__.d(__webpack_exports__, "FFileItem", function() { return /* reexport */ FFileItem; });
__webpack_require__.d(__webpack_exports__, "FFileSelector", function() { return /* reexport */ FFileSelector; });
__webpack_require__.d(__webpack_exports__, "FSortFilterDatasetInjected", function() { return /* reexport */ FSortFilterDatasetInjected; });
__webpack_require__.d(__webpack_exports__, "FSortFilterDataset", function() { return /* reexport */ FSortFilterDataset; });
__webpack_require__.d(__webpack_exports__, "FValidationGroup", function() { return /* reexport */ FValidationGroup; });
__webpack_require__.d(__webpack_exports__, "FForm", function() { return /* reexport */ FForm; });
__webpack_require__.d(__webpack_exports__, "FFormStep", function() { return /* reexport */ FFormStep; });
__webpack_require__.d(__webpack_exports__, "FFormStepButton", function() { return /* reexport */ FFormStepButton; });
__webpack_require__.d(__webpack_exports__, "setRef", function() { return /* reexport */ setRef; });
__webpack_require__.d(__webpack_exports__, "getRef", function() { return /* reexport */ getRef; });
__webpack_require__.d(__webpack_exports__, "setIsOpen", function() { return /* reexport */ setIsOpen; });
__webpack_require__.d(__webpack_exports__, "createFFormProvideOptions", function() { return /* reexport */ createFFormProvideOptions; });
__webpack_require__.d(__webpack_exports__, "cleanUpElements", function() { return /* reexport */ cleanUpElements; });
__webpack_require__.d(__webpack_exports__, "sortComponentsWithErrorsOnDOMOrder", function() { return /* reexport */ sortComponentsWithErrorsOnDOMOrder; });
__webpack_require__.d(__webpack_exports__, "isFormStepReference", function() { return /* reexport */ isFormStepReference; });
__webpack_require__.d(__webpack_exports__, "FIcon", function() { return /* reexport */ FIcon; });
__webpack_require__.d(__webpack_exports__, "FLabel", function() { return /* reexport */ FLabel; });
__webpack_require__.d(__webpack_exports__, "FList", function() { return /* reexport */ FList; });
__webpack_require__.d(__webpack_exports__, "FLoader", function() { return /* reexport */ FLoader; });
__webpack_require__.d(__webpack_exports__, "FMessageBox", function() { return /* reexport */ FMessageBox; });
__webpack_require__.d(__webpack_exports__, "FModal", function() { return /* reexport */ FModal; });
__webpack_require__.d(__webpack_exports__, "FConfirmModal", function() { return /* reexport */ FConfirmModal; });
__webpack_require__.d(__webpack_exports__, "FFormModal", function() { return /* reexport */ FFormModal; });
__webpack_require__.d(__webpack_exports__, "FFormModalAction", function() { return /* reexport */ IValidationFormAction; });
__webpack_require__.d(__webpack_exports__, "FOffline", function() { return /* reexport */ FOffline; });
__webpack_require__.d(__webpack_exports__, "mountFOffline", function() { return /* reexport */ mountFOffline; });
__webpack_require__.d(__webpack_exports__, "FOutputField", function() { return /* reexport */ FOutputField; });
__webpack_require__.d(__webpack_exports__, "FPageHeader", function() { return /* reexport */ FPageHeader; });
__webpack_require__.d(__webpack_exports__, "FProgressbar", function() { return /* reexport */ FProgressbar; });
__webpack_require__.d(__webpack_exports__, "FRadioGroupField", function() { return /* reexport */ FRadioGroupField; });
__webpack_require__.d(__webpack_exports__, "FRadioGroup", function() { return /* reexport */ FRadioGroup; });
__webpack_require__.d(__webpack_exports__, "FSelectField", function() { return /* reexport */ FSelectField; });
__webpack_require__.d(__webpack_exports__, "FStaticField", function() { return /* reexport */ FStaticField; });
__webpack_require__.d(__webpack_exports__, "FInteractiveTable", function() { return /* reexport */ FInteractiveTable; });
__webpack_require__.d(__webpack_exports__, "FTableColumn", function() { return /* reexport */ FTableColumn; });
__webpack_require__.d(__webpack_exports__, "FTextareaField", function() { return /* reexport */ FTextareaField; });
__webpack_require__.d(__webpack_exports__, "FTextField", function() { return /* reexport */ FTextField; });
__webpack_require__.d(__webpack_exports__, "FEmailTextField", function() { return /* reexport */ FEmailTextField; });
__webpack_require__.d(__webpack_exports__, "FPhoneTextField", function() { return /* reexport */ FPhoneTextField; });
__webpack_require__.d(__webpack_exports__, "FCurrencyTextField", function() { return /* reexport */ FCurrencyTextField; });
__webpack_require__.d(__webpack_exports__, "FBankAccountNumberTextField", function() { return /* reexport */ FBankAccountNumberTextField; });
__webpack_require__.d(__webpack_exports__, "FBankgiroTextField", function() { return /* reexport */ FBankgiroTextField; });
__webpack_require__.d(__webpack_exports__, "FClearingnumberTextField", function() { return /* reexport */ FClearingnumberTextField; });
__webpack_require__.d(__webpack_exports__, "FNumericTextField", function() { return /* reexport */ FNumericTextField; });
__webpack_require__.d(__webpack_exports__, "FPersonnummerTextField", function() { return /* reexport */ FPersonnummerTextField; });
__webpack_require__.d(__webpack_exports__, "FPlusgiroTextField", function() { return /* reexport */ FPlusgiroTextField; });
__webpack_require__.d(__webpack_exports__, "FPostalCodeTextField", function() { return /* reexport */ FPostalCodeTextField; });
__webpack_require__.d(__webpack_exports__, "FPercentTextField", function() { return /* reexport */ FPercentTextField; });
__webpack_require__.d(__webpack_exports__, "FOrganisationsnummerTextField", function() { return /* reexport */ FOrganisationsnummerTextField; });
__webpack_require__.d(__webpack_exports__, "FTooltip", function() { return /* reexport */ FTooltip; });
__webpack_require__.d(__webpack_exports__, "FTranslationSelect", function() { return /* reexport */ FTranslationSelect; });
__webpack_require__.d(__webpack_exports__, "FWizard", function() { return /* reexport */ FWizard; });
__webpack_require__.d(__webpack_exports__, "FWizardStep", function() { return /* reexport */ FWizardStep; });
__webpack_require__.d(__webpack_exports__, "FWizardStepAction", function() { return /* reexport */ IValidationFormAction; });
__webpack_require__.d(__webpack_exports__, "FKUIConfigButtonOrder", function() { return /* reexport */ FKUIConfigButtonOrder; });
__webpack_require__.d(__webpack_exports__, "config", function() { return /* reexport */ config_config; });
__webpack_require__.d(__webpack_exports__, "IFlex", function() { return /* reexport */ IFlex; });
__webpack_require__.d(__webpack_exports__, "IFlexItem", function() { return /* reexport */ IFlexItem; });
__webpack_require__.d(__webpack_exports__, "IPopup", function() { return /* reexport */ IPopup; });
__webpack_require__.d(__webpack_exports__, "IMenu", function() { return /* reexport */ IMenu; });
__webpack_require__.d(__webpack_exports__, "IPopupMenu", function() { return /* reexport */ IPopupMenu; });
__webpack_require__.d(__webpack_exports__, "IAnimateExpand", function() { return /* reexport */ IAnimateExpand; });
__webpack_require__.d(__webpack_exports__, "ISkipLink", function() { return /* reexport */ ISkipLink; });
__webpack_require__.d(__webpack_exports__, "IValidationForm", function() { return /* reexport */ IValidationForm; });
__webpack_require__.d(__webpack_exports__, "IValidationFormAction", function() { return /* reexport */ IValidationFormAction; });
__webpack_require__.d(__webpack_exports__, "TestPlugin", function() { return /* reexport */ TestPlugin; });
__webpack_require__.d(__webpack_exports__, "TranslationPlugin", function() { return /* reexport */ TranslationPlugin; });
__webpack_require__.d(__webpack_exports__, "TranslationMixin", function() { return /* reexport */ TranslationMixin; });
__webpack_require__.d(__webpack_exports__, "ValidationPlugin", function() { return /* reexport */ ValidationPlugin; });
__webpack_require__.d(__webpack_exports__, "ErrorPlugin", function() { return /* reexport */ error_ErrorPlugin; });
__webpack_require__.d(__webpack_exports__, "UNHANDLED_ERROR_EVENT", function() { return /* reexport */ UNHANDLED_ERROR_EVENT; });
__webpack_require__.d(__webpack_exports__, "FErrorHandlingApp", function() { return /* reexport */ FErrorHandlingApp; });
__webpack_require__.d(__webpack_exports__, "ErrorData", function() { return /* reexport */ ErrorData; });
__webpack_require__.d(__webpack_exports__, "ErrorViewData", function() { return /* reexport */ ErrorViewData; });
__webpack_require__.d(__webpack_exports__, "FormErrorList", function() { return /* reexport */ FormErrorList; });
__webpack_require__.d(__webpack_exports__, "FormStep", function() { return /* reexport */ FormStep; });
__webpack_require__.d(__webpack_exports__, "hasSlot", function() { return /* reexport */ hasSlot; });
__webpack_require__.d(__webpack_exports__, "renderSlotText", function() { return /* reexport */ renderSlotText; });
__webpack_require__.d(__webpack_exports__, "EventBus", function() { return /* reexport */ EventBus; });
__webpack_require__.d(__webpack_exports__, "itemEquals", function() { return /* reexport */ itemEquals; });
__webpack_require__.d(__webpack_exports__, "includeItem", function() { return /* reexport */ includeItem; });
__webpack_require__.d(__webpack_exports__, "handleKeyboardFocusNavigation", function() { return /* reexport */ handleKeyboardFocusNavigation; });
__webpack_require__.d(__webpack_exports__, "TableScroll", function() { return /* reexport */ TableScroll; });
__webpack_require__.d(__webpack_exports__, "tableScrollClasses", function() { return /* reexport */ tableScrollClasses; });
__webpack_require__.d(__webpack_exports__, "getTextFromScopedSlot", function() { return /* reexport */ getTextFromScopedSlot; });
__webpack_require__.d(__webpack_exports__, "dispatchComponentValidityEvent", function() { return /* reexport */ dispatchComponentValidityEvent; });
__webpack_require__.d(__webpack_exports__, "refIsElement", function() { return /* reexport */ refIsElement; });
__webpack_require__.d(__webpack_exports__, "refIsElementArray", function() { return /* reexport */ refIsElementArray; });
__webpack_require__.d(__webpack_exports__, "refIsHTMLElementArray", function() { return /* reexport */ refIsHTMLElementArray; });
__webpack_require__.d(__webpack_exports__, "refIsVue", function() { return /* reexport */ refIsVue; });
__webpack_require__.d(__webpack_exports__, "refIsVueArray", function() { return /* reexport */ refIsVueArray; });
__webpack_require__.d(__webpack_exports__, "getElementsFromVueRef", function() { return /* reexport */ getElementsFromVueRef; });
__webpack_require__.d(__webpack_exports__, "getHTMLElementsFromVueRef", function() { return /* reexport */ getHTMLElementsFromVueRef; });
__webpack_require__.d(__webpack_exports__, "findElementFromVueRef", function() { return /* reexport */ findElementFromVueRef; });
__webpack_require__.d(__webpack_exports__, "getElementFromVueRef", function() { return /* reexport */ getElementFromVueRef; });
__webpack_require__.d(__webpack_exports__, "getHTMLElementFromVueRef", function() { return /* reexport */ getHTMLElementFromVueRef; });
__webpack_require__.d(__webpack_exports__, "formModal", function() { return /* reexport */ formModal; });
__webpack_require__.d(__webpack_exports__, "ModalReason", function() { return /* reexport */ ModalReason; });
__webpack_require__.d(__webpack_exports__, "openModal", function() { return /* reexport */ openModal; });
__webpack_require__.d(__webpack_exports__, "mountComponent", function() { return /* reexport */ mountComponent; });
__webpack_require__.d(__webpack_exports__, "confirmModal", function() { return /* reexport */ confirmModal; });

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (true) {
    var getCurrentScript = __webpack_require__("405b")
    currentScript = getCurrentScript()

    // for backward compatibility, because previously we directly included the polyfill
    if (!('currentScript' in document)) {
      Object.defineProperty(document, 'currentScript', { get: getCurrentScript })
    }
  }

  var setPublicPath_src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (setPublicPath_src) {
    __webpack_require__.p = setPublicPath_src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FCalendar/FCalendarAddedSummaryDay.vue?vue&type=template&id=539140a4&
var FCalendarAddedSummaryDayvue_type_template_id_539140a4_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
        'calendar__addedday-collapsed': !_vm.expanded,
    }},[_c('div',{staticClass:"calendar__addedday"},[_c('div',{staticClass:"calendar__addedday-date",attrs:{"aria-hidden":String(!_vm.expanded)}},[_c('div',{},[_vm._v(_vm._s(_vm.calendarDate.getDayOfWeek()))]),_vm._v(" "),_c('div',{staticClass:"calendar__addedday-date-day"},[_vm._v(_vm._s(_vm.calendarDate.day))]),_vm._v(" "),_c('div',{},[_vm._v(_vm._s(_vm.monthName))])]),_vm._v(" "),_c('div',{staticClass:"calendar__addedday-content",attrs:{"aria-hidden":String(!_vm.expanded)}},[_c('div',{staticClass:"calendar__addedday-text"},[_vm._t("addedday-data",null,{"collected":_vm.collected,"day":_vm.day})],2),_vm._v(" "),_c('div',{staticClass:"calendar__addedday-buttons"},[(_vm.isRemovable)?_c('button',{staticClass:"button button--discrete",attrs:{"type":"button","aria-label":("Ta bort " + (_vm.calendarDate.getDayOfWeek()) + " " + (_vm.calendarDate.day) + " " + _vm.monthName)},on:{"click":function($event){return _vm.removeSelectedDay(_vm.day)}}},[_c('f-icon',{staticClass:"button__icon",attrs:{"name":"trashcan"}}),_vm._v(" "),_c('span',[_vm._v("Ta bort")])],1):_vm._e(),_vm._v(" "),(_vm.isEditable)?_c('button',{staticClass:"button button--discrete",attrs:{"type":"button","aria-label":("Ändra " + (_vm.calendarDate.getDayOfWeek()) + " " + (_vm.calendarDate.day) + " " + _vm.monthName),"aria-expanded":String(_vm.isEditing)},on:{"click":_vm.editDay}},[_c('f-icon',{staticClass:"button__icon",attrs:{"name":"pen"}}),_vm._v(" "),_c('span',[_vm._v("Ändra")])],1):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"sr-only"},[_vm._v("\n            Valt "+_vm._s(_vm.calendarDate.getDayOfWeek())+" "+_vm._s(_vm.calendarDate.day)+" "+_vm._s(_vm.monthName)+" med:\n            "),_vm._l((_vm.computedDay.collectedData),function(collectedDay,index){return _c('span',{key:index},[_vm._v(_vm._s(collectedDay.id)+" som "+_vm._s(collectedDay.value))])})],2)]),_vm._v(" "),(_vm.isEditing)?_c('f-calendar-editbox',{attrs:{"selected-dates":[_vm.day],"calendar-state":_vm.calendarState},scopedSlots:_vm._u([_vm._l((Object.keys(_vm.$scopedSlots)),function(slot){return {key:slot,fn:function(scope){return [_vm._t(slot,null,null,scope)]}}})],null,true)}):_vm._e()],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/FCalendar/FCalendarAddedSummaryDay.vue?vue&type=template&id=539140a4&

// EXTERNAL MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("ef1f");

// EXTERNAL MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("fa8c");

// EXTERNAL MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("0d9f");

// EXTERNAL MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/core-js/modules/es.object.set-prototype-of.js
var es_object_set_prototype_of = __webpack_require__("2d4c");

// EXTERNAL MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/core-js/modules/es.error.cause.js
var es_error_cause = __webpack_require__("f38f");

// EXTERNAL MODULE: external "@fkui/logic"
var logic_ = __webpack_require__("7bcd");

// CONCATENATED MODULE: ./src/components/FCalendar/types/types.ts



var __extends = undefined && undefined.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();


/** @deprecated Deprecated alias, use ShortDate directly instead */

var CDate =
/** @class */
function (_super) {
  __extends(CDate, _super);

  function CDate() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return CDate;
}(logic_["ShortDate"]);


// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FCalendar/FCalendarEditbox.vue?vue&type=template&id=0cfb4650&
var FCalendarEditboxvue_type_template_id_0cfb4650_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calendar__editbox"},[_c('div',{staticClass:"calendar__editbox-header"},[_vm._v("\n        Valda datum:\n        "),_c('strong',[_vm._v(_vm._s(_vm.selectedDates.length))])]),_vm._v(" "),_c('div',{staticClass:"calendar__editbox-content"},[_vm._t("editbox",null,null,{ onInput: _vm.onInput, onChange: _vm.onChange, collected: _vm.collected, selectedDates: _vm.selectedDates, save: _vm.save, cancel: _vm.cancel, isEditing: _vm.isEditing })],2)])}
var FCalendarEditboxvue_type_template_id_0cfb4650_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/FCalendar/FCalendarEditbox.vue?vue&type=template&id=0cfb4650&

// EXTERNAL MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("f8a5");

// EXTERNAL MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("cfce");

// EXTERNAL MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("2d6d");

// EXTERNAL MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("d86f");

// EXTERNAL MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("841a");

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__("8bbf");
var external_commonjs_vue_commonjs2_vue_root_Vue_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_vue_commonjs2_vue_root_Vue_);

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FCalendar/FCalendarEditbox.vue?vue&type=script&lang=ts&







/* harmony default export */ var FCalendarEditboxvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: "FCalendarEditbox",
  props: {
    selectedDates: {
      required: true,
      type: Array
    },
    calendarState: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      collected: {}
    };
  },
  computed: {
    isEditing: function isEditing() {
      var editMonth = this.calendarState.getEditMonth();
      var editDay = this.calendarState.getEditDay();
      return Object.keys(editMonth || {}).length !== 0 || Object.keys(editDay || {}).length !== 0;
    }
  },
  created: function created() {
    this.populateWithCollectedData();
  },
  methods: {
    // eslint-disable-next-line complexity
    populateWithCollectedData: function populateWithCollectedData() {
      var _a;

      var collectedDatas = this.calendarState.getDatesByDays(this.selectedDates).map(function (selectedDate) {
        return selectedDate.collectedData;
      });

      var knownIds = (_a = []).concat.apply(_a, collectedDatas).map(function (it) {
        return it.id;
      }).filter(function (elem, index, self) {
        return index === self.indexOf(elem);
      });

      var _loop_1 = function _loop_1(name) {
        var collectedDataWithId = this_1.calendarState.getDatesByDays(this_1.selectedDates).map(function (selectedDate) {
          return selectedDate.collectedData.find(function (data) {
            return data.id === name;
          });
        }).filter(function (value) {
          return value !== undefined;
        }) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        .map(function (it) {
          return it.value;
        });

        if (collectedDataWithId.length !== this_1.selectedDates.length) {
          return "continue";
        }

        var allValuesAreEqualAndDefined = collectedDataWithId.every(function (c) {
          return c !== undefined && collectedDataWithId[0] !== undefined && c === collectedDataWithId[0];
        });

        if (allValuesAreEqualAndDefined && collectedDataWithId && collectedDataWithId[0]) {
          this_1.collected[name] = collectedDataWithId[0];
        } else {
          this_1.collected[name] = "";
        }
      };

      var this_1 = this;

      for (var _i = 0, knownIds_1 = knownIds; _i < knownIds_1.length; _i++) {
        var name = knownIds_1[_i];

        _loop_1(name);
      }
    },
    onInput: function onInput(prop, event) {
      if (typeof event === "string") {
        this.collected[prop] = event;
      }
    },
    onChange: function onChange(prop, event) {
      if (typeof event === "string") {
        this.collected[prop] = event;
      }
    },
    save: function save() {
      var collectedData = [];

      for (var _i = 0, _a = Object.keys(this.collected); _i < _a.length; _i++) {
        var given = _a[_i];
        collectedData.push({
          id: given,
          value: this.collected[given]
        });
      }

      for (var _b = 0, _c = this.selectedDates; _b < _c.length; _b++) {
        var selectedDate = _c[_b];
        this.calendarState.removeDay(selectedDate);
        this.calendarState.saveDay(selectedDate, {
          selected: false,
          added: true,
          collectedData: collectedData
        });
      }

      this.calendarState.saveEditMonth(undefined);
      this.calendarState.saveEditDay(undefined);
      this.$emit("editbox-saved", this.selectedDates);
    },
    cancel: function cancel() {
      this.calendarState.unselectAll();
      this.calendarState.saveEditMonth(undefined);
      this.calendarState.saveEditDay(undefined);
      this.$emit("editbox-cancelled", this.selectedDates);
    }
  }
}));
// CONCATENATED MODULE: ./src/components/FCalendar/FCalendarEditbox.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FCalendar_FCalendarEditboxvue_type_script_lang_ts_ = (FCalendarEditboxvue_type_script_lang_ts_); 
// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
        injectStyles.call(
          this,
          (options.functional ? this.parent : this).$root.$options.shadowRoot
        )
      }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// CONCATENATED MODULE: ./src/components/FCalendar/FCalendarEditbox.vue





/* normalize component */

var FCalendarEditbox_component = normalizeComponent(
  FCalendar_FCalendarEditboxvue_type_script_lang_ts_,
  FCalendarEditboxvue_type_template_id_0cfb4650_render,
  FCalendarEditboxvue_type_template_id_0cfb4650_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FCalendarEditbox = (FCalendarEditbox_component.exports);
// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FIcon/FIcon.vue?vue&type=template&id=1157d763&
var FIconvue_type_template_id_1157d763_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g(_vm._b({staticClass:"icon",class:[_vm.spriteKey ].concat( _vm.modifiers),attrs:{"focusable":"false"}},'svg',_vm.attrs,false),_vm.$listeners),[_vm._t("default"),_vm._v(" "),_c('use',{attrs:{"xlink:href":_vm.spriteId}})],2)}
var FIconvue_type_template_id_1157d763_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/FIcon/FIcon.vue?vue&type=template&id=1157d763&

// EXTERNAL MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/core-js/modules/es.object.assign.js
var es_object_assign = __webpack_require__("2007");

// EXTERNAL MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("8d0d");

// EXTERNAL MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("868d");

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FIcon/FIcon.vue?vue&type=script&lang=ts&





var __assign = undefined && undefined.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};


var Flip = ["horizontal", "vertical"];
var Rotate = ["90", "180", "270"];
/**
 * Level: Beta
 */

/* harmony default export */ var FIconvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: "FIcon",
  inheritAttrs: false,
  props: {
    /**
     * Icon name.
     */
    name: {
      type: String,
      required: true
    },

    /**
     * fk-icon library
     */
    library: {
      type: String,
      required: false,
      default: "f"
    },

    /**
     * Flip icon horizontally or vertically.
     *
     * Must be set to one of:
     *
     * - `horizontal`
     * - `vertical`
     */
    flip: {
      type: String,
      default: null,
      required: false,
      validator: function validator(value) {
        return Flip.includes(value);
      }
    },

    /**
     * Rotate icon.
     *
     * Must be set to one of:
     *
     * - `90`
     * - `180`
     * - `270`
     */
    rotate: {
      type: String,
      default: null,
      required: false,
      validator: function validator(value) {
        return Rotate.includes(value);
      }
    }
  },
  computed: {
    attrs: function attrs() {
      return __assign({}, this.$attrs);
    },
    spriteKey: function spriteKey() {
      return "".concat(this.library, "-icon-").concat(this.name);
    },
    spriteId: function spriteId() {
      return "#".concat(this.spriteKey);
    },
    modifiers: function modifiers() {
      var classes = [];

      if (this.flip) {
        classes.push("icon--flip-".concat(this.flip));
      }

      if (this.rotate) {
        classes.push("icon--rotate-".concat(this.rotate));
      }

      return classes;
    }
  }
}));
// CONCATENATED MODULE: ./src/components/FIcon/FIcon.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FIcon_FIconvue_type_script_lang_ts_ = (FIconvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FIcon/FIcon.vue





/* normalize component */

var FIcon_component = normalizeComponent(
  FIcon_FIconvue_type_script_lang_ts_,
  FIconvue_type_template_id_1157d763_render,
  FIconvue_type_template_id_1157d763_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FIcon = (FIcon_component.exports);
// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FCalendar/FCalendarAddedSummaryDay.vue?vue&type=script&lang=ts&








/* harmony default export */ var FCalendarAddedSummaryDayvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: "FCalendarAddedSummaryDay",
  components: {
    FCalendarEditbox: FCalendarEditbox,
    FIcon: FIcon
  },
  props: {
    confirmRemoveDay: {
      type: Function,
      required: true
    },
    day: {
      type: String,
      required: true
    },
    expanded: {
      type: Boolean,
      required: true
    },
    calendarState: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      MONTHNAMES_LONG: logic_["MONTHNAMES_LONG"]
    };
  },
  computed: {
    calendarDate: function calendarDate() {
      return CDate.fromString(this.day);
    },
    computedDay: function computedDay() {
      return this.calendarState.getDays()[this.day];
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    collected: function collected() {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      var collected = {}; // eslint-disable-next-line @typescript-eslint/no-explicit-any

      this.calendarState.getDays()[this.day].collectedData.forEach(function (key) {
        collected[key.id] = key.value;
      });
      return collected;
    },
    isEditable: function isEditable() {
      return !(this.computedDay.controls && this.computedDay.controls.editable === false);
    },
    isRemovable: function isRemovable() {
      return !(this.computedDay.controls && this.computedDay.controls.removable === false);
    },
    isEditing: function isEditing() {
      return this.calendarState.getEditDay() !== undefined && this.calendarState.getEditDay() === this.day;
    },
    monthName: function monthName() {
      return this.MONTHNAMES_LONG[CDate.fromString(this.day).getMonth() - 1];
    }
  },
  methods: {
    removeSelectedDay: function removeSelectedDay() {
      var _this = this;

      this.confirmRemoveDay().then(function () {
        _this.calendarState.removeDay(_this.day);

        _this.$emit("day-removed", _this.day);
      }).catch(function () {
        /* Rejected - do nothing */
      });
    },
    editDay: function editDay() {
      this.calendarState.unselectAll();
      /**
       * Toggle edit day
       */

      this.isEditing ? this.calendarState.saveEditDay(undefined) : this.calendarState.saveEditDay(this.day);
      this.calendarState.saveEditMonth(undefined);

      if (this.isEditing) {
        this.$emit("edit-days-pre-opened", [this.calendarDate.toString()]);
      }
    }
  }
}));
// CONCATENATED MODULE: ./src/components/FCalendar/FCalendarAddedSummaryDay.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FCalendar_FCalendarAddedSummaryDayvue_type_script_lang_ts_ = (FCalendarAddedSummaryDayvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FCalendar/FCalendarAddedSummaryDay.vue





/* normalize component */

var FCalendarAddedSummaryDay_component = normalizeComponent(
  FCalendar_FCalendarAddedSummaryDayvue_type_script_lang_ts_,
  FCalendarAddedSummaryDayvue_type_template_id_539140a4_render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FCalendarAddedSummaryDay = (FCalendarAddedSummaryDay_component.exports);
// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FCalendar/FCalendarAddedSummaryMonth.vue?vue&type=template&id=48d2a675&
var FCalendarAddedSummaryMonthvue_type_template_id_48d2a675_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calendar__addedmonth",class:{ 'calendar__addedmonth--collapsed': !_vm.expanded }},[_c('span',{staticClass:"calendar__addedmonth-header"},[_c('button',{staticClass:"calendar__addedmonth-header-expand",attrs:{"type":"button","aria-expanded":String(_vm.expanded)},on:{"click":_vm.expand}},[_c('span',{staticClass:"calendar__addedmonth-header-expand-icon"}),_vm._v(" "),_c('span',{staticClass:"calendar__addedmonth-header-expand-text"},[_c('span',[_vm._v("\n                    "+_vm._s(_vm.MONTHNAMES_LONG[_vm.calendarDate.getMonth() - 1])+"\n                    "+_vm._s(_vm.calendarDate.year)+"\n                ")]),_vm._v(" "),_c('span',{staticClass:"calendar__addedmonth-header-expand-days"},[_vm._v(_vm._s(_vm.computedDays.length)+" datum")])])]),_vm._v(" "),_c('button',{staticClass:"button button--discrete calendar__addedmonth-header-edit",attrs:{"type":"button","aria-label":("Ändra alla i " + (_vm.MONTHNAMES_LONG[_vm.calendarDate.getMonth() - 1]) + " " + (_vm.calendarDate.year)),"aria-expanded":String(_vm.isEditing)},on:{"click":_vm.editMonth}},[_c('f-icon',{staticClass:"button__icon",attrs:{"name":"pen"}}),_vm._v(" "),_c('span',[_vm._v("Ändra alla")])],1)]),_vm._v(" "),(_vm.isEditing)?_c('f-calendar-editbox',{attrs:{"selected-dates":_vm.computedDays,"calendar-state":_vm.calendarState},scopedSlots:_vm._u([_vm._l((Object.keys(_vm.$scopedSlots)),function(slot){return {key:slot,fn:function(scope){return [_vm._t(slot,null,null,scope)]}}})],null,true)}):_vm._e(),_vm._v(" "),(_vm.expanded)?_c('div',{staticClass:"calendar__addedmonth-collapsable"},_vm._l((_vm.computedDays),function(day,index){return _c('f-calendar-added-summary-day',{key:index,attrs:{"day":day,"expanded":_vm.expanded,"calendar-state":_vm.calendarState,"confirm-remove-day":_vm.confirmRemoveDay},on:{"day-removed":_vm.onDayRemoved,"edit-days-pre-opened":_vm.onEditDaysPreOpened},scopedSlots:_vm._u([_vm._l((Object.keys(_vm.$scopedSlots)),function(slot){return {key:slot,fn:function(scope){return [_vm._t(slot,null,null,scope)]}}})],null,true)})}),1):_vm._e()],1)}
var FCalendarAddedSummaryMonthvue_type_template_id_48d2a675_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/FCalendar/FCalendarAddedSummaryMonth.vue?vue&type=template&id=48d2a675&

// CONCATENATED MODULE: ./src/components/FIcon/index.ts

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FCalendar/FCalendarAddedSummaryMonth.vue?vue&type=script&lang=ts&






/* harmony default export */ var FCalendarAddedSummaryMonthvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: "FCalendarAddedSummaryMonth",
  components: {
    FCalendarAddedSummaryDay: FCalendarAddedSummaryDay,
    FCalendarEditbox: FCalendarEditbox,
    FIcon: FIcon
  },
  props: {
    days: {
      type: Array,
      required: true
    },
    calendarState: {
      type: Object,
      required: true
    },
    confirmRemoveDay: {
      type: Function,
      required: true
    }
  },
  data: function data() {
    return {
      expanded: false,
      MONTHNAMES_LONG: logic_["MONTHNAMES_LONG"],
      calendarDate: CDate.fromString(this.days[0])
    };
  },
  computed: {
    computedDays: function computedDays() {
      return this.days;
    },
    isEditing: function isEditing() {
      var editMonth = this.calendarState.getEditMonth();
      return editMonth !== undefined && editMonth.year === this.calendarDate.getYear() && editMonth.month === this.calendarDate.getMonth();
    }
  },
  methods: {
    expand: function expand() {
      this.expanded = !this.expanded;
      this.calendarState.saveEditDay(undefined);
      this.calendarState.saveEditMonth(undefined);
    },
    editMonth: function editMonth() {
      if (this.expanded) {
        this.expand();
      }

      this.calendarState.unselectAll();
      var month = {
        year: this.calendarDate.getYear(),
        month: this.calendarDate.getMonth()
      };
      this.calendarState.saveEditDay(undefined);
      /**
       * Toggle edit month
       */

      this.isEditing ? this.calendarState.saveEditMonth(undefined) : this.calendarState.saveEditMonth(month);

      if (this.isEditing) {
        this.$emit("edit-days-pre-opened", this.days);
      }
    },
    onDayRemoved: function onDayRemoved(day) {
      this.$emit("day-removed", day);
    },
    onEditDaysPreOpened: function onEditDaysPreOpened(days) {
      this.$emit("edit-days-pre-opened", days);
    }
  }
}));
// CONCATENATED MODULE: ./src/components/FCalendar/FCalendarAddedSummaryMonth.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FCalendar_FCalendarAddedSummaryMonthvue_type_script_lang_ts_ = (FCalendarAddedSummaryMonthvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FCalendar/FCalendarAddedSummaryMonth.vue





/* normalize component */

var FCalendarAddedSummaryMonth_component = normalizeComponent(
  FCalendar_FCalendarAddedSummaryMonthvue_type_script_lang_ts_,
  FCalendarAddedSummaryMonthvue_type_template_id_48d2a675_render,
  FCalendarAddedSummaryMonthvue_type_template_id_48d2a675_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FCalendarAddedSummaryMonth = (FCalendarAddedSummaryMonth_component.exports);
// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FCalendar/FCalendarAddedSummary.vue?vue&type=template&id=63026631&
var FCalendarAddedSummaryvue_type_template_id_63026631_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calendar__addedsummary"},[_c('div',{staticClass:"calendar__addedmonth-wrapper"},_vm._l((_vm.addedMonths()),function(value,key){return _c('f-calendar-added-summary-month',{key:key,attrs:{"days":value,"calendar-state":_vm.calendarState,"confirm-remove-day":_vm.confirmRemoveDay},on:{"day-removed":_vm.onDayRemoved,"edit-days-pre-opened":_vm.onEditDaysPreOpened},scopedSlots:_vm._u([_vm._l((Object.keys(_vm.$scopedSlots)),function(slot){return {key:slot,fn:function(scope){return [_vm._t(slot,null,null,scope)]}}})],null,true)})}),1)])}
var FCalendarAddedSummaryvue_type_template_id_63026631_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/FCalendar/FCalendarAddedSummary.vue?vue&type=template&id=63026631&

// EXTERNAL MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/core-js/modules/es.array.sort.js
var es_array_sort = __webpack_require__("b506");

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FCalendar/FCalendarAddedSummary.vue?vue&type=script&lang=ts&





/* harmony default export */ var FCalendarAddedSummaryvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: "FCalendarAddedSummary",
  components: {
    FCalendarAddedSummaryMonth: FCalendarAddedSummaryMonth
  },
  props: {
    calendarState: {
      type: Object,
      required: true
    },
    confirmRemoveDay: {
      type: Function,
      required: true
    }
  },
  computed: {
    addedDays: function addedDays() {
      return this.calendarState.getIncludedAddedDays();
    }
  },
  methods: {
    addedMonths: function addedMonths() {
      var months = {};

      for (var _i = 0, _a = this.addedDays; _i < _a.length; _i++) {
        var day = _a[_i];
        var calendarDate = CDate.fromString(day);
        var key = "y".concat(calendarDate.getYear(), "-m").concat(calendarDate.getMonth());

        if (!months[key]) {
          months[key] = [];
        }

        months[key].push(day);
        months[key].sort();
      }

      return months;
    },
    onDayRemoved: function onDayRemoved(day) {
      this.$emit("day-removed", day);
    },
    onEditDaysPreOpened: function onEditDaysPreOpened(days) {
      this.$emit("edit-days-pre-opened", days);
    }
  }
}));
// CONCATENATED MODULE: ./src/components/FCalendar/FCalendarAddedSummary.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FCalendar_FCalendarAddedSummaryvue_type_script_lang_ts_ = (FCalendarAddedSummaryvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FCalendar/FCalendarAddedSummary.vue





/* normalize component */

var FCalendarAddedSummary_component = normalizeComponent(
  FCalendar_FCalendarAddedSummaryvue_type_script_lang_ts_,
  FCalendarAddedSummaryvue_type_template_id_63026631_render,
  FCalendarAddedSummaryvue_type_template_id_63026631_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FCalendarAddedSummary = (FCalendarAddedSummary_component.exports);
// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FCalendar/FCalendar.vue?vue&type=template&id=edb46850&
var FCalendarvue_type_template_id_edb46850_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"calendar",staticClass:"calendar",class:{ 'calendar--hide-tabs': !_vm.options.showPlanning },attrs:{"id":_vm.id}},[_c('div',{staticClass:"calendar__container"},[_c('span',{staticClass:"sr-only"},[_vm._v("Kalender välj dagar")]),_vm._v(" "),(_vm.options.showPlanning)?_c('ul',{staticClass:"calendar__tabs",attrs:{"aria-label":"Välj en flik"}},[_c('li',{attrs:{"aria-current":_vm.value.isPlanning() == false}},[_c('button',{staticClass:"calendar__tabs-tab calendar__tabs-tab--left",class:_vm.value.isPlanning() ? '' : 'calendar__tabs-tab--selected',attrs:{"type":"button","aria-label":"Välj datum"},on:{"click":function($event){return _vm.onClickPlanningHide()}}},[_c('f-icon',{staticClass:"button__icon",attrs:{"name":"calendar"}}),_vm._v(" "),_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("Välj datum")])],1)]),_vm._v(" "),_c('li',{attrs:{"aria-current":_vm.value.isPlanning() == true}},[_c('button',{staticClass:"calendar__tabs-tab calendar__tabs-tab--right",class:_vm.value.isPlanning() ? 'calendar__tabs-tab--selected' : '',attrs:{"type":"button","aria-label":"Välj en längre period"},on:{"click":function($event){return _vm.onClickPlanningShow()}}},[_c('f-icon',{staticClass:"button__icon",attrs:{"name":"calendar-add"}}),_vm._v(" "),_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("Välj en längre period")])],1)])]):_vm._e(),_vm._v(" "),(_vm.options.showPlanning && _vm.value.isPlanning())?_c('f-calendar-tab-period',{attrs:{"calendar-state":_vm.data,"options":_vm.options},on:{"period-selected":_vm.onPeriodSelected},scopedSlots:_vm._u([_vm._l((Object.keys(_vm.$scopedSlots)),function(slot){return {key:slot,fn:function(scope){return [_vm._t(slot,null,null,scope)]}}})],null,true)}):_vm._e(),_vm._v(" "),_c('f-calendar-tab-main',{directives:[{name:"show",rawName:"v-show",value:(!_vm.value.isPlanning()),expression:"!value.isPlanning()"}],ref:"fcalendartabmain",attrs:{"calendar-state":_vm.data,"options":_vm.options},on:{"day-selected":_vm.onDaySelected,"day-unselected":_vm.onDayUnselected,"day-removed":_vm.onDayRemoved,"disabled-day-requested":_vm.onDisabledDayRequested,"year-navigation":_vm.onYearNavigation,"month-navigation":_vm.onMonthNavigation}})],1),_vm._v(" "),_vm._t("message",null,null,{ selectedDisabledDate: _vm.selectedDisabledDate }),_vm._v(" "),(_vm.showEditBox)?_c('f-calendar-editbox',{key:'editbox-' + _vm.selectedDays.length,attrs:{"selected-dates":_vm.selectedDays,"calendar-state":_vm.data},on:{"editbox-saved":_vm.onEditboxSaved,"editbox-cancelled":_vm.onEditboxCancelled},scopedSlots:_vm._u([_vm._l((Object.keys(_vm.$scopedSlots)),function(slot){return {key:slot,fn:function(scope){return [_vm._t(slot,null,null,scope)]}}})],null,true)}):_vm._e(),_vm._v(" "),(_vm.hasAddedDays)?_c('f-calendar-added-summary',{attrs:{"calendar-state":_vm.data,"confirm-remove-day":_vm.confirmRemoveDay},on:{"day-removed":_vm.onDayRemoved,"edit-days-pre-opened":_vm.onEditDaysPreOpened},scopedSlots:_vm._u([_vm._l((Object.keys(_vm.$scopedSlots)),function(slot){return {key:slot,fn:function(scope){return [_vm._t(slot,null,null,scope)]}}})],null,true)}):_vm._e()],2)}
var FCalendarvue_type_template_id_edb46850_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/FCalendar/FCalendar.vue?vue&type=template&id=edb46850&

// EXTERNAL MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__("26d3");

// EXTERNAL MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("d6de");

// EXTERNAL MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("8d0f");

// EXTERNAL MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__("68b8");

// EXTERNAL MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__("9531");

// EXTERNAL MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__("f3b8");

// EXTERNAL MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__("918c");

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FCalendar/FCalendarTabPeriod.vue?vue&type=template&id=36f71926&
var FCalendarTabPeriodvue_type_template_id_36f71926_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calendar__period"},[_c('f-datepicker',{directives:[{name:"validation",rawName:"v-validation.required.date",modifiers:{"required":true,"date":true}}],staticClass:"calendar__period-fromdate",attrs:{"e2e-id":"period-from","options":_vm.fromDatepickerOptions},on:{"component-validity":function($event){_vm.onComponentValidity($event);
            _vm.updateToDatepickerOptions($event);}},model:{value:(_vm.fromDate),callback:function ($$v) {_vm.fromDate=$$v},expression:"fromDate"}},[_vm._v(_vm._s(_vm.$t("fkuiCalenderTabPeriodSelectFromDate", "Från och med")))]),_vm._v(" "),_c('f-datepicker',{directives:[{name:"validation",rawName:"v-validation.required.date",modifiers:{"required":true,"date":true}}],staticClass:"calendar__period-todate",attrs:{"e2e-id":"period-to","options":_vm.toDatepickerOptions},on:{"component-validity":_vm.onComponentValidity},model:{value:(_vm.toDate),callback:function ($$v) {_vm.toDate=$$v},expression:"toDate"}},[_vm._v(_vm._s(_vm.$t("fkuiCalenderTabPeriodSelectToDate", "Till och med")))]),_vm._v(" "),(_vm.startAfterEnd)?_c('span',{staticClass:"label__message label__message--error"},[_vm._v("\n        "+_vm._s(_vm.$t(
                "fkuiCalenderTabPeriodSelectToDateBeforeFromDate",
                "Datumet måste vara senare än från och med-datumet. Välj ett senare datum."
            ))+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.options.planningWeekdays)?_c('f-checkbox-group',{directives:[{name:"validation",rawName:"v-validation.required",value:({
            required: {
                errorMessage: _vm.$t('fkuiCalenderTabPeriodSelectAtleastOneDay', 'Välj minst en veckodag.'),
            },
        }),expression:"{\n            required: {\n                errorMessage: $t('fkuiCalenderTabPeriodSelectAtleastOneDay', 'Välj minst en veckodag.'),\n            },\n        }",modifiers:{"required":true}}],attrs:{"e2e-id":"weekday-selection","name":"f-calendar-checkbox-group"},on:{"change":_vm.onChange},scopedSlots:_vm._u([{key:"label",fn:function(){return [_vm._v(_vm._s(_vm.$t("fkuiCalenderTabPeriodSelectDays", "Välj veckodagar")))]},proxy:true}],null,false,1144066184)},[_vm._v(" "),_c('f-checkbox-group-field',{directives:[{name:"test",rawName:"v-test",value:('all-weekdays-input'),expression:"'all-weekdays-input'"}],attrs:{"name":"selectAll","value":true},on:{"change":_vm.onSelectAllChange},model:{value:(_vm.selectAll),callback:function ($$v) {_vm.selectAll=$$v},expression:"selectAll"}},[_vm._v("\n            "+_vm._s(_vm.$t("fkuiCalenderTabPeriodAllDays", "Alla dagar"))+"\n        ")]),_vm._v(" "),_c('div',{directives:[{name:"test",rawName:"v-test",value:('weekdays-wrapper'),expression:"'weekdays-wrapper'"}]},_vm._l((_vm.WEEKDAYS_LONG),function(day,dayIndex){return _c('f-checkbox-group-field',{key:dayIndex,attrs:{"value":dayIndex + 1},on:{"change":function ($value) { return _vm.onWeekdayChange($value, dayIndex + 1); }},model:{value:(_vm.weekdays),callback:function ($$v) {_vm.weekdays=$$v},expression:"weekdays"}},[_vm._v(_vm._s(_vm._f("capitalize")(day))+"\n            ")])}),1)],1):_vm._e(),_vm._v(" "),(_vm.options.planningWeeklyRecurrence)?_c('f-select-field',{directives:[{name:"validation",rawName:"v-validation.required",value:({
            required: {
                errorMessage: _vm.$t(
                    'fkuiCalenderTabPeriodSelectWeeklyRecurrence',
                    'Välj hur ofta ditt val ska upprepas.'
                ),
            },
        }),expression:"{\n            required: {\n                errorMessage: $t(\n                    'fkuiCalenderTabPeriodSelectWeeklyRecurrence',\n                    'Välj hur ofta ditt val ska upprepas.',\n                ),\n            },\n        }",modifiers:{"required":true}},{name:"test",rawName:"v-test",value:('weekly-recurrence'),expression:"'weekly-recurrence'"}],attrs:{"input-type":"number"},on:{"component-validity":_vm.onComponentValidity},scopedSlots:_vm._u([{key:"label",fn:function(){return [_vm._v(_vm._s(_vm.$t("fkuiCalenderTabPeriodRepeat", "Upprepa")))]},proxy:true}],null,false,3310886906),model:{value:(_vm.weeklyRecurrence),callback:function ($$v) {_vm.weeklyRecurrence=$$v},expression:"weeklyRecurrence"}},[_vm._v(" "),_c('option',{domProps:{"value":undefined}},[_vm._v("\n            "+_vm._s(_vm.$t("fkuiCalenderTabPeriodSelectRecurrence", "Välj hur ofta..."))+"\n        ")]),_vm._v(" "),_c('option',{domProps:{"value":_vm.WeeklyRecurrence.EVERY}},[_vm._v("\n            "+_vm._s(_vm.$t("fkuiCalenderTabPeriodEveryWeek", "Varje vecka"))+"\n        ")]),_vm._v(" "),_c('option',{domProps:{"value":_vm.WeeklyRecurrence.EVERY_OTHER}},[_vm._v("\n            "+_vm._s(_vm.$t("fkuiCalenderTabPeriodEveryOtherWeek", "Varannan vecka"))+"\n        ")]),_vm._v(" "),_c('option',{domProps:{"value":_vm.WeeklyRecurrence.EVERY_THIRD}},[_vm._v("\n            "+_vm._s(_vm.$t("fkuiCalenderTabPeriodEveryThirdWeek", "Var tredje vecka"))+"\n        ")]),_vm._v(" "),_c('option',{domProps:{"value":_vm.WeeklyRecurrence.EVERY_FOURTH}},[_vm._v("\n            "+_vm._s(_vm.$t("fkuiCalenderTabPeriodEveryFourthWeek", "Var fjärde vecka"))+"\n        ")])]):_vm._e()],1)}
var FCalendarTabPeriodvue_type_template_id_36f71926_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/FCalendar/FCalendarTabPeriod.vue?vue&type=template&id=36f71926&

// EXTERNAL MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("33ef");

// EXTERNAL MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("c78b");

// EXTERNAL MODULE: external "moment"
var external_moment_ = __webpack_require__("c32d");
var external_moment_default = /*#__PURE__*/__webpack_require__.n(external_moment_);

// EXTERNAL MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/core-js/modules/es.object.entries.js
var es_object_entries = __webpack_require__("6559");

// EXTERNAL MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/core-js/modules/es.object.values.js
var es_object_values = __webpack_require__("d48b");

// CONCATENATED MODULE: ./src/components/FCalendar/types/CalendarState.ts













var CalendarState_CalendarState =
/** @class */
function () {
  function CalendarState(days) {
    this.days = {};
    this.planning = false;
    this.days = days || {};
    this.editDay = undefined;
    this.editMonth = undefined;
    this.focusedDay = 1;
    this.focusedMonth = 1;
    this.selectedDisabledDate = undefined;
    this.currentYear = external_moment_default()().year();
    this.currentMonth = external_moment_default()().month() + 1;
  }

  CalendarState.prototype.getCurrentDateInView = function () {
    return new CDate(this.currentYear, this.currentMonth, this.focusedDay);
  };

  CalendarState.prototype.getFocusedMonth = function () {
    return this.focusedMonth;
  };

  CalendarState.prototype.setFocusedMonth = function (focusedMonth) {
    this.focusedMonth = focusedMonth;
  };

  CalendarState.prototype.getFocusedDay = function () {
    return this.focusedDay;
  };

  CalendarState.prototype.setFocusedDay = function (focusedDay) {
    this.focusedDay = focusedDay;
  };

  CalendarState.prototype.getSelectedDisabledDate = function () {
    return this.selectedDisabledDate;
  };

  CalendarState.prototype.setSelectedDisabledDate = function (value) {
    this.selectedDisabledDate = value;
  };

  CalendarState.prototype.saveDay = function (day, data) {
    external_commonjs_vue_commonjs2_vue_root_Vue_default.a.set(this.days, CDate.verifyDateString(day), data);
  };

  CalendarState.prototype.removeDay = function (date) {
    external_commonjs_vue_commonjs2_vue_root_Vue_default.a.delete(this.days, CDate.verifyDateString(date));
  };

  CalendarState.prototype.getDatesByDays = function (days) {
    return Object.entries(this.days).filter(function (e) {
      return days.indexOf(e[0]) !== -1;
    }).map(function (e) {
      return e[1];
    });
  };

  CalendarState.prototype.getDays = function () {
    return this.days;
  };

  CalendarState.prototype.getDay = function (day) {
    return this.days[day];
  };

  CalendarState.prototype.unselectAll = function () {
    for (var date in this.days) {
      this.days[date].selected = false;
    }
  };

  CalendarState.prototype.saveEditDay = function (day) {
    this.editDay = day;
  };

  CalendarState.prototype.getEditDay = function () {
    return this.editDay;
  };

  CalendarState.prototype.saveEditMonth = function (month) {
    this.editMonth = month;
  };

  CalendarState.prototype.getEditMonth = function () {
    return this.editMonth;
  };

  CalendarState.prototype.hasAddedDays = function () {
    return this.getAddedDates().length > 0;
  };

  CalendarState.prototype.hasSelectedDays = function () {
    return this.getSelectedDates().length > 0;
  };

  CalendarState.prototype.getSelectedDates = function () {
    return Object.values(this.days).filter(function (it) {
      return it.selected;
    });
  };

  CalendarState.prototype.setSelectedDays = function (toSelect) {
    var _this = this; //Select included but not selected


    Object.entries(this.days).filter(function (e) {
      return toSelect.indexOf(e[0]) !== -1 && !e[1].selected;
    }).forEach(function (it) {
      external_commonjs_vue_commonjs2_vue_root_Vue_default.a.set(_this.days, it[0], Object.assign(it[1], {
        selected: true
      }));
    }); //Unselect not included

    Object.entries(this.days).filter(function (e) {
      return toSelect.indexOf(e[0]) === -1;
    }).forEach(function (it) {
      external_commonjs_vue_commonjs2_vue_root_Vue_default.a.set(_this.days, it[0], Object.assign(it[1], {
        selected: false
      }));
    }); //Set new dates as selected

    toSelect.filter(function (it) {
      return Object.keys(_this.days).indexOf(it) === -1;
    }).forEach(function (it) {
      external_commonjs_vue_commonjs2_vue_root_Vue_default.a.set(_this.days, it, {
        selected: true,
        added: false,
        collectedData: []
      });
    });
  };

  CalendarState.prototype.getSelectedDays = function () {
    return Object.entries(this.days).filter(function (it) {
      return it[1].selected;
    }).map(function (it) {
      return it[0];
    });
  };

  CalendarState.prototype.getAddedDates = function () {
    return Object.values(this.days).filter(function (it) {
      return it.added;
    });
  };

  CalendarState.prototype.getIncludedAddedDays = function () {
    return Object.entries(this.days).filter(function (it) {
      return it[1].added && !it[1].excluded;
    }).map(function (it) {
      return it[0];
    }).sort();
  };

  CalendarState.prototype.setPlanning = function (planning) {
    this.planning = planning;
  };

  CalendarState.prototype.isPlanning = function () {
    return this.planning;
  };

  return CalendarState;
}();


// CONCATENATED MODULE: ./src/components/FCalendar/types/FCalendarComponentOptions.ts



var FCalendarComponentOptions_FCalendarComponentOptions =
/** @class */
function () {
  function FCalendarComponentOptions(attributes) {
    this.initialYear = CDate.today().getYear();
    this.initialMonth = CDate.today().getMonth();
    this.initialFocusedDay = undefined;
    this.firstAvailableDate = "";
    this.lastAvailableDate = "";
    this.disabledDates = [];
    this.disabledWeekDays = [];
    this.showWeekNumbers = true;
    this.showPlanning = true;
    this.planningWeekdays = false;
    this.planningWeeklyRecurrence = false;
    this.today = "";
    this.showNavigationBar = true;
    Object.assign(this, attributes || {});
  }

  return FCalendarComponentOptions;
}();


// CONCATENATED MODULE: ./src/components/FCalendar/types/index.ts



// CONCATENATED MODULE: ./src/components/FDatepicker/types/FDatepickerComponentOptions.ts




var FDatepickerComponentOptions_extends = undefined && undefined.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var FDatepickerComponentOptions_assign = undefined && undefined.__assign || function () {
  FDatepickerComponentOptions_assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return FDatepickerComponentOptions_assign.apply(this, arguments);
};



var FDatepickerComponentOptions_FDatepickerComponentOptions =
/** @class */
function (_super) {
  FDatepickerComponentOptions_extends(FDatepickerComponentOptions, _super);

  function FDatepickerComponentOptions(attributes) {
    var _this = _super.call(this, FDatepickerComponentOptions_assign(FDatepickerComponentOptions_assign({}, attributes), {
      initialFocusedDay: CDate.today().getDay()
    })) || this;

    Object.assign(_this, attributes || {});
    return _this;
  }

  return FDatepickerComponentOptions;
}(FCalendarComponentOptions_FCalendarComponentOptions);


// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FDatepicker/FDatepicker.vue?vue&type=template&id=35ae5700&
var FDatepickervue_type_template_id_35ae5700_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"datepicker"},[_c('div',{staticClass:"datepicker__select"},[_c('f-text-field',_vm._g(_vm._b({directives:[{name:"validation",rawName:"v-validation.date.disabledDates",value:(_vm.validationConfig),expression:"validationConfig",modifiers:{"date":true,"disabledDates":true}}],attrs:{"formatter":_vm.dateFormatter,"name":"datepicker-date","maxlength":"20","disabled":_vm.disabled},scopedSlots:_vm._u([{key:"tooltip",fn:function(){return [_vm._t("tooltip")]},proxy:true},{key:"description",fn:function(ref){
var descriptionClass = ref.descriptionClass;
var discreteDescriptionClass = ref.discreteDescriptionClass;
return [_vm._t("description",null,null,{ descriptionClass: descriptionClass, discreteDescriptionClass: discreteDescriptionClass })]}},{key:"error-message",fn:function(){return [_vm._t("error-message")]},proxy:true}],null,true)},'f-text-field',_vm.attrs,false),_vm.listeners),[_vm._t("default")],2),_vm._v(" "),_c('button',{ref:"popupAnchor",staticClass:"datepicker__open",attrs:{"type":"button","aria-label":_vm.getAriaLabel,"aria-expanded":String(_vm.isOpen),"disabled":_vm.disabled},on:{"click":function($event){return _vm.onClickOpen()}}},[_c('f-icon',{attrs:{"name":"calendar"}})],1)],1),_vm._v(" "),_c('i-popup',{attrs:{"is-open":_vm.isOpen,"anchor":_vm.$refs.popupAnchor,"always-inline":_vm.alwaysInline},on:{"close":_vm.onClosePopup}},[_c('div',{staticClass:"datepicker__calendar"},[_c('div',{staticClass:"calendar calendar--hide-tabs"},[_c('f-calendar-tab-main',{staticClass:"calendar__container",attrs:{"name":'datepicker-calendar',"options":_vm.calendarOptions},on:{"day-selected":_vm.onDaySelected}})],1)])])],1)}
var FDatepickervue_type_template_id_35ae5700_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/FDatepicker/FDatepicker.vue?vue&type=template&id=35ae5700&

// EXTERNAL MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/core-js/modules/es.json.stringify.js
var es_json_stringify = __webpack_require__("d331b");

// EXTERNAL MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("28eb");

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FTextField/FTextField.vue?vue&type=template&id=0555cb95&
var FTextFieldvue_type_template_id_0555cb95_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-field",class:_vm.validityClass},[_c('f-label',{attrs:{"for":_vm.id},scopedSlots:_vm._u([{key:"default",fn:function(){return [_vm._t("default",function(){return [(_vm.defaultText !== '')?_c('span',[_vm._v(_vm._s(_vm.defaultText))]):_vm._e()]})]},proxy:true},{key:"tooltip",fn:function(){return [_vm._t("tooltip")]},proxy:true},{key:"description",fn:function(ref){
var descriptionClass = ref.descriptionClass;
var discreteDescriptionClass = ref.discreteDescriptionClass;
return [_vm._t("description",function(){return [(_vm.descriptionText)?_c('span',{class:descriptionClass},[(_vm.descriptionScreenReaderText)?_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.descriptionScreenReaderText))]):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.descriptionText))])]):_vm._e(),_vm._v(" "),(_vm.discreteDescriptionText)?_c('span',{class:discreteDescriptionClass},[(_vm.discreteDescriptionScreenReaderText)?_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.discreteDescriptionScreenReaderText))]):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.discreteDescriptionText))])]):_vm._e()]},null,{ descriptionClass: descriptionClass, discreteDescriptionClass: discreteDescriptionClass })]}},{key:"error-message",fn:function(){return [_vm._t("error-message",function(){return [(_vm.hasError)?[_vm._v(_vm._s(_vm.validity.validationMessage))]:_vm._e()]})]},proxy:true}],null,true)}),_vm._v(" "),_c('div',{staticClass:"text-field__input-wrapper"},[_vm._t("input-left"),_vm._v(" "),_c('div',{staticClass:"text-field__icon-wrapper"},[(((_vm.attrs).type)==='checkbox')?_c('input',_vm._g(_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.viewValue),expression:"viewValue"}],ref:"input",staticClass:"text-field__input",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.viewValue)?_vm._i(_vm.viewValue,null)>-1:(_vm.viewValue)},on:{"validity":_vm.onValidity,"pending-validity":_vm.onPendingValidity,"change":function($event){var $$a=_vm.viewValue,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.viewValue=$$a.concat([$$v]))}else{$$i>-1&&(_vm.viewValue=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.viewValue=$$c}}}},'input',_vm.attrs,false),_vm.listeners)):(((_vm.attrs).type)==='radio')?_c('input',_vm._g(_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.viewValue),expression:"viewValue"}],ref:"input",staticClass:"text-field__input",attrs:{"type":"radio"},domProps:{"checked":_vm._q(_vm.viewValue,null)},on:{"validity":_vm.onValidity,"pending-validity":_vm.onPendingValidity,"change":function($event){_vm.viewValue=null}}},'input',_vm.attrs,false),_vm.listeners)):_c('input',_vm._g(_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.viewValue),expression:"viewValue"}],ref:"input",staticClass:"text-field__input",attrs:{"type":(_vm.attrs).type},domProps:{"value":(_vm.viewValue)},on:{"validity":_vm.onValidity,"pending-validity":_vm.onPendingValidity,"input":function($event){if($event.target.composing){ return; }_vm.viewValue=$event.target.value}}},'input',_vm.attrs,false),_vm.listeners)),_vm._v(" "),(_vm.isValid)?_c('f-icon',{staticClass:"text-field__icon",attrs:{"name":"success"}}):_vm._e()],1),_vm._v(" "),_vm._t("input-right")],2)],1)}
var FTextFieldvue_type_template_id_0555cb95_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/FTextField/FTextField.vue?vue&type=template&id=0555cb95&

// EXTERNAL MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("e94e");

// EXTERNAL MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/core-js/modules/es.string.trim.js
var es_string_trim = __webpack_require__("b55a");

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FLabel/FLabel.vue?vue&type=template&id=efad54fa&
var FLabelvue_type_template_id_efad54fa_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasTooltipSlot)?_c('div',[(_vm.hasDefaultSlot)?_c('div',{staticClass:"tooltip-before"},[_c('label',{staticClass:"label tooltip-before__label",attrs:{"for":_vm.forProperty}},[_vm._t("default")],2)]):_vm._e(),_vm._v(" "),_vm._t("tooltip"),_vm._v(" "),(_vm.hasDescriptionSlot || _vm.hasErrorMessageSlot)?_c('label',{staticClass:"label sr-separator",attrs:{"for":_vm.forProperty}},[_vm._t("description",null,null,_vm.descriptionSlotClasses),_vm._v(" "),(_vm.hasErrorMessageSlot)?_c('span',{staticClass:"label__message label__message--error"},[_c('f-icon',{staticClass:"label__icon--left",attrs:{"name":"error"}}),_vm._v(" "),_vm._t("error-message")],2):_vm._e()],2):_vm._e()],2):_c('label',{staticClass:"label",attrs:{"for":_vm.forProperty}},[_vm._t("default"),_vm._v(" "),_vm._t("description",null,null,_vm.descriptionSlotClasses),_vm._v(" "),(_vm.hasErrorMessageSlot)?_c('span',{staticClass:"label__message label__message--error"},[_c('f-icon',{staticClass:"label__icon--left",attrs:{"name":"error"}}),_vm._v(" "),_vm._t("error-message")],2):_vm._e()],2)}
var FLabelvue_type_template_id_efad54fa_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/FLabel/FLabel.vue?vue&type=template&id=efad54fa&

// EXTERNAL MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("2aa5");

// EXTERNAL MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("32f5");

// EXTERNAL MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("ef14");

// CONCATENATED MODULE: ./src/utils/ComponentUtils.ts





/**
 * Trims and collapses multiple whitespace (including newlines) to a single
 * space
 */

function collapseWhitespace(text) {
  return text.replace(/\s+/gm, " ").replace(/(^ | $)/g, "");
}
/**
 * Recursively collect text content from nodes.
 */


function getTextContent(node) {
  if (node.children) {
    return node.children.map(function (it) {
      return getTextContent(it);
    }).join("");
  } else {
    return node.text || "";
  }
}

function hasSlot( // eslint-disable-next-line @typescript-eslint/ban-types
vm, slotName) {
  var scopedSlot = vm.$scopedSlots[slotName];
  return Object(logic_["isSet"])(scopedSlot) && Object(logic_["isSet"])(scopedSlot({}));
}
/**
 * Render slot and get contents as text. Whitespace is collapsed.
 *
 * Typical usage:
 *
 * ```js
 * const slot = this.$scopedSlots["my-slot"];
 * const text = renderSlotText(slot, { value: 'foobar' });
 * ```
 *
 * @param render - Slot function.
 * @param props - Optional props to pass to render function.
 * @returns Text content or undefined if render function was not found.
 */

function renderSlotText(render, props) {
  if (!Object(logic_["isSet"])(render)) {
    return undefined;
  }

  var nodes = render(props);

  if (!nodes || nodes.length === 0) {
    return undefined;
  }

  var text = nodes.map(function (it) {
    return getTextContent(it);
  }).join("");
  return collapseWhitespace(text);
}
// CONCATENATED MODULE: ./src/utils/EventBus.ts

var EventBus = new external_commonjs_vue_commonjs2_vue_root_Vue_default.a();
// CONCATENATED MODULE: ./src/utils/ListUtils.ts




function itemEquals(item1, item2, compareAttribute) {
  if (!Object(logic_["isSet"])(item1) || !Object(logic_["isSet"])(item2)) {
    return false;
  }

  if (item1 === item2) {
    return true;
  }

  return item1[compareAttribute] === item2[compareAttribute];
}
function includeItem(item, itemList, compareAttribute) {
  if (!Object(logic_["isSet"])(item) || !Object(logic_["isSet"])(itemList)) {
    return false;
  }

  var itemCompareValue = item[compareAttribute];
  return itemList.find(function (i) {
    return i[compareAttribute] === itemCompareValue;
  }) !== undefined;
}
function handleKeyboardFocusNavigation(key, focusedElement, focusableElements) {
  var tabPosition = focusableElements.indexOf(focusedElement);
  var keyDown = ["ArrowDown", "Down"];
  var keyUp = ["ArrowUp", "Up"];

  if (keyDown.includes(key)) {
    tabPosition++;

    if (tabPosition === focusableElements.length) {
      tabPosition = 0;
    }
  }

  if (keyUp.includes(key)) {
    tabPosition--;

    if (tabPosition === -1) {
      tabPosition = focusableElements.length - 1;
    }
  }

  if (focusableElements[tabPosition]) {
    focusableElements[tabPosition].focus();
  }
}
// CONCATENATED MODULE: ./src/utils/TableScroll.ts
var TableScroll_a;

var TableScroll;

(function (TableScroll) {
  TableScroll["HORIZONTAL"] = "horizontal";
  TableScroll["VERTICAL"] = "vertical";
  TableScroll["BOTH"] = "both";
  TableScroll["NONE"] = "none";
})(TableScroll || (TableScroll = {}));

var scrollClasses = (TableScroll_a = {}, TableScroll_a[TableScroll.HORIZONTAL] = ["table__scroll", "table__scroll--horizontal"], TableScroll_a[TableScroll.VERTICAL] = ["table__scroll", "table__scroll--vertical"], TableScroll_a[TableScroll.BOTH] = ["table__scroll", "table__scroll--horizontal", "table__scroll--vertical"], TableScroll_a[TableScroll.NONE] = [], TableScroll_a);
/**
 * Get list of classes to apply based on what scrolling is requested.
 */

function tableScrollClasses(val) {
  return scrollClasses[val];
}
// CONCATENATED MODULE: ./src/utils/ValidationUtils.ts






/**
 * Extracts plain text from given slot.
 * Supports only a flat structure of elements, e.g.
 *  <template v-slot:label>An <b>element</b> in the text</template>
 * will return "An element in the text."
 *
 * @param scopedSlot slot to extract text from
 */
function getTextFromScopedSlot(scopedSlot) {
  var message = "";
  var slots = scopedSlot({});

  if (slots) {
    var foundMessage = slots.filter(function (slot) {
      return slot.text !== undefined && slot.text.trim() !== "" || slot.children && slot.children.length > 0;
    }).map(function (node) {
      return (node.text || node.children && node.children[0].text || "").trim();
    }).join(" ");
    message = foundMessage;
  }

  return message;
}
/**
 * Dispatch an ComponentValidityEvent to the given element.
 *
 * @param element the element to dispatch event to
 * @param detail the event detail
 */

function dispatchComponentValidityEvent(element, detail) {
  element.dispatchEvent(new CustomEvent("component-validity", {
    detail: detail,
    bubbles: true
  }));
}
// CONCATENATED MODULE: ./src/utils/VueRefUtils.ts



/**
 * Verifies that a ref is a single `Element` and nothing else.
 * @param value The value to type check.
 * @returns `true` if the ref is an `Element`, otherwise false.
 */

function refIsElement(value) {
  return value instanceof Element;
}
/**
 * Verifies that a ref is an array containing at least one `Element`.
 * @param value The value to type check.
 * @returns `true` if the ref is an `Element` array with at least one item,
 * otherwise false.
 */

function refIsElementArray(value) {
  return Array.isArray(value) && value.length > 0 && value[0] instanceof Element;
}
/**
 * Verifies that a ref is an array containing at least one `HTMLElement`.
 * @param value The value to type check.
 * @returns `true` if the ref is an `HTMLElement` array with at least one item,
 * otherwise false.
 */

function refIsHTMLElementArray(value) {
  return Array.isArray(value) && value.length > 0 && value[0] instanceof HTMLElement;
}
/**
 * Verifies that a ref is a single Vue component and nothing else.
 * @param value The value to type check.
 * @returns `true` if the ref is a `Vue` (component), otherwise false.
 */

function refIsVue(value) {
  return Object(logic_["isSet"])(value) && !Array.isArray(value) && !(value instanceof Element);
}
/**
 * Verifies that a ref is an array containing at least one Vue component.
 * @param value The value to type check.
 * @returns `true` if the ref is a `Vue` (component) array with at least one
 * item, otherwise false.
 */

function refIsVueArray(value) {
  return Array.isArray(value) && value.length > 0 && !(value[0] instanceof Element);
}
/**
 * Gets an array of `Element` items from a ref. If there are none, the array
 * returned will be empty rather than `undefined`.
 * @param ref The ref to extract `Element` items from.
 * @returns An `Array` of `Element` items. Possibly empty.
 */

function getElementsFromVueRef(ref) {
  var result = [];

  if (refIsVueArray(ref)) {
    result = ref.map(function (vueRef) {
      return vueRef.$el;
    });
  } else if (refIsElementArray(ref)) {
    result = ref;
  } else if (Object(logic_["isSet"])(ref)) {
    result = [getElementFromVueRef(ref)];
  }

  return result;
}
/**
 * Gets an array of `HTMLElement` items from a ref. If there are none, the array
 * returned will be empty rather than `undefined`.
 * @param ref The ref to extract `HTMLElement` items from.
 * @returns An `Array` of `HTMLElement` items. Possibly empty.
 */

function getHTMLElementsFromVueRef(ref) {
  var result = [];

  if (refIsVueArray(ref)) {
    result = ref.map(function (vueRef) {
      return vueRef.$el;
    });
  } else if (refIsHTMLElementArray(ref)) {
    result = ref;
  } else if (Object(logic_["isSet"])(ref)) {
    result = [getHTMLElementFromVueRef(ref)];
  }

  return result;
}
/**
 * Find an `Element` from a ref, provided it is defined and not an array.
 * @param ref The ref to extract the `Element` from.
 * @returns An `Element` if ref is `Vue` or `Element`. Otherwise `undefined`.
 */

function findElementFromVueRef(ref) {
  if (ref instanceof Element) {
    return ref;
  } else if (!Object(logic_["isSet"])(ref) || Array.isArray(ref)) {
    return undefined;
  }

  return ref.$el;
}
/**
 * Gets an `Element` a ref, provided it is defined and not an array.
 * @param ref The ref to extract the `Element` from.
 * @returns An `Element` if ref is `Vue` or `Element`.
 * @throws An error if an `Element` could not be found.
 */

function getElementFromVueRef(ref) {
  var element = findElementFromVueRef(ref);

  if (!Object(logic_["isSet"])(element)) {
    throw new Error("Unable to find element from ".concat(ref, "."));
  }

  return element;
}
/**
 * Gets an `HTMLElement` a ref, provided it is defined and not an array.
 * @param ref The ref to extract the `HTMLElement` from.
 * @returns An `HTMLElement` if ref is `Vue` or `Element`.
 * @throws An error if an `HTMLElement` could not be found.
 */

function getHTMLElementFromVueRef(ref) {
  var element = findElementFromVueRef(ref);

  if (!Object(logic_["isSet"])(element)) {
    throw new Error("Unable to find element from ".concat(ref, "."));
  }

  if (element instanceof HTMLElement) {
    return element;
  }

  throw new Error("Not instance of HTMLELement ".concat(ref, "."));
}
// CONCATENATED MODULE: ./src/utils/mount-component/mount-component.ts



var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};



function getTargetElement(target) {
  if (typeof target !== "string") {
    return target;
  }

  var element = document.querySelector(target);

  if (!element) {
    throw new Error("mountComponent(..) requires a target element (selector \"".concat(target, "\" returned no element)"));
  }

  return element;
}

function createContainer(attachTo) {
  var parent = getTargetElement(attachTo);
  var element = document.createElement("div");
  parent.appendChild(element);
  return element;
}
/**
 * Create an instance of a component and mount it to given element.
 *
 * @param Component - Component to mount.
 * @param options - Mount options.
 *
 * @throws Error
 * Throw if [[Component]] is `undefined` or the `attachTo` selector does not
 * exist.
 */


function mountComponent(Component, options) {
  /* sanity check: ensure a component was passed */
  if (!Component) {
    throw new Error("mountComponent(..) called without a component");
  }

  var attachTo = options.attachTo,
      data = __rest(options, ["attachTo"]);

  return new external_commonjs_vue_commonjs2_vue_root_Vue_default.a({
    el: createContainer(attachTo),
    render: function render(createElement) {
      return createElement(Component, data);
    }
  });
} // ? Needed for Styleguidist to pickup the documentation.

/* harmony default export */ var mount_component = ({});
// CONCATENATED MODULE: ./src/utils/mount-component/index.ts

// CONCATENATED MODULE: ./src/config/config.ts

var FKUIConfigButtonOrder;

(function (FKUIConfigButtonOrder) {
  FKUIConfigButtonOrder[FKUIConfigButtonOrder["LEFT_TO_RIGHT"] = 0] = "LEFT_TO_RIGHT";
  FKUIConfigButtonOrder[FKUIConfigButtonOrder["RIGHT_TO_LEFT"] = 1] = "RIGHT_TO_LEFT";
})(FKUIConfigButtonOrder || (FKUIConfigButtonOrder = {}));

var production = true;
var config_config = {
  buttonOrder: FKUIConfigButtonOrder.LEFT_TO_RIGHT,
  modalTarget: "body",

  set production(value) {
    production = value;
    logic_["configLogic"].production = value;
  },

  get production() {
    return production;
  }

};
// CONCATENATED MODULE: ./src/config/index.ts

// CONCATENATED MODULE: ./src/utils/open-modal/open-modal.ts




var open_modal_assign = undefined && undefined.__assign || function () {
  open_modal_assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return open_modal_assign.apply(this, arguments);
};




function unpackPayload(event, src) {
  var defaultPayload = {};

  var _a = src !== null && src !== void 0 ? src : defaultPayload,
      _b = _a.reason,
      reason = _b === void 0 ? event : _b,
      rawData = _a.data;
  /* this cast is needed when the caller lies about T, there is no sane way to
   * verify the type of the emitted event matches the caller requested type so
   * might as well just cast it. */


  var data = rawData;
  return {
    reason: reason,
    data: data
  };
}

function openModal(Component, options) {
  if (typeof options === "string") {
    return openModal(Component, {
      props: {
        content: options
      }
    });
  }

  var defaultOptions = {
    attachTo: config_config.modalTarget,
    props: {}
  };

  var _a = open_modal_assign(open_modal_assign({}, defaultOptions), options),
      attachTo = _a.attachTo,
      props = _a.props;

  return new Promise(function (resolve, reject) {
    var terminate = function terminate(event, payload) {
      try {
        var result = unpackPayload(event, payload);
        var parent = vm.$el.parentNode;

        if (parent) {
          parent.removeChild(vm.$el);
        }

        vm.$destroy();
        resolve(result);
      } catch (err)
      /* istanbul ignore next */
      {
        /* eslint-disable-next-line no-console */
        console.error(err);
        reject(err);
      }
    };

    var vm = mountComponent(Component, {
      attachTo: attachTo,
      props: open_modal_assign({
        isOpen: true
      }, props),
      on: {
        close: function close(data) {
          terminate("close", data);
        }
      }
    });
  });
} // ? Needed for Styleguidist to pickup the documentation.

/* harmony default export */ var open_modal = ({});
// CONCATENATED MODULE: ./src/utils/form-modal/form-modal.ts











var form_modal_assign = undefined && undefined.__assign || function () {
  form_modal_assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return form_modal_assign.apply(this, arguments);
};

var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = undefined && undefined.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};


/**
 * Open a form modal and return the results from the input fields.
 *
 * @param Component - Vue component to render.
 * @param options - Component options.
 * @returns A promise resolved with values from input fields or rejected if user cancels.
 */

function formModal(Component, options) {
  var _a;

  return __awaiter(this, void 0, Promise, function () {
    var props, result;
    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          props = form_modal_assign({
            size: (_a = options === null || options === void 0 ? void 0 : options.size) !== null && _a !== void 0 ? _a : "",
            beforeSubmit: options === null || options === void 0 ? void 0 : options.beforeSubmit
          }, options === null || options === void 0 ? void 0 : options.props);
          return [4
          /*yield*/
          , openModal(Component, {
            props: props
          })];

        case 1:
          result = _b.sent();

          if (result.reason === "submit") {
            return [2
            /*return*/
            , result.data];
          } else {
            return [2
            /*return*/
            , Promise.reject("cancel")];
          }

          return [2
          /*return*/
          ];
      }
    });
  });
} // ? Needed for Styleguidist to pickup the documentation.

/* harmony default export */ var form_modal = ({});
// CONCATENATED MODULE: ./src/utils/form-modal/index.ts

// CONCATENATED MODULE: ./src/utils/open-modal/modal-reason.ts
/**
 * Predefined reasons the modal was closed.
 */
var ModalReason;

(function (ModalReason) {
  /**
   * Positive response from modal.
   */
  ModalReason["CONFIRM"] = "confirm";
  /**
   * Negative response from modal.
   */

  ModalReason["DISMISS"] = "dismiss";
})(ModalReason || (ModalReason = {}));
// CONCATENATED MODULE: ./src/utils/open-modal/index.ts


// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FModal/FModal.vue?vue&type=template&id=376edef2&
var FModalvue_type_template_id_376edef2_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isOpen)?_c('div',{staticClass:"modal",class:_vm.modalClass,attrs:{"id":_vm.id}},[_c('div',{staticClass:"modal__backdrop"},[_c('div',{staticClass:"modal__outer-container",attrs:{"tabindex":"-1"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.onClose.apply(null, arguments)},"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){ return null; }return _vm.onKeyTab.apply(null, arguments)}}},[_c('div',{staticClass:"modal__inner-container",attrs:{"role":"dialog","aria-modal":"true"}},[_c('div',{ref:"modalDialogContainer",staticClass:"modal__dialog-container",class:_vm.containerClasses},[_c('div',{staticClass:"modal__dialog"},[_c('div',{staticClass:"modal__dialog-inner"},[_c('div',{staticClass:"modal__header"},[(_vm.type)?_c('span',{staticClass:"modal__title-icon icon-stack",class:_vm.stackTypeClass},[_c('f-icon',{attrs:{"name":_vm.symbol}}),_vm._v(" "),_c('f-icon',{attrs:{"name":_vm.sign}})],1):_vm._e(),_vm._v(" "),_c('h1',{ref:"modalTitle",staticClass:"modal__title",attrs:{"tabindex":"-1"}},[_vm._t("header")],2)]),_vm._v(" "),_c('div',{staticClass:"modal__content"},[_vm._t("content")],2),_vm._v(" "),_c('div',{staticClass:"modal__footer"},[_vm._t("footer")],2)]),_vm._v(" "),_c('div',{staticClass:"modal__shelf"},[_c('button',{staticClass:"button button--discrete button--discrete--black modal__close-button",attrs:{"type":"button","aria-label":_vm.ariaCloseText},on:{"click":_vm.onClose}},[_c('span',[_vm._v(_vm._s(_vm.$t("fkuiModalClose", "Stäng")))]),_vm._v(" "),_c('f-icon',{staticClass:"button__icon",attrs:{"name":"close"}})],1)])])])])])])]):_vm._e()}
var FModalvue_type_template_id_376edef2_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/FModal/FModal.vue?vue&type=template&id=376edef2&

// CONCATENATED MODULE: ./src/components/FModal/sizes.ts


var sizes = ["", "small", "medium", "large", "fullscreen", "fullwidth"];
function sizeClass(size) {
  if (!sizes.includes(size)) {
    throw new Error("\"".concat(size, "\" is not a valid size"));
  }

  if (!size) {
    return [];
  } else if (size === "fullscreen") {
    return ["modal__dialog-container--fullwidth"];
  } else {
    return ["modal__dialog-container--".concat(size)];
  }
}
// CONCATENATED MODULE: ./src/plugins/test/TestPlugin.ts

var DATA_TEST_ATTRIBUTE_NAME = "data-test";
function TestPlugin(Vue) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function throwErrorIfEmpty(value) {
    if (!value) {
      throw new Error("Did you forgot to add a value to v-test?");
    }
  }

  Vue.directive("test", {
    inserted: function inserted(el, _a) {
      var value = _a.value;
      throwErrorIfEmpty(value);
      el.setAttribute(DATA_TEST_ATTRIBUTE_NAME, value);
    },
    update: function update(el, _a) {
      var value = _a.value;
      throwErrorIfEmpty(value);
      el.setAttribute(DATA_TEST_ATTRIBUTE_NAME, value);
    }
  });
} // ? Needed for Styleguidist to pickup the documentation.

/* harmony default export */ var test_TestPlugin = ({});
// CONCATENATED MODULE: ./src/plugins/test/index.ts

// CONCATENATED MODULE: ./src/plugins/translation/TranslationPlugin.ts










var TranslationPlugin_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var TranslationPlugin_generator = undefined && undefined.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};


var TranslationMixin = {
  methods: {
    $t: function $t(key, defaultValueOrArgs, args) {
      return logic_["TranslationService"].provider.translate(key, defaultValueOrArgs, args);
    }
  }
};
function TranslationPlugin(Vue) {
  return TranslationPlugin_awaiter(this, void 0, Promise, function () {
    return TranslationPlugin_generator(this, function (_a) {
      Vue.mixin(TranslationMixin);
      return [2
      /*return*/
      ];
    });
  });
} // ? Needed for Styleguidist to pickup the documentation.

/* harmony default export */ var translation_TranslationPlugin = ({});
// CONCATENATED MODULE: ./src/plugins/translation/index.ts
/* istanbul ignore file */

// EXTERNAL MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/lodash/isEqual.js
var isEqual = __webpack_require__("9e74");
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);

// CONCATENATED MODULE: ./src/plugins/validation/ValidationPlugin.ts








function getValidatableElement(element) {
  if (Object(logic_["isValidatableHTMLElement"])(element)) {
    return element;
  }

  var validatableInsideElement = element.querySelector("input, textarea, select");

  if (validatableInsideElement) {
    return validatableInsideElement;
  } else {
    throw new Error("Couldn't find any validatable element");
  }
}

function triggerInitialValidationToSupportFFormStepValidation(el) {
  var target = getValidatableElement(el);
  logic_["ValidationService"].validateElement(target);
}

function registerValidators(el, binding) {
  var _a = binding.modifiers,
      bindingModifiers = _a === void 0 ? {} : _a,
      _b = binding.value,
      bindingValue = _b === void 0 ? {} : _b;
  var target = getValidatableElement(el);
  Object.keys(bindingValue).forEach(function (validatorName) {
    if (!bindingModifiers[validatorName]) {
      throw new Error("Have you forget to add '".concat(validatorName, "' to v-validation.").concat(validatorName, "?"));
    }
  });
  var validatorConfigs = {};
  Object.keys(bindingModifiers).forEach(function (validatorName) {
    validatorConfigs[validatorName] = bindingValue[validatorName] || {};
  });
  logic_["ValidationService"].addValidatorsToElement(target, validatorConfigs);
}

function ValidationPlugin(Vue) {
  Vue.directive("validation", {
    bind: function bind(el, binding) {
      registerValidators(el, binding);
    },
    componentUpdated: function componentUpdated(el, binding) {
      if (!isEqual_default()(binding.value, binding.oldValue)) {
        registerValidators(el, binding);
      }
    },
    inserted: function inserted(el) {
      triggerInitialValidationToSupportFFormStepValidation(el);
    }
  });
  Vue.directive("validation-prefix", {
    bind: function bind(el, binding) {
      el.addEventListener("component-validity", function (event) {
        var e = event;
        e.detail.errorMessage = "".concat(binding.value).concat(e.detail.errorMessage);
      });
    }
  });
} // ? Needed for Styleguidist to pickup the documentation.

/* harmony default export */ var validation_ValidationPlugin = ({});
// CONCATENATED MODULE: ./src/plugins/validation/index.ts
/* istanbul ignore file */

// CONCATENATED MODULE: ./src/types/ComponentValidityEvent.ts

// CONCATENATED MODULE: ./src/types/ErrorData.ts
var ErrorData =
/** @class */
function () {
  function ErrorData(error, vm, info) {
    this.error = error;
    this.vm = vm;
    this.info = info;
  }

  return ErrorData;
}();


// CONCATENATED MODULE: ./src/types/ErrorViewData.ts
var ErrorViewData =
/** @class */
function () {
  function ErrorViewData(hasError, payload) {
    if (hasError === void 0) {
      hasError = false;
    }

    this.hasError = hasError;
    this.payload = payload;
  }

  return ErrorViewData;
}();


// CONCATENATED MODULE: ./src/types/FErrorList/ErrorItem.ts

// CONCATENATED MODULE: ./src/types/FErrorList/index.ts

// CONCATENATED MODULE: ./src/types/GroupValidityEvent.ts

// CONCATENATED MODULE: ./src/types/FForm/FormErrorList.ts


var FormErrorList =
/** @class */
function () {
  function FormErrorList(fields) {
    this.focusElementId = "";
    this.id = "";
    this.isValid = false;
    this.numberOfTimesSubmitted = 0;
    this.title = "";
    Object.assign(this, fields);
  }

  return FormErrorList;
}();


// CONCATENATED MODULE: ./src/types/FForm/FormStepData.ts


var FormStep =
/** @class */
function () {
  function FormStep(fields) {
    this.isOpen = false;
    this.isAnyFieldTouched = false;
    this.focusElementId = "";
    this.id = "";
    this.isValid = false;
    this.numberOfTimesSubmitted = 0;
    this.title = "";
    Object.assign(this, fields);
  }

  return FormStep;
}();


// CONCATENATED MODULE: ./src/types/FForm/index.ts


// CONCATENATED MODULE: ./src/types/FList/index.ts

// CONCATENATED MODULE: ./src/types/index.ts







// CONCATENATED MODULE: ./src/plugins/error/ErrorPlugin.ts


var ErrorPlugin_assign = undefined && undefined.__assign || function () {
  ErrorPlugin_assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return ErrorPlugin_assign.apply(this, arguments);
};



var UNHANDLED_ERROR_EVENT = "unhandled-error";
var defaults = {
  captureWarnings: true,
  logToConsole: true
};
function errorHandler(options, error, vm, info) {
  if (options.logToConsole) {
    var consoleOutput = info ? ["Error in ".concat(info, ":"), error, vm] : [error, vm];
    /* eslint-disable-next-line no-console */

    console.error.apply(console, consoleOutput);
  }

  EventBus.$emit(UNHANDLED_ERROR_EVENT, new ErrorData(error, vm, info));
}
function warnHandler(options, msg, vm, trace) {
  if (options.logToConsole) {
    /* eslint-disable-next-line no-console */
    console.warn("Warning:", msg, trace);
  }

  var error = {
    name: "warning",
    message: msg,
    stack: trace
  };
  EventBus.$emit(UNHANDLED_ERROR_EVENT, new ErrorData(error, vm, "warning"));
}
var ErrorPlugin = {
  install: function install(Vue, options) {
    if (options === void 0) {
      options = {};
    }

    var config = ErrorPlugin_assign(ErrorPlugin_assign({}, defaults), options);

    Vue.config.errorHandler = errorHandler.bind(undefined, config);

    if (config.captureWarnings) {
      Vue.config.warnHandler = warnHandler.bind(undefined, config);
    }
  }
};
/* harmony default export */ var error_ErrorPlugin = (ErrorPlugin);
// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/plugins/error/FErrorHandlingApp.vue?vue&type=template&id=5acdebae&
var FErrorHandlingAppvue_type_template_id_5acdebae_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasError)?_c(_vm.errorComponent,{tag:"component",attrs:{"payload":_vm.payload}}):_c(_vm.defaultComponent,{tag:"component"})}
var FErrorHandlingAppvue_type_template_id_5acdebae_staticRenderFns = []


// CONCATENATED MODULE: ./src/plugins/error/FErrorHandlingApp.vue?vue&type=template&id=5acdebae&

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/plugins/error/FErrorPage.vue?vue&type=template&id=2495844e&
var FErrorPagevue_type_template_id_2495844e_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var FErrorPagevue_type_template_id_2495844e_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-test":"f-error-page"}},[_c('h1',[_vm._v("Fel")]),_vm._v(" "),_c('p',[_vm._v("Ett fel har uppstått.")]),_vm._v(" "),_c('a',{attrs:{"href":"/"}},[_vm._v("Gå till startsidan")])])}]


// CONCATENATED MODULE: ./src/plugins/error/FErrorPage.vue?vue&type=template&id=2495844e&

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/plugins/error/FErrorPage.vue?vue&type=script&lang=ts&

/* harmony default export */ var FErrorPagevue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: "FErrorPage",
  props: {
    payload: {
      type: Object,
      required: false,
      default: null
    }
  }
}));
// CONCATENATED MODULE: ./src/plugins/error/FErrorPage.vue?vue&type=script&lang=ts&
 /* harmony default export */ var error_FErrorPagevue_type_script_lang_ts_ = (FErrorPagevue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/plugins/error/FErrorPage.vue





/* normalize component */

var FErrorPage_component = normalizeComponent(
  error_FErrorPagevue_type_script_lang_ts_,
  FErrorPagevue_type_template_id_2495844e_render,
  FErrorPagevue_type_template_id_2495844e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FErrorPage = (FErrorPage_component.exports);
// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/plugins/error/FErrorHandlingApp.vue?vue&type=script&lang=ts&





/* harmony default export */ var FErrorHandlingAppvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: "FErrorHandlingApp",
  props: {
    defaultComponent: {
      type: [Function, Object],
      required: true
    },
    errorComponent: {
      type: [Function, Object],
      required: false,
      default: FErrorPage
    }
  },
  data: function data() {
    return new ErrorViewData();
  },
  watch: {
    $route: function $route() {
      this.hasError = false;
    }
  },
  created: function created() {
    var _this = this;

    EventBus.$on(UNHANDLED_ERROR_EVENT, function (payload) {
      _this.hasError = true;
      _this.payload = payload;
    });
  }
}));
// CONCATENATED MODULE: ./src/plugins/error/FErrorHandlingApp.vue?vue&type=script&lang=ts&
 /* harmony default export */ var error_FErrorHandlingAppvue_type_script_lang_ts_ = (FErrorHandlingAppvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/plugins/error/FErrorHandlingApp.vue





/* normalize component */

var FErrorHandlingApp_component = normalizeComponent(
  error_FErrorHandlingAppvue_type_script_lang_ts_,
  FErrorHandlingAppvue_type_template_id_5acdebae_render,
  FErrorHandlingAppvue_type_template_id_5acdebae_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FErrorHandlingApp = (FErrorHandlingApp_component.exports);
// CONCATENATED MODULE: ./src/plugins/error/index.ts


// CONCATENATED MODULE: ./src/plugins/index.ts




// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FModal/FModal.vue?vue&type=script&lang=ts&














var FModalvue_type_script_lang_ts_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var FModalvue_type_script_lang_ts_generator = undefined && undefined.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __spreadArray = undefined && undefined.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};







var FModalvue_type_script_lang_ts_iconClasses = {
  information: {
    symbol: "circle",
    sign: "i",
    stack: "info"
  },
  warning: {
    symbol: "circle",
    sign: "alert",
    stack: "warning"
  },
  error: {
    symbol: "triangle",
    sign: "alert",
    stack: "error"
  }
};
/**
 * Level: Ready
 */

/* harmony default export */ var FModalvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: "FModal",
  components: {
    FIcon: FIcon
  },
  mixins: [TranslationMixin],
  inheritAttrs: true,
  props: {
    /**
     * The id for the root element id attribute.
     * If the prop is not set a random value will be generated.
     */
    id: {
      type: String,
      required: false,
      default: function _default() {
        return logic_["ElementIdService"].generateElementId();
      }
    },

    /**
     * If the modal is open.
     * Use this to toggle if the modal should be visible or not.
     */
    isOpen: {
      type: Boolean,
      required: false,
      default: false
    },

    /**
     * The aria-label attribute text for the top right close button.
     */
    ariaCloseText: {
      type: String,
      required: false,
      default: undefined
    },

    /**
     * Enable fullscreen mode in mobile.
     */
    fullscreen: {
      type: Boolean,
      required: false,
      default: false
    },

    /**
     * The type of modal. 'information', 'warning' and 'error' is valid.
     */
    type: {
      type: String,
      default: "",
      validator: function validator(value) {
        return ["", "information", "warning", "error"].includes(value);
      }
    },

    /**
     * The size of modal in desktop mode.
     */
    size: {
      type: String,
      default: "",
      validator: function validator(value) {
        return sizes.includes(value);
      }
    }
  },
  data: function data() {
    return {
      nonModalFocusableElements: []
    };
  },
  computed: {
    modalClass: function modalClass() {
      return this.type ? ["modal--".concat(this.type)] : [];
    },
    containerClasses: function containerClasses() {
      var size = sizeClass(this.size);

      if (this.fullscreen) {
        return __spreadArray(__spreadArray([], size, true), ["modal__dialog-container--fullscreen"], false);
      } else {
        return size;
      }
    },
    symbol: function symbol() {
      return FModalvue_type_script_lang_ts_iconClasses[this.type].symbol;
    },
    sign: function sign() {
      return FModalvue_type_script_lang_ts_iconClasses[this.type].sign;
    },
    stackTypeClass: function stackTypeClass() {
      return this.type ? ["icon-stack--".concat(FModalvue_type_script_lang_ts_iconClasses[this.type].stack)] : [];
    }
  },
  watch: {
    isOpen: {
      immediate: true,
      handler: function handler(value) {
        return FModalvue_type_script_lang_ts_awaiter(this, void 0, Promise, function () {
          var modalTitle;
          return FModalvue_type_script_lang_ts_generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                if (!value) return [3
                /*break*/
                , 2];
                document.documentElement.classList.add("modal__open");
                Object(logic_["saveFocus"])(document);
                return [4
                /*yield*/
                , this.$nextTick()];

              case 1:
                _a.sent();

                modalTitle = this.$refs.modalTitle;

                if (modalTitle instanceof HTMLElement) {
                  Object(logic_["focus"])(modalTitle);
                }

                return [3
                /*break*/
                , 3];

              case 2:
                document.documentElement.classList.remove("modal__open");
                Object(logic_["restoreFocus"])();
                _a.label = 3;

              case 3:
                return [2
                /*return*/
                ];
            }
          });
        });
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.documentElement.classList.remove("modal__open");
  },
  methods: {
    onKeyTab: function onKeyTab(event) {
      Object(logic_["handleTab"])(event, this.$refs.modalDialogContainer);
    },
    onClose: function onClose() {
      /**
       * Event that is dispatched when the escape button is pressed.
       * In most use cases the `isOpen` prop should be set to false when this event is triggered.
       */
      this.$emit("close");
    }
  }
}));
// CONCATENATED MODULE: ./src/components/FModal/FModal.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FModal_FModalvue_type_script_lang_ts_ = (FModalvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FModal/FModal.vue





/* normalize component */

var FModal_component = normalizeComponent(
  FModal_FModalvue_type_script_lang_ts_,
  FModalvue_type_template_id_376edef2_render,
  FModalvue_type_template_id_376edef2_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FModal = (FModal_component.exports);
// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FModal/FConfirmModal/FConfirmModal.vue?vue&type=template&id=45c5e78a&
var FConfirmModalvue_type_template_id_45c5e78a_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f-modal',{attrs:{"fullscreen":_vm.fullscreen,"is-open":_vm.isOpen,"aria-close-text":_vm.ariaCloseText,"type":"warning","size":_vm.size},on:{"close":_vm.onClose},scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._t("heading",function(){return [_vm._v(_vm._s(_vm.heading))]})]},proxy:true},{key:"content",fn:function(){return [_vm._t("content",function(){return [_vm._v(_vm._s(_vm.content))]})]},proxy:true},{key:"footer",fn:function(){return [_c('div',{staticClass:"button-group"},_vm._l((_vm.preparedButtons),function(button){return _c('button',{key:button.label,staticClass:"button-group__item",class:button.classlist,attrs:{"type":"button"},on:{"click":function($event){return _vm.onClick(button)}}},[_c('span',[_vm._v(_vm._s(button.label))]),_vm._v(" "),(button.screenreader)?_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(button.screenreader))]):_vm._e()])}),0)]},proxy:true}],null,true)})}
var FConfirmModalvue_type_template_id_45c5e78a_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/FModal/FConfirmModal/FConfirmModal.vue?vue&type=template&id=45c5e78a&

// CONCATENATED MODULE: ./src/components/FModal/FConfirmModal/modal-button.ts


function prepareButtonList(src) {
  var list = src.map(function (it) {
    var _a, _b, _c, _d;

    return {
      label: it.label,
      event: (_a = it.event) !== null && _a !== void 0 ? _a : "dismiss",
      reason: (_c = (_b = it.reason) !== null && _b !== void 0 ? _b : it.event) !== null && _c !== void 0 ? _c : "dismiss",
      classlist: ["button", "button--".concat((_d = it.type) !== null && _d !== void 0 ? _d : "secondary")]
    };
  });

  switch (config_config.buttonOrder) {
    case FKUIConfigButtonOrder.LEFT_TO_RIGHT:
      return list;

    case FKUIConfigButtonOrder.RIGHT_TO_LEFT:
      return list.reverse();
  }
}
// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FModal/FConfirmModal/FConfirmModal.vue?vue&type=script&lang=ts&






/**
 * Level: Ready
 */

/* harmony default export */ var FConfirmModalvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: "FConfirmModal",
  components: {
    FModal: FModal
  },
  inheritAttrs: true,
  props: {
    /**
     * Enable fullscreen mode in mobile.
     */
    fullscreen: {
      type: Boolean,
      required: false,
      default: false
    },

    /**
     * Prop for opening modal
     */
    isOpen: {
      type: Boolean,
      required: false,
      default: false
    },

    /**
     * Simple text content
     */
    content: {
      type: String,
      required: false,
      default: "Brödtext"
    },

    /**
     * Simple text header
     */
    heading: {
      type: String,
      required: false,
      default: "Rubrik"
    },

    /**
     * The size of modal. 'large' and 'fullscreen' is valid.
     */
    size: {
      type: String,
      default: "",
      validator: function validator(value) {
        return sizes.includes(value);
      }
    },

    /**
     * The aria-label attribute text for the top right close button.
     */
    ariaCloseText: {
      type: String,
      required: false,
      default: undefined
    },

    /**
     * List of buttons
     */
    buttons: {
      type: Array,
      required: false,
      default: function _default() {
        return [{
          label: "Primärknapp",
          event: "confirm",
          type: "primary"
        }, {
          label: "Sekundärknapp",
          event: "dismiss",
          type: "secondary"
        }];
      }
    }
  },
  computed: {
    preparedButtons: function preparedButtons() {
      return prepareButtonList(this.buttons);
    }
  },
  methods: {
    onClose: function onClose() {
      this.$emit("close", {
        reason: "close"
      });
    },
    onClick: function onClick(button) {
      /**
       * Emits specified button event when clicked
       *
       * @event button.event
       *
       */
      this.$emit(button.event);
      /**
       * Emits reason for closing modal
       */

      this.$emit("close", {
        reason: button.reason
      });
    }
  }
}));
// CONCATENATED MODULE: ./src/components/FModal/FConfirmModal/FConfirmModal.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FConfirmModal_FConfirmModalvue_type_script_lang_ts_ = (FConfirmModalvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FModal/FConfirmModal/FConfirmModal.vue





/* normalize component */

var FConfirmModal_component = normalizeComponent(
  FConfirmModal_FConfirmModalvue_type_script_lang_ts_,
  FConfirmModalvue_type_template_id_45c5e78a_render,
  FConfirmModalvue_type_template_id_45c5e78a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FConfirmModal = (FConfirmModal_component.exports);
// CONCATENATED MODULE: ./src/components/FModal/FConfirmModal/index.ts

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FModal/FFormModal/FFormModal.vue?vue&type=template&id=d0cbece2&
var FFormModalvue_type_template_id_d0cbece2_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f-modal',{attrs:{"data-test":_vm.dataTest,"fullscreen":_vm.fullscreen,"is-open":_vm.isOpen,"size":_vm.size,"aria-close-text":_vm.ariaCloseText},on:{"close":_vm.onClose},scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._t("header")]},proxy:true},{key:"content",fn:function(){return [_c('div',[_vm._t("default")],2),_vm._v(" "),_c('i-validation-form',{attrs:{"id":_vm.formId,"before-submit":_vm.beforeSubmit,"use-error-list":_vm.useErrorList},on:{"submit":_vm.onSubmit,"cancel":_vm.onCancel},scopedSlots:_vm._u([{key:"error-message",fn:function(){return [_vm._t("error-message")]},proxy:true}],null,true)},[_vm._v(" "),_vm._t("input-text-fields")],2)]},proxy:true},{key:"footer",fn:function(){return [_c('div',{staticClass:"button-group"},[_c('button',{staticClass:"button button--primary button-group__item",attrs:{"form":_vm.formId,"data-test":"submit-button","type":"submit"}},[_vm._t("submit-button-text",function(){return [_vm._v("\n                    "+_vm._s(_vm.$t("fkuiFormModalSubmitButtonText", "Spara"))+"\n                ")]})],2),_vm._v(" "),_c('button',{staticClass:"button button--secondary button-group__item",attrs:{"data-test":"cancel-button","type":"button"},on:{"click":_vm.onCancel}},[_vm._t("cancel-button-text",function(){return [_vm._v("\n                    "+_vm._s(_vm.$t("fkuiFormModalCancelButtonText", "Avbryt"))+"\n                ")]})],2)])]},proxy:true}],null,true)})}
var FFormModalvue_type_template_id_d0cbece2_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/FModal/FFormModal/FFormModal.vue?vue&type=template&id=d0cbece2&

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/internal-components/IFlex/IFlex.vue?vue&type=template&id=316fc2dc&
var IFlexvue_type_template_id_316fc2dc_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"iflex",class:_vm.classList},[_vm._t("default")],2)}
var IFlexvue_type_template_id_316fc2dc_staticRenderFns = []


// CONCATENATED MODULE: ./src/internal-components/IFlex/IFlex.vue?vue&type=template&id=316fc2dc&

// CONCATENATED MODULE: ./src/internal-components/IFlex/constants.ts
var GAP = ["1x", "2x", "3x", "4x", "5x", "6x", "7x", "8x"];
var ALIGNMENT = ["top", "center", "bottom"];
var FLOAT = ["left", "center", "right"];
// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/internal-components/IFlex/IFlex.vue?vue&type=script&lang=ts&




/* harmony default export */ var IFlexvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: "IFlex",
  inheritAttrs: true,
  props: {
    /**
     * Set gap (gutter) between items.
     *
     * Must be one of:
     *
     * - `"1x"`
     * - `"2x"`
     * - `"3x"`
     * - ...
     * - `"8x"`
     *
     * Example: a value of `"3x"` corresponds to a gap of `3 * 0.25 = 0.75rem`.
     */
    gap: {
      type: String,
      default: "",
      validator: function validator(val) {
        return val === "" || GAP.includes(val);
      }
    },

    /**
     * If set the IFlexItems will be fullwidth and
     * stacked on top of each other when breakpoint is small (aka mobile).
     */
    collapse: {
      type: Boolean,
      default: false
    },

    /**
     * If set the IFlexItems will wrap when out of space
     */
    wrap: {
      type: Boolean,
      default: false
    },

    /**
     * Set how IFlexItems should float.
     *
     * Must be one of:
     *
     * - `"left"`
     * - `"center"`
     * - `"right"`
     */
    float: {
      type: String,
      default: "",
      validator: function validator(val) {
        return val === "" || FLOAT.includes(val);
      }
    }
  },
  computed: {
    classList: function classList() {
      var classes = [];

      if (this.collapse) {
        classes.push("iflex--collapse");
      }

      if (this.gap) {
        classes.push("iflex--gap-".concat(this.gap));
      }

      if (this.wrap) {
        classes.push("iflex--wrap");
      }

      if (this.float) {
        classes.push("iflex--float-".concat(this.float));
      }

      return classes;
    }
  }
}));
// CONCATENATED MODULE: ./src/internal-components/IFlex/IFlex.vue?vue&type=script&lang=ts&
 /* harmony default export */ var IFlex_IFlexvue_type_script_lang_ts_ = (IFlexvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/internal-components/IFlex/IFlex.vue





/* normalize component */

var IFlex_component = normalizeComponent(
  IFlex_IFlexvue_type_script_lang_ts_,
  IFlexvue_type_template_id_316fc2dc_render,
  IFlexvue_type_template_id_316fc2dc_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var IFlex = (IFlex_component.exports);
// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/internal-components/IFlex/IFlexItem.vue?vue&type=template&id=9d4bacbe&
var IFlexItemvue_type_template_id_9d4bacbe_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"iflex__item",class:_vm.classList},[_vm._t("default")],2)}
var IFlexItemvue_type_template_id_9d4bacbe_staticRenderFns = []


// CONCATENATED MODULE: ./src/internal-components/IFlex/IFlexItem.vue?vue&type=template&id=9d4bacbe&

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/internal-components/IFlex/IFlexItem.vue?vue&type=script&lang=ts&




/* harmony default export */ var IFlexItemvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: "IFlexItem",
  inheritAttrs: true,
  props: {
    /**
     * If set this item will grow to its largest possible size.
     */
    grow: {
      type: Boolean,
      default: false
    },

    /**
     * If set this item will shrink to its smallest possible size.
     */
    shrink: {
      type: Boolean,
      default: false
    },

    /**
     * Vertical positioning of content.
     *
     * Must be one of:
     *
     * - `"top"`
     * - `"center"`
     * - `"bottom"`
     */
    align: {
      type: String,
      default: "top",
      validator: function validator(val) {
        return ALIGNMENT.includes(val);
      }
    }
  },
  computed: {
    classList: function classList() {
      var classList = ["iflex--align-".concat(this.align)];

      if (this.grow) {
        classList.push("iflex--grow");
      } else if (this.shrink) {
        classList.push("iflex--shrink");
      }

      return classList;
    }
  }
}));
// CONCATENATED MODULE: ./src/internal-components/IFlex/IFlexItem.vue?vue&type=script&lang=ts&
 /* harmony default export */ var IFlex_IFlexItemvue_type_script_lang_ts_ = (IFlexItemvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/internal-components/IFlex/IFlexItem.vue





/* normalize component */

var IFlexItem_component = normalizeComponent(
  IFlex_IFlexItemvue_type_script_lang_ts_,
  IFlexItemvue_type_template_id_9d4bacbe_render,
  IFlexItemvue_type_template_id_9d4bacbe_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var IFlexItem = (IFlexItem_component.exports);
// CONCATENATED MODULE: ./src/internal-components/IFlex/index.ts


// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/internal-components/IPopup/IPopup.vue?vue&type=template&id=ce2be6a0&
var IPopupvue_type_template_id_ce2be6a0_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.popupClasses},[(_vm.isOpen)?_c('div',{ref:"popup",staticClass:"popup__wrapper",on:{"click":_vm.onPopupClickHandler,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }$event.stopPropagation();return _vm.onKeyEsc.apply(null, arguments)},"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){ return null; }return _vm.onKeyTab.apply(null, arguments)}}},[_vm._t("default",null,null,{ toggleIsOpen: _vm.toggleIsOpen })],2):_vm._e()])}
var IPopupvue_type_template_id_ce2be6a0_staticRenderFns = []


// CONCATENATED MODULE: ./src/internal-components/IPopup/IPopup.vue?vue&type=template&id=ce2be6a0&

// EXTERNAL MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/core-js/modules/es.string.anchor.js
var es_string_anchor = __webpack_require__("5f28");

// EXTERNAL MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/core-js/modules/es.array.find-index.js
var es_array_find_index = __webpack_require__("bdf7");

// CONCATENATED MODULE: ./src/internal-components/IPopup/IPopupUtils.ts




var IPopupUtils_assign = undefined && undefined.__assign || function () {
  IPopupUtils_assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return IPopupUtils_assign.apply(this, arguments);
};

function offset(page, el) {
  var rect = el.getBoundingClientRect();
  return {
    top: rect.top + page.pageYOffset,
    left: rect.left + page.pageXOffset
  };
}

function clamp(value, min, max) {
  return Math.max(Math.min(value, max), min);
}
function getElement(anchor) {
  if (!anchor) {
    return null;
  }

  if (typeof anchor === "string") {
    return document.getElementById(anchor);
  } else {
    return anchor;
  }
}
/**
 * Given two rectangles it generates a list of candidate positions for the
 * target rectangle.
 *
 *      Left-aligned  | Right-aligned
 *      +---------+   |   +---------+
 *      |    C    |   |   |    D    |
 *      +---------+   |   +---------+
 *      (spacing)     |     (spacing)
 *      +------+      |      +------+
 *      |Anchor|      |      |Anchor|
 *      +------+      |      +------+
 *      (spacing)     |     (spacing)
 *      +---------+   |   +---------+
 *      |    A    |   |   |    B    |
 *      +---------+   |   +---------+
 *
 * Centered Right (E) | Centered Left (F)
 *           +----+   |   +----+
 * +------+  |    |   |   |    | +------+
 * |Anchor|  | E  |   |   | F  | |Anchor|
 * +------+  |    |   |   |    | +------+
 *           +----+   |   +----+
 *
 * Position G: Like E but positioned at the top of the clippedArea
 * Position H: Like F but positioned at the top of the clippedArea
 *
 * @internal
 */

function getCandidates(anchor, target, clippedArea, spacing) {
  var dw = target.width - anchor.width;
  var a = {
    x: anchor.x,
    y: anchor.y + anchor.height + spacing,
    width: target.width,
    height: target.height
  };
  var b = {
    x: anchor.x - dw,
    y: anchor.y + anchor.height + spacing,
    width: target.width,
    height: target.height
  };
  var c = {
    x: anchor.x,
    y: anchor.y - target.height - spacing,
    width: target.width,
    height: target.height
  };
  var d = {
    x: anchor.x - dw,
    y: anchor.y - target.height - spacing,
    width: target.width,
    height: target.height
  };
  var e = {
    x: anchor.x + anchor.width + spacing,
    y: anchor.y + anchor.height / 2 - target.height / 2,
    width: target.width,
    height: target.height
  };
  var f = {
    x: anchor.x - (target.width + spacing),
    y: anchor.y + anchor.height / 2 - target.height / 2,
    width: target.width,
    height: target.height
  };
  var g = {
    x: anchor.x + anchor.width + spacing,
    y: clippedArea.y + spacing,
    width: target.width,
    height: target.height
  };
  var h = {
    x: anchor.x - (target.width + spacing),
    y: clippedArea.y + spacing,
    width: target.width,
    height: target.height
  };
  return [a, b, c, d, e, f, g, h];
}
/**
 * Returns true if the inner rect is fully contained inside the outer rect
 * (minus spacing). Comparision is inclusive, i.e. the inner can overlap
 * outer.
 *
 * @internal
 */

function isInside(outer, inner, spacing) {
  var ax = [inner.x, inner.x + inner.width];
  var ay = [inner.y, inner.y + inner.height];
  var bx = [outer.x + spacing, outer.x + outer.width - spacing];
  var by = [outer.y + spacing, outer.y + outer.height - spacing];

  if (ax[0] < bx[0] || ax[1] > bx[1]) {
    return false;
  }

  if (ay[0] < by[0] || ay[1] > by[1]) {
    return false;
  }

  return true;
}

function isElementOptions(options) {
  return options.target instanceof HTMLElement;
}
/**
 * Clip given rect so no edges is outside the viewport, i.e. the rect where rect
 * and viewport intersects.
 *
 * @internal
 */


function clipRect(src, clip) {
  if (!clip) {
    return src;
  }

  var x = Math.max(src.x, clip.x);
  var y = Math.max(src.y, clip.y);
  var width = Math.min(src.x + src.width, clip.x + clip.width) - x;
  var height = Math.min(src.y + src.height, clip.y + clip.height) - y;
  return {
    x: x,
    y: y,
    width: width,
    height: height
  };
}
function getAbsolutePosition(src) {
  if (!src) {
    return undefined;
  }

  var isRoot = src.isSameNode(document.documentElement);

  if (isRoot) {
    return {
      x: window.pageXOffset,
      y: window.pageYOffset,
      width: src.clientWidth,
      height: src.clientHeight
    };
  }

  var rect = src.getBoundingClientRect();
  return {
    x: Math.floor(rect.left + window.pageXOffset),
    y: Math.floor(rect.top + window.pageYOffset),
    width: Math.floor(rect.width),
    height: Math.floor(rect.height)
  };
}
function fitInsideArea(options) {
  var _a;

  if (isElementOptions(options)) {
    var areaElement = options.area,
        anchorElement = options.anchor,
        targetElement = options.target,
        viewportElement = options.viewport,
        spacing_1 = options.spacing;
    var area_1 = getAbsolutePosition(areaElement);
    var anchor_1 = getAbsolutePosition(anchorElement);
    var target_1 = getAbsolutePosition(targetElement);
    var viewport_1 = getAbsolutePosition(viewportElement);
    var result = fitInsideArea({
      area: area_1,
      target: target_1,
      anchor: anchor_1,
      viewport: viewport_1,
      spacing: spacing_1
    });
    var offset_1 = (_a = targetElement.offsetParent) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();

    if (!offset_1) {
      return result;
    }

    return IPopupUtils_assign(IPopupUtils_assign({}, result), {
      x: result.x - (offset_1.left + window.pageXOffset),
      y: result.y - (offset_1.top + window.pageYOffset)
    });
  }

  var anchor = options.anchor,
      target = options.target,
      area = options.area,
      viewport = options.viewport,
      spacing = options.spacing;
  var clippedArea = clipRect(area, viewport);
  var candidates = getCandidates(anchor, target, clippedArea, spacing);
  /* try to find a good match, i.e. a candidate where the entire target fits
   * inside given area */

  var index = candidates.findIndex(function (it) {
    return isInside(clippedArea, it, spacing);
  });

  if (index >= 0) {
    var match = candidates[index];
    return {
      x: match.x,
      y: match.y,
      candidate: index
    };
  }
  /* if all candidates would be obscured position target below anchor but
   * try to keep as close to anchor horizontal position as possible */


  return IPopupUtils_assign(IPopupUtils_assign({}, getFallbackPosition(anchor, target, clippedArea, spacing)), {
    candidate: -1
  });
}
/**
 * When opening poupup inline this metod
 * calculates the need scroll to get the
 * popup within the viewport.
 *
 * @param param
 */

function getScrollToPopup(param) {
  var popupOffset = offset({
    pageXOffset: 0,
    pageYOffset: param.scrollTop
  }, param.popup);
  var popupHeight = param.popup.offsetHeight;
  var neededScroll = popupOffset.top - param.windowInnerHeight + popupHeight + param.spacing;

  if (neededScroll > param.scrollTop) {
    return neededScroll;
  } else {
    return param.scrollTop;
  }
}
/**
 * Get the fallback position coordinates
 * try to align with anchor.x if there is room for the target
 * if target is outside the clippedArea, use no horizontal alignment
 *
 * @internal
 */

function getFallbackPosition(anchor, target, clippedArea, spacing) {
  var x = anchor.x - (target.width + spacing);
  var y = anchor.y + anchor.height + spacing;

  if (x >= clippedArea.x) {
    return {
      x: x,
      y: y
    };
  } else {
    // no horizontal alignment
    return {
      x: clippedArea.x + spacing,
      y: y
    };
  }
}
// CONCATENATED MODULE: ./src/internal-components/IPopup/get-focusable-element.ts

function getFocusableElement(rootElement, callback) {
  var _a;
  /* if user callback is provided use that only, if it returns null no element should be focused */


  if (callback) {
    return callback();
  }
  /* if no callback is provided we lookup the first tabbable element in the popup */


  var elements = Object(logic_["findTabbableElements"])(rootElement);
  return (_a = elements[0]) !== null && _a !== void 0 ? _a : null;
  /* null coalece */
}
// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/internal-components/IPopup/IPopup.vue?vue&type=script&lang=ts&











var IPopupvue_type_script_lang_ts_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var IPopupvue_type_script_lang_ts_generator = undefined && undefined.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};






/* harmony default export */ var IPopupvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: "IPopup",
  inheritAttrs: false,
  props: {
    /**
     * Toggle open/closed popup.
     */
    isOpen: {
      type: Boolean,
      required: true
    },

    /**
     * DOM element to position popup at.
     */
    anchor: {
      type: HTMLElement,
      required: false,
      default: undefined
    },

    /**
     * Force popup to always display inline.
     */
    alwaysInline: {
      type: Boolean,
      default: false
    },

    /**
     * Which element to use as viewport
     */
    viewport: {
      type: HTMLElement,
      required: false,
      default: function _default() {
        return document.body;
      }
    },

    /**
     * Prevents tabbing outside of component.
     */
    keyboardTrap: {
      type: Boolean,
      required: false,
      default: true
    },

    /**
     * Function that returns the element that will receive focus
     */
    focusElement: {
      type: Function,
      required: false,
      default: null
    }
  },
  data: function data() {
    return {
      focus: null
    };
  },
  computed: {
    popupClasses: function popupClasses() {
      return {
        popup: !this.alwaysInline,
        "popup--force-inline": this.alwaysInline
      };
    }
  },
  watch: {
    isOpen: {
      immediate: true,
      handler: function handler(value) {
        var _this = this;

        this.toggleIsOpen(value);

        if (value) {
          // wait one tick so we dont get the click
          // that launches the popup (await nextTick doesnt work here)
          setTimeout(function () {
            document.addEventListener("click", _this.onDocumentClickHandler);
            window.addEventListener("resize", _this.onWindowResizeHandler);
          }, 0);
        } else {
          document.removeEventListener("click", this.onDocumentClickHandler);
          window.removeEventListener("resize", this.onWindowResizeHandler);
        }
      }
    }
  },
  destroyed: function destroyed() {
    // Clean up if destroyed but still opened
    document.removeEventListener("click", this.onDocumentClickHandler);
    window.removeEventListener("resize", this.onWindowResizeHandler);
  },
  methods: {
    toggleIsOpen: function toggleIsOpen(isOpen) {
      return IPopupvue_type_script_lang_ts_awaiter(this, void 0, Promise, function () {
        var focusableElement, popup, anchor, spacing, top, area, viewport, result;
        return IPopupvue_type_script_lang_ts_generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              /* popup is closing */
              if (!isOpen) {
                /* restore focus */
                if (this.focus) {
                  Object(logic_["popFocus"])(this.focus);
                  this.focus = null;
                }

                return [2
                /*return*/
                ];
              }
              /* popup is opening */
              // Wait for popup to show up


              return [4
              /*yield*/
              , this.$nextTick()];

            case 1:
              /* popup is opening */
              // Wait for popup to show up
              _a.sent();

              focusableElement = getFocusableElement(this.$el, this.focusElement);
              this.focus = Object(logic_["pushFocus"])(focusableElement);
              popup = this.$refs["popup"];
              anchor = getElement(this.anchor);
              spacing = 20;

              if (!anchor) {
                throw new Error("No anchor element found");
              }

              if (this.isMobileOrForcedInline()) {
                top = getScrollToPopup({
                  popup: popup,
                  windowInnerHeight: window.innerHeight,
                  scrollTop: window.pageYOffset,
                  spacing: spacing
                });
                popup.style.removeProperty("left");
                popup.style.removeProperty("top");
                window.scrollTo({
                  top: top,
                  behavior: "smooth"
                });
              } else {
                area = document.body;
                viewport = this.viewport;
                result = fitInsideArea({
                  area: area,
                  anchor: anchor,
                  target: popup,
                  viewport: viewport,
                  spacing: spacing
                });
                popup.style.left = "".concat(result.x, "px");
                popup.style.top = "".concat(result.y, "px");
              }

              return [2
              /*return*/
              ];
          }
        });
      });
    },
    isMobileOrForcedInline: function isMobileOrForcedInline() {
      return window.innerWidth < 640 || this.alwaysInline;
    },
    onDocumentClickHandler: function onDocumentClickHandler() {
      this.$emit("close");
    },
    onWindowResizeHandler: function onWindowResizeHandler() {
      this.$emit("close");
    },
    onPopupClickHandler: function onPopupClickHandler(event) {
      // prevent propagation so we don't catch this
      // event in onDocumentClickHandler and close ourself.
      event.stopPropagation();
    },
    onKeyEsc: function onKeyEsc() {
      this.$emit("close");
    },
    onKeyTab: function onKeyTab(event) {
      if (this.keyboardTrap) {
        Object(logic_["handleTab"])(event, this.$refs.popup);
      }
    }
  }
}));
// CONCATENATED MODULE: ./src/internal-components/IPopup/IPopup.vue?vue&type=script&lang=ts&
 /* harmony default export */ var IPopup_IPopupvue_type_script_lang_ts_ = (IPopupvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/internal-components/IPopup/IPopup.vue





/* normalize component */

var IPopup_component = normalizeComponent(
  IPopup_IPopupvue_type_script_lang_ts_,
  IPopupvue_type_template_id_ce2be6a0_render,
  IPopupvue_type_template_id_ce2be6a0_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var IPopup = (IPopup_component.exports);
// CONCATENATED MODULE: ./src/internal-components/IPopup/index.ts

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/internal-components/IMenu/IMenu.vue?vue&type=template&id=070d2e4f&
var IMenuvue_type_template_id_070d2e4f_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"imenu",class:_vm.cssClasses,on:{"keyup":_vm.onKeyUp,"keydown":_vm.onKeyDown}},[_c('ul',{staticClass:"imenu__list"},_vm._l((_vm.items),function(item,index){return _c('li',{key:item.key,ref:"items",refInFor:true,staticClass:"imenu__list__item",class:_vm.cssClassHighlight(item),on:{"click":function($event){return _vm.onClickItem(item)}}},[_c('a',{ref:"anchors",refInFor:true,attrs:{"href":item.href,"tabindex":_vm.tabIndex(index),"target":item.target}},[_vm._v(_vm._s(item.label)+" "),(item.iconRight)?_c('f-icon',{attrs:{"name":item.iconRight}}):_vm._e()],1)])}),0)])}
var IMenuvue_type_template_id_070d2e4f_staticRenderFns = []


// CONCATENATED MODULE: ./src/internal-components/IMenu/IMenu.vue?vue&type=template&id=070d2e4f&

// CONCATENATED MODULE: ./src/internal-components/IMenu/imenu-utils.ts


/**
 * Find the first element to overflow.
 *
 * @returns Element index or -1 if no element overflows.
 */
function findOverflowIndex(totalWidth, elements) {
  var sum = 0;
  return elements.findIndex(function (element) {
    sum += element.offsetWidth;
    return sum > totalWidth;
  });
}
// CONCATENATED MODULE: ./src/internal-components/IMenu/imenu-logic.ts










var imenu_logic_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var imenu_logic_generator = undefined && undefined.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var MenuAction;

(function (MenuAction) {
  MenuAction[MenuAction["MOVE_NEXT"] = 0] = "MOVE_NEXT";
  MenuAction[MenuAction["MOVE_PREV"] = 1] = "MOVE_PREV";
  MenuAction[MenuAction["MOVE_FIRST"] = 2] = "MOVE_FIRST";
  MenuAction[MenuAction["MOVE_LAST"] = 3] = "MOVE_LAST";
  MenuAction[MenuAction["ACTIVATE"] = 4] = "ACTIVATE";
})(MenuAction || (MenuAction = {}));

function getNewItemIndexFromMenuAction(action, index, n) {
  var newIndex;

  if (n <= 0) {
    return 0;
  }

  switch (action) {
    case MenuAction.MOVE_NEXT:
      newIndex = (index + 1) % n;
      break;

    case MenuAction.MOVE_PREV:
      newIndex = (index - 1 + n) % n;
      break;

    case MenuAction.MOVE_FIRST:
      newIndex = 0;
      break;

    case MenuAction.MOVE_LAST:
      newIndex = Math.max(n - 1, 0);
      break;

    default:
      newIndex = index;
  }

  return newIndex;
}
function doMenuAction(action, target) {
  return imenu_logic_awaiter(this, void 0, Promise, function () {
    var itemsLength, currentIndex, newFocusedItemIndex, _a;

    return imenu_logic_generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          itemsLength = target.items.length;
          currentIndex = target.currentFocusedItemIndex;
          newFocusedItemIndex = getNewItemIndexFromMenuAction(action, currentIndex, itemsLength);
          _a = action;

          switch (_a) {
            case MenuAction.MOVE_NEXT:
              return [3
              /*break*/
              , 1];

            case MenuAction.MOVE_PREV:
              return [3
              /*break*/
              , 1];

            case MenuAction.MOVE_FIRST:
              return [3
              /*break*/
              , 1];

            case MenuAction.MOVE_LAST:
              return [3
              /*break*/
              , 1];

            case MenuAction.ACTIVATE:
              return [3
              /*break*/
              , 3];
          }

          return [3
          /*break*/
          , 5];

        case 1:
          return [4
          /*yield*/
          , target.setFocusOnItem(newFocusedItemIndex)];

        case 2:
          _b.sent();

          return [3
          /*break*/
          , 5];

        case 3:
          return [4
          /*yield*/
          , target.activateItem(newFocusedItemIndex)];

        case 4:
          _b.sent();

          return [3
          /*break*/
          , 5];

        case 5:
          return [2
          /*return*/
          ];
      }
    });
  });
}
function actionFromKeyboardEvent(event) {
  switch (event.key) {
    case "End":
      return MenuAction.MOVE_LAST;

    case "Home":
      return MenuAction.MOVE_FIRST;

    case "Up":
    case "ArrowUp":
      return MenuAction.MOVE_PREV;

    case "Down":
    case "ArrowDown":
      return MenuAction.MOVE_NEXT;

    case "Left":
    case "ArrowLeft":
      return MenuAction.MOVE_PREV;

    case "Right":
    case "ArrowRight":
      return MenuAction.MOVE_NEXT;

    case "Tab":
      return MenuAction.MOVE_NEXT;

    case " ":
    case "Spacebar":
    case "Enter":
      return MenuAction.ACTIVATE;

    default:
      return null;
  }
}
// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/internal-components/IMenu/IMenu.vue?vue&type=script&lang=ts&











var IMenuvue_type_script_lang_ts_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var IMenuvue_type_script_lang_ts_generator = undefined && undefined.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};








var preventKeys = ["Tab", "Up", "Down", "Left", "Right", "ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight", "Home", "End", " ", "Spacebar", "Enter"];
/* harmony default export */ var IMenuvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: "IMenu",
  components: {
    FIcon: FIcon
  },
  model: {
    prop: "highlight",
    event: "select"
  },
  props: {
    /**
     * The currently highlighted menu item key
     */
    highlight: {
      type: String,
      required: false,
      default: ""
    },

    /**
     * The items to be diplayed in the menu
     */
    items: {
      type: Array,
      required: true
    },

    /**
     * If true, show the menu vertically
     */
    vertical: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      resizeObserver: undefined,
      currentFocusedItemIndex: 0
    };
  },
  computed: {
    cssClasses: function cssClasses() {
      return {
        "imenu--horizontal": !this.vertical,
        "imenu--vertical": this.vertical
      };
    },
    anchors: function anchors() {
      return getHTMLElementsFromVueRef(this.$refs.anchors);
    }
  },
  watch: {
    items: {
      handler: function handler() {
        return IMenuvue_type_script_lang_ts_awaiter(this, void 0, void 0, function () {
          return IMenuvue_type_script_lang_ts_generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                return [4
                /*yield*/
                , this.$nextTick()];

              case 1:
                _a.sent();

                this.onResize();
                return [2
                /*return*/
                ];
            }
          });
        });
      }
    }
  },
  mounted: function mounted() {
    this.currentFocusedItemIndex = 0;

    if (!this.vertical) {
      this.resizeObserver = new ResizeObserver(Object(logic_["debounce"])(this.onResize, 100));
      this.resizeObserver.observe(this.$el);
      this.onResize();
    }
  },
  destroyed: function destroyed() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  },
  methods: {
    onClickItem: function onClickItem(item, doClick) {
      if (doClick === void 0) {
        doClick = false;
      }
      /**
       *  V-model event. Event that is dispatched when an item is clicked.
       *
       * @event select
       * @type {string} item key
       */


      this.$emit("select", item.key);

      if (item.href && doClick) {
        this.anchors[this.currentFocusedItemIndex].click();
      }
    },
    onResize: function onResize() {
      var barElement = this.$el;

      if (!barElement) {
        return;
      }

      var barWidth = barElement.offsetWidth;
      var itemElements = this.$refs["items"];
      var overflowIndex = findOverflowIndex(barWidth, itemElements);
      /**
       * Emitted on item overflow. Event that is dispatched when the horizontal
       * menu items do not fit in the current total width.
       * The event payload is the item position/index of the item in overflow.
       *
       * @event overflow
       * @type {number} index for overflowed item
       */

      this.$emit("overflow", overflowIndex);
    },
    cssClassHighlight: function cssClassHighlight(item) {
      return item.key === this.highlight ? "imenu__list__item--highlight" : "";
    },
    tabIndex: function tabIndex(index) {
      return index === this.currentFocusedItemIndex ? 0 : -1;
    },
    onKeyUp: function onKeyUp(event) {
      if (preventKeys.includes(event.key)) {
        event.preventDefault();
      }
    },
    onKeyDown: function onKeyDown(event) {
      return IMenuvue_type_script_lang_ts_awaiter(this, void 0, void 0, function () {
        var action;
        return IMenuvue_type_script_lang_ts_generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              action = actionFromKeyboardEvent(event);
              if (!(action !== null)) return [3
              /*break*/
              , 2];
              event.preventDefault();
              return [4
              /*yield*/
              , doMenuAction(action, this)];

            case 1:
              _a.sent();

              _a.label = 2;

            case 2:
              return [2
              /*return*/
              ];
          }
        });
      });
    },
    setFocusOnItem: function setFocusOnItem(index) {
      return IMenuvue_type_script_lang_ts_awaiter(this, void 0, Promise, function () {
        var menuItem;
        return IMenuvue_type_script_lang_ts_generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              this.currentFocusedItemIndex = index;
              return [4
              /*yield*/
              , this.$nextTick()];

            case 1:
              _a.sent();

              menuItem = this.anchors[index];
              Object(logic_["focus"])(menuItem);
              return [2
              /*return*/
              ];
          }
        });
      });
    },
    activateItem: function activateItem(index) {
      return IMenuvue_type_script_lang_ts_awaiter(this, void 0, Promise, function () {
        return IMenuvue_type_script_lang_ts_generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              if (!(index !== this.currentFocusedItemIndex)) return [3
              /*break*/
              , 2];
              return [4
              /*yield*/
              , this.setFocusOnItem(index)];

            case 1:
              _a.sent();

              _a.label = 2;

            case 2:
              this.onClickItem(this.items[this.currentFocusedItemIndex], true);
              return [2
              /*return*/
              ];
          }
        });
      });
    }
  }
}));
// CONCATENATED MODULE: ./src/internal-components/IMenu/IMenu.vue?vue&type=script&lang=ts&
 /* harmony default export */ var IMenu_IMenuvue_type_script_lang_ts_ = (IMenuvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/internal-components/IMenu/IMenu.vue





/* normalize component */

var IMenu_component = normalizeComponent(
  IMenu_IMenuvue_type_script_lang_ts_,
  IMenuvue_type_template_id_070d2e4f_render,
  IMenuvue_type_template_id_070d2e4f_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var IMenu = (IMenu_component.exports);
// CONCATENATED MODULE: ./src/internal-components/IMenu/index.ts

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/internal-components/IPopupMenu/IPopupMenu.vue?vue&type=template&id=0c841dcf&
var IPopupMenuvue_type_template_id_0c841dcf_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i-popup',{staticClass:"ipopupmenu",attrs:{"is-open":_vm.isOpen,"keyboard-trap":false,"anchor":_vm.anchor,"always-inline":false},on:{"close":function($event){return _vm.$emit('close')}}},[_c('nav',{staticClass:"ipopupmenu ipopupmenu--vertical",on:{"keyup":_vm.onKeyUp,"keydown":_vm.onKeyDown}},[_c('ul',{staticClass:"ipopupmenu__list",attrs:{"role":"menu"}},_vm._l((_vm.items),function(item,index){return _c('li',{key:item.key,ref:"items",refInFor:true,staticClass:"ipopupmenu__list__item",class:_vm.cssClassHighlight(item),attrs:{"role":"presentation"},on:{"click":function($event){return _vm.onClickItem(item)}}},[_c('a',{ref:"anchors",refInFor:true,attrs:{"href":item.href,"role":"menuitem","target":item.target,"tabindex":_vm.tabIndex(index)}},[_vm._v(_vm._s(item.label)+" "),(item.iconRight)?_c('f-icon',{attrs:{"name":item.iconRight}}):_vm._e()],1)])}),0)])])}
var IPopupMenuvue_type_template_id_0c841dcf_staticRenderFns = []


// CONCATENATED MODULE: ./src/internal-components/IPopupMenu/IPopupMenu.vue?vue&type=template&id=0c841dcf&

// CONCATENATED MODULE: ./src/internal-components/IPopupMenu/ipopupmenu-logic.ts










var ipopupmenu_logic_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var ipopupmenu_logic_generator = undefined && undefined.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var ipopupmenu_logic_MenuAction;

(function (MenuAction) {
  MenuAction[MenuAction["MOVE_NEXT"] = 0] = "MOVE_NEXT";
  MenuAction[MenuAction["MOVE_PREV"] = 1] = "MOVE_PREV";
  MenuAction[MenuAction["MOVE_FIRST"] = 2] = "MOVE_FIRST";
  MenuAction[MenuAction["MOVE_LAST"] = 3] = "MOVE_LAST";
  MenuAction[MenuAction["ACTIVATE"] = 4] = "ACTIVATE";
})(ipopupmenu_logic_MenuAction || (ipopupmenu_logic_MenuAction = {}));

function ipopupmenu_logic_getNewItemIndexFromMenuAction(action, index, n) {
  var newIndex;

  if (n <= 0) {
    return 0;
  }

  switch (action) {
    case ipopupmenu_logic_MenuAction.MOVE_NEXT:
      newIndex = (index + 1) % n;
      break;

    case ipopupmenu_logic_MenuAction.MOVE_PREV:
      newIndex = (index - 1 + n) % n;
      break;

    case ipopupmenu_logic_MenuAction.MOVE_FIRST:
      newIndex = 0;
      break;

    case ipopupmenu_logic_MenuAction.MOVE_LAST:
      newIndex = Math.max(n - 1, 0);
      break;

    default:
      newIndex = index;
  }

  return newIndex;
}
function ipopupmenu_logic_doMenuAction(action, target) {
  return ipopupmenu_logic_awaiter(this, void 0, Promise, function () {
    var itemsLength, currentIndex, newFocusedItemIndex, _a;

    return ipopupmenu_logic_generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          itemsLength = target.items.length;
          currentIndex = target.currentFocusedItemIndex;
          newFocusedItemIndex = ipopupmenu_logic_getNewItemIndexFromMenuAction(action, currentIndex, itemsLength);
          _a = action;

          switch (_a) {
            case ipopupmenu_logic_MenuAction.MOVE_NEXT:
              return [3
              /*break*/
              , 1];

            case ipopupmenu_logic_MenuAction.MOVE_PREV:
              return [3
              /*break*/
              , 1];

            case ipopupmenu_logic_MenuAction.MOVE_FIRST:
              return [3
              /*break*/
              , 1];

            case ipopupmenu_logic_MenuAction.MOVE_LAST:
              return [3
              /*break*/
              , 1];

            case ipopupmenu_logic_MenuAction.ACTIVATE:
              return [3
              /*break*/
              , 3];
          }

          return [3
          /*break*/
          , 5];

        case 1:
          return [4
          /*yield*/
          , target.setFocusOnItem(newFocusedItemIndex)];

        case 2:
          _b.sent();

          return [3
          /*break*/
          , 5];

        case 3:
          return [4
          /*yield*/
          , target.activateItem(newFocusedItemIndex)];

        case 4:
          _b.sent();

          return [3
          /*break*/
          , 5];

        case 5:
          return [2
          /*return*/
          ];
      }
    });
  });
}
function ipopupmenu_logic_actionFromKeyboardEvent(event) {
  switch (event.key) {
    case "End":
      return ipopupmenu_logic_MenuAction.MOVE_LAST;

    case "Home":
      return ipopupmenu_logic_MenuAction.MOVE_FIRST;

    case "Up":
    case "ArrowUp":
      return ipopupmenu_logic_MenuAction.MOVE_PREV;

    case "Down":
    case "ArrowDown":
      return ipopupmenu_logic_MenuAction.MOVE_NEXT;

    case " ":
    case "Spacebar":
    case "Enter":
      return ipopupmenu_logic_MenuAction.ACTIVATE;

    default:
      return null;
  }
}
// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/internal-components/IPopupMenu/IPopupMenu.vue?vue&type=script&lang=ts&










var IPopupMenuvue_type_script_lang_ts_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var IPopupMenuvue_type_script_lang_ts_generator = undefined && undefined.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};






/* harmony default export */ var IPopupMenuvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: "IPopupMenu",
  components: {
    IPopup: IPopup
  },
  model: {
    prop: "highlight",
    event: "select"
  },
  props: {
    /**
     * Toggle open/closed popup.
     */
    isOpen: {
      type: Boolean,
      required: true
    },

    /**
     * DOM element to position popup at.
     */
    anchor: {
      type: HTMLElement,
      default: undefined
    },

    /**
     * The currently highlighted menu item key
     */
    highlight: {
      type: String,
      required: false,
      default: ""
    },

    /**
     * The items to be diplayed in the menu
     */
    items: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      selectedItem: this.highlight,
      currentFocusedItemIndex: 0
    };
  },
  watch: {
    isOpen: {
      immediate: true,
      handler: function handler() {
        return IPopupMenuvue_type_script_lang_ts_awaiter(this, void 0, Promise, function () {
          var anchors, popupMenuFirstItem;
          return IPopupMenuvue_type_script_lang_ts_generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                if (!this.isOpen) return [3
                /*break*/
                , 2];
                return [4
                /*yield*/
                , this.$nextTick()];

              case 1:
                _a.sent();

                anchors = getHTMLElementsFromVueRef(this.$refs.anchors);
                popupMenuFirstItem = anchors[0];
                popupMenuFirstItem.focus();
                this.currentFocusedItemIndex = 0;
                _a.label = 2;

              case 2:
                return [2
                /*return*/
                ];
            }
          });
        });
      }
    }
  },
  methods: {
    onClickItem: function onClickItem(item, doClick) {
      if (doClick === void 0) {
        doClick = false;
      }
      /**
       * V-model event. Event that is dispatched when an item is selected.
       * @event select
       * @type {string} item key
       */


      this.$emit("select", item.key);
      /**
       * Event that is dispatched after an item is selected or
       * after pressing tab in the menu
       */

      this.$emit("close");

      if (item.href && doClick) {
        var anchors = getHTMLElementsFromVueRef(this.$refs.anchors);
        anchors[this.currentFocusedItemIndex].click();
      }
    },
    cssClassHighlight: function cssClassHighlight(item) {
      return item.key === this.highlight ? "ipopupmenu__list__item--highlight" : "";
    },
    tabIndex: function tabIndex(index) {
      return index === this.currentFocusedItemIndex ? 0 : -1;
    },
    onKeyUp: function onKeyUp(event) {
      switch (event.key) {
        case "Tab":
          // emit close and let event propagate
          this.$emit("close");
          break;

        case "Up":
        case "Down":
        case "ArrowUp":
        case "ArrowDown":
        case "Home":
        case "End":
        case " ":
        case "Spacebar":
        case "Enter":
          // stop event propagation to avoid scrolling
          event.preventDefault();
          break;
      }
    },
    onKeyDown: function onKeyDown(event) {
      return IPopupMenuvue_type_script_lang_ts_awaiter(this, void 0, void 0, function () {
        var action;
        return IPopupMenuvue_type_script_lang_ts_generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              action = ipopupmenu_logic_actionFromKeyboardEvent(event);
              if (!(action !== null)) return [3
              /*break*/
              , 2];
              event.preventDefault();
              return [4
              /*yield*/
              , ipopupmenu_logic_doMenuAction(action, this)];

            case 1:
              _a.sent();

              _a.label = 2;

            case 2:
              return [2
              /*return*/
              ];
          }
        });
      });
    },
    setFocusOnItem: function setFocusOnItem(index) {
      return IPopupMenuvue_type_script_lang_ts_awaiter(this, void 0, Promise, function () {
        var anchors, popupMenuItem;
        return IPopupMenuvue_type_script_lang_ts_generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              this.currentFocusedItemIndex = index;
              return [4
              /*yield*/
              , this.$nextTick()];

            case 1:
              _a.sent();

              anchors = getHTMLElementsFromVueRef(this.$refs.anchors);
              popupMenuItem = anchors[index];
              Object(logic_["focus"])(popupMenuItem, {
                preventScroll: true
              });
              return [2
              /*return*/
              ];
          }
        });
      });
    },
    activateItem: function activateItem(index) {
      return IPopupMenuvue_type_script_lang_ts_awaiter(this, void 0, Promise, function () {
        return IPopupMenuvue_type_script_lang_ts_generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              if (!(index !== this.currentFocusedItemIndex)) return [3
              /*break*/
              , 2];
              return [4
              /*yield*/
              , this.setFocusOnItem(index)];

            case 1:
              _a.sent();

              _a.label = 2;

            case 2:
              this.onClickItem(this.items[this.currentFocusedItemIndex], true);
              return [2
              /*return*/
              ];
          }
        });
      });
    }
  }
}));
// CONCATENATED MODULE: ./src/internal-components/IPopupMenu/IPopupMenu.vue?vue&type=script&lang=ts&
 /* harmony default export */ var IPopupMenu_IPopupMenuvue_type_script_lang_ts_ = (IPopupMenuvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/internal-components/IPopupMenu/IPopupMenu.vue





/* normalize component */

var IPopupMenu_component = normalizeComponent(
  IPopupMenu_IPopupMenuvue_type_script_lang_ts_,
  IPopupMenuvue_type_template_id_0c841dcf_render,
  IPopupMenuvue_type_template_id_0c841dcf_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var IPopupMenu = (IPopupMenu_component.exports);
// CONCATENATED MODULE: ./src/internal-components/IPopupMenu/index.ts

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/internal-components/IAnimateExpand/IAnimateExpand.vue?vue&type=template&id=6439ab02&
var IAnimateExpandvue_type_template_id_6439ab02_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.animationClasses,style:(_vm.heightStyle)},[(_vm.shouldVIf)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.shouldVShow),expression:"shouldVShow"}],ref:"content",attrs:{"data-test":"animation-content"}},[_vm._t("default")],2):_vm._e()])}
var IAnimateExpandvue_type_template_id_6439ab02_staticRenderFns = []


// CONCATENATED MODULE: ./src/internal-components/IAnimateExpand/IAnimateExpand.vue?vue&type=template&id=6439ab02&

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/internal-components/IAnimateExpand/IAnimateExpand.vue?vue&type=script&lang=ts&












var IAnimateExpandvue_type_script_lang_ts_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var IAnimateExpandvue_type_script_lang_ts_generator = undefined && undefined.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};


var ANIMATION_DURATION = 500;
var NO_CSS_CLASSES = "";
var CLOSED_CSS_CLASS_OPACITY = "animate-expand animate-expand--opacity";
var CLOSED_CSS_CLASS = "animate-expand";
var ANIMATION_CSS_CLASSES = "animate-expand animate-expand--expanded";
/* harmony default export */ var IAnimateExpandvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: "IAnimateExpand",
  props: {
    /**
     * Perform animation or not
     */
    animate: {
      type: Boolean,
      default: true
    },

    /**
     * Use v-show instead of v-if when hiding content.
     */
    useVShow: {
      type: Boolean,
      default: false
    },

    /**
     * Toggle expanded/collapsed state
     */
    expanded: {
      type: [String, Number, Boolean],
      default: true
    },

    /* Toggle opacity in animation */
    opacity: {
      type: Boolean,
      default: true
    },

    /**
     * Optional callback for performing actions before animation.
     * Callback will await Promise.
     */
    beforeAnimation: {
      type: Function,
      required: false,
      default: function _default() {
        /* do nothing by default */
      }
    },

    /**
     * Optional callback for performing actions after animation.
     * Callback will await Promise.
     */
    afterAnimation: {
      type: Function,
      required: false,
      default: function _default() {
        /* do nothing by default */
      }
    }
  },
  data: function data() {
    return {
      internalExpanded: Boolean(this.expanded),
      height: 0,
      isAnimating: false,
      cssClasses: "",

      /**
       * When the open animation is triggered it creates a timer for `ANIMATION_DURATION`.
       * If the collapse animation is triggered before this timer has started
       * it must be canceled or the previous opening will reset the state before collapse is finished thus corrupting the state of the element.
       * Vice verse when collapse animation is triggered it also creates timers which the open animation must cancel.
       * Actor            IAnimationExpand
       * |                      |
       * +----[ open ] -------> |
       * |                      +----+ Timer 1
       * |                      |    |
       * +----[ close ] ------> |    |
       * |                      +----)----+ Timer 2
       * |                      |    |    |
       * |            *KABOOM*  |<---+    |
       * |                      |         |
       * |                      |         |
       * |            *KABOOM*  |<--------+
       * |                      |
       */
      timerList: []
    };
  },
  computed: {
    animationClasses: function animationClasses() {
      if (!this.animate) {
        return "";
      }

      return this.cssClasses;
    },
    heightStyle: function heightStyle() {
      return this.height === "" ? "" : "height: ".concat(this.height, "px");
    },
    shouldVIf: function shouldVIf() {
      if (this.useVShow) {
        return true;
      } else {
        return this.internalExpanded;
      }
    },
    shouldVShow: function shouldVShow() {
      if (this.useVShow) {
        return this.internalExpanded;
      } else {
        return true;
      }
    }
  },
  watch: {
    expanded: {
      immediate: false,
      handler: function handler() {
        if (this.expanded && this.animate) {
          this.openAnimation();
        } else if (this.expanded) {
          this.openNoAnimation();
        } else if (this.animate) {
          this.closeAnimation();
        } else {
          this.closeNoAnimation();
        }
      }
    }
  },
  beforeMount: function beforeMount() {
    // We don't want an initial animation (solved by immediate: false in watch),
    // but we need to setup css classes here for coming animations.
    if (this.expanded) {
      this.height = "";
    } else if (this.animate) {
      this.cssClasses = this.opacity ? CLOSED_CSS_CLASS_OPACITY : CLOSED_CSS_CLASS;
    }
  },
  methods: {
    getContentHeight: function getContentHeight() {
      var content = this.$refs.content;
      return content ? content.getBoundingClientRect().height : 0;
    },
    openNoAnimation: function openNoAnimation() {
      return IAnimateExpandvue_type_script_lang_ts_awaiter(this, void 0, Promise, function () {
        return IAnimateExpandvue_type_script_lang_ts_generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , this.beforeAnimation(true)];

            case 1:
              _a.sent();

              this.internalExpanded = true;
              return [4
              /*yield*/
              , this.$nextTick()];

            case 2:
              _a.sent();

              this.cssClasses = NO_CSS_CLASSES;
              this.height = this.getContentHeight();
              return [4
              /*yield*/
              , this.afterAnimation(true)];

            case 3:
              _a.sent();

              return [2
              /*return*/
              ];
          }
        });
      });
    },
    closeNoAnimation: function closeNoAnimation() {
      return IAnimateExpandvue_type_script_lang_ts_awaiter(this, void 0, Promise, function () {
        return IAnimateExpandvue_type_script_lang_ts_generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , this.beforeAnimation(false)];

            case 1:
              _a.sent();

              this.internalExpanded = false;
              this.cssClasses = NO_CSS_CLASSES;
              this.height = "0";
              return [4
              /*yield*/
              , this.$nextTick()];

            case 2:
              _a.sent();

              return [4
              /*yield*/
              , this.afterAnimation(false)];

            case 3:
              _a.sent();

              return [2
              /*return*/
              ];
          }
        });
      });
    },
    openAnimation: function openAnimation() {
      return IAnimateExpandvue_type_script_lang_ts_awaiter(this, void 0, Promise, function () {
        var _i, _a, timer, t;

        var _this = this;

        return IAnimateExpandvue_type_script_lang_ts_generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , this.beforeAnimation(true)];

            case 1:
              _b.sent();

              this.internalExpanded = true;
              return [4
              /*yield*/
              , this.$nextTick()];

            case 2:
              _b.sent();

              this.cssClasses = ANIMATION_CSS_CLASSES;
              this.height = this.getContentHeight();

              for (_i = 0, _a = this.timerList; _i < _a.length; _i++) {
                timer = _a[_i];
                clearTimeout(timer);
              }

              t = setTimeout(function () {
                return IAnimateExpandvue_type_script_lang_ts_awaiter(_this, void 0, void 0, function () {
                  return IAnimateExpandvue_type_script_lang_ts_generator(this, function (_a) {
                    switch (_a.label) {
                      case 0:
                        this.timerList = [];
                        this.cssClasses = NO_CSS_CLASSES;
                        this.height = "";
                        return [4
                        /*yield*/
                        , this.afterAnimation(true)];

                      case 1:
                        _a.sent();

                        return [2
                        /*return*/
                        ];
                    }
                  });
                });
              }, ANIMATION_DURATION);
              this.timerList = [t];
              return [2
              /*return*/
              ];
          }
        });
      });
    },
    closeAnimation: function closeAnimation() {
      return IAnimateExpandvue_type_script_lang_ts_awaiter(this, void 0, Promise, function () {
        var _i, _a, timer, t1, t2;

        var _this = this;

        return IAnimateExpandvue_type_script_lang_ts_generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , this.beforeAnimation(false)];

            case 1:
              _b.sent();

              this.height = this.getContentHeight();
              this.cssClasses = ANIMATION_CSS_CLASSES;

              for (_i = 0, _a = this.timerList; _i < _a.length; _i++) {
                timer = _a[_i];
                clearTimeout(timer);
              }

              t1 = setTimeout(function () {
                _this.timerList = _this.timerList.filter(function (it) {
                  return it !== t1;
                });
                _this.cssClasses = _this.opacity ? CLOSED_CSS_CLASS_OPACITY : CLOSED_CSS_CLASS;
                _this.height = "0";
              }, 0);
              t2 = setTimeout(function () {
                return IAnimateExpandvue_type_script_lang_ts_awaiter(_this, void 0, void 0, function () {
                  return IAnimateExpandvue_type_script_lang_ts_generator(this, function (_a) {
                    switch (_a.label) {
                      case 0:
                        this.timerList = this.timerList.filter(function (it) {
                          return it !== t2;
                        });
                        this.internalExpanded = false;
                        return [4
                        /*yield*/
                        , this.afterAnimation(false)];

                      case 1:
                        _a.sent();

                        return [2
                        /*return*/
                        ];
                    }
                  });
                });
              }, ANIMATION_DURATION);
              this.timerList = [t1, t2];
              return [2
              /*return*/
              ];
          }
        });
      });
    }
  }
}));
// CONCATENATED MODULE: ./src/internal-components/IAnimateExpand/IAnimateExpand.vue?vue&type=script&lang=ts&
 /* harmony default export */ var IAnimateExpand_IAnimateExpandvue_type_script_lang_ts_ = (IAnimateExpandvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/internal-components/IAnimateExpand/IAnimateExpand.vue





/* normalize component */

var IAnimateExpand_component = normalizeComponent(
  IAnimateExpand_IAnimateExpandvue_type_script_lang_ts_,
  IAnimateExpandvue_type_template_id_6439ab02_render,
  IAnimateExpandvue_type_template_id_6439ab02_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var IAnimateExpand = (IAnimateExpand_component.exports);
// CONCATENATED MODULE: ./src/internal-components/IAnimateExpand/index.ts

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/internal-components/ISkipLink/ISkipLink.vue?vue&type=template&id=2413d1c4&
var ISkipLinkvue_type_template_id_2413d1c4_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"iskiplink",attrs:{"href":_vm.href}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.$t("fkuiSkipLinkText", "Gå direkt till innehåll")))]})],2)}
var ISkipLinkvue_type_template_id_2413d1c4_staticRenderFns = []


// CONCATENATED MODULE: ./src/internal-components/ISkipLink/ISkipLink.vue?vue&type=template&id=2413d1c4&

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/internal-components/ISkipLink/ISkipLink.vue?vue&type=script&lang=ts&


/* harmony default export */ var ISkipLinkvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: "ISkipLink",
  mixins: [TranslationMixin],
  props: {
    /**
     * Target for skiplink.
     */
    href: {
      type: String,
      required: false,
      default: "main"
    }
  }
}));
// CONCATENATED MODULE: ./src/internal-components/ISkipLink/ISkipLink.vue?vue&type=script&lang=ts&
 /* harmony default export */ var ISkipLink_ISkipLinkvue_type_script_lang_ts_ = (ISkipLinkvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/internal-components/ISkipLink/ISkipLink.vue





/* normalize component */

var ISkipLink_component = normalizeComponent(
  ISkipLink_ISkipLinkvue_type_script_lang_ts_,
  ISkipLinkvue_type_template_id_2413d1c4_render,
  ISkipLinkvue_type_template_id_2413d1c4_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ISkipLink = (ISkipLink_component.exports);
// CONCATENATED MODULE: ./src/internal-components/ISkipLink/index.ts

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/internal-components/IValidationForm/IValidationForm.vue?vue&type=template&id=6114c978&
var IValidationFormvue_type_template_id_6114c978_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f-validation-group',{key:_vm.groupKey,attrs:{"stop-propagation":true},model:{value:(_vm.validity),callback:function ($$v) {_vm.validity=$$v},expression:"validity"}},[_c('form',_vm._b({attrs:{"id":_vm.id,"novalidate":"","autocomplete":"off"},on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit.apply(null, arguments)}}},'form',_vm.$attrs,false),[(_vm.displayErrors)?_c('nav',{ref:"errors",attrs:{"tabindex":"-1","role":"group"}},[_c('f-error-list',{attrs:{"bullets":true,"items":_vm.errors},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._t("error-message")]},proxy:true}],null,true)})],1):_vm._e(),_vm._v(" "),_vm._t("default")],2)])}
var IValidationFormvue_type_template_id_6114c978_staticRenderFns = []


// CONCATENATED MODULE: ./src/internal-components/IValidationForm/IValidationForm.vue?vue&type=template&id=6114c978&

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FErrorList/FErrorList.vue?vue&type=template&id=261123cc&
var FErrorListvue_type_template_id_261123cc_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-list"},[_c('i-flex',[(_vm.hasTitleSlot)?_c('i-flex-item',{attrs:{"shrink":""}},[_c('f-icon',{staticClass:"error-list__icon",attrs:{"name":"error"}})],1):_vm._e(),_vm._v(" "),(_vm.hasTitleSlot)?_c('i-flex-item',{attrs:{"shrink":""}},[_vm._v(" ")]):_vm._e(),_vm._v(" "),_c('i-flex-item',{attrs:{"grow":""}},[(_vm.hasTitleSlot)?_c('div',[_vm._t("title")],2):_vm._e(),_vm._v(" "),_c('ul',{staticClass:"error-list__list error-list--list-style-none"},_vm._l((_vm.items),function(item){return _c('li',{key:item.id,class:_vm.liClasses(item)},[(item.id)?_c('a',{attrs:{"href":"javascript:"},on:{"click":function($event){$event.preventDefault();return _vm.onClickItem(item)}}},[(_vm.bullets)?[_c('span',{staticClass:"error-list__bullet",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"error-list__link"},[_vm._v(_vm._s(item.title))])]:[_vm._v(_vm._s(item.title))]],2):[(_vm.bullets)?[_c('span',{staticClass:"error-list__bullet",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.title))])]:[_vm._v(_vm._s(item.title))]]],2)}),0)])],1)],1)}
var FErrorListvue_type_template_id_261123cc_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/FErrorList/FErrorList.vue?vue&type=template&id=261123cc&

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FErrorList/FErrorList.vue?vue&type=script&lang=ts&










var FErrorListvue_type_script_lang_ts_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var FErrorListvue_type_script_lang_ts_generator = undefined && undefined.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};






/* harmony default export */ var FErrorListvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: "FErrorList",
  components: {
    FIcon: FIcon,
    IFlex: IFlex,
    IFlexItem: IFlexItem
  },
  props: {
    /**
     * List of errors of type `ErrorItem`.
     * If element id is unspecified, no link will be rendered.
     * If element with id don't exist on navigation, an exception is thrown.
     */
    items: {
      type: Array,
      required: true
    },

    /**
     * Display bullets in list.
     */
    bullets: {
      type: Boolean,
      required: false,
      default: false
    },

    /**
     * Optional callback for performing actions before navigation.
     */
    beforeNavigate: {
      type: Function,
      required: false,
      default: function _default() {
        /* do nothing by default */
      }
    }
  },
  computed: {
    hasTitleSlot: function hasTitleSlot() {
      return hasSlot(this, "title");
    }
  },
  methods: {
    liClasses: function liClasses(errorItem) {
      var classes = [];

      if (!this.bullets && errorItem.id) {
        classes.push("error-list__link");
      }

      return classes;
    },
    onClickItem: function onClickItem(item) {
      return FErrorListvue_type_script_lang_ts_awaiter(this, void 0, void 0, function () {
        var element, focusElement;
        return FErrorListvue_type_script_lang_ts_generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , this.beforeNavigate(item)];

            case 1:
              _a.sent();

              element = document.querySelector("#".concat(item.id));

              if (!element) {
                throw new Error("Can not find element with id ".concat(item.id));
              }

              focusElement = document.querySelector("#".concat(item.focusElementId));
              Object(logic_["scrollTo"])(element, window.innerHeight * 0.25);
              Object(logic_["focus"])(focusElement ? focusElement : element);
              return [2
              /*return*/
              ];
          }
        });
      });
    }
  }
}));
// CONCATENATED MODULE: ./src/components/FErrorList/FErrorList.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FErrorList_FErrorListvue_type_script_lang_ts_ = (FErrorListvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FErrorList/FErrorList.vue





/* normalize component */

var FErrorList_component = normalizeComponent(
  FErrorList_FErrorListvue_type_script_lang_ts_,
  FErrorListvue_type_template_id_261123cc_render,
  FErrorListvue_type_template_id_261123cc_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FErrorList = (FErrorList_component.exports);
// CONCATENATED MODULE: ./src/components/FErrorList/index.ts

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FValidationGroup/FValidationGroup.vue?vue&type=template&id=b1cc6b28&
var FValidationGroupvue_type_template_id_b1cc6b28_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"component-validity":_vm.onComponentValidity}},[_vm._t("default")],2)}
var FValidationGroupvue_type_template_id_b1cc6b28_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/FValidationGroup/FValidationGroup.vue?vue&type=template&id=b1cc6b28&

// CONCATENATED MODULE: ./src/components/FForm/FormUtils.ts








/*
 *   Clean inputs which doesn't exist in the DOM
 */

function cleanUpElements(vm) {
  return new Promise(function (resolve) {
    /**
     * To be able to clean up validation errors after elements that have been v-if:ed away (removed from DOM)
     * the clean up needs to be runned after DOM has been updated, thus setTimeout. $nextTick can't be
     * used due to only virtual DOM in Vue has been updated and not actual browse DOM.
     */
    window.setTimeout(function () {
      Object.keys(vm.components).forEach(function (id) {
        var domElement = vm.$el.querySelector("#".concat(id));

        if (!domElement) {
          vm.$delete(vm.components, id);
        }
      });
      resolve();
    }, 0);
  });
}
/*
 * Sorts errorlist based on the order of the elements in the DOM
 */

function sortComponentsWithErrorsOnDOMOrder(componentList) {
  var errorList = Object.values(componentList).filter(function (component) {
    var validity = component instanceof logic_["Reference"] ? component.ref.isValid : component.validityMode;
    return typeof validity === "boolean" ? validity === false : validity === "ERROR";
  });
  errorList.sort(function (a, b) {
    var elementToCompareA = a instanceof logic_["Reference"] ? document.querySelector("#".concat(a.ref.id)) : a.target;
    var elementToCompareB = b instanceof logic_["Reference"] ? document.querySelector("#".concat(b.ref.id)) : b.target;
    return Object(logic_["documentOrderComparator"])(elementToCompareA, elementToCompareB);
  });
  return errorList;
}
/*
 * Checks if reference is FormStep
 */

function isFormStepReference(reference) {
  return "isOpen" in reference.ref;
}
// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FValidationGroup/FValidationGroup.vue?vue&type=script&lang=ts&













var FValidationGroupvue_type_script_lang_ts_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var FValidationGroupvue_type_script_lang_ts_generator = undefined && undefined.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};




/**
 * Level: Draft
 */

/* harmony default export */ var FValidationGroupvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: "FValidationGroup",
  model: {
    prop: "value",
    event: "group-validity"
  },
  props: {
    /**
     * A `GroupValidityEvent` object containing:
     *
     *   `isValid`: the aggregated validity of underlying components
     *
     *   `componentsWithError`: a list of components with errors sorted in DOM order
     *
     *   `componentCount`: number of registered components
     * @model
     */
    value: {
      type: Object,
      required: false,
      default: function _default() {
        return {
          isValid: false,
          componentsWithError: [],
          componentCount: 0
        };
      }
    },

    /**
     * Controls whether component-validity event should be propagated or not from underlying components.
     */
    stopPropagation: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      components: {}
    };
  },
  methods: {
    onComponentValidity: function onComponentValidity(event) {
      return FValidationGroupvue_type_script_lang_ts_awaiter(this, void 0, Promise, function () {
        return FValidationGroupvue_type_script_lang_ts_generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              if (this.stopPropagation) {
                event.stopPropagation();
              }

              return [4
              /*yield*/
              , cleanUpElements(this)];

            case 1:
              _a.sent();

              this.$set(this.components, event.detail.elementId, event.detail);
              this.triggerGroupValidityEvent();
              return [2
              /*return*/
              ];
          }
        });
      });
    },
    triggerGroupValidityEvent: function triggerGroupValidityEvent() {
      var components = Object.values(this.components);
      var isValid = components.every(function (component) {
        return component.isValid;
      });
      var componentsWithError = components.filter(function (component) {
        return component.validityMode === "ERROR";
      });
      componentsWithError.sort(function (a, b) {
        return Object(logic_["documentOrderComparator"])(a.target, b.target);
      });
      /**
       * V-model event.
       *
       * @event group-validity
       * @type {GroupValidityEvent}
       */

      this.$emit("group-validity", {
        isValid: isValid,
        componentsWithError: componentsWithError,
        componentCount: components.length
      });
    }
  }
}));
// CONCATENATED MODULE: ./src/components/FValidationGroup/FValidationGroup.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FValidationGroup_FValidationGroupvue_type_script_lang_ts_ = (FValidationGroupvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FValidationGroup/FValidationGroup.vue





/* normalize component */

var FValidationGroup_component = normalizeComponent(
  FValidationGroup_FValidationGroupvue_type_script_lang_ts_,
  FValidationGroupvue_type_template_id_b1cc6b28_render,
  FValidationGroupvue_type_template_id_b1cc6b28_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FValidationGroup = (FValidationGroup_component.exports);
// CONCATENATED MODULE: ./src/components/FValidationGroup/index.ts

// CONCATENATED MODULE: ./src/internal-components/IValidationForm/types.ts
var IValidationFormAction;

(function (IValidationFormAction) {
  IValidationFormAction[IValidationFormAction["CONTINUE"] = 0] = "CONTINUE";
  IValidationFormAction[IValidationFormAction["CANCEL"] = 1] = "CANCEL";
})(IValidationFormAction || (IValidationFormAction = {}));
// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/internal-components/IValidationForm/IValidationForm.vue?vue&type=script&lang=ts&











var IValidationFormvue_type_script_lang_ts_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var IValidationFormvue_type_script_lang_ts_generator = undefined && undefined.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};






/* harmony default export */ var IValidationFormvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: "IValidationForm",
  components: {
    FValidationGroup: FValidationGroup,
    FErrorList: FErrorList
  },
  inheritAttrs: false,
  props: {
    /**
     * If given, this function is called before the [[submit]] event is emitted.
     *
     * Optionally this callback may return [[IValidationFormAction]]. If
     * [[IValidationFormAction.CANCEL]] is returned the submission is
     * cancelled and no event will be emitted. The consumer should make it
     * clear why the action was cancelled.
     *
     * If a promise is returned it will be awaited.
     *
     * The consumer does not need to validate form data, it is handled
     * internally by the component.
     */
    beforeSubmit: {
      type: Function,
      required: false,
      default: function _default() {
        /* do nothing */
      }
    },

    /**
     * The id for the form id attribute.
     * If the prop is not set a random value will be generated.
     */
    id: {
      type: String,
      required: false,
      default: function _default() {
        return logic_["ElementIdService"].generateElementId();
      }
    },

    /**
     * Include the error list component.
     */
    useErrorList: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data: function data() {
    return {
      validity: {
        isValid: true,
        componentsWithError: [],
        componentCount: 0
      },
      submitted: false
    };
  },
  computed: {
    groupKey: function groupKey() {
      return "".concat(this.id, "-group");
    },
    errors: function errors() {
      return this.validity.componentsWithError.map(function (c) {
        return {
          id: c.elementId,
          focusElementId: c.focusElementId,
          title: c.errorMessage
        };
      });
    },
    displayErrors: function displayErrors() {
      return this.useErrorList && this.submitted && this.errors.length > 0;
    }
  },
  methods: {
    hasFormErrors: function hasFormErrors() {
      return IValidationFormvue_type_script_lang_ts_awaiter(this, void 0, Promise, function () {
        var firstError, element;
        return IValidationFormvue_type_script_lang_ts_generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              logic_["ValidationService"].setSubmitted(this.id);
              return [4
              /*yield*/
              , logic_["ValidationService"].validateAllElements(this.id)];

            case 1:
              _a.sent();

              return [4
              /*yield*/
              , this.$nextTick()];

            case 2:
              _a.sent();

              return [4
              /*yield*/
              , new Promise(function (resolve) {
                return window.setTimeout(resolve, 0);
              })];

            case 3:
              _a.sent();

              if (this.validity.isValid) {
                return [2
                /*return*/
                , false];
              }

              if (this.useErrorList) {
                Object(logic_["focus"])(this.$refs.errors);
              } else {
                firstError = this.validity.componentsWithError[0];
                element = document.getElementById(firstError.focusElementId);
                Object(logic_["focus"])(element);
              }

              return [2
              /*return*/
              , true];
          }
        });
      });
    },
    onSubmit: function onSubmit() {
      return IValidationFormvue_type_script_lang_ts_awaiter(this, void 0, Promise, function () {
        var beforeAction;
        return IValidationFormvue_type_script_lang_ts_generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              this.submitted = true;
              return [4
              /*yield*/
              , this.hasFormErrors()];

            case 1:
              if (_a.sent()) {
                return [2
                /*return*/
                ];
              }

              return [4
              /*yield*/
              , this.beforeSubmit()];

            case 2:
              beforeAction = _a.sent();

              if (beforeAction === IValidationFormAction.CANCEL) {
                return [2
                /*return*/
                ];
              }

              return [4
              /*yield*/
              , this.hasFormErrors()];

            case 3:
              if (_a.sent()) {
                return [2
                /*return*/
                ];
              }
              /** V-model event.
               *
               * @event submit
               *
               */


              this.$emit("submit");
              return [2
              /*return*/
              ];
          }
        });
      });
    }
  }
}));
// CONCATENATED MODULE: ./src/internal-components/IValidationForm/IValidationForm.vue?vue&type=script&lang=ts&
 /* harmony default export */ var IValidationForm_IValidationFormvue_type_script_lang_ts_ = (IValidationFormvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/internal-components/IValidationForm/IValidationForm.vue





/* normalize component */

var IValidationForm_component = normalizeComponent(
  IValidationForm_IValidationFormvue_type_script_lang_ts_,
  IValidationFormvue_type_template_id_6114c978_render,
  IValidationFormvue_type_template_id_6114c978_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var IValidationForm = (IValidationForm_component.exports);
// CONCATENATED MODULE: ./src/internal-components/IValidationForm/index.ts


// CONCATENATED MODULE: ./src/internal-components/index.ts







// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FModal/FFormModal/FFormModal.vue?vue&type=script&lang=ts&












var FFormModalvue_type_script_lang_ts_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var FFormModalvue_type_script_lang_ts_generator = undefined && undefined.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};








/* harmony default export */ var FFormModalvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: "FFormModal",
  components: {
    FModal: FModal,
    IValidationForm: IValidationForm
  },
  mixins: [TranslationMixin],
  inheritAttrs: true,
  props: {
    /**
     * Enable fullscreen mode in mobile.
     */
    fullscreen: {
      type: Boolean,
      required: false,
      default: true
    },

    /**
     * If the modal is open.
     * Use this to toggle if the modal should be visible or not.
     */
    isOpen: {
      type: Boolean,
      required: false,
      default: true
    },

    /**
     * See <f-modal> `size` props.
     */
    size: {
      type: String,
      default: "",
      validator: function validator(value) {
        return sizes.includes(value);
      }
    },

    /**
     * @ignore
     */
    dataTest: {
      type: String,
      required: false,
      default: ""
    },

    /**
     * The data that has been submitted.
     */
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },

    /**
     * Include the error list component.
     */
    useErrorList: {
      type: Boolean,
      required: false,
      default: true
    },

    /**
     * The id for the form id attribute.
     * If the prop is not set a random value will be generated.
     */
    formId: {
      type: String,
      required: false,
      default: function _default() {
        return logic_["ElementIdService"].generateElementId();
      }
    },

    /**
     * The aria-label attribute text for the top right close button.
     */
    ariaCloseText: {
      type: String,
      required: false,
      default: undefined
    },

    /**
     * If given, this function is called before the [[submit]] event is emitted.
     * See <i-validation-form> `beforeSubmit` props for more info.
     */
    beforeSubmit: {
      type: Function,
      required: false,
      default: function _default() {
        /* do nothing */
      }
    }
  },
  data: function data() {
    return {};
  },
  methods: {
    onClose: function onClose() {
      logic_["ValidationService"].resetState(this.$el);
      /**
       * Event that is dispatched when escape is pressed or when the cancel or close buttons are clicked.
       * In most use cases the isOpen prop should be set to false when this event is triggered.
       */

      this.$emit("cancel");
      /**
       * Event that is dispatched when escape is pressed or when the cancel or close buttons are clicked.
       * In most use cases the isOpen prop should be set to false when this event is triggered.
       */

      this.$emit("close", {
        reason: "close"
      });
    },
    onSubmit: function onSubmit() {
      return FFormModalvue_type_script_lang_ts_awaiter(this, void 0, void 0, function () {
        var beforeAction;
        return FFormModalvue_type_script_lang_ts_generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , this.beforeSubmit()];

            case 1:
              beforeAction = _a.sent();

              if (beforeAction === IValidationFormAction.CANCEL) {
                return [2
                /*return*/
                ];
              }

              logic_["ValidationService"].resetState(this.$el);
              /**
               * Event that is dispatched when the submit button is is clicked.
               * The event payload is the data that has been submitted.
               */

              this.$emit("submit", {
                data: this.value
              });
              this.$emit("close", {
                reason: "submit",
                data: this.value
              });
              return [2
              /*return*/
              ];
          }
        });
      });
    },
    onCancel: function onCancel() {
      logic_["ValidationService"].resetState(this.$el);
      this.$emit("cancel");
      this.$emit("close", {
        reason: "close"
      });
    }
  }
}));
// CONCATENATED MODULE: ./src/components/FModal/FFormModal/FFormModal.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FFormModal_FFormModalvue_type_script_lang_ts_ = (FFormModalvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FModal/FFormModal/FFormModal.vue





/* normalize component */

var FFormModal_component = normalizeComponent(
  FFormModal_FFormModalvue_type_script_lang_ts_,
  FFormModalvue_type_template_id_d0cbece2_render,
  FFormModalvue_type_template_id_d0cbece2_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FFormModal = (FFormModal_component.exports);
// CONCATENATED MODULE: ./src/components/FModal/FFormModal/action.ts

// CONCATENATED MODULE: ./src/components/FModal/FFormModal/index.ts


// CONCATENATED MODULE: ./src/components/FModal/index.ts



// CONCATENATED MODULE: ./src/utils/confirm-modal/confirm-modal.ts










var confirm_modal_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var confirm_modal_generator = undefined && undefined.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};



function confirmModal(modalData) {
  return confirm_modal_awaiter(this, void 0, Promise, function () {
    var buttons, reason;
    return confirm_modal_generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          buttons = [{
            label: modalData.confirm,
            event: "confirm",
            type: "primary"
          }, {
            label: modalData.dismiss,
            event: "dismiss",
            type: "secondary"
          }];
          return [4
          /*yield*/
          , openModal(FConfirmModal, {
            props: {
              heading: modalData.heading,
              content: modalData.content,
              buttons: buttons
            }
          })];

        case 1:
          reason = _a.sent().reason;
          return [2
          /*return*/
          , reason === "confirm"];
      }
    });
  });
} // ? Needed for Styleguidist to pickup the documentation.

/* harmony default export */ var confirm_modal = ({});
// CONCATENATED MODULE: ./src/utils/confirm-modal/index.ts

// CONCATENATED MODULE: ./src/utils/index.ts










// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FLabel/FLabel.vue?vue&type=script&lang=ts&



/* harmony default export */ var FLabelvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: "FLabel",
  components: {
    FIcon: FIcon
  },
  props: {
    /**
     * The id for the form element the label is bound to.
     */
    for: {
      type: String,
      required: false,
      default: undefined
    }
  },
  data: function data() {
    return {
      descriptionSlotClasses: {
        descriptionClass: ["label__description"],
        discreteDescriptionClass: ["label__description", "label__description--discrete"]
      }
    };
  },
  computed: {
    forProperty: function forProperty() {
      return this.for;
    },
    hasDefaultSlot: function hasDefaultSlot() {
      return hasSlot(this, "default");
    },
    hasErrorMessageSlot: function hasErrorMessageSlot() {
      return hasSlot(this, "error-message");
    },
    hasDescriptionSlot: function hasDescriptionSlot() {
      return hasSlot(this, "description");
    },
    hasTooltipSlot: function hasTooltipSlot() {
      return hasSlot(this, "tooltip");
    }
  }
}));
// CONCATENATED MODULE: ./src/components/FLabel/FLabel.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FLabel_FLabelvue_type_script_lang_ts_ = (FLabelvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FLabel/FLabel.vue





/* normalize component */

var FLabel_component = normalizeComponent(
  FLabel_FLabelvue_type_script_lang_ts_,
  FLabelvue_type_template_id_efad54fa_render,
  FLabelvue_type_template_id_efad54fa_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FLabel = (FLabel_component.exports);
// CONCATENATED MODULE: ./src/components/FLabel/index.ts

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FTextField/FTextField.vue?vue&type=script&lang=ts&














var FTextFieldvue_type_script_lang_ts_assign = undefined && undefined.__assign || function () {
  FTextFieldvue_type_script_lang_ts_assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return FTextFieldvue_type_script_lang_ts_assign.apply(this, arguments);
};

var FTextFieldvue_type_script_lang_ts_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var FTextFieldvue_type_script_lang_ts_generator = undefined && undefined.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};







/* harmony default export */ var FTextFieldvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: "FTextField",
  components: {
    FLabel: FLabel,
    FIcon: FIcon
  },
  inheritAttrs: false,
  model: {
    prop: "value",
    event: "update"
  },
  props: {
    /**
     * The id for the input id attribute.
     * The id for the label for attribute.
     * If the prop is not set a random value will be generated.
     */
    id: {
      type: String,
      required: false,
      default: function _default() {
        return logic_["ElementIdService"].generateElementId();
      }
    },

    /**
     * The value for the input.
     * If the prop is not set undefined will be used.
     * @model
     */
    value: {
      type: [String, Number],
      required: false,
      default: ""
    },

    /**
     * The type used for the input.
     * If the prop is not set text will be used.
     */
    type: {
      type: String,
      required: false,
      default: "text"
    },

    /**
     * - The `formatter` function must only be used on a component that uses validation.
     * - The `formatter` function acts differently depending on if the `parser` function is defined or not.
     *
     * | formatter without parser | formatter with parser |
     * | ----- | -----|
     * | modelvalue = parsed viewvalue using formatter function | modelvalue = parsed viewvalue using parser function |
     * | viewvalue = modelvalue (where modelvalue is already parsed) | viewvalue = formatted modelvalue using formatter function (where modelvalue is already parsed) |
     */
    formatter: {
      type: Function,
      required: false,
      default: undefined
    },

    /**
     * - The `parser` function must only be used on a component that uses validation.
     * - The `parser` function acts differently depending on if the `formatter` function is defined or not.
     *   - For parser combined with formatter, refer to formatter prop doc.
     *
     * | parser without formatter |
     * | ----- | -----|
     * | modelvalue = parsed viewvalue using parser function |
     * | viewvalue = never updated except when modelvalue differs from parsed viewvalue |
     */
    parser: {
      type: Function,
      required: false,
      default: undefined
    }
  },
  data: function data() {
    return {
      viewValue: "",
      lastModelValue: "",
      validity: {
        validityMode: "INITIAL"
      },
      // internal default texts possible to override when extending component
      defaultText: "",
      descriptionText: "",
      descriptionScreenReaderText: "",
      discreteDescriptionText: "",
      discreteDescriptionScreenReaderText: ""
    };
  },
  computed: {
    attrs: function attrs() {
      return FTextFieldvue_type_script_lang_ts_assign(FTextFieldvue_type_script_lang_ts_assign({}, this.$attrs), {
        id: this.id,
        type: this.type
      });
    },

    /* eslint-disable-next-line @typescript-eslint/ban-types */
    listeners: function listeners() {
      var _this = this;

      return FTextFieldvue_type_script_lang_ts_assign(FTextFieldvue_type_script_lang_ts_assign({}, this.$listeners), {
        change: function change() {
          return FTextFieldvue_type_script_lang_ts_awaiter(_this, void 0, void 0, function () {
            return FTextFieldvue_type_script_lang_ts_generator(this, function (_a) {
              switch (_a.label) {
                case 0:
                  if (!!this.$refs.input.hasAttribute("data-validation")) return [3
                  /*break*/
                  , 2];
                  /* V-model event.
                   *
                   * @event update
                   * @type {string}
                   */

                  this.$emit("update", this.viewValue);
                  return [4
                  /*yield*/
                  , this.$nextTick()];

                case 1:
                  _a.sent(); // wait for model update before triggering change event

                  /**
                   * @event change
                   * @type {string}
                   */


                  this.$emit("change", this.viewValue);
                  _a.label = 2;

                case 2:
                  return [2
                  /*return*/
                  ];
              }
            });
          });
        },
        blur: function blur() {
          return FTextFieldvue_type_script_lang_ts_awaiter(_this, void 0, void 0, function () {
            return FTextFieldvue_type_script_lang_ts_generator(this, function (_a) {
              switch (_a.label) {
                case 0:
                  if (!!this.$refs.input.hasAttribute("data-validation")) return [3
                  /*break*/
                  , 2];
                  this.$emit("update", this.viewValue);
                  return [4
                  /*yield*/
                  , this.$nextTick()];

                case 1:
                  _a.sent(); // wait for model update before triggering blur event

                  /**
                   * @event blur
                   * @type {string}
                   */


                  this.$emit("blur", this.viewValue);
                  _a.label = 2;

                case 2:
                  return [2
                  /*return*/
                  ];
              }
            });
          });
        }
      });
    },
    isValid: function isValid() {
      return this.validity.validityMode === "VALID";
    },
    hasError: function hasError() {
      return this.validity.validityMode === "ERROR";
    },
    validityClass: function validityClass() {
      return {
        "text-field--valid": this.isValid,
        "text-field--error": this.hasError
      };
    },
    isModelUpdatedProgrammatically: function isModelUpdatedProgrammatically() {
      return this.lastModelValue !== this.value;
    }
  },
  watch: {
    value: {
      immediate: true,
      // eslint-disable-next-line complexity
      handler: function handler() {
        if (this.value === undefined || this.value === null) {
          this.viewValue = "";
          return;
        }

        if (this.isModelUpdatedProgrammatically) {
          this.setViewValueToFormattedValueOrFallbackToValue();
          return;
        }

        if (Object(logic_["isSet"])(this.parser)) {
          if (Object(logic_["isSet"])(this.formatter)) {
            this.setViewValueToFormattedValueOrFallbackToValue();
          }
        } else {
          this.viewValue = String(this.value);
        }
      }
    }
  },
  methods: {
    onValidity: function onValidity(_a) {
      var detail = _a.detail;
      return FTextFieldvue_type_script_lang_ts_awaiter(this, void 0, Promise, function () {
        var newModelValue;
        return FTextFieldvue_type_script_lang_ts_generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              this.$set(this, "validity", detail);
              if (!["change", "blur"].includes(detail.nativeEvent)) return [3
              /*break*/
              , 2];
              newModelValue = void 0;

              if (detail.isValid) {
                newModelValue = this.resolveNewModelValue(this.viewValue);
              } else {
                newModelValue = this.viewValue;
              }

              this.lastModelValue = newModelValue;
              this.$emit("update", newModelValue);
              return [4
              /*yield*/
              , this.$nextTick()];

            case 1:
              _b.sent(); // wait for model update before triggering change, blur event


              this.$emit(detail.nativeEvent, newModelValue);
              this.syncViewValueAfterModelUpdate(newModelValue);
              _b.label = 2;

            case 2:
              this.triggerComponentValidityEvent(detail);
              return [2
              /*return*/
              ];
          }
        });
      });
    },
    onPendingValidity: function onPendingValidity() {
      this.validity.validityMode = "INITIAL";
    },
    // eslint-disable-next-line complexity
    resolveNewModelValue: function resolveNewModelValue(viewValue) {
      var _a, _b;

      var trimmedViewValue = viewValue.trim();

      if (trimmedViewValue === "") {
        return "";
      } else if (Object(logic_["isSet"])(this.parser)) {
        return (_a = this.parser(trimmedViewValue)) !== null && _a !== void 0 ? _a : trimmedViewValue;
      } else if (Object(logic_["isSet"])(this.formatter)) {
        return (_b = this.formatter(trimmedViewValue)) !== null && _b !== void 0 ? _b : trimmedViewValue;
      } else {
        return trimmedViewValue;
      }
    },
    syncViewValueAfterModelUpdate: function syncViewValueAfterModelUpdate(newModelValue) {
      if (newModelValue === "") {
        this.viewValue = "";
      } else if (Object(logic_["isSet"])(this.parser)) {
        if (Object(logic_["isSet"])(this.formatter)) {
          this.viewValue = String(this.formatter(newModelValue) || this.viewValue);
        }
      } else {
        this.viewValue = String(newModelValue);
      }
    },
    triggerComponentValidityEvent: function triggerComponentValidityEvent(validityEvent) {
      var errorMessage = "";

      if (this.$scopedSlots.default) {
        errorMessage = getTextFromScopedSlot(this.$scopedSlots.default);
      } else {
        errorMessage = this.defaultText;
      }

      var element = this.$el.querySelector("#".concat(validityEvent.elementId));

      if (element) {
        dispatchComponentValidityEvent(element, FTextFieldvue_type_script_lang_ts_assign(FTextFieldvue_type_script_lang_ts_assign({}, validityEvent), {
          errorMessage: errorMessage,
          focusElementId: validityEvent.elementId
        }));
      }
    },
    setViewValueToFormattedValueOrFallbackToValue: function setViewValueToFormattedValueOrFallbackToValue() {
      if (this.formatter) {
        var formattedValue = this.formatter(this.value);
        this.viewValue = Object(logic_["isSet"])(formattedValue) ? formattedValue : String(this.value);
      } else {
        this.viewValue = String(this.value);
      }
    }
  }
}));
// CONCATENATED MODULE: ./src/components/FTextField/FTextField.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FTextField_FTextFieldvue_type_script_lang_ts_ = (FTextFieldvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FTextField/FTextField.vue





/* normalize component */

var FTextField_component = normalizeComponent(
  FTextField_FTextFieldvue_type_script_lang_ts_,
  FTextFieldvue_type_template_id_0555cb95_render,
  FTextFieldvue_type_template_id_0555cb95_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FTextField = (FTextField_component.exports);
// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FCalendar/FCalendarTabMain.vue?vue&type=template&id=afc00606&
var FCalendarTabMainvue_type_template_id_afc00606_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calendar__events",on:{"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }return _vm.onKeyLeft.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"right",39,$event.key,["Right","ArrowRight"])){ return null; }if('button' in $event && $event.button !== 2){ return null; }return _vm.onKeyRight.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }return _vm.onKeyUp.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }return _vm.onKeyDown.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.onKeyEsc.apply(null, arguments)}],"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }return _vm.onArrowKeyPrevent.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"right",39,$event.key,["Right","ArrowRight"])){ return null; }if('button' in $event && $event.button !== 2){ return null; }return _vm.onArrowKeyPrevent.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }return _vm.onArrowKeyPrevent.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }return _vm.onArrowKeyPrevent.apply(null, arguments)}]}},[(_vm.options.showNavigationBar)?_c('div',{staticClass:"calendar__navbar"},[_c('button',{staticClass:"calendar__navbar-arrow calendar__navbar-arrow--left",class:{ 'calendar__navbar-arrow--month': !_vm.yearView },attrs:{"type":"button","aria-label":_vm.yearView ? 'Visa år ' + (_vm.calendarState.currentYear - 1) : 'Visa ' + _vm.prevMonthFullName() + ' månad'},on:{"click":function($event){return _vm.onClickPrev()}}},[_c('f-icon',{staticClass:"button__icon",attrs:{"name":"arrow-in-circle"}}),_vm._v(" "),_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v(_vm._s(_vm.yearView ? _vm.calendarState.currentYear - 1 : _vm.prevMonthName()))])],1),_vm._v(" "),_c('button',{staticClass:"calendar__navbar-middle",attrs:{"type":"button","aria-label":_vm.yearView
                    ? ((_vm.calendarState.currentYear) + " visa månadsvy")
                    : ((_vm.MONTHNAMES_LONG[_vm.calendarState.currentMonth - 1]) + " " + (_vm.calendarState.currentYear) + " visa årsvy")},on:{"click":function($event){return _vm.changeView()}}},[(!_vm.yearView)?_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v(_vm._s(_vm.MONTHNAMES_LONG[_vm.calendarState.currentMonth - 1])+" "+_vm._s(_vm.calendarState.currentYear))]):_vm._e(),_vm._v(" "),(_vm.yearView)?_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v(_vm._s(_vm.calendarState.currentYear))]):_vm._e()]),_vm._v(" "),_c('button',{staticClass:"calendar__navbar-arrow calendar__navbar-arrow--right",class:{ 'calendar__navbar-arrow--month': !_vm.yearView },attrs:{"type":"button","aria-label":_vm.yearView ? 'Visa år ' + (_vm.calendarState.currentYear + 1) : 'Visa ' + _vm.nextMonthFullName() + ' månad'},on:{"click":function($event){return _vm.onClickNext()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v(_vm._s(_vm.yearView ? _vm.calendarState.currentYear + 1 : _vm.nextMonthName()))]),_vm._v(" "),_c('f-icon',{staticClass:"button__icon",attrs:{"name":"arrow-in-circle"}})],1)]):_vm._e(),_vm._v(" "),(!_vm.yearView)?_c('f-calendar-month',{key:'month-' + _vm.calendarState.currentMonth,attrs:{"year":_vm.calendarState.currentYear,"month":_vm.calendarState.currentMonth,"calendar-state":_vm.calendarState,"options":_vm.options},on:{"day-selected":_vm.onDaySelected,"day-unselected":_vm.onDayUnselected,"disabled-day-requested":_vm.onDisabledDayRequested}}):_vm._e(),_vm._v(" "),(_vm.yearView)?_c('f-calendar-year',{attrs:{"year":_vm.calendarState.currentYear,"month":_vm.calendarState.currentMonth,"calendar-state":_vm.calendarState},on:{"month-item-clicked":_vm.onClickSelectMonth}}):_vm._e()],1)}
var FCalendarTabMainvue_type_template_id_afc00606_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/FCalendar/FCalendarTabMain.vue?vue&type=template&id=afc00606&

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FCalendar/FCalendarMonth.vue?vue&type=template&id=bdf25052&
var FCalendarMonthvue_type_template_id_bdf25052_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calendar__monthview",attrs:{"role":"grid"}},[_c('div',{staticClass:"calendar__row"},[(_vm.options.showWeekNumbers)?_c('div',{staticClass:"calendar__item calendar__item--week"}):_vm._e(),_vm._v(" "),_vm._l((_vm.WEEKDAYNAMES_SHORT),function(day,dayIndex){return _c('div',{key:dayIndex,staticClass:"calendar__item calendar__item--week",attrs:{"aria-hidden":"true"}},[_vm._v("\n            "+_vm._s(day)+"\n        ")])})],2),_vm._v(" "),_vm._l((_vm.getCalendarMonth()),function(week,index){return _c('f-calendar-month-week',{key:index,attrs:{"week-number":week.weekNumber,"week-days":week.weekDays,"fillers-before":week.fillersBefore,"fillers-after":week.fillersAfter,"calendar-state":_vm.calendarState,"options":_vm.options},on:{"day-selected":_vm.onDaySelected,"day-unselected":_vm.onDayUnselected,"disabled-day-requested":_vm.onDisabledDayRequested}})})],2)}
var FCalendarMonthvue_type_template_id_bdf25052_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/FCalendar/FCalendarMonth.vue?vue&type=template&id=bdf25052&

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FCalendar/FCalendarMonthWeek.vue?vue&type=template&id=60768599&
var FCalendarMonthWeekvue_type_template_id_60768599_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calendar__row",attrs:{"role":"row"}},[(_vm.options.showWeekNumbers)?_c('div',{staticClass:"calendar__item calendar__item--week",attrs:{"type":"button","aria-hidden":"true"}},[_vm._v("\n        v. "+_vm._s(_vm.weekNumber)+"\n    ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.fillersBefore),function(index){return _c('div',{key:'before' + index,staticClass:"calendar__item"})}),_vm._v(" "),_vm._l((_vm.weekDays),function(day,index){return _c('f-calendar-month-day',{key:index,attrs:{"day":day,"calendar-state":_vm.calendarState,"options":_vm.options},on:{"day-selected":_vm.onDaySelected,"day-unselected":_vm.onDayUnselected,"disabled-day-requested":_vm.onDisabledDayRequested}})}),_vm._v(" "),_vm._l((_vm.fillersAfter),function(index){return _c('div',{key:'after' + index,staticClass:"calendar__item"})})],2)}
var FCalendarMonthWeekvue_type_template_id_60768599_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/FCalendar/FCalendarMonthWeek.vue?vue&type=template&id=60768599&

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FCalendar/FCalendarMonthDay.vue?vue&type=template&id=63297006&
var FCalendarMonthDayvue_type_template_id_63297006_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{ref:"dayButton",staticClass:"calendar__item calendar__item--date",class:_vm.cssClasses,attrs:{"type":"button","tabindex":_vm.tabindex,"role":"gridcell","aria-live":"polite","aria-selected":_vm.iday.selected,"aria-checked":_vm.iday.selected},on:{"click":function($event){return _vm.dayClicked()},"blur":function($event){return _vm.dayBlurred()}}},[_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.srText))]),_vm._v(" "),_c('span',{class:'calendar__item__number calendar__item__number-' + _vm.day.day,attrs:{"aria-hidden":"true"}},[_vm._v(_vm._s(_vm.day.day))])])}
var FCalendarMonthDayvue_type_template_id_63297006_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/FCalendar/FCalendarMonthDay.vue?vue&type=template&id=63297006&

// CONCATENATED MODULE: ./src/components/FCalendar/FCalendarDateMethods.ts







external_moment_default.a.updateLocale("sv", {
  week: {
    dow: 1,
    doy: 4 // Used to determine first week of the year.

  }
});

function getDatesByYearAndMonth(year, month) {
  var days = [];
  var currentMonth = external_moment_default()([year, month - 1]);
  var daysInMonth = currentMonth.daysInMonth();

  for (var i = 0; i < daysInMonth; i++) {
    days.push(new CDate(year, month, i + 1));
  }

  return days;
}

function groupDaysByWeek(days) {
  var weekList = [];
  days.forEach(function (date) {
    var momentDate = external_moment_default()(date.toDate());
    var weekNumber = momentDate.week();
    var ref = weekList.find(function (week) {
      return week.weekNumber === weekNumber;
    });

    if (ref) {
      ref.weekDays.push(date);
    } else {
      weekList.push({
        weekNumber: weekNumber,
        weekDays: [date],
        fillersBefore: 0,
        fillersAfter: 0
      });
    }
  });
  return weekList;
}

function FCalendarDateMethods_getCalendarMonth(year, month) {
  var daysInMonth = getDatesByYearAndMonth(year, month);
  var weekList = groupDaysByWeek(daysInMonth);
  weekList[0].fillersBefore = 7 - weekList[0].weekDays.length;
  weekList[weekList.length - 1].fillersAfter = 7 - weekList[weekList.length - 1].weekDays.length;
  return weekList;
}
function FCalendarDateMethods_isDisabled(day, options) {
  var momentDay = external_moment_default()(day, "YYYY-MM-DD");

  for (var _i = 0, _a = options.disabledWeekDays || []; _i < _a.length; _i++) {
    var disabledWeekDay = _a[_i];

    if (momentDay.isoWeekday() === disabledWeekDay) {
      return true;
    }
  }

  var isOneOfTheDisabledDates = options.disabledDates && options.disabledDates.includes(day);

  if (isOneOfTheDisabledDates) {
    return true;
  }

  var afterFirstDay = !options.firstAvailableDate || options.firstAvailableDate && day >= options.firstAvailableDate;
  var beforeLastDay = !options.lastAvailableDate || options.lastAvailableDate && day <= options.lastAvailableDate;
  var enabled = afterFirstDay && beforeLastDay;
  return !enabled;
}
// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FCalendar/FCalendarMonthDay.vue?vue&type=script&lang=ts&







/* harmony default export */ var FCalendarMonthDayvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: "FCalendarMonthDay",
  props: {
    day: {
      required: true,
      type: Object
    },
    calendarState: {
      required: true,
      type: Object
    },
    options: {
      required: false,
      type: Object,
      default: function _default() {
        return new FCalendarComponentOptions_FCalendarComponentOptions();
      }
    }
  },
  computed: {
    hasFocusState: function hasFocusState() {
      return this.calendarState.getFocusedDay() === this.day.getDay();
    },
    tabindex: function tabindex() {
      return this.hasFocusState ? 0 : -1;
    },
    iday: function iday() {
      var defaultReturnDate = {
        selected: false,
        added: false,
        collectedData: []
      }; // Check if date exists in store, otherwise create date.

      var compareDate = this.calendarState.getDays()[this.day.toString()];
      return compareDate ? compareDate : defaultReturnDate;
    },
    cssClasses: function cssClasses() {
      return {
        "calendar__item--today": this.isToday,
        "calendar__item--selected": this.iday.selected,
        "calendar__item--added": this.iday.added,
        "calendar--focused": this.hasFocusState,
        "calendar__item--disabled": this.isDisabled
      };
    },
    // eslint-disable-next-line complexity
    srText: function srText() {
      var day = "".concat(this.weekDay, " ").concat(this.dayOrdinal, " ").concat(this.longDate);

      if (this.isDisabled) {
        return "".concat(day, " Dag ej valbar");
      } else if (this.iday.selected && this.iday.added) {
        return "".concat(day, " markerad och vald");
      } else if (this.iday.selected && !this.iday.added) {
        return "".concat(day, " markerad och ej vald");
      } else if (!this.iday.selected && this.iday.added) {
        return "".concat(day, " vald och ej markerad");
      } else if (!this.iday.selected && !this.iday.added) {
        return "".concat(day, " ej vald och ej markerad");
      }

      return day;
    },
    dayOrdinal: function dayOrdinal() {
      return external_moment_default()(this.day.toDate()).format("Do");
    },
    longDate: function longDate() {
      return external_moment_default()(this.day.toDate()).format("MMMM YYYY");
    },
    weekDay: function weekDay() {
      return external_moment_default()(this.day.toDate()).format("dddd");
    },
    isToday: function isToday() {
      return external_moment_default()(CDate.today().toDate()).isSame(this.day.toDate(), "d");
    },
    isDisabled: function isDisabled() {
      return FCalendarDateMethods_isDisabled(external_moment_default()(this.day.toDate()).format("YYYY-MM-DD"), this.options);
    }
  },
  methods: {
    dayBlurred: function dayBlurred() {
      this.calendarState.setSelectedDisabledDate(undefined);
    },
    dayClicked: function dayClicked() {
      this.calendarState.setFocusedDay(this.day.getDay());

      if (this.isDisabled) {
        this.calendarState.setSelectedDisabledDate(this.day.toString());
        this.$emit("disabled-day-requested", this.day);
        return;
      }

      this.calendarState.saveEditMonth(undefined);
      this.calendarState.saveEditDay(undefined);
      var adjustedDay = this.iday;
      adjustedDay.selected = !this.iday.selected;

      if (adjustedDay.selected || adjustedDay.added) {
        this.calendarState.saveDay(this.day.toString(), adjustedDay);
      } else {
        this.calendarState.removeDay(this.day.toString());
      }

      if (adjustedDay.selected) {
        this.$emit("day-selected", this.day);
      } else {
        this.$emit("day-unselected", this.day);
      }
    }
  }
}));
// CONCATENATED MODULE: ./src/components/FCalendar/FCalendarMonthDay.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FCalendar_FCalendarMonthDayvue_type_script_lang_ts_ = (FCalendarMonthDayvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FCalendar/FCalendarMonthDay.vue





/* normalize component */

var FCalendarMonthDay_component = normalizeComponent(
  FCalendar_FCalendarMonthDayvue_type_script_lang_ts_,
  FCalendarMonthDayvue_type_template_id_63297006_render,
  FCalendarMonthDayvue_type_template_id_63297006_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FCalendarMonthDay = (FCalendarMonthDay_component.exports);
// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FCalendar/FCalendarMonthWeek.vue?vue&type=script&lang=ts&




/* harmony default export */ var FCalendarMonthWeekvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: "FCalendarMonthWeek",
  components: {
    FCalendarMonthDay: FCalendarMonthDay
  },
  props: {
    weekNumber: {
      required: true,
      type: Number
    },
    weekDays: {
      required: true,
      type: Array
    },
    fillersBefore: {
      required: true,
      type: Number
    },
    fillersAfter: {
      required: true,
      type: Number
    },
    calendarState: {
      required: true,
      type: Object
    },
    options: {
      required: false,
      type: Object,
      default: function _default() {
        return new FCalendarComponentOptions_FCalendarComponentOptions();
      }
    }
  },
  methods: {
    onDaySelected: function onDaySelected(day) {
      this.$emit("day-selected", day);
    },
    onDayUnselected: function onDayUnselected(day) {
      this.$emit("day-unselected", day);
    },
    onDisabledDayRequested: function onDisabledDayRequested(day) {
      this.$emit("disabled-day-requested", day);
    }
  }
}));
// CONCATENATED MODULE: ./src/components/FCalendar/FCalendarMonthWeek.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FCalendar_FCalendarMonthWeekvue_type_script_lang_ts_ = (FCalendarMonthWeekvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FCalendar/FCalendarMonthWeek.vue





/* normalize component */

var FCalendarMonthWeek_component = normalizeComponent(
  FCalendar_FCalendarMonthWeekvue_type_script_lang_ts_,
  FCalendarMonthWeekvue_type_template_id_60768599_render,
  FCalendarMonthWeekvue_type_template_id_60768599_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FCalendarMonthWeek = (FCalendarMonthWeek_component.exports);
// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FCalendar/FCalendarMonth.vue?vue&type=script&lang=ts&






/* harmony default export */ var FCalendarMonthvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: "FCalendarMonth",
  components: {
    FCalendarMonthWeek: FCalendarMonthWeek
  },
  props: {
    month: {
      type: Number,
      required: true
    },
    year: {
      type: Number,
      required: true
    },
    calendarState: {
      type: Object,
      required: true
    },
    options: {
      required: false,
      type: Object,
      default: function _default() {
        return new FCalendarComponentOptions_FCalendarComponentOptions();
      }
    }
  },
  data: function data() {
    return {
      WEEKDAYNAMES_SHORT: logic_["WEEKDAYNAMES_SHORT"]
    };
  },
  methods: {
    onDaySelected: function onDaySelected(day) {
      this.$emit("day-selected", day);
    },
    onDayUnselected: function onDayUnselected(day) {
      this.$emit("day-unselected", day);
    },
    onDisabledDayRequested: function onDisabledDayRequested(day) {
      this.$emit("disabled-day-requested", day);
    },
    getCalendarMonth: function getCalendarMonth() {
      return FCalendarDateMethods_getCalendarMonth(this.year, this.month);
    }
  }
}));
// CONCATENATED MODULE: ./src/components/FCalendar/FCalendarMonth.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FCalendar_FCalendarMonthvue_type_script_lang_ts_ = (FCalendarMonthvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FCalendar/FCalendarMonth.vue





/* normalize component */

var FCalendarMonth_component = normalizeComponent(
  FCalendar_FCalendarMonthvue_type_script_lang_ts_,
  FCalendarMonthvue_type_template_id_bdf25052_render,
  FCalendarMonthvue_type_template_id_bdf25052_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FCalendarMonth = (FCalendarMonth_component.exports);
// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FCalendar/FCalendarYear.vue?vue&type=template&id=75d7046f&
var FCalendarYearvue_type_template_id_75d7046f_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calendar__yearview",attrs:{"role":"grid"}},_vm._l((4),function(i){return _c('div',{key:i,staticClass:"calendar__row",attrs:{"role":"row"}},_vm._l((_vm.getMonthsInQuarter(i)),function(month,index){return _c('f-calendar-year-month-item',{key:index,attrs:{"month":month,"calendar-state":_vm.calendarState,"role":"gridcell"},on:{"month-item-clicked":_vm.onClickSelectMonth}})}),1)}),0)}
var FCalendarYearvue_type_template_id_75d7046f_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/FCalendar/FCalendarYear.vue?vue&type=template&id=75d7046f&

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FCalendar/FCalendarYearMonthItem.vue?vue&type=template&id=7246cf78&
var FCalendarYearMonthItemvue_type_template_id_7246cf78_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"calendar__month-item",class:{
        'calendar__month-item--has-days': _vm.numberOfAddedDays,
    },attrs:{"type":"button","tabindex":_vm.tabindex},on:{"click":_vm.onClickSelectMonth}},[_c('span',{staticClass:"calendar__month-item--name calendar__month-item--name-lg",attrs:{"aria-hidden":"true"}},[_vm._v(_vm._s(_vm.MONTHNAMES_LONG[_vm.month.month - 1]))]),_vm._v(" "),_c('span',{staticClass:"calendar__month-item--name calendar__month-item--name-sm",attrs:{"aria-hidden":"true"}},[_vm._v(_vm._s(_vm.MONTHNAMES_SHORT[_vm.month.month - 1]))]),_vm._v(" "),_c('span',{staticClass:"calendar__month-item--days",attrs:{"aria-hidden":"true"}},[_vm._v(_vm._s(_vm.numberOfAddedDays))]),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.MONTHNAMES_LONG[_vm.month.month - 1])+" med "+_vm._s(_vm.numberOfAddedDays)+" valda dagar")])])}
var FCalendarYearMonthItemvue_type_template_id_7246cf78_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/FCalendar/FCalendarYearMonthItem.vue?vue&type=template&id=7246cf78&

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FCalendar/FCalendarYearMonthItem.vue?vue&type=script&lang=ts&






/* harmony default export */ var FCalendarYearMonthItemvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: "FCalendarYearMonthItem",
  props: {
    month: {
      required: true,
      type: Object
    },
    calendarState: {
      required: true,
      type: Object
    }
  },
  data: function data() {
    return {
      MONTHNAMES_LONG: logic_["MONTHNAMES_LONG"],
      MONTHNAMES_SHORT: logic_["MONTHNAMES_SHORT"]
    };
  },
  computed: {
    hasFocusState: function hasFocusState() {
      return this.calendarState.getFocusedMonth() === this.month.month;
    },
    tabindex: function tabindex() {
      return this.hasFocusState ? 0 : -1;
    },
    numberOfAddedDays: function numberOfAddedDays() {
      var _this = this;

      var days = this.calendarState.getDays();
      return Object.entries(days).filter(function (e) {
        var calendarDate = CDate.fromString(e[0]);
        return e[1].added && calendarDate.getMonth() === _this.month.month && calendarDate.getYear() === _this.month.year;
      }).length;
    }
  },
  methods: {
    onClickSelectMonth: function onClickSelectMonth() {
      this.$emit("month-item-clicked", this.month);
    }
  }
}));
// CONCATENATED MODULE: ./src/components/FCalendar/FCalendarYearMonthItem.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FCalendar_FCalendarYearMonthItemvue_type_script_lang_ts_ = (FCalendarYearMonthItemvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FCalendar/FCalendarYearMonthItem.vue





/* normalize component */

var FCalendarYearMonthItem_component = normalizeComponent(
  FCalendar_FCalendarYearMonthItemvue_type_script_lang_ts_,
  FCalendarYearMonthItemvue_type_template_id_7246cf78_render,
  FCalendarYearMonthItemvue_type_template_id_7246cf78_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FCalendarYearMonthItem = (FCalendarYearMonthItem_component.exports);
// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FCalendar/FCalendarYear.vue?vue&type=script&lang=ts&




/* harmony default export */ var FCalendarYearvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: "FCalendarYear",
  components: {
    FCalendarYearMonthItem: FCalendarYearMonthItem
  },
  props: {
    year: {
      required: true,
      type: Number
    },
    calendarState: {
      required: true,
      type: Object
    }
  },
  methods: {
    getMonthsInQuarter: function getMonthsInQuarter(quarter) {
      var _this = this;

      return [1, 2, 3].map(function (i) {
        return {
          year: _this.year,
          month: (quarter - 1) * 3 + i
        };
      });
    },
    onClickSelectMonth: function onClickSelectMonth(month) {
      this.$emit("month-item-clicked", month);
    }
  }
}));
// CONCATENATED MODULE: ./src/components/FCalendar/FCalendarYear.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FCalendar_FCalendarYearvue_type_script_lang_ts_ = (FCalendarYearvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FCalendar/FCalendarYear.vue





/* normalize component */

var FCalendarYear_component = normalizeComponent(
  FCalendar_FCalendarYearvue_type_script_lang_ts_,
  FCalendarYearvue_type_template_id_75d7046f_render,
  FCalendarYearvue_type_template_id_75d7046f_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FCalendarYear = (FCalendarYear_component.exports);
// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FCalendar/FCalendarTabMain.vue?vue&type=script&lang=ts&











var FCalendarTabMainvue_type_script_lang_ts_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var FCalendarTabMainvue_type_script_lang_ts_generator = undefined && undefined.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
/* eslint-disable vue/no-mutating-props */









/**
 * Level: DRAFT
 */

/* harmony default export */ var FCalendarTabMainvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: "FCalendarTabMain",
  components: {
    FCalendarMonth: FCalendarMonth,
    FCalendarYear: FCalendarYear,
    FIcon: FIcon
  },
  props: {
    calendarState: {
      type: Object,
      required: false,
      default: function _default() {
        return new CalendarState_CalendarState();
      }
    },
    options: {
      required: true,
      type: Object
    }
  },
  data: function data() {
    return {
      yearView: false,
      MONTHNAMES_LONG: logic_["MONTHNAMES_LONG"],
      MONTHNAMES_SHORT: logic_["MONTHNAMES_SHORT"]
    };
  },
  computed: {
    showEditBox: function showEditBox() {
      return this.hasSelectedDays && this.$scopedSlots["editbox"] !== undefined;
    },
    selectedDays: function selectedDays() {
      return this.calendarState.getSelectedDays();
    },
    hasSelectedDays: function hasSelectedDays() {
      return this.calendarState.hasSelectedDays();
    },
    hasAddedDays: function hasAddedDays() {
      return this.calendarState.hasAddedDays();
    }
  },
  mounted: function mounted() {
    if (this.options.initialYear > 0) {
      this.calendarState.currentYear = this.options.initialYear;
    }

    if (this.options.initialMonth > 0) {
      this.calendarState.currentMonth = this.options.initialMonth;
    }

    var focusedByOption = this.options.initialFocusedDay;

    if (focusedByOption) {
      this.calendarState.setFocusedDay(focusedByOption);
      this.focusInMonthView();
    }
  },
  methods: {
    findDayByDate: function findDayByDate(children, date) {
      var newDay = date.date();
      var newMonth = date.month() + 1;
      var newYear = date.year();
      var found = this.findElement(children, function (value) {
        return value.$props && value.$props.day && value.$props.day.year === newYear && value.$props.day.month === newMonth && value.$props.day.day === newDay;
      });
      return found;
    },
    findElement: function findElement(children, predicate) {
      var found = children.find(predicate);

      if (found) {
        return found;
      }

      for (var _i = 0, children_1 = children; _i < children_1.length; _i++) {
        var child = children_1[_i];
        var foundInChild = this.findElement(child.$children, predicate);

        if (foundInChild) {
          return foundInChild;
        }
      }

      return undefined;
    },
    focusInCalendar: function focusInCalendar() {
      if (this.yearView) {
        this.focusInYearView();
      } else {
        this.focusInMonthView();
      }
    },
    changeView: function changeView() {
      return FCalendarTabMainvue_type_script_lang_ts_awaiter(this, void 0, Promise, function () {
        return FCalendarTabMainvue_type_script_lang_ts_generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              this.yearView = !this.yearView;
              return [4
              /*yield*/
              , this.$nextTick()];

            case 1:
              _a.sent();

              this.focusInCalendar();
              return [2
              /*return*/
              ];
          }
        });
      });
    },
    prevMonthName: function prevMonthName() {
      return this.calendarState.currentMonth === 1 ? this.MONTHNAMES_SHORT[11] : this.MONTHNAMES_SHORT[this.calendarState.currentMonth - 2];
    },
    nextMonthName: function nextMonthName() {
      return this.calendarState.currentMonth === 12 ? this.MONTHNAMES_SHORT[0] : this.MONTHNAMES_SHORT[this.calendarState.currentMonth];
    },
    prevMonthFullName: function prevMonthFullName() {
      return (this.calendarState.currentMonth === 1 ? this.MONTHNAMES_LONG[11] : this.MONTHNAMES_LONG[this.calendarState.currentMonth - 2]).toLowerCase();
    },
    nextMonthFullName: function nextMonthFullName() {
      return (this.calendarState.currentMonth === 12 ? this.MONTHNAMES_LONG[0] : this.MONTHNAMES_LONG[this.calendarState.currentMonth]).toLowerCase();
    },
    onArrowKeyPrevent: function onArrowKeyPrevent(e) {
      e.preventDefault();
    },
    onKeyUp: function onKeyUp() {
      if (this.yearView) {
        this.onMonthNavigation(function (m) {
          return m - 3;
        });
      } else {
        this.onDayNavigation(function (m) {
          return m.subtract(7, "days");
        });
      }
    },
    onKeyDown: function onKeyDown() {
      if (this.yearView) {
        this.onMonthNavigation(function (m) {
          return m + 3;
        });
      } else {
        this.onDayNavigation(function (m) {
          return m.add(7, "days");
        });
      }
    },
    onKeyLeft: function onKeyLeft() {
      if (this.yearView) {
        this.onMonthNavigation(function (m) {
          return m - 1;
        });
      } else {
        this.onDayNavigation(function (m) {
          return m.subtract(1, "days");
        });
      }
    },
    onKeyRight: function onKeyRight() {
      if (this.yearView) {
        this.onMonthNavigation(function (m) {
          return m + 1;
        });
      } else {
        this.onDayNavigation(function (m) {
          return m.add(1, "days");
        });
      }
    },
    onKeyEsc: function onKeyEsc() {
      // Focus and blur the first child of the first element
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      var firstSelectable = this.$el.querySelector(".calendar__navbar");

      for (var i = 0; i < firstSelectable.children.length; i++) {
        var child = firstSelectable.children[i]; // First visible child

        if (child.offsetWidth > 0 && child.offsetHeight > 0) {
          child.focus();
          child.blur();
          break;
        } else {
          continue;
        }
      }
    },
    onDayNavigation: function onDayNavigation(dateModifier) {
      return FCalendarTabMainvue_type_script_lang_ts_awaiter(this, void 0, void 0, function () {
        var focusedDate, focusedMomentDate, nextFocusedMomentDate;
        return FCalendarTabMainvue_type_script_lang_ts_generator(this, function (_a) {
          focusedDate = this.calendarState.getFocusedDay();
          focusedMomentDate = external_moment_default()([this.calendarState.currentYear, this.calendarState.currentMonth - 1, focusedDate]);
          nextFocusedMomentDate = dateModifier(focusedMomentDate);
          this.calendarState.currentYear = nextFocusedMomentDate.year();
          this.calendarState.currentMonth = nextFocusedMomentDate.month() + 1;
          this.calendarState.setFocusedDay(nextFocusedMomentDate.date());
          this.focusInMonthView();
          return [2
          /*return*/
          ];
        });
      });
    },
    onMonthNavigation: function onMonthNavigation(dateModifier) {
      var focusedMonth = this.calendarState.getFocusedMonth();
      var nextFocused = (dateModifier(focusedMonth) - 1 + 12) % 12 + 1;
      this.calendarState.setFocusedMonth(nextFocused);
      this.focusInYearView();
    },
    onClickPrev: function onClickPrev() {
      if (this.yearView) {
        // ÅR
        this.calendarState.currentYear--;
        this.$emit("year-navigation", this.calendarState.getCurrentDateInView());
      } else {
        // MÅNAD
        if (this.calendarState.currentMonth === 1) {
          this.calendarState.currentYear--;
          this.calendarState.currentMonth = 12;
        } else {
          this.calendarState.currentMonth--;
        }

        this.$emit("month-navigation", this.calendarState.getCurrentDateInView());
      }
    },
    onClickNext: function onClickNext() {
      if (this.yearView) {
        // ÅR
        this.calendarState.currentYear++;
        this.$emit("year-navigation", this.calendarState.getCurrentDateInView());
      } else {
        // MÅNAD
        if (this.calendarState.currentMonth === 12) {
          this.calendarState.currentYear++;
          this.calendarState.currentMonth = 1;
        } else {
          this.calendarState.currentMonth++;
        }

        this.$emit("month-navigation", this.calendarState.getCurrentDateInView());
      }
    },
    onClickSelectMonth: function onClickSelectMonth(month) {
      this.calendarState.currentYear = month.year;
      this.calendarState.currentMonth = month.month;
      this.yearView = false;
      this.focusInMonthView();
    },
    focusInYearView: function focusInYearView() {
      return FCalendarTabMainvue_type_script_lang_ts_awaiter(this, void 0, void 0, function () {
        var focusedMonth, found;
        return FCalendarTabMainvue_type_script_lang_ts_generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , this.$nextTick()];

            case 1:
              _a.sent();

              focusedMonth = this.calendarState.getFocusedMonth();
              found = this.findMonthByNumber(this.$root.$children, focusedMonth);

              if (found) {
                // IPopup is handling scrolling, thus prevent scroll
                found.$el.focus({
                  preventScroll: true
                });
              }

              return [2
              /*return*/
              ];
          }
        });
      });
    },
    focusInMonthView: function focusInMonthView() {
      return FCalendarTabMainvue_type_script_lang_ts_awaiter(this, void 0, void 0, function () {
        var focusedDayMoment, found;
        return FCalendarTabMainvue_type_script_lang_ts_generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , this.$nextTick()];

            case 1:
              _a.sent();

              focusedDayMoment = this.getFocusedDayInCurrentMonth(this.calendarState.currentYear, this.calendarState.currentMonth, this.calendarState.getFocusedDay());
              this.calendarState.setFocusedDay(focusedDayMoment.date());
              found = this.findDayByDate(this.$root.$children, focusedDayMoment);

              if (found) {
                // IPopup is handling scrolling, thus prevent scroll
                found.$el.focus({
                  preventScroll: true
                });
              }

              return [2
              /*return*/
              ];
          }
        });
      });
    },
    getFocusedDayInCurrentMonth: function getFocusedDayInCurrentMonth(currentYear, currentMonth, focusedDate) {
      var daysInCurrentMonth = external_moment_default()([currentYear, currentMonth - 1]).daysInMonth();

      if (daysInCurrentMonth < focusedDate) {
        return external_moment_default()([currentYear, currentMonth - 1, daysInCurrentMonth]);
      } else {
        return external_moment_default()([currentYear, currentMonth - 1, focusedDate]);
      }
    },
    findMonthByNumber: function findMonthByNumber(children, focusedMonth) {
      var found = this.findElement(children, function (value) {
        return value.$props && value.$props.month && value.$props.month.month === focusedMonth;
      });
      return found;
    },
    onDaySelected: function onDaySelected(day) {
      this.calendarState.currentYear = day.getYear();
      this.calendarState.currentMonth = day.getMonth();
      this.calendarState.setFocusedDay(day.getDay());
      this.focusInMonthView();
      this.$emit("day-selected", day);
    },
    onDayUnselected: function onDayUnselected(day) {
      this.$emit("day-unselected", day);
    },
    onDayRemoved: function onDayRemoved(day) {
      this.$emit("day-removed", day);
    },
    onEditboxSaved: function onEditboxSaved(selectedDates) {
      this.focusInCalendar();
      this.$emit("editbox-saved", selectedDates);
    },
    onEditboxCancelled: function onEditboxCancelled(selectedDates) {
      this.focusInCalendar();
      this.$emit("editbox-cancelled", selectedDates);
    },
    onDisabledDayRequested: function onDisabledDayRequested(day) {
      this.$emit("disabled-day-requested", day);
    }
  }
}));
// CONCATENATED MODULE: ./src/components/FCalendar/FCalendarTabMain.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FCalendar_FCalendarTabMainvue_type_script_lang_ts_ = (FCalendarTabMainvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FCalendar/FCalendarTabMain.vue





/* normalize component */

var FCalendarTabMain_component = normalizeComponent(
  FCalendar_FCalendarTabMainvue_type_script_lang_ts_,
  FCalendarTabMainvue_type_template_id_afc00606_render,
  FCalendarTabMainvue_type_template_id_afc00606_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FCalendarTabMain = (FCalendarTabMain_component.exports);
// CONCATENATED MODULE: ./src/components/FDatepicker/DisabledDatesValidator.ts

var DisabledDatesValidator = {
  name: "disabledDates",
  validation: function validation(value, element, config) {
    return !FCalendarDateMethods_isDisabled(value, config.options);
  }
};
// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FDatepicker/FDatepicker.vue?vue&type=script&lang=ts&















var FDatepickervue_type_script_lang_ts_assign = undefined && undefined.__assign || function () {
  FDatepickervue_type_script_lang_ts_assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return FDatepickervue_type_script_lang_ts_assign.apply(this, arguments);
};

var FDatepickervue_type_script_lang_ts_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var FDatepickervue_type_script_lang_ts_generator = undefined && undefined.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};










 // Due to async and focus problems when opening
// several popups we need to know the last opened datepicker.
// @see onClickOpen, onClosePopup

var lastOpenedDatepicker = undefined;
logic_["ValidationService"].registerValidator(DisabledDatesValidator);
/**
 * Level: DRAFT
 */

/* harmony default export */ var FDatepickervue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: "FDatepicker",
  components: {
    FTextField: FTextField,
    FCalendarTabMain: FCalendarTabMain,
    FIcon: FIcon,
    IPopup: IPopup
  },
  mixins: [TranslationMixin],
  inheritAttrs: false,
  model: {
    prop: "value",
    event: "update"
  },
  props: {
    /**
     * The id for the input id attribute.
     * The id for the label for attribute.
     * If the prop is not set a random value will be generated.
     */
    id: {
      type: String,
      required: false,
      default: function _default() {
        return logic_["ElementIdService"].generateElementId();
      }
    },

    /**
     * The value for the input.
     * If the prop is not set undefined will be used.
     * @model
     */
    value: {
      type: String,
      required: false,
      default: ""
    },

    /**
     * Options that can be applied to the component.
     */
    options: {
      type: Object,
      required: false,
      default: function _default() {
        return new FDatepickerComponentOptions_FDatepickerComponentOptions();
      }
    },

    /**
     * Force popup to always display inline. This might be
     * need in some rare cases when datepick is inside div
     * that has position fixed and overflow auto.
     */
    alwaysInline: {
      type: Boolean,
      default: false
    },

    /**
     * Specifies that the component should be disabled, i.e. unusable.
     */
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      isOpen: false,
      calendarOptions: {}
    };
  },
  computed: {
    attrs: function attrs() {
      return FDatepickervue_type_script_lang_ts_assign(FDatepickervue_type_script_lang_ts_assign({}, this.$attrs), {
        value: this.value,
        id: this.id
      });
    },
    validationConfig: function validationConfig() {
      return {
        disabledDates: {
          options: this.options,
          errorMessage: this.$t("fkuiDatePickerDisabledDates", "Du har skrivit ett ogiltigt datum.")
        }
      };
    },
    getAriaLabel: function getAriaLabel() {
      var ariaLabel = this.isOpen ? "Stäng datumväljare" : "Öppna datumväljare";
      return this.$t("fkuiDatePickerAriaLabel", ariaLabel);
    },

    /* eslint-disable-next-line @typescript-eslint/ban-types */
    listeners: function listeners() {
      var _this = this;

      return FDatepickervue_type_script_lang_ts_assign(FDatepickervue_type_script_lang_ts_assign({}, this.$listeners), {
        update: function update(event) {
          /**
           * V-model event.
           *
           * @event update
           * @type {string | number}
           */
          _this.$emit("update", event);
        },
        change: function change(event) {
          /**
           * @event change
           * @type {string | number}
           */
          _this.$emit("change", event);
        },
        blur: function blur(event) {
          /**
           * @event blur
           * @type {string | number}
           */
          _this.$emit("blur", event);
        },
        keyup: function keyup(event) {
          if (event.keyCode === 13) {
            logic_["ValidationService"].validateElement(_this.id);

            _this.$emit("update", _this.value);
          }
        }
      });
    }
  },
  methods: {
    onDaySelected: function onDaySelected(val) {
      return FDatepickervue_type_script_lang_ts_awaiter(this, void 0, Promise, function () {
        var openButton;
        return FDatepickervue_type_script_lang_ts_generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              this.isOpen = false;
              this.$emit("update", val.toString());
              return [4
              /*yield*/
              , this.$nextTick()];

            case 1:
              _a.sent();

              logic_["ValidationService"].validateElement(this.id);
              openButton = this.$el.querySelector(".datepicker__open");

              if (openButton) {
                openButton.focus();
              }

              return [2
              /*return*/
              ];
          }
        });
      });
    },
    deepEqual: function deepEqual(a, b) {
      return JSON.stringify(a) === JSON.stringify(b);
    },
    getFDatepickerComponentOptionsDifference: function getFDatepickerComponentOptionsDifference(a, b) {
      var _this = this;

      return Object.entries(a).reduce(function (acc, _a) {
        var key = _a[0],
            value = _a[1];

        if (!_this.deepEqual(a[key], b[key])) {
          acc[key] = value;
        }

        return acc;
      }, {});
    },
    updateOptions: function updateOptions() {
      var datepickerOptions = new FDatepickerComponentOptions_FDatepickerComponentOptions();
      var defaultOptionsOverrides = this.getFDatepickerComponentOptionsDifference(this.options, datepickerOptions);
      var valueOverrides = {};

      if (this.value && this.$el.querySelectorAll(".text-field__input:invalid").length === 0) {
        var date = CDate.fromString(this.value);
        valueOverrides = {
          initialYear: date.getYear(),
          initialMonth: date.getMonth(),
          initialFocusedDay: date.getDay()
        };
      }

      this.calendarOptions = Object.assign(datepickerOptions, defaultOptionsOverrides, valueOverrides);
    },
    onClickOpen: function onClickOpen() {
      if (!this.isOpen) {
        this.updateOptions();
      }

      this.isOpen = !this.isOpen;

      if (this.isOpen) {
        // eslint-disable-next-line consistent-this, @typescript-eslint/no-this-alias
        lastOpenedDatepicker = this;
      }
    },
    onClosePopup: function onClosePopup() {
      this.isOpen = false;

      if (lastOpenedDatepicker === this) {
        this.$refs.popupAnchor.focus();
      }
    },
    dateFormatter: logic_["parseDate"]
  }
}));
// CONCATENATED MODULE: ./src/components/FDatepicker/FDatepicker.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FDatepicker_FDatepickervue_type_script_lang_ts_ = (FDatepickervue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FDatepicker/FDatepicker.vue





/* normalize component */

var FDatepicker_component = normalizeComponent(
  FDatepicker_FDatepickervue_type_script_lang_ts_,
  FDatepickervue_type_template_id_35ae5700_render,
  FDatepickervue_type_template_id_35ae5700_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FDatepicker = (FDatepicker_component.exports);
// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FCheckboxGroup/FCheckboxGroupField.vue?vue&type=template&id=56b4469a&
var FCheckboxGroupFieldvue_type_template_id_56b4469a_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox",class:_vm.disabledClass,on:{"validity":_vm.onValidity}},[_c('input',_vm._g(_vm._b({staticClass:"checkbox__input",attrs:{"type":"checkbox"},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }return _vm.onKeydown.apply(null, arguments)}}},'input',_vm.attrs,false),_vm.listeners)),_vm._v(" "),_c('label',{staticClass:"checkbox__label",attrs:{"for":_vm.attrs.id}},[_vm._t("default")],2)])}
var FCheckboxGroupFieldvue_type_template_id_56b4469a_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/FCheckboxGroup/FCheckboxGroupField.vue?vue&type=template&id=56b4469a&

// EXTERNAL MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/core-js/modules/es.array.splice.js
var es_array_splice = __webpack_require__("11ed");

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FCheckboxGroup/FCheckboxGroupField.vue?vue&type=script&lang=ts&








var FCheckboxGroupFieldvue_type_script_lang_ts_assign = undefined && undefined.__assign || function () {
  FCheckboxGroupFieldvue_type_script_lang_ts_assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return FCheckboxGroupFieldvue_type_script_lang_ts_assign.apply(this, arguments);
};

var FCheckboxGroupFieldvue_type_script_lang_ts_spreadArray = undefined && undefined.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};



 // ! Boolean must be last so that empty string ('') is not parsed as true, see: https://github.com/vuejs/vue/blob/81e1e47cabbd479e2a285f03120944f1efffe749/test/unit/features/options/props.spec.js#L516.

var anyType = [String, Object, Array, Number, Date, Boolean];
/* harmony default export */ var FCheckboxGroupFieldvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: "FCheckboxGroupField",
  inject: {
    getFieldsetLabelText: {
      default: function _default() {
        return "";
      }
    }
  },
  inheritAttrs: false,
  model: {
    prop: "checked",
    event: "change"
  },
  props: {
    /**
     * The id for the input id attribute.
     * The id for the label for attribute.
     * If the prop is not set a random value will be generated.
     */
    id: {
      type: String,
      required: false,
      default: function _default() {
        return logic_["ElementIdService"].generateElementId();
      }
    },

    /**
     * The value for the input checked attribute.
     */
    // ? The rule is disabled so that the `checked` prop can be undefined or null.
    // eslint-disable-next-line vue/require-default-prop
    checked: {
      type: anyType,
      required: false
    },

    /**
     * The value for the input.
     * @model
     */
    value: {
      type: anyType,
      required: true
    }
  },
  data: function data() {
    return {
      validity: {
        validityMode: "INITIAL"
      }
    };
  },
  computed: {
    attrs: function attrs() {
      var checked;

      if (Array.isArray(this.checked)) {
        checked = this.checked.includes(this.value);
      } else {
        checked = this.value === this.checked;
      }

      return FCheckboxGroupFieldvue_type_script_lang_ts_assign(FCheckboxGroupFieldvue_type_script_lang_ts_assign({}, this.$attrs), {
        id: this.id,
        value: this.value,
        checked: checked
      });
    },
    disabledClass: function disabledClass() {
      var disabled = this.$attrs.disabled;
      return Object(logic_["isSet"])(disabled) && disabled !== false ? "disabled" : "";
    },

    /* eslint-disable-next-line @typescript-eslint/ban-types */
    listeners: function listeners() {
      var _this = this;

      return FCheckboxGroupFieldvue_type_script_lang_ts_assign(FCheckboxGroupFieldvue_type_script_lang_ts_assign({}, this.$listeners), {
        change: function change(event) {
          if (event.target instanceof HTMLInputElement) {
            _this.emitVModelEvent(event);
          }
        },
        input: function input(event) {
          // ? Force focus on Mac + Safari
          event.target.focus();
        }
      });
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    injected: function injected() {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      return this;
    }
  },
  methods: {
    // eslint-disable-next-line complexity
    emitVModelEvent: function emitVModelEvent(event) {
      var newValue;

      if (Array.isArray(this.checked)) {
        newValue = FCheckboxGroupFieldvue_type_script_lang_ts_spreadArray([], this.checked, true);

        if (newValue.includes(this.value)) {
          newValue.splice(newValue.indexOf(this.value), 1);
        } else {
          newValue.push(this.value);
        }
      } else {
        if (this.value === this.checked) {
          newValue = typeof this.value === "boolean" ? false : undefined;
        } else {
          var target = event.target;
          newValue = target.value === "true" ? true : this.value;
        }
      }
      /**
       * V-model event.
       *
       * @event change
       * @type {anyType | anyType[]}
       */


      this.$emit("change", newValue);
    },
    onKeydown: function onKeydown(event) {
      // Fix SFKUI-2912: mark checkbox with space in IE11
      event.stopPropagation();
    },
    onValidity: function onValidity(_a) {
      var detail = _a.detail;

      if (detail.target !== this.$el.querySelector("input")) {
        return;
      }

      this.$set(this, "validity", detail);
      var errorMessage = "";

      if (this.$scopedSlots.default) {
        var labelText = this.injected.getFieldsetLabelText();

        if (labelText) {
          errorMessage = "".concat(labelText, " ").concat(getTextFromScopedSlot(this.$scopedSlots.default));
        } else {
          errorMessage = "".concat(getTextFromScopedSlot(this.$scopedSlots.default));
        }
      }

      var element = this.$el.querySelector("#".concat(detail.elementId));

      if (element) {
        dispatchComponentValidityEvent(element, FCheckboxGroupFieldvue_type_script_lang_ts_assign(FCheckboxGroupFieldvue_type_script_lang_ts_assign({}, detail), {
          errorMessage: errorMessage,
          focusElementId: detail.elementId
        }));
      }
    }
  }
}));
// CONCATENATED MODULE: ./src/components/FCheckboxGroup/FCheckboxGroupField.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FCheckboxGroup_FCheckboxGroupFieldvue_type_script_lang_ts_ = (FCheckboxGroupFieldvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FCheckboxGroup/FCheckboxGroupField.vue





/* normalize component */

var FCheckboxGroupField_component = normalizeComponent(
  FCheckboxGroup_FCheckboxGroupFieldvue_type_script_lang_ts_,
  FCheckboxGroupFieldvue_type_template_id_56b4469a_render,
  FCheckboxGroupFieldvue_type_template_id_56b4469a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FCheckboxGroupField = (FCheckboxGroupField_component.exports);
// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FCheckboxGroup/FCheckboxGroup.vue?vue&type=template&id=64a9c52c&
var FCheckboxGroupvue_type_template_id_64a9c52c_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f-fieldset',_vm._g(_vm._b({staticClass:"checkbox-group",attrs:{"label-class":"checkbox-group__label","content-class":"checkbox-group__content"},scopedSlots:_vm._u([{key:"label",fn:function(){return [_vm._t("label"),_vm._v(" "),(_vm.children.length !== 1)?_c('span',{staticClass:"sr-only"},[_c('span',[_vm._v(_vm._s(_vm.numberOfCheckboxesScreenReaderText))])]):_vm._e()]},proxy:true},{key:"tooltip",fn:function(){return [_vm._t("tooltip")]},proxy:true},{key:"description",fn:function(ref){
var descriptionClass = ref.descriptionClass;
var discreteDescriptionClass = ref.discreteDescriptionClass;
return [_vm._t("description",null,null,{ descriptionClass: descriptionClass, discreteDescriptionClass: discreteDescriptionClass })]}},{key:"error-message",fn:function(){return [_vm._t("error-message")]},proxy:true}],null,true)},'f-fieldset',_vm.attrs,false),_vm.$listeners),[_vm._v(" "),_vm._v(" "),_c('span',{staticClass:"sr-only",attrs:{"aria-live":"polite"}},[(_vm.children.length === 1)?_c('span',[_vm._v(_vm._s(_vm.checkboxCheckedScreenReaderText))]):_c('span',[_vm._v(_vm._s(_vm.numberOfCheckedCheckboxesScreenText))])]),_vm._v(" "),_vm._v(" "),_vm._v(" "),_vm._t("default")],2)}
var FCheckboxGroupvue_type_template_id_64a9c52c_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/FCheckboxGroup/FCheckboxGroup.vue?vue&type=template&id=64a9c52c&

// EXTERNAL MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__("8423");

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FFieldset/FFieldset.vue?vue&type=template&id=22da6bc6&
var FFieldsetvue_type_template_id_22da6bc6_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',_vm._g(_vm._b({on:{"validity":_vm.onValidity}},'fieldset',_vm.attrs,false),_vm.$listeners),[_c('legend',{key:_vm.legendKey,staticClass:"label",class:_vm.legendClass},[_vm._t("label"),_vm._v(" "),_vm._t("description",null,null,_vm.descriptionSlotClasses),_vm._v(" "),_vm._t("error-message",function(){return [(_vm.hasError)?[_c('span',{staticClass:"label__message label__message--error"},[_c('f-icon',{staticClass:"label__icon--left",attrs:{"name":"error"}}),_vm._v("\n                        "+_vm._s(_vm.validity.validationMessage)+"\n                    ")],1)]:_vm._e()]})],2),_vm._v(" "),(_vm.hasTooltipSlot)?[_c('div',{staticClass:"sr-separator"},[_c('div',{staticClass:"tooltip-before",attrs:{"aria-hidden":"true"}},[_c('div',{staticClass:"label tooltip-before__label"},[_vm._t("label")],2)]),_vm._v(" "),_vm._t("tooltip")],2),_vm._v(" "),(_vm.hasDescriptionSlot || _vm.hasErrorMessageSlot || _vm.hasError)?_c('div',{staticClass:"label",class:_vm.labelClass,attrs:{"aria-hidden":"true"}},[_vm._t("description",null,null,_vm.descriptionSlotClasses),_vm._v(" "),_vm._t("error-message",function(){return [(_vm.hasError)?[_c('span',{staticClass:"label__message label__message--error"},[_c('f-icon',{staticClass:"label__icon--left",attrs:{"name":"error"}}),_vm._v("\n                            "+_vm._s(_vm.validity.validationMessage)+"\n                        ")],1)]:_vm._e()]})],2):_vm._e()]:_vm._e(),_vm._v(" "),_c('div',{class:_vm.contentClass},[_vm._t("default")],2)],2)}
var FFieldsetvue_type_template_id_22da6bc6_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/FFieldset/FFieldset.vue?vue&type=template&id=22da6bc6&

// CONCATENATED MODULE: ./src/components/FFieldset/FFieldsetProvide.ts



var getFieldsetLabelText = Symbol("getFieldsetLabelText");
// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FFieldset/FFieldset.vue?vue&type=script&lang=ts&












var FFieldsetvue_type_script_lang_ts_assign = undefined && undefined.__assign || function () {
  FFieldsetvue_type_script_lang_ts_assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return FFieldsetvue_type_script_lang_ts_assign.apply(this, arguments);
};

var FFieldsetvue_type_script_lang_ts_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var FFieldsetvue_type_script_lang_ts_generator = undefined && undefined.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};







/* harmony default export */ var FFieldsetvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: "FFieldset",
  components: {
    FIcon: FIcon
  },
  provide: function provide() {
    var _a;

    var _this = this;

    return _a = {}, _a[getFieldsetLabelText] = function () {
      return _this.$scopedSlots.label ? getTextFromScopedSlot(_this.$scopedSlots.label) : undefined;
    }, _a;
  },
  props: {
    /**
     * The id for the fieldset id attribute.
     * If the prop is not set a random value will be generated.
     */
    id: {
      type: String,
      required: false,
      default: function _default() {
        return logic_["ElementIdService"].generateElementId();
      }
    },

    /**
     * The name for the fieldset name attribute.
     */
    name: {
      type: String,
      required: false,
      default: ""
    },

    /**
     * The CSS classes for the label, description and error-message slot.
     */
    labelClass: {
      type: String,
      required: false,
      default: ""
    },

    /**
     * The CSS classes for the default slot.
     */
    contentClass: {
      type: String,
      required: false,
      default: ""
    }
  },
  data: function data() {
    return {
      validity: {
        validityMode: "INITIAL"
      },
      descriptionSlotClasses: {
        descriptionClass: ["label__description"],
        discreteDescriptionClass: ["label__description", "label__description--discrete"]
      },
      validityElement: null,
      dispatchObject: {},
      detail: {},
      hasDocumentListener: false,
      legendKey: 1,
      oldMessage: ""
    };
  },
  computed: {
    attrs: function attrs() {
      return FFieldsetvue_type_script_lang_ts_assign(FFieldsetvue_type_script_lang_ts_assign({}, this.$attrs), {
        id: this.id,
        name: this.name
      });
    },
    hasError: function hasError() {
      return this.validity.validityMode === "ERROR";
    },
    hasErrorMessageSlot: function hasErrorMessageSlot() {
      return hasSlot(this, "error-message");
    },
    hasTooltipSlot: function hasTooltipSlot() {
      return hasSlot(this, "tooltip");
    },
    hasDescriptionSlot: function hasDescriptionSlot() {
      return hasSlot(this, "description");
    },
    legendClass: function legendClass() {
      var _a;

      return _a = {}, // If the tooltip is provided we should avoid adding the labelClass to the top legend element.
      _a[this.labelClass] = !this.hasTooltipSlot, _a["sr-only"] = this.hasTooltipSlot, _a;
    }
  },
  methods: {
    onValidity: function onValidity(_a) {
      var detail = _a.detail;
      return FFieldsetvue_type_script_lang_ts_awaiter(this, void 0, Promise, function () {
        var errorMessage, firstFocusableElement, focusElementId, message;
        return FFieldsetvue_type_script_lang_ts_generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              if (detail.target !== this.$el) {
                return [2
                /*return*/
                ];
              }

              this.$set(this, "detail", detail);
              return [4
              /*yield*/
              , this.$nextTick()];

            case 1:
              _b.sent();

              errorMessage = "";
              firstFocusableElement = this.$el.querySelector("input:not(disabled), select:not(disabled), textarea:not(disabled)");
              focusElementId = firstFocusableElement ? firstFocusableElement.id : this.id;

              if (this.$scopedSlots.label) {
                errorMessage = getTextFromScopedSlot(this.$scopedSlots.label);
              }

              this.validityElement = this.$el;
              this.dispatchObject = FFieldsetvue_type_script_lang_ts_assign(FFieldsetvue_type_script_lang_ts_assign({}, detail), {
                errorMessage: errorMessage,
                focusElementId: focusElementId
              });
              this.validity = this.detail;
              this.validityElement ? dispatchComponentValidityEvent(this.validityElement, this.dispatchObject) : false;
              message = detail.validityMode === "INITIAL" ? "" : detail.validationMessage;

              if (message !== this.oldMessage) {
                this.forceLegendUpdate();
                this.oldMessage = message;
              }

              return [2
              /*return*/
              ];
          }
        });
      });
    },

    /**
     * Workaround for NVDA-bug. Force re rendering of legend element due to NVDA not recognizing innerHTML changes.
     * NVDA has closed the bug as it is related to the browser (works in FF): https://github.com/nvaccess/nvda/issues/13162
     */
    forceLegendUpdate: function forceLegendUpdate() {
      this.legendKey++;
    }
  }
}));
// CONCATENATED MODULE: ./src/components/FFieldset/FFieldset.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FFieldset_FFieldsetvue_type_script_lang_ts_ = (FFieldsetvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FFieldset/FFieldset.vue





/* normalize component */

var FFieldset_component = normalizeComponent(
  FFieldset_FFieldsetvue_type_script_lang_ts_,
  FFieldsetvue_type_template_id_22da6bc6_render,
  FFieldsetvue_type_template_id_22da6bc6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FFieldset = (FFieldset_component.exports);
// CONCATENATED MODULE: ./src/components/FFieldset/index.ts

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FCheckboxGroup/FCheckboxGroup.vue?vue&type=script&lang=ts&
















var FCheckboxGroupvue_type_script_lang_ts_assign = undefined && undefined.__assign || function () {
  FCheckboxGroupvue_type_script_lang_ts_assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return FCheckboxGroupvue_type_script_lang_ts_assign.apply(this, arguments);
};

var FCheckboxGroupvue_type_script_lang_ts_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var FCheckboxGroupvue_type_script_lang_ts_generator = undefined && undefined.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};




/* harmony default export */ var FCheckboxGroupvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: "FCheckboxGroup",
  components: {
    FFieldset: FFieldset
  },
  inheritAttrs: false,
  props: {
    /**
     * The id for the fieldset id attribute.
     * If the prop is not set the id will be generated.
     */
    id: {
      type: String,
      required: false,
      default: function _default() {
        return logic_["ElementIdService"].generateElementId();
      }
    },

    /**
     * The name of the checkbox group.
     */
    name: {
      type: String,
      required: true
    },

    /**
     * The screen reader text for when entering the group to inform the number of checkboxes.
     * %VALUE will be replaced with the total number of checkboxes.
     */
    numberOfCheckboxesScreenReaderTemplate: {
      type: String,
      default: "Grupp med %VALUE% kryssrutor"
    },

    /**
     * The screen reader text for when checking/unchecking checkboxes to inform the number of checked checkboxes.
     * %CHECKED will be replaced with the number of checked checkboxes.
     * %TOTAL will be replaced with the total number of checkboxes.
     */
    numberOfCheckedCheckboxesScreenReaderTemplate: {
      type: String,
      default: "%CHECKED% kryssad av %VALUE%"
    }
  },
  data: function data() {
    return {
      children: new Array()
    };
  },
  computed: {
    attrs: function attrs() {
      return FCheckboxGroupvue_type_script_lang_ts_assign(FCheckboxGroupvue_type_script_lang_ts_assign({}, this.$attrs), {
        id: this.id,
        name: this.name
      });
    },
    checkedChildren: function checkedChildren() {
      return this.children.filter(function (child) {
        return child.checked;
      });
    },
    debouncedUpdateChildren: function debouncedUpdateChildren() {
      return Object(logic_["debounce"])(this.updateChildren.bind(this), 150);
    },
    checkboxCheckedScreenReaderText: function checkboxCheckedScreenReaderText() {
      return this.checkedChildren.length === 1 ? "Kryssruta kryssad" : "Kryssruta ej kryssad";
    },
    numberOfCheckboxesScreenReaderText: function numberOfCheckboxesScreenReaderText() {
      return this.numberOfCheckboxesScreenReaderTemplate.replace("%VALUE%", String(this.children.length));
    },
    numberOfCheckedCheckboxesScreenText: function numberOfCheckedCheckboxesScreenText() {
      return this.numberOfCheckedCheckboxesScreenReaderTemplate.replace("%CHECKED%", String(this.checkedChildren.length)).replace("%VALUE%", String(this.children.length));
    }
  },
  mounted: function mounted() {
    return FCheckboxGroupvue_type_script_lang_ts_awaiter(this, void 0, Promise, function () {
      return FCheckboxGroupvue_type_script_lang_ts_generator(this, function (_a) {
        this.updateChildren();
        return [2
        /*return*/
        ];
      });
    });
  },
  updated: function updated() {
    this.debouncedUpdateChildren();
  },
  methods: {
    updateChildren: function updateChildren() {
      var _a;

      return FCheckboxGroupvue_type_script_lang_ts_awaiter(this, void 0, Promise, function () {
        return FCheckboxGroupvue_type_script_lang_ts_generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , this.$nextTick()];

            case 1:
              _b.sent();

              this.children = Array.from((_a = this.$el.querySelectorAll('input[type="checkbox"]')) !== null && _a !== void 0 ? _a : []);
              return [2
              /*return*/
              ];
          }
        });
      });
    }
  }
}));
// CONCATENATED MODULE: ./src/components/FCheckboxGroup/FCheckboxGroup.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FCheckboxGroup_FCheckboxGroupvue_type_script_lang_ts_ = (FCheckboxGroupvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FCheckboxGroup/FCheckboxGroup.vue





/* normalize component */

var FCheckboxGroup_component = normalizeComponent(
  FCheckboxGroup_FCheckboxGroupvue_type_script_lang_ts_,
  FCheckboxGroupvue_type_template_id_64a9c52c_render,
  FCheckboxGroupvue_type_template_id_64a9c52c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FCheckboxGroup = (FCheckboxGroup_component.exports);
// CONCATENATED MODULE: ./src/components/FCheckboxGroup/index.ts


// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FSelectField/FSelectField.vue?vue&type=template&id=a5fc5588&
var FSelectFieldvue_type_template_id_a5fc5588_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"select-field",class:_vm.validityClass,on:{"validity":_vm.onValidity}},[_c('f-label',{attrs:{"for":_vm.id},scopedSlots:_vm._u([{key:"default",fn:function(){return [_vm._t("label")]},proxy:true},{key:"tooltip",fn:function(){return [_vm._t("tooltip")]},proxy:true},{key:"description",fn:function(ref){
var descriptionClass = ref.descriptionClass;
var discreteDescriptionClass = ref.discreteDescriptionClass;
return [_vm._t("description",null,null,{ descriptionClass: descriptionClass, discreteDescriptionClass: discreteDescriptionClass })]}},{key:"error-message",fn:function(){return [_vm._t("error-message",function(){return [(_vm.hasError)?[_vm._v(_vm._s(_vm.validity.validationMessage))]:_vm._e()]})]},proxy:true}],null,true)}),_vm._v(" "),_c('div',{staticClass:"select-field__icon-wrapper"},[_c('select',_vm._g(_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.vModel),expression:"vModel"}],staticClass:"select-field__select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.vModel=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},'select',_vm.attrs,false),_vm.listeners),[_vm._t("default")],2),_vm._v(" "),_c('f-icon',{staticClass:"select-field__icon",attrs:{"name":"arrow-down"}})],1)],1)}
var FSelectFieldvue_type_template_id_a5fc5588_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/FSelectField/FSelectField.vue?vue&type=template&id=a5fc5588&

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FSelectField/FSelectField.vue?vue&type=script&lang=ts&












var FSelectFieldvue_type_script_lang_ts_assign = undefined && undefined.__assign || function () {
  FSelectFieldvue_type_script_lang_ts_assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return FSelectFieldvue_type_script_lang_ts_assign.apply(this, arguments);
};

var FSelectFieldvue_type_script_lang_ts_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var FSelectFieldvue_type_script_lang_ts_generator = undefined && undefined.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};






/* harmony default export */ var FSelectFieldvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: "FSelectField",
  components: {
    FIcon: FIcon,
    FLabel: FLabel
  },
  inheritAttrs: false,
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    /**
     * The id for the select id attribute.
     * The id for the label for attribute.
     * If the prop is not set a random value will be generated.
     */
    id: {
      type: String,
      required: false,
      default: function _default() {
        return logic_["ElementIdService"].generateElementId();
      }
    },

    /**
     * The value for the input.
     * If the prop is not set undefined will be used.
     * @model
     */
    value: {
      type: [String, Number, Object, Array, Boolean],
      required: false,
      default: undefined
    }
  },
  data: function data() {
    return {
      validity: {
        validityMode: "INITIAL"
      }
    };
  },
  computed: {
    attrs: function attrs() {
      return FSelectFieldvue_type_script_lang_ts_assign(FSelectFieldvue_type_script_lang_ts_assign({}, this.$attrs), {
        id: this.id
      });
    },

    /* eslint-disable-next-line @typescript-eslint/ban-types */
    listeners: function listeners() {
      return FSelectFieldvue_type_script_lang_ts_assign(FSelectFieldvue_type_script_lang_ts_assign({}, this.$listeners), {
        // Disable change listeners in $listeners
        change: function change() {
          return undefined;
        }
      });
    },
    isValid: function isValid() {
      return this.validity.validityMode === "VALID";
    },
    hasError: function hasError() {
      return this.validity.validityMode === "ERROR";
    },
    validityClass: function validityClass() {
      var _a;

      return _a = {}, _a["select-field--valid"] = this.isValid, _a["select-field--error"] = this.hasError, _a;
    },
    vModel: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        /**
         * V-model event.
         *
         * @event change
         * @type {string}
         */
        this.$emit("change", value);
      }
    }
  },
  methods: {
    onValidity: function onValidity(_a) {
      var detail = _a.detail;
      return FSelectFieldvue_type_script_lang_ts_awaiter(this, void 0, Promise, function () {
        var errorMessage, element;
        return FSelectFieldvue_type_script_lang_ts_generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              this.$set(this, "validity", detail);
              return [4
              /*yield*/
              , this.$nextTick()];

            case 1:
              _b.sent();

              errorMessage = "";

              if (this.$scopedSlots.label) {
                errorMessage = getTextFromScopedSlot(this.$scopedSlots.label);
              }

              element = this.$el.querySelector("#".concat(detail.elementId));

              if (element) {
                dispatchComponentValidityEvent(element, FSelectFieldvue_type_script_lang_ts_assign(FSelectFieldvue_type_script_lang_ts_assign({}, detail), {
                  errorMessage: errorMessage,
                  focusElementId: detail.elementId
                }));
              }

              return [2
              /*return*/
              ];
          }
        });
      });
    }
  }
}));
// CONCATENATED MODULE: ./src/components/FSelectField/FSelectField.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FSelectField_FSelectFieldvue_type_script_lang_ts_ = (FSelectFieldvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FSelectField/FSelectField.vue





/* normalize component */

var FSelectField_component = normalizeComponent(
  FSelectField_FSelectFieldvue_type_script_lang_ts_,
  FSelectFieldvue_type_template_id_a5fc5588_render,
  FSelectFieldvue_type_template_id_a5fc5588_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FSelectField = (FSelectField_component.exports);
// CONCATENATED MODULE: ./src/components/FSelectField/index.ts

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FCalendar/FCalendarTabPeriod.vue?vue&type=script&lang=ts&









var FCalendarTabPeriodvue_type_script_lang_ts_assign = undefined && undefined.__assign || function () {
  FCalendarTabPeriodvue_type_script_lang_ts_assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return FCalendarTabPeriodvue_type_script_lang_ts_assign.apply(this, arguments);
};










var WeeklyRecurrence;

(function (WeeklyRecurrence) {
  WeeklyRecurrence[WeeklyRecurrence["EVERY"] = 1] = "EVERY";
  WeeklyRecurrence[WeeklyRecurrence["EVERY_OTHER"] = 2] = "EVERY_OTHER";
  WeeklyRecurrence[WeeklyRecurrence["EVERY_THIRD"] = 3] = "EVERY_THIRD";
  WeeklyRecurrence[WeeklyRecurrence["EVERY_FOURTH"] = 4] = "EVERY_FOURTH";
})(WeeklyRecurrence || (WeeklyRecurrence = {}));

/* harmony default export */ var FCalendarTabPeriodvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: "FCalendarTabPeriod",
  components: {
    FDatepicker: FDatepicker,
    FCheckboxGroup: FCheckboxGroup,
    FCheckboxGroupField: FCheckboxGroupField,
    FSelectField: FSelectField
  },
  filters: {
    capitalize: function capitalize(value) {
      if (!value) {
        return "";
      }

      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  },
  mixins: [TranslationMixin],
  props: {
    calendarState: {
      type: Object,
      required: true
    },
    options: {
      required: true,
      type: Object
    }
  },
  data: function data() {
    return {
      fromDate: "",
      toDate: "",
      toDatepickerOptions: undefined,
      startAfterEnd: false,
      selectAll: false,
      weekdays: [],
      WeeklyRecurrence: WeeklyRecurrence,
      weeklyRecurrence: undefined,
      WEEKDAYS_LONG: logic_["WEEKDAYS_LONG"]
    };
  },
  computed: {
    fromDatepickerOptions: function fromDatepickerOptions() {
      var clonedOptions = FCalendarTabPeriodvue_type_script_lang_ts_assign({}, this.options);

      return new FDatepickerComponentOptions_FDatepickerComponentOptions(Object.assign(clonedOptions, {
        showPlanning: false
      }));
    },
    idFromDateElement: function idFromDateElement() {
      return logic_["ElementIdService"].generateElementId();
    },
    isWeekdaySelectionValid: function isWeekdaySelectionValid() {
      return !this.options.planningWeekdays || this.weekdays.length > 0;
    },
    isWeeklyRecurrenceValid: function isWeeklyRecurrenceValid() {
      return !this.options.planningWeeklyRecurrence || this.weeklyRecurrence;
    }
  },
  created: function created() {
    // Initialize with same options as from input
    this.toDatepickerOptions = this.fromDatepickerOptions;
  },
  methods: {
    onSelectAllChange: function onSelectAllChange(value) {
      if (value) {
        this.weekdays = logic_["WEEKDAYS_LONG"].map(function (value, index) {
          return index + 1;
        });
      } else {
        this.weekdays = [];
      }
    },
    onWeekdayChange: function onWeekdayChange(model, value) {
      var deselectedDay = !model.includes(value);

      if (deselectedDay) {
        this.selectAll = false;
      }
    },
    isEnabled: function isEnabled(day) {
      return !this.options.disabledDates.includes(day.format("YYYY-MM-DD"));
    },
    isEnabledWeekDay: function isEnabledWeekDay(day) {
      var weekDay = day.isoWeekday();
      return !this.options.disabledWeekDays.includes(weekDay);
    },
    isInSelectedWeekDays: function isInSelectedWeekDays(day) {
      return this.weekdays.includes(day.isoWeekday());
    },
    isInSelectedNthRecurringWeek: function isInSelectedNthRecurringWeek(day, firstDate) {
      if (!this.weeklyRecurrence || this.weeklyRecurrence === WeeklyRecurrence.EVERY) {
        return true;
      }

      var startOfFirstWeek = firstDate.clone().startOf("isoWeek");
      var weeksSinceFirstDate = day.diff(startOfFirstWeek, "weeks");
      return weeksSinceFirstDate % this.weeklyRecurrence === 0;
    },
    validateDateSpan: function validateDateSpan() {
      if (!(this.fromDate && this.toDate && this.$el.querySelectorAll(".text-field__input:invalid").length === 0)) {
        return false;
      }

      var start = external_moment_default()(this.fromDate);
      var end = external_moment_default()(this.toDate);
      this.startAfterEnd = start.isAfter(end);
      return !this.startAfterEnd;
    },
    updateSelection: function updateSelection() {
      var _this = this;

      var start = external_moment_default()(this.fromDate);
      var end = external_moment_default()(this.toDate);
      var rangeOfDates = this.getRangeOfDates(start, end);
      var selectedDays = rangeOfDates.filter(function (day) {
        return _this.isEnabled(day) && _this.isEnabledWeekDay(day);
      }).filter(function (day) {
        if (!_this.options.planningWeekdays) {
          return true;
        }

        return _this.isInSelectedWeekDays(day);
      }).filter(function (day) {
        if (!_this.options.planningWeeklyRecurrence) {
          return true;
        }

        return _this.isInSelectedNthRecurringWeek(day, start);
      }).map(function (it) {
        return it.format("YYYY-MM-DD");
      });
      this.calendarState.saveEditMonth(undefined);
      this.calendarState.saveEditDay(undefined);
      this.calendarState.setSelectedDays(selectedDays);
      var disabledDates = rangeOfDates.filter(function (day) {
        return !(_this.isEnabled(day) && _this.isEnabledWeekDay(day));
      }).map(function (date) {
        return date.format("YYYY-MM-DD");
      });
      this.$emit("period-selected", selectedDays.map(function (date) {
        return CDate.fromString(date);
      }), disabledDates.map(function (date) {
        return CDate.fromString(date);
      }));
    },
    onComponentValidity: function onComponentValidity(event) {
      event.stopPropagation();

      if (!event.detail.isValid) {
        this.calendarState.setSelectedDays([]);
        return;
      }

      this.onChange();
    },
    onChange: function onChange() {
      var isDateSelectionValid = this.validateDateSpan();

      if (isDateSelectionValid && this.isWeekdaySelectionValid && this.isWeeklyRecurrenceValid) {
        this.updateSelection();
      } else {
        this.calendarState.setSelectedDays([]);
      }
    },
    getRangeOfDates: function getRangeOfDates(start, end) {
      var range = [start];

      while (start < end) {
        start = external_moment_default()(start).add(1, "day").startOf("day");
        range.push(start);
      }

      return range;
    },
    updateToDatepickerOptions: function updateToDatepickerOptions(event) {
      if (!event.detail.isValid) {
        return;
      }

      var fromDate = CDate.fromString(this.fromDate);
      var initialSelectedDate = {
        initialYear: fromDate.getYear(),
        initialMonth: fromDate.getMonth(),
        initialFocusedDay: fromDate.getDay()
      };
      this.toDatepickerOptions = new FDatepickerComponentOptions_FDatepickerComponentOptions(FCalendarTabPeriodvue_type_script_lang_ts_assign(FCalendarTabPeriodvue_type_script_lang_ts_assign(FCalendarTabPeriodvue_type_script_lang_ts_assign({}, this.options), {
        showPlanning: false
      }), initialSelectedDate));
    }
  }
}));
// CONCATENATED MODULE: ./src/components/FCalendar/FCalendarTabPeriod.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FCalendar_FCalendarTabPeriodvue_type_script_lang_ts_ = (FCalendarTabPeriodvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FCalendar/FCalendarTabPeriod.vue





/* normalize component */

var FCalendarTabPeriod_component = normalizeComponent(
  FCalendar_FCalendarTabPeriodvue_type_script_lang_ts_,
  FCalendarTabPeriodvue_type_template_id_36f71926_render,
  FCalendarTabPeriodvue_type_template_id_36f71926_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FCalendarTabPeriod = (FCalendarTabPeriod_component.exports);
// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FCalendar/FCalendar.vue?vue&type=script&lang=ts&











var FCalendarvue_type_script_lang_ts_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var FCalendarvue_type_script_lang_ts_generator = undefined && undefined.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};













/**
 * Level: DRAFT
 */

/* harmony default export */ var FCalendarvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: "FCalendar",
  components: {
    FCalendarEditbox: FCalendarEditbox,
    FCalendarAddedSummary: FCalendarAddedSummary,
    FCalendarTabPeriod: FCalendarTabPeriod,
    FCalendarTabMain: FCalendarTabMain,
    FIcon: FIcon
  },
  mixins: [TranslationMixin],
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    /**
     * State of the calendar, see comments in [[CalendarState]].
     */
    value: {
      type: Object,
      required: false,
      default: function _default() {
        return new CalendarState_CalendarState();
      }
    },

    /**
     * Options that can be applied to the component.
     */
    options: {
      required: false,
      type: Object,
      default: function _default() {
        return new FCalendarComponentOptions_FCalendarComponentOptions();
      }
    },

    /**
     * Unique id for html
     */
    id: {
      type: String,
      required: false,
      default: function _default() {
        return logic_["ElementIdService"].generateElementId();
      }
    },

    /**
     * Promise for confirming removal of day
     * Promise that can be rejected or resolved
     */
    confirmRemoveDay: {
      type: Function,
      required: false,
      default: function _default() {
        return Promise.resolve();
      }
    }
  },
  data: function data() {
    return {
      yearView: false,
      MONTHNAMES_LONG: logic_["MONTHNAMES_LONG"],
      MONTHNAMES_SHORT: logic_["MONTHNAMES_SHORT"],
      data: this.value
    };
  },
  computed: {
    showEditBox: function showEditBox() {
      return this.hasSelectedDays && this.$scopedSlots["editbox"] !== undefined;
    },
    selectedDays: function selectedDays() {
      return this.data.getSelectedDays();
    },
    hasSelectedDays: function hasSelectedDays() {
      return this.data.hasSelectedDays();
    },
    hasAddedDays: function hasAddedDays() {
      return this.data.hasAddedDays();
    },
    selectedDisabledDate: function selectedDisabledDate() {
      return this.data.getSelectedDisabledDate();
    }
  },
  watch: {
    value: {
      handler: function handler() {
        Object.assign(this.data, this.value);
      },
      deep: true,
      immediate: true
    }
  },
  created: function created() {
    CDate.setTodaysDate(this.options.today);
  },
  methods: {
    onClickPlanningShow: function onClickPlanningShow() {
      this.value.setPlanning(true);
    },
    onClickPlanningHide: function onClickPlanningHide() {
      this.value.setPlanning(false);
    },
    onEditDaysPreOpened: function onEditDaysPreOpened(days) {
      /**
       * Emits event when one ore more dates are up for change. Contains dates that will be edited
       * @type {string[]}
       */
      this.$emit("edit-days-pre-opened", days);
    },
    onDaySelected: function onDaySelected(day) {
      this.onDaysSelected([day], "CLICK");
    },
    onDaysSelected: function onDaysSelected(days, type) {
      /**
       * Emits event when dates have been selected.
       * @type {CalendarSelectionEvent}
       * @property {CDate[]} days - The selected days
       * @property {SelectionType} type - The type of selection
       */
      this.$emit("days-selected", {
        days: days,
        type: type
      });
    },
    onDisabledDayRequested: function onDisabledDayRequested(day) {
      this.onDisabledDaysRequested([day], "CLICK");
    },
    onDisabledDaysRequested: function onDisabledDaysRequested(days, type) {
      /**
       * Emits event when disabled dates have been requested to be selected.
       * @type {CalendarSelectionEvent}
       * @property {CDate[]} days - The requested days
       * @property {SelectionType} type - The type of selection
       */
      this.$emit("disabled-days-requested", {
        days: days,
        type: type
      });
    },
    onPeriodSelected: function onPeriodSelected(days, disabledDays) {
      this.onDaysSelected(days, "PERIOD");
      this.onDisabledDaysRequested(disabledDays, "PERIOD");
    },
    onDayUnselected: function onDayUnselected(day) {
      /**
       * Emits event when date has been unselected.
       * @type {CDate}
       */
      this.$emit("day-unselected", day);
    },
    onDayRemoved: function onDayRemoved(day) {
      /**
       * Emits event when date has been removed.
       * @type {string}
       */
      this.$emit("day-removed", day);
    },
    onYearNavigation: function onYearNavigation(day) {
      /**
       * Emits event when user navigates between months in main tab
       * @type {CDate}
       */
      this.$emit("year-navigation", day);
    },
    onMonthNavigation: function onMonthNavigation(day) {
      /**
       * Emits event when user navigates between years in main tab
       * @type {CDate}
       */
      this.$emit("month-navigation", day);
    },
    onEditboxSaved: function onEditboxSaved(selectedDates) {
      return FCalendarvue_type_script_lang_ts_awaiter(this, void 0, void 0, function () {
        var firstMonth;
        return FCalendarvue_type_script_lang_ts_generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , this.$nextTick()];

            case 1:
              _a.sent();

              if (this.value.isPlanning()) {
                firstMonth = this.$el.querySelector(".calendar__addedmonth-header-expand");

                if (firstMonth) {
                  firstMonth.focus();
                }
              } else {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                this.$refs.fcalendartabmain.onEditboxSaved(selectedDates);
              }
              /**
               * Emits event when form in Editbox is saved. Contains dates that were being edited.
               * @type {string[]}
               */


              this.$emit("editbox-saved", selectedDates);
              return [2
              /*return*/
              ];
          }
        });
      });
    },
    onEditboxCancelled: function onEditboxCancelled(selectedDates) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      this.$refs.fcalendartabmain.onEditboxCancelled(selectedDates);
      /**
       * Emits event when form in Editbox is cancelled. Contains dates that were being edited.
       * @type {string[]}
       */

      this.$emit("editbox-cancelled", selectedDates);
    }
  }
}));
// CONCATENATED MODULE: ./src/components/FCalendar/FCalendar.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FCalendar_FCalendarvue_type_script_lang_ts_ = (FCalendarvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FCalendar/FCalendar.vue





/* normalize component */

var FCalendar_component = normalizeComponent(
  FCalendar_FCalendarvue_type_script_lang_ts_,
  FCalendarvue_type_template_id_edb46850_render,
  FCalendarvue_type_template_id_edb46850_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FCalendar = (FCalendar_component.exports);
// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FCalendar/FCalendarAddedDaysOverview.vue?vue&type=template&id=66a66175&
var FCalendarAddedDaysOverviewvue_type_template_id_66a66175_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.addedDays.length > 0)?_c('div',{staticClass:"calendar__addedsummary-days"},[_vm._v("\n    Tillagda datum:\n    "),_c('strong',[_vm._v(_vm._s(_vm.addedDays.length))])]):_vm._e()}
var FCalendarAddedDaysOverviewvue_type_template_id_66a66175_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/FCalendar/FCalendarAddedDaysOverview.vue?vue&type=template&id=66a66175&

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FCalendar/FCalendarAddedDaysOverview.vue?vue&type=script&lang=ts&

/* harmony default export */ var FCalendarAddedDaysOverviewvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: "FCalendarAddedDaysOverview",
  props: {
    calendarState: {
      type: Object,
      required: true
    }
  },
  computed: {
    addedDays: function addedDays() {
      return this.calendarState.getIncludedAddedDays();
    }
  }
}));
// CONCATENATED MODULE: ./src/components/FCalendar/FCalendarAddedDaysOverview.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FCalendar_FCalendarAddedDaysOverviewvue_type_script_lang_ts_ = (FCalendarAddedDaysOverviewvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FCalendar/FCalendarAddedDaysOverview.vue





/* normalize component */

var FCalendarAddedDaysOverview_component = normalizeComponent(
  FCalendar_FCalendarAddedDaysOverviewvue_type_script_lang_ts_,
  FCalendarAddedDaysOverviewvue_type_template_id_66a66175_render,
  FCalendarAddedDaysOverviewvue_type_template_id_66a66175_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FCalendarAddedDaysOverview = (FCalendarAddedDaysOverview_component.exports);
// CONCATENATED MODULE: ./src/components/FCalendar/index.ts













// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FCrudDataset/FCrudDataset.vue?vue&type=template&id=4f429bd5&
var FCrudDatasetvue_type_template_id_4f429bd5_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"crud-dataset"},[_vm._t("default"),_vm._v(" "),(_vm.hasAddSlot)?_c('div',[_c('button',{staticClass:"button button--discrete crud-dataset__add-button",attrs:{"data-test":"f-crud-dataset-add-button","type":"button"},on:{"click":function($event){return _vm.createItem()}}},[_c('f-icon',{staticClass:"button__icon",attrs:{"name":"plus"}}),_vm._v(" "+_vm._s(_vm.$t("fkuiCrudButton.add", "Lägg till ny"))+"\n            ")],1)]):_vm._e(),_vm._v(" "),_c('f-form-modal',{attrs:{"is-open":_vm.isFormModalOpen,"aria-close-text":_vm.$t('fkuiCrudDataset.modal.close', 'Stäng'),"use-error-list":false},on:{"close":_vm.onModalCancel,"submit":_vm.onFormModalSubmit},scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._v(_vm._s(_vm.formModalHeader))]},proxy:true},{key:"input-text-fields",fn:function(){return [(_vm.operation === _vm.Operation.ADD)?_vm._t("add",null,null,{ item: _vm.item }):_vm._e(),_vm._v(" "),(_vm.operation === _vm.Operation.MODIFY)?_vm._t("modify",null,null,{ item: _vm.item }):_vm._e()]},proxy:true},{key:"submit-button-text",fn:function(){return [_vm._v(_vm._s(_vm.confirmButtonText))]},proxy:true},{key:"cancel-button-text",fn:function(){return [_vm._v(_vm._s(_vm.cancelButtonText))]},proxy:true}],null,true)}),_vm._v(" "),_c('f-confirm-modal',{attrs:{"is-open":_vm.isConfirmModalOpen,"buttons":_vm.confirmDeleteButtons},on:{"confirm":_vm.onDeleteConfirm,"close":_vm.onModalCancel},scopedSlots:_vm._u([{key:"heading",fn:function(){return [_vm._v("\n                "+_vm._s(_vm.$t("fkuiCrudDataset.modal.header.delete", "Är du säker på att du vill ta bort raden?"))+"\n            ")]},proxy:true},{key:"content",fn:function(){return [_vm._t("delete",null,null,{ item: _vm.item })]},proxy:true}],null,true)}),_vm._v(" "),_c('span',{staticClass:"sr-only",attrs:{"aria-live":"polite"}},[_vm._v("\n            "+_vm._s(_vm.operationScreenReaderText)+"\n        ")])],2)}
var FCrudDatasetvue_type_template_id_4f429bd5_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/FCrudDataset/FCrudDataset.vue?vue&type=template&id=4f429bd5&

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FCrudDataset/FCrudDataset.vue?vue&type=script&lang=ts&







var FCrudDatasetvue_type_script_lang_ts_spreadArray = undefined && undefined.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};






var Operation;

(function (Operation) {
  Operation[Operation["ADD"] = 0] = "ADD";
  Operation[Operation["DELETE"] = 1] = "DELETE";
  Operation[Operation["MODIFY"] = 2] = "MODIFY";
  Operation[Operation["NONE"] = 3] = "NONE";
})(Operation || (Operation = {}));

/* harmony default export */ var FCrudDatasetvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: "FCrudDataset",
  components: {
    FFormModal: FFormModal,
    FConfirmModal: FConfirmModal,
    FIcon: FIcon
  },
  mixins: [TranslationMixin],
  provide: function provide() {
    var _this = this;

    return {
      delete: function _delete(item) {
        _this.deleteItem(item);
      },
      modify: function modify(item) {
        _this.updateItem(item);
      },
      registerCallbackAfterItemAdd: function registerCallbackAfterItemAdd(callback) {
        _this.callbackAfterItemAdd = callback;
      },
      registerCallbackBeforeItemDelete: function registerCallbackBeforeItemDelete(callback) {
        _this.callbackBeforeItemDelete = callback;
      }
    };
  },
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    /**
     * The list of items that should be deleted, modified or added to.
     * If the prop is not set an empty array will be used.
     * @model
     */
    value: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },

    /**
     * A function that returns an item to the #add template. Can be used to populate data that the user should not input themself e.g. an id.
     * Or to give the user suggestions for inputs. If the prop is not used an empty item will be returned.
     */
    beforeCreate: {
      type: Function,
      required: false,
      default: function _default() {
        return {};
      }
    },

    /**
     * If `true` the primary button in the modals will be placed to the right side instead of to the left.
     */
    primaryButtonRight: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      result: [],
      Operation: Operation,
      operation: Operation.NONE,
      item: null,
      originalItemToUpdate: null,
      isFormModalOpen: false,
      isConfirmModalOpen: false,
      operationScreenReaderText: "",
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      callbackAfterItemAdd: function callbackAfterItemAdd(item) {
        // dummy method when not provided by underlying component
        return;
      },
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      callbackBeforeItemDelete: function callbackBeforeItemDelete(item) {
        // dummy method when not provided by underlying component
        return;
      }
    };
  },
  computed: {
    confirmButtonText: function confirmButtonText() {
      return this.operation === Operation.ADD ? this.$t("fkuiCrudDataset.modal.confirm.add", "Lägg till") : this.$t("fkuiCrudDataset.modal.confirm.modify", "Spara");
    },
    cancelButtonText: function cancelButtonText() {
      return this.operation === Operation.ADD ? this.$t("fkuiCrudDataset.modal.cancel.add", "Avbryt") : this.$t("fkuiCrudDataset.modal.cancel.modify", "Avbryt");
    },
    confirmDeleteButtons: function confirmDeleteButtons() {
      return [{
        label: this.$t("fkuiCrudDataset.modal.confirm.delete", "Ja, ta bort"),
        type: "primary",
        event: "confirm"
      }, {
        label: this.$t("fkuiCrudDataset.modal.cancel.delete", "Nej, avbryt"),
        type: "secondary"
      }];
    },
    hasAddSlot: function hasAddSlot() {
      return this.$scopedSlots.add ? true : false;
    },
    hasDeletelot: function hasDeletelot() {
      return this.$scopedSlots.delete ? true : false;
    },
    hasModifySlot: function hasModifySlot() {
      return this.$scopedSlots.modify ? true : false;
    },
    formModalHeader: function formModalHeader() {
      return this.operation === Operation.ADD ? this.$t("fkuiCrudDataset.modal.header.add", "Lägg till ny rad") : this.$t("fkuiCrudDataset.modal.header.modify", "Ändra rad");
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: function handler(data) {
        this.result = FCrudDatasetvue_type_script_lang_ts_spreadArray([], data, true);
      }
    }
  },
  mounted: function mounted() {
    if (!this.hasAddSlot && !this.hasDeletelot && !this.hasModifySlot) {
      throw Error("Atleast one template of the following must be defined. #add, #delete or #modify");
    }
  },
  methods: {
    createItem: function createItem() {
      if (!this.hasAddSlot) {
        throw Error("No template is defined for #add");
      }

      this.operationScreenReaderText = "";
      this.operation = Operation.ADD;
      this.item = this.beforeCreate();
      this.isFormModalOpen = true;
    },
    deleteItem: function deleteItem(item) {
      if (!this.hasDeletelot) {
        throw Error("No template is defined for #delete");
      }

      this.operationScreenReaderText = "";
      this.operation = Operation.DELETE;
      this.item = item;
      this.isConfirmModalOpen = true;
    },
    onDeleteConfirm: function onDeleteConfirm() {
      var _this = this;

      this.callbackBeforeItemDelete(this.item);
      this.result = this.result.filter(function (item) {
        return item !== _this.item;
      });
      /**
       * Emitted when an item is deleted.
       * @event deleted
       * @param item - the deleted item.
       */

      this.$emit("deleted", this.item);
      this.$emit("change", this.result);
      this.operationScreenReaderText = this.$t("fkuiCrudDataset.arialive.delete", "Raden har tagits bort");
    },
    onModalCancel: function onModalCancel() {
      this.isFormModalOpen = false;
      this.isConfirmModalOpen = false;
    },
    onFormModalSubmit: function onFormModalSubmit() {
      if (this.operation === Operation.ADD) {
        this.result.push(this.item);
        /**
         * Emitted when an item is added.
         * @event created
         * @param item - the added item.
         */

        this.$emit("created", this.item);
        this.$emit("change", this.result);
        this.callbackAfterItemAdd(this.item);
        this.operationScreenReaderText = this.$t("fkuiCrudDataset.arialive.add", "En rad har lagts till");
      } else if (this.operation === Operation.MODIFY) {
        Object.assign(this.originalItemToUpdate, this.item);
        /**
         * Emitted when an item is updated.
         * @event updated
         * @param item - the updated item.
         */

        this.$emit("updated", this.originalItemToUpdate);
        /**
         * V-model event.
         * @event change
         */

        this.$emit("change", this.result);
        this.operationScreenReaderText = this.$t("fkuiCrudDataset.arialive.modify", "Raden har ändrats");
      }

      this.isFormModalOpen = false;
    },
    updateItem: function updateItem(item) {
      if (!this.hasModifySlot) {
        throw Error("No template is defined for #modify");
      }

      this.operationScreenReaderText = "";
      this.operation = Operation.MODIFY;
      this.originalItemToUpdate = item;
      this.item = Object(logic_["deepClone"])(item);
      this.isFormModalOpen = true;
    }
  }
}));
// CONCATENATED MODULE: ./src/components/FCrudDataset/FCrudDataset.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FCrudDataset_FCrudDatasetvue_type_script_lang_ts_ = (FCrudDatasetvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FCrudDataset/FCrudDataset.vue





/* normalize component */

var FCrudDataset_component = normalizeComponent(
  FCrudDataset_FCrudDatasetvue_type_script_lang_ts_,
  FCrudDatasetvue_type_template_id_4f429bd5_render,
  FCrudDatasetvue_type_template_id_4f429bd5_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FCrudDataset = (FCrudDataset_component.exports);
// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FCrudDataset/FCrudButton.vue?vue&type=template&id=6abe0200&
var FCrudButtonvue_type_template_id_6abe0200_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button button--discrete",attrs:{"type":"button"},on:{"click":_vm.executeAction}},[(_vm.icon)?_c('f-icon',{staticClass:"button__icon",attrs:{"name":_vm.iconName}}):_vm._e(),_vm._v(" "),(!_vm.label)?_c('span',{staticClass:"sr-only"},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.buttonText)+" ")]})],2):_vm._e(),_vm._v(" "),(_vm.label)?_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.buttonText)+" ")]}):_vm._e()],2)}
var FCrudButtonvue_type_template_id_6abe0200_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/FCrudDataset/FCrudButton.vue?vue&type=template&id=6abe0200&

// CONCATENATED MODULE: ./src/components/FCrudDataset/FCrudDatasetInterface.ts
var FCrudDatasetInjected = ["delete", "modify"];
// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FCrudDataset/FCrudButton.vue?vue&type=script&lang=ts&





var FCrudButtonvue_type_script_lang_ts_Vue = external_commonjs_vue_commonjs2_vue_root_Vue_default.a;
/* harmony default export */ var FCrudButtonvue_type_script_lang_ts_ = (FCrudButtonvue_type_script_lang_ts_Vue.extend({
  name: "FCrudButton",
  components: {
    FIcon: FIcon
  },
  mixins: [TranslationMixin],
  inject: FCrudDatasetInjected,
  props: {
    action: {
      type: String,
      required: true,
      validator: function validator(value) {
        return ["delete", "modify"].includes(value);
      }
    },
    icon: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      required: true
    },
    label: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    iconName: function iconName() {
      if (this.action === "delete") {
        return "trashcan";
      } else {
        return "pen";
      }
    },
    buttonText: function buttonText() {
      if (this.action === "delete") {
        return this.$t("fkuiCrudButton.delete", "Ta bort");
      } else {
        return this.$t("fkuiCrudButton.modify", "Ändra");
      }
    }
  },
  methods: {
    executeAction: function executeAction() {
      if (this.action === "delete") {
        this.delete(this.item);
      } else {
        this.modify(this.item);
      }
    }
  }
}));
// CONCATENATED MODULE: ./src/components/FCrudDataset/FCrudButton.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FCrudDataset_FCrudButtonvue_type_script_lang_ts_ = (FCrudButtonvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FCrudDataset/FCrudButton.vue





/* normalize component */

var FCrudButton_component = normalizeComponent(
  FCrudDataset_FCrudButtonvue_type_script_lang_ts_,
  FCrudButtonvue_type_template_id_6abe0200_render,
  FCrudButtonvue_type_template_id_6abe0200_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FCrudButton = (FCrudButton_component.exports);
// CONCATENATED MODULE: ./src/components/FCrudDataset/ActivateItemInterface.ts
var ActivateItemInjected = {
  registerCallbackAfterItemAdd: {
    default: function _default() {
      return function () {
        return undefined;
      };
    }
  },
  registerCallbackBeforeItemDelete: {
    default: function _default() {
      return function () {
        return undefined;
      };
    }
  }
};
// CONCATENATED MODULE: ./src/components/FCrudDataset/index.ts



// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FDataTable/FDataTable.vue?vue&type=template&id=2e97f4d7&
var FDataTablevue_type_template_id_2e97f4d7_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.wrapperClasses},[_c('table',_vm._g(_vm._b({staticClass:"table",class:_vm.tableClasses,attrs:{"tabindex":_vm.tabindex}},'table',_vm.$attrs,false),_vm.$listeners),[(_vm.hasCaption)?_c('caption',[_vm._t("caption")],2):_vm._e(),_vm._v(" "),_c('colgroup',_vm._l((_vm.columns),function(column){return _c('col',{key:column.index,class:column.size})}),0),_vm._v(" "),_c('thead',[_c('tr',{staticClass:"table__row"},_vm._l((_vm.visibleColumns),function(column){return _c('th',_vm._g({key:column.index,class:_vm.columnClasses(column),attrs:{"scope":"col"}},column.sortable ? { click: function () { return _vm.onClickColumnHeader(column); } } : {}),[_c('span',{domProps:{"innerHTML":_vm._s(_vm.escapeNewlines(column.title))}}),_vm._v(" "),(column.sortable)?_c('f-icon',{class:_vm.iconClasses(column),attrs:{"name":_vm.iconName(column)}}):_vm._e(),_vm._v(" "),(column.description)?_c('span',{staticClass:"table__column__description"},[_vm._v(_vm._s(column.description))]):_vm._e()],1)}),0)]),_vm._v(" "),_c('tbody',[(!_vm.hasInitiateColumns)?_c('tr',[_vm._t("default",null,null,{ row: _vm.emptyRow })],2):_vm._e(),_vm._v(" "),(_vm.isEmpty)?_c('tr',[_c('td',{staticClass:"table__column table__column--action",attrs:{"colspan":_vm.columns.length}},[_vm._t("empty",function(){return [_vm._v(_vm._s(_vm.$t("fkuiTableEmpty", "Tabellen är tom")))]})],2)]):_vm._e(),_vm._v(" "),_vm._l((_vm.rows),function(row){return _c('tr',{key:_vm.rowKey(row),staticClass:"table__row"},[_vm._t("default",null,null,{ row: row })],2)})],2)])])}
var FDataTablevue_type_template_id_2e97f4d7_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/FDataTable/FDataTable.vue?vue&type=template&id=2e97f4d7&

// EXTERNAL MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/core-js/modules/es.string.match.js
var es_string_match = __webpack_require__("58d3");

// CONCATENATED MODULE: ./src/components/FTableColumn/FTableColumnData.ts








var FTableColumnData_spreadArray = undefined && undefined.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};

var FTableColumnType;

(function (FTableColumnType) {
  FTableColumnType["TEXT"] = "text";
  FTableColumnType["DATE"] = "date";
  FTableColumnType["NUMERIC"] = "numeric";
  FTableColumnType["ACTION"] = "action";
})(FTableColumnType || (FTableColumnType = {}));

var FTableColumnSize;

(function (FTableColumnSize) {
  FTableColumnSize["EXPAND"] = "table__column--expand";
  FTableColumnSize["SHRINK"] = "table__column--shrink";
})(FTableColumnSize || (FTableColumnSize = {}));

var FTableColumnSort;

(function (FTableColumnSort) {
  FTableColumnSort["UNSORTED"] = "unsorted";
  FTableColumnSort["ASCENDING"] = "ascending";
  FTableColumnSort["DESCENDING"] = "descending";
})(FTableColumnSort || (FTableColumnSort = {}));

function FTableColumnData_addColumn(src, column) {
  if (!src.some(function (col) {
    return col.name === column.name;
  })) {
    return FTableColumnData_spreadArray(FTableColumnData_spreadArray([], src, true), [column], false);
  }

  return src;
}
function FTableColumnData_setVisibilityColumn(src, id, visible) {
  var column = src.find(function (col) {
    return col.name === id;
  });

  if (column) {
    column.visible = visible;
  }
}
function updateSortOrder(src, columnName, ascending) {
  src.forEach(function (column) {
    if (column.name === columnName) {
      column.sort = ascending ? FTableColumnSort.ASCENDING : FTableColumnSort.DESCENDING;
    } else {
      column.sort = FTableColumnSort.UNSORTED;
    }
  });
}
function setSortableColumns(src, columnNames) {
  var _loop_1 = function _loop_1(columnName) {
    var foundColumn = src.find(function (col) {
      return col.name === columnName;
    });

    if (foundColumn) {
      foundColumn.sortable = true;
    }
  };

  for (var _i = 0, columnNames_1 = columnNames; _i < columnNames_1.length; _i++) {
    var columnName = columnNames_1[_i];

    _loop_1(columnName);
  }
}
function getSortableIconName(column) {
  switch (column.sort) {
    case FTableColumnSort.UNSORTED:
      return "sort";

    case FTableColumnSort.ASCENDING:
      return "caret-up";

    case FTableColumnSort.DESCENDING:
      return "caret-down";

    default:
      return "";
  }
}
function getSortableIconClasses(column) {
  var classes = ["table__column__header__icon"];

  if (column.sort === FTableColumnSort.UNSORTED) {
    classes.push("table__column__header__icon--discrete");
  }

  return classes;
}
// CONCATENATED MODULE: ./src/components/FTableColumn/FTableInterface.ts
var FTableInjected = ["addColumn", "setVisibilityColumn", "cellRole"];
// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FTableColumn/FTableColumn.vue?vue&type=template&id=d0063a2c&
var FTableColumnvue_type_template_id_d0063a2c_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c(_vm.tagName,_vm._g(_vm._b({tag:"component",class:_vm.classes,attrs:{"role":_vm.role,"scope":_vm.scope}},'component',_vm.$attrs,false),_vm.$listeners),[_vm._t("default"),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v(" ")])],2):_vm._e()}
var FTableColumnvue_type_template_id_d0063a2c_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/FTableColumn/FTableColumn.vue?vue&type=template&id=d0063a2c&

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FTableColumn/FTableColumn.vue?vue&type=script&lang=ts&










var FTableColumnvue_type_script_lang_ts_Vue = external_commonjs_vue_commonjs2_vue_root_Vue_default.a;
/* harmony default export */ var FTableColumnvue_type_script_lang_ts_ = (FTableColumnvue_type_script_lang_ts_Vue.extend({
  name: "FTableColumn",
  inject: FTableInjected,
  inheritAttrs: false,
  props: {
    /**
     * Unique (per-table) identifier.
     *
     * Typically set to the row property displayed but any unique string can
     * be used.
     */
    name: {
      type: String,
      required: true
    },

    /**
     * If set to true, display the column, set to false to hide it.
     *
     */
    visible: {
      type: Boolean,
      default: true
    },

    /**
     * If `true` this cell will be a row header (`<th>` as opposed to
     * `<td>`).
     */
    rowHeader: {
      type: Boolean,
      required: false,
      default: false
    },

    /**
     * Text to show in column header. In order to force newlines use "\n".
     */
    title: {
      type: String,
      required: true
    },

    /**
     * Additional column description.
     */
    description: {
      type: String,
      required: false,
      default: ""
    },

    /**
     * Set this column to shrink as small as possible.
     *
     * Cannot be combined with `expand`
     */
    shrink: {
      type: Boolean,
      required: false,
      default: false
    },

    /**
     * Set this column to expand as large as possible.
     *
     * Cannot be combined with `shrink`
     *
     * Default if neither `expand` or `shrink` is set.
     */
    expand: {
      type: Boolean,
      required: false,
      default: false
    },

    /**
     * Type of data the rows contains.
     *
     * Applies proper alignment and some styling (e.g. "numeric" uses fixed
     * width numbers).
     *
     * Can be one of the following values:
     *
     * - `"text"`: regular text data (default)
     * - `"date"`: date (should be YYYY-MM-DD)
     * - `"numeric"`: numeric data
     * - `"action"`: buttons to perform actions on row
     */
    type: {
      type: String,
      required: false,
      default: "text",
      validator: function validator(value) {
        var types = Object.values(FTableColumnType);
        return types.includes(value);
      }
    }
  },
  computed: {
    classes: function classes() {
      return ["table__column", "table__column--".concat(this.type)];
    },
    role: function role() {
      return this.cellRole();
    },
    scope: function scope() {
      return this.rowHeader ? "row" : null;
    },
    tagName: function tagName() {
      if (this.rowHeader) {
        return "th";
      } else {
        return "td";
      }
    }
  },
  watch: {
    visible: {
      handler: function handler() {
        this.setVisibilityColumn(this.name, this.visible);
      }
    }
  },
  created: function created() {
    if (this.shrink && this.expand) {
      throw new Error("Table cannot have both shrink and expand enabled at the same time");
    }

    var size = this.shrink ? FTableColumnSize.SHRINK : FTableColumnSize.EXPAND;
    this.addColumn({
      name: this.name,
      title: this.title,
      description: this.description || undefined,
      size: size,
      type: this.type,
      visible: this.visible,
      sortable: false,
      sort: FTableColumnSort.UNSORTED
    });
  }
}));
// CONCATENATED MODULE: ./src/components/FTableColumn/FTableColumn.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FTableColumn_FTableColumnvue_type_script_lang_ts_ = (FTableColumnvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FTableColumn/FTableColumn.vue





/* normalize component */

var FTableColumn_component = normalizeComponent(
  FTableColumn_FTableColumnvue_type_script_lang_ts_,
  FTableColumnvue_type_template_id_d0063a2c_render,
  FTableColumnvue_type_template_id_d0063a2c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FTableColumn = (FTableColumn_component.exports);
// CONCATENATED MODULE: ./src/components/FTableColumn/index.ts



// CONCATENATED MODULE: ./src/components/FSortFilterDataset/FSortFilterDatasetInterface.ts
// Empty dummy methods to be used when no FSortFilterDataset is used
var FSortFilterDatasetInjected = {
  sort: {
    default: function _default() {
      return function () {
        return undefined;
      };
    }
  },
  registerCallbackOnSort: {
    default: function _default() {
      return function () {
        return undefined;
      };
    }
  },
  registerCallbackOnMount: {
    default: function _default() {
      return function () {
        return undefined;
      };
    }
  }
};
// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FSortFilterDataset/FSortFilterDataset.vue?vue&type=template&id=1d84218c&
var FSortFilterDatasetvue_type_template_id_1d84218c_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sort-filter-dataset"},[_c('i-flex',{attrs:{"collapse":"","gap":"3x","wrap":""}},[_c('i-flex-item',{attrs:{"shrink":"","align":"center"}},[_vm._t("header",null,null,{ slotClass: 'sort-filter-dataset__toolbar__header' })],2),_vm._v(" "),_c('i-flex-item',{attrs:{"grow":""}},[_c('i-flex',{attrs:{"collapse":"","wrap":"","float":"right"}},[(_vm.showFilter)?_c('i-flex-item',{attrs:{"shrink":"","align":"center"}},[_c('div',{staticClass:"sort-filter-dataset__search"},[_c('f-icon',{staticClass:"sort-filter-dataset__search__magnify-icon",attrs:{"library":"f-social","name":"search"}}),_vm._v(" "),_c('f-text-field',{staticClass:"text-field--inline",attrs:{"placeholder":_vm.placeholderFilter,"maxlength":"64"},on:{"input":_vm.onSearchInput,"blur":_vm.onSearchBlur},model:{value:(_vm.searchString),callback:function ($$v) {_vm.searchString=$$v},expression:"searchString"}},[_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.placeholderFilter))])]),_vm._v(" "),(_vm.showClearButton)?_c('button',{staticClass:"button button--discrete sort-filter-dataset__search__close-icon",attrs:{"type":"button","title":_vm.$t('fkuiSortSearchDataset.clear.filter', 'Rensa sökfält')},on:{"click":_vm.onClickClearSearch}},[_c('f-icon',{attrs:{"name":"close"}}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.$t("fkuiSortSearchDataset.clear.filter", "Rensa sökfält")))])],1):_vm._e()],1)]):_vm._e(),_vm._v(" "),(_vm.showSort)?_c('i-flex-item',{attrs:{"shrink":"","align":"center"}},[_c('f-select-field',{staticClass:"select-field--inline sort-filterdataset__sort",on:{"change":_vm.onChangeSortAttribute},scopedSlots:_vm._u([{key:"label",fn:function(){return [_vm._v(_vm._s(_vm.$t("fkuiSortSearchDataset.label.sort", "Sortera\u00A0på")))]},proxy:true}],null,false,171660001),model:{value:(_vm.sortAttribute),callback:function ($$v) {_vm.sortAttribute=$$v},expression:"sortAttribute"}},[_vm._v(" "),_c('option',{domProps:{"value":{ attribute: '', ascending: false }}},[_vm._v("\n                                "+_vm._s(_vm.$t("fkuiSortSearchDataset.label.unsorted", "Välj"))+"\n                            ")]),_vm._v(" "),_vm._l((_vm.sortOrders),function(sortOrder){return _c('option',{key:sortOrder.id,domProps:{"value":sortOrder}},[_vm._v("\n                                "+_vm._s(sortOrder.name)+" ("+_vm._s(sortOrder.ascendingName)+")\n                            ")])})],2)],1):_vm._e()],1)],1)],1),_vm._v(" "),_c('span',{staticClass:"sr-only",attrs:{"aria-live":"polite"}},[_vm._v(_vm._s(_vm.searchAriaLive))]),_vm._v(" "),_vm._t("default",null,null,{ sortFilterResult: _vm.sortFilterResult })],2)}
var FSortFilterDatasetvue_type_template_id_1d84218c_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/FSortFilterDataset/FSortFilterDataset.vue?vue&type=template&id=1d84218c&

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FTextField/extendedTextFields/FEmailTextField/FEmailTextField.vue?vue&type=template&id=23121ca7&
var FEmailTextFieldvue_type_template_id_23121ca7_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('f-text-field',_vm._g(_vm._b({attrs:{"type":"email","maxlength":_vm.maxLength,"value":_vm.value},on:{"validity":_vm.onValidity,"pending-validity":_vm.onPendingValidity},scopedSlots:_vm._u([{key:"error-message",fn:function(){return [(_vm.showPasteErrorMessage)?_c('span',[_vm._v("\n                "+_vm._s(_vm.pasteErrorText)+"\n            ")]):_vm._e()]},proxy:true}])},'f-text-field',_vm.$attrs,false),_vm.listeners),[_vm._v(_vm._s(_vm.defaultText)+"\n        ")]),_vm._v(" "),(_vm.extendedValidation)?_c('f-text-field',{attrs:{"type":"email","maxlength":_vm.maxLength},on:{"paste":_vm.onPaste,"blur":function($event){_vm.showPasteErrorMessage = false}},model:{value:(_vm.secondEmail),callback:function ($$v) {_vm.secondEmail=$$v},expression:"secondEmail"}},[_vm._v(_vm._s(_vm.$t("fkuiEmailTextFieldRepeatMailAddress", "Upprepa mejladress")))]):_vm._e()],1)}
var FEmailTextFieldvue_type_template_id_23121ca7_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/FTextField/extendedTextFields/FEmailTextField/FEmailTextField.vue?vue&type=template&id=23121ca7&

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FTextField/extendedTextFields/FEmailTextField/FEmailTextField.vue?vue&type=script&lang=ts&





var FEmailTextFieldvue_type_script_lang_ts_assign = undefined && undefined.__assign || function () {
  FEmailTextFieldvue_type_script_lang_ts_assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return FEmailTextFieldvue_type_script_lang_ts_assign.apply(this, arguments);
};







/* harmony default export */ var FEmailTextFieldvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: "FEmailTextField",
  components: {
    FTextField: FTextField
  },
  mixins: [TranslationMixin],
  inheritAttrs: false,
  model: {
    prop: "value",
    event: "update"
  },
  props: {
    /**
     * The id for the input id attribute.
     * The id for the label for attribute.
     * If the prop is not set a random value will be generated.
     */
    id: {
      type: String,
      required: false,
      default: function _default() {
        return logic_["ElementIdService"].generateElementId();
      }
    },

    /**
     * The value for the input.
     * If the prop is not set undefined will be used.
     * @model
     */
    value: {
      type: [String],
      required: false,
      default: undefined
    },
    maxLength: {
      type: Number,
      default: 80
    },
    extendedValidation: {
      type: Boolean,
      default: false
    },

    /**
     * The error message to be displayed on paste
     * If the prop is not set the default text "Du kan inte kopiera mejladressen. Du måste skriva in den igen." will be set
     */
    pasteErrorText: {
      type: String,
      required: false,
      default: logic_["TranslationService"].provider.translate("fkuiEmailTextFieldPasteError", "Du kan inte kopiera mejladressen. Du måste skriva in den igen.")
    }
  },
  data: function data() {
    return {
      validity: {
        validityMode: "INITIAL"
      },
      secondEmail: "",
      showPasteErrorMessage: false,
      defaultText: this.$t("fkuiEmailTextFieldMailAddress", "Mejladress")
    };
  },
  computed: {
    attrs: function attrs() {
      return FEmailTextFieldvue_type_script_lang_ts_assign(FEmailTextFieldvue_type_script_lang_ts_assign({}, this.$attrs), {
        id: this.id,
        value: this.value
      });
    },

    /* eslint-disable-next-line @typescript-eslint/ban-types */
    listeners: function listeners() {
      var _this = this;

      return FEmailTextFieldvue_type_script_lang_ts_assign(FEmailTextFieldvue_type_script_lang_ts_assign({}, this.$listeners), {
        change: function change(event) {
          /**
           * @event change
           * @type {string | number}
           */
          _this.$emit("change", event);
        },
        blur: function blur(event) {
          /**
           * @event blur
           * @type {string | number}
           */
          _this.$emit("blur", event);
        },
        update: function update(event) {
          /**
           * V-model event.
           *
           * @event update
           * @type {string}
           */
          _this.$emit("update", event);
        }
      });
    }
  },
  mounted: function mounted() {
    this.configureValidators();
  },
  methods: {
    onPaste: function onPaste(event) {
      this.showPasteErrorMessage = true;
      event.preventDefault();
      return false;
    },
    onValidity: function onValidity(_a) {
      var detail = _a.detail;
      this.showPasteErrorMessage = false;
      this.$set(this, "validity", detail);
      var errorMessage = "";

      if (this.$scopedSlots.default) {
        errorMessage = getTextFromScopedSlot(this.$scopedSlots.default);
      } else {
        errorMessage = this.defaultText;
      }

      var element = this.$el.querySelector("#".concat(detail.elementId));

      if (element) {
        dispatchComponentValidityEvent(element, FEmailTextFieldvue_type_script_lang_ts_assign(FEmailTextFieldvue_type_script_lang_ts_assign({}, detail), {
          errorMessage: errorMessage,
          focusElementId: detail.elementId
        }));
      }
    },
    onPendingValidity: function onPendingValidity() {
      this.validity.validityMode = "INITIAL";
    },
    configureValidators: function configureValidators() {
      var elements = Array.from(this.$el.querySelectorAll("input"));
      var validatorEmailConfig = {
        email: {
          errorMessage: this.$t("fkuiEmailTextFieldEmailError", "Mejladressen är inte korrekt ifylld")
        }
      };
      /*
       * Since this is an extended component the third argument "isBaseConfigs" for addValidatorsToElement() is set to true
       * in order to keep the base configuration set in this constructor when the application code adds its own validators, for example:
       * <f-email-text-field v-validation.required>
       */

      logic_["ValidationService"].addValidatorsToElement(elements[0], validatorEmailConfig, true);

      if (this.extendedValidation) {
        this.configureExtendedValidation(elements);
      }
    },
    configureExtendedValidation: function configureExtendedValidation(elements) {
      var validatorEmailMatchesConfig = {
        required: {
          enabled: elements[0].hasAttribute("required")
        },
        email: {
          errorMessage: this.$t("fkuiEmailTextFieldEmailError", "Mejladressen är inte korrekt ifylld")
        },
        matches: {
          id: elements[0].id,
          errorMessage: this.$t("fkuiEmailTextFieldMatchesError", "Mejladressen matchar ej")
        }
      };
      logic_["ValidationService"].addValidatorsToElement(elements[1], validatorEmailMatchesConfig, true);
    }
  }
}));
// CONCATENATED MODULE: ./src/components/FTextField/extendedTextFields/FEmailTextField/FEmailTextField.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FEmailTextField_FEmailTextFieldvue_type_script_lang_ts_ = (FEmailTextFieldvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FTextField/extendedTextFields/FEmailTextField/FEmailTextField.vue





/* normalize component */

var FEmailTextField_component = normalizeComponent(
  FEmailTextField_FEmailTextFieldvue_type_script_lang_ts_,
  FEmailTextFieldvue_type_template_id_23121ca7_render,
  FEmailTextFieldvue_type_template_id_23121ca7_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FEmailTextField = (FEmailTextField_component.exports);
// CONCATENATED MODULE: ./src/components/FTextField/extendedTextFields/FEmailTextField/index.ts

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FTextField/extendedTextFields/FPhoneTextField/FPhoneTextField.vue?vue&type=template&id=540ed84a&
var FPhoneTextFieldvue_type_template_id_540ed84a_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('f-text-field',_vm._g(_vm._b({attrs:{"type":"tel","maxlength":_vm.maxLength,"value":_vm.value},on:{"validity":_vm.onValidity,"pending-validity":_vm.onPendingValidity}},'f-text-field',_vm.attrs,false),_vm.listeners),[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.defaultText))]})],2),_vm._v(" "),(_vm.extendedValidation)?_c('f-text-field',{attrs:{"type":"tel","maxlength":_vm.maxLength},model:{value:(_vm.secondPhone),callback:function ($$v) {_vm.secondPhone=$$v},expression:"secondPhone"}},[_vm._t("extendedLabel",function(){return [_vm._v(_vm._s(_vm.$t("fkuiPhoneTextFieldExtendedPhonenumber", "Upprepa telefonnumret")))]})],2):_vm._e()],1)}
var FPhoneTextFieldvue_type_template_id_540ed84a_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/FTextField/extendedTextFields/FPhoneTextField/FPhoneTextField.vue?vue&type=template&id=540ed84a&

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FTextField/extendedTextFields/FPhoneTextField/FPhoneTextField.vue?vue&type=script&lang=ts&





var FPhoneTextFieldvue_type_script_lang_ts_assign = undefined && undefined.__assign || function () {
  FPhoneTextFieldvue_type_script_lang_ts_assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return FPhoneTextFieldvue_type_script_lang_ts_assign.apply(this, arguments);
};






/* harmony default export */ var FPhoneTextFieldvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: "FPhoneTextField",
  components: {
    FTextField: FTextField
  },
  mixins: [TranslationMixin],
  inheritAttrs: false,
  model: {
    prop: "value",
    event: "update"
  },
  props: {
    /**
     * The id for the input id attribute.
     * The id for the label for attribute.
     * If the prop is not set a random value will be generated.
     */
    id: {
      type: String,
      required: false,
      default: function _default() {
        return logic_["ElementIdService"].generateElementId();
      }
    },

    /**
     * The value for the input.
     * If the prop is not set undefined will be used.
     * @model
     */
    value: {
      type: [String],
      required: false,
      default: undefined
    },
    maxLength: {
      type: Number,
      default: 80
    },
    extendedValidation: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      validity: {
        validityMode: "INITIAL"
      },
      secondPhone: "",
      defaultText: this.$t("fkuiPhoneTextFieldPhonenumber", "Telefonnummer")
    };
  },
  computed: {
    attrs: function attrs() {
      return FPhoneTextFieldvue_type_script_lang_ts_assign(FPhoneTextFieldvue_type_script_lang_ts_assign({}, this.$attrs), {
        id: this.id,
        value: this.value
      });
    },

    /* eslint-disable-next-line @typescript-eslint/ban-types */
    listeners: function listeners() {
      var _this = this;

      return FPhoneTextFieldvue_type_script_lang_ts_assign(FPhoneTextFieldvue_type_script_lang_ts_assign({}, this.$listeners), {
        change: function change(event) {
          /**
           * @event change
           * @type {string | number}
           */
          _this.$emit("change", event);
        },
        blur: function blur(event) {
          /**
           * @event blur
           * @type {string | number}
           */
          _this.$emit("blur", event);
        },
        update: function update(event) {
          /**
           * V-model event.
           *
           * @event update
           * @type {string}
           */
          _this.$emit("update", event);
        }
      });
    }
  },
  mounted: function mounted() {
    this.configureValidators();
  },
  methods: {
    onValidity: function onValidity(_a) {
      var detail = _a.detail;
      this.$set(this, "validity", detail);
      var errorMessage = "";

      if (this.$scopedSlots.default) {
        errorMessage = getTextFromScopedSlot(this.$scopedSlots.default);
      } else {
        errorMessage = this.defaultText;
      }

      var element = this.$el.querySelector("#".concat(detail.elementId));

      if (element) {
        dispatchComponentValidityEvent(element, FPhoneTextFieldvue_type_script_lang_ts_assign(FPhoneTextFieldvue_type_script_lang_ts_assign({}, detail), {
          errorMessage: errorMessage,
          focusElementId: detail.elementId
        }));
      }
    },
    onPendingValidity: function onPendingValidity() {
      this.validity.validityMode = "INITIAL";
    },
    configureValidators: function configureValidators() {
      var elements = Array.from(this.$el.querySelectorAll("input"));
      var validatorPhoneConfig = {
        phoneNumber: {
          errorMessage: this.$t("fkuiPhoneTextFieldPhoneNumberError", "Telefonnumret är inte korrekt ifyllt")
        }
      };
      /*
       * Since this is an extended component the third argument "isBaseConfigs" for addValidatorsToElement() is set to true
       * in order to keep the base configuration set in this constructor when the application code adds its own validators, for example:
       * <f-phone-text-field v-validation.required>
       */

      logic_["ValidationService"].addValidatorsToElement(elements[0], validatorPhoneConfig, true);

      if (this.extendedValidation) {
        this.configureExtendedValidation(elements);
      }
    },
    configureExtendedValidation: function configureExtendedValidation(elements) {
      var validatorPhoneMatchesConfig = {
        required: {
          enabled: elements[0].hasAttribute("required")
        },
        phoneNumber: {
          errorMessage: this.$t("fkuiPhoneTextFieldPhoneNumberError", "Telefonnumret är inte korrekt ifyllt")
        },
        matches: {
          id: elements[0].id,
          errorMessage: this.$t("fkuiPhoneTextFieldMatchesError", "Telefonnumret matchar ej")
        }
      };
      logic_["ValidationService"].addValidatorsToElement(elements[1], validatorPhoneMatchesConfig, true);
    }
  }
}));
// CONCATENATED MODULE: ./src/components/FTextField/extendedTextFields/FPhoneTextField/FPhoneTextField.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FPhoneTextField_FPhoneTextFieldvue_type_script_lang_ts_ = (FPhoneTextFieldvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FTextField/extendedTextFields/FPhoneTextField/FPhoneTextField.vue





/* normalize component */

var FPhoneTextField_component = normalizeComponent(
  FPhoneTextField_FPhoneTextFieldvue_type_script_lang_ts_,
  FPhoneTextFieldvue_type_template_id_540ed84a_render,
  FPhoneTextFieldvue_type_template_id_540ed84a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FPhoneTextField = (FPhoneTextField_component.exports);
// CONCATENATED MODULE: ./src/components/FTextField/extendedTextFields/FPhoneTextField/index.ts

// CONCATENATED MODULE: ./src/components/FTextField/extendedTextFields/ExtendHelper.ts

function getInputElement(vm) {
  var inputElement = vm.$el.querySelector("input");

  if (!inputElement) {
    throw new Error("Could not find input element in FTextField with id ".concat(vm.$el.id));
  }

  return inputElement;
}
// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FTextField/extendedTextFields/FCurrencyTextField/FCurrencyTextField.vue?vue&type=script&lang=ts&





/* harmony default export */ var FCurrencyTextFieldvue_type_script_lang_ts_ = (FTextField.extend({
  name: "FCurrencyTextField",
  mixins: [TranslationMixin],
  mounted: function mounted() {
    var inputElement = getInputElement(this);
    inputElement.setAttribute("inputmode", "numeric");
    inputElement.setAttribute("maxlength", "20");
    logic_["ValidationService"].addValidatorsToElement(inputElement, {
      currency: {
        errorMessage: this.$t("fkui.currencyTextField.ejkorrekt", "Fyll i ett belopp.")
      },
      integer: {}
    }, true);
  },
  data: function data() {
    return {
      defaultText: this.$t("fkui.currencyTextField.label", "Pengar")
    };
  },
  props: {
    formatter: {
      type: Function,
      required: false,
      default: logic_["formatNumber"]
    },
    parser: {
      type: Function,
      required: false,
      default: logic_["parseNumber"]
    }
  }
}));
// CONCATENATED MODULE: ./src/components/FTextField/extendedTextFields/FCurrencyTextField/FCurrencyTextField.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FCurrencyTextField_FCurrencyTextFieldvue_type_script_lang_ts_ = (FCurrencyTextFieldvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FTextField/extendedTextFields/FCurrencyTextField/FCurrencyTextField.vue
var FCurrencyTextField_render, FCurrencyTextField_staticRenderFns




/* normalize component */

var FCurrencyTextField_component = normalizeComponent(
  FCurrencyTextField_FCurrencyTextFieldvue_type_script_lang_ts_,
  FCurrencyTextField_render,
  FCurrencyTextField_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FCurrencyTextField = (FCurrencyTextField_component.exports);
// CONCATENATED MODULE: ./src/components/FTextField/extendedTextFields/FCurrencyTextField/index.ts

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FTextField/extendedTextFields/FBankAccountNumberTextField/FBankAccountNumberTextField.vue?vue&type=script&lang=ts&




/* harmony default export */ var FBankAccountNumberTextFieldvue_type_script_lang_ts_ = (FTextField.extend({
  name: "FBankAccountNumberTextField",
  mixins: [TranslationMixin],
  mounted: function mounted() {
    var inputElement = getInputElement(this);
    logic_["ValidationService"].addValidatorsToElement(inputElement, {
      bankAccountNumber: {}
    }, true);
    inputElement.setAttribute("inputmode", "numeric");
    inputElement.setAttribute("maxlength", "40");
  },
  props: {
    parser: {
      type: Function,
      required: false,
      default: logic_["parseBankAccountNumber"]
    }
  },
  data: function data() {
    return {
      defaultText: this.$t("fkui.bankAccountNumberTextField.label", "Kontonummer")
    };
  }
}));
// CONCATENATED MODULE: ./src/components/FTextField/extendedTextFields/FBankAccountNumberTextField/FBankAccountNumberTextField.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FBankAccountNumberTextField_FBankAccountNumberTextFieldvue_type_script_lang_ts_ = (FBankAccountNumberTextFieldvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FTextField/extendedTextFields/FBankAccountNumberTextField/FBankAccountNumberTextField.vue
var FBankAccountNumberTextField_render, FBankAccountNumberTextField_staticRenderFns




/* normalize component */

var FBankAccountNumberTextField_component = normalizeComponent(
  FBankAccountNumberTextField_FBankAccountNumberTextFieldvue_type_script_lang_ts_,
  FBankAccountNumberTextField_render,
  FBankAccountNumberTextField_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FBankAccountNumberTextField = (FBankAccountNumberTextField_component.exports);
// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FTextField/extendedTextFields/FBankgiroTextField/FBankgiroTextField.vue?vue&type=script&lang=ts&




/* harmony default export */ var FBankgiroTextFieldvue_type_script_lang_ts_ = (FTextField.extend({
  name: "FBankgiroTextField",
  mixins: [TranslationMixin],
  mounted: function mounted() {
    var inputElement = getInputElement(this);
    logic_["ValidationService"].addValidatorsToElement(inputElement, {
      maxLength: {
        length: 9
      },
      bankgiro: {}
    }, true);
    inputElement.setAttribute("inputmode", "numeric");
    inputElement.setAttribute("maxlength", "40");
  },
  data: function data() {
    return {
      defaultText: this.$t("fkui.bankgiroTextField.label", "Bankgironummer")
    };
  },
  props: {
    formatter: {
      type: Function,
      required: false,
      default: logic_["parseBankgiro"]
    }
  }
}));
// CONCATENATED MODULE: ./src/components/FTextField/extendedTextFields/FBankgiroTextField/FBankgiroTextField.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FBankgiroTextField_FBankgiroTextFieldvue_type_script_lang_ts_ = (FBankgiroTextFieldvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FTextField/extendedTextFields/FBankgiroTextField/FBankgiroTextField.vue
var FBankgiroTextField_render, FBankgiroTextField_staticRenderFns




/* normalize component */

var FBankgiroTextField_component = normalizeComponent(
  FBankgiroTextField_FBankgiroTextFieldvue_type_script_lang_ts_,
  FBankgiroTextField_render,
  FBankgiroTextField_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FBankgiroTextField = (FBankgiroTextField_component.exports);
// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FTextField/extendedTextFields/FClearingnumberTextField/FClearingnumberTextField.vue?vue&type=script&lang=ts&




/* harmony default export */ var FClearingnumberTextFieldvue_type_script_lang_ts_ = (FTextField.extend({
  name: "FClearingnumberTextField",
  mixins: [TranslationMixin],
  mounted: function mounted() {
    var inputElement = getInputElement(this);
    logic_["ValidationService"].addValidatorsToElement(inputElement, {
      clearingNumber: {}
    }, true);
    inputElement.setAttribute("inputmode", "numeric");
    inputElement.setAttribute("maxlength", "16");
  },
  data: function data() {
    return {
      defaultText: this.$t("fkui.clearingnumberTextField.label", "Clearingnummer")
    };
  },
  props: {
    formatter: {
      type: Function,
      required: false,
      default: logic_["parseClearingNumber"]
    }
  }
}));
// CONCATENATED MODULE: ./src/components/FTextField/extendedTextFields/FClearingnumberTextField/FClearingnumberTextField.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FClearingnumberTextField_FClearingnumberTextFieldvue_type_script_lang_ts_ = (FClearingnumberTextFieldvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FTextField/extendedTextFields/FClearingnumberTextField/FClearingnumberTextField.vue
var FClearingnumberTextField_render, FClearingnumberTextField_staticRenderFns




/* normalize component */

var FClearingnumberTextField_component = normalizeComponent(
  FClearingnumberTextField_FClearingnumberTextFieldvue_type_script_lang_ts_,
  FClearingnumberTextField_render,
  FClearingnumberTextField_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FClearingnumberTextField = (FClearingnumberTextField_component.exports);
// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FTextField/extendedTextFields/FNumericTextField/FNumericTextField.vue?vue&type=script&lang=ts&




/* harmony default export */ var FNumericTextFieldvue_type_script_lang_ts_ = (FTextField.extend({
  name: "FNumericTextField",
  mounted: function mounted() {
    var inputElement = getInputElement(this);
    inputElement.setAttribute("inputmode", "numeric");
    inputElement.setAttribute("maxlength", "20");
    logic_["ValidationService"].addValidatorsToElement(inputElement, {
      number: {}
    }, true);
  },
  props: {
    /**
     * The number of decimals to format number as.
     * @model
     */
    decimals: {
      type: [Number],
      required: false,
      default: undefined
    },
    formatter: {
      type: Function,
      required: false,
      default: function _default(modelValue) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return Object(logic_["formatNumber"])(modelValue, this.decimals);
      }
    },
    parser: {
      type: Function,
      required: false,
      default: logic_["parseNumber"]
    }
  }
}));
// CONCATENATED MODULE: ./src/components/FTextField/extendedTextFields/FNumericTextField/FNumericTextField.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FNumericTextField_FNumericTextFieldvue_type_script_lang_ts_ = (FNumericTextFieldvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FTextField/extendedTextFields/FNumericTextField/FNumericTextField.vue
var FNumericTextField_render, FNumericTextField_staticRenderFns




/* normalize component */

var FNumericTextField_component = normalizeComponent(
  FNumericTextField_FNumericTextFieldvue_type_script_lang_ts_,
  FNumericTextField_render,
  FNumericTextField_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FNumericTextField = (FNumericTextField_component.exports);
// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FTextField/extendedTextFields/FPersonnummerTextField/FPersonnummerTextField.vue?vue&type=script&lang=ts&




/* harmony default export */ var FPersonnummerTextFieldvue_type_script_lang_ts_ = (FTextField.extend({
  name: "FPersonnummerTextField",
  mixins: [TranslationMixin],
  mounted: function mounted() {
    var inputElement = getInputElement(this);
    logic_["ValidationService"].addValidatorsToElement(inputElement, {
      maxLength: {
        length: 13
      },
      personnummer: {}
    }, true);
    inputElement.setAttribute("inputmode", "numeric");
    inputElement.setAttribute("maxlength", "23");
  },
  data: function data() {
    return {
      defaultText: this.$t("fkui.personnummerTextField.label", "Fyll i personnummer"),
      discreteDescriptionText: this.$t("fkui.personnummerTextField.example", "(ååååmmdd-nnnn)"),
      discreteDescriptionScreenReaderText: this.$t("fkui.common.formatDescription", "Formatbeskrivning")
    };
  },
  props: {
    formatter: {
      type: Function,
      required: false,
      default: logic_["parsePersonnummer"]
    }
  }
}));
// CONCATENATED MODULE: ./src/components/FTextField/extendedTextFields/FPersonnummerTextField/FPersonnummerTextField.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FPersonnummerTextField_FPersonnummerTextFieldvue_type_script_lang_ts_ = (FPersonnummerTextFieldvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FTextField/extendedTextFields/FPersonnummerTextField/FPersonnummerTextField.vue
var FPersonnummerTextField_render, FPersonnummerTextField_staticRenderFns




/* normalize component */

var FPersonnummerTextField_component = normalizeComponent(
  FPersonnummerTextField_FPersonnummerTextFieldvue_type_script_lang_ts_,
  FPersonnummerTextField_render,
  FPersonnummerTextField_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FPersonnummerTextField = (FPersonnummerTextField_component.exports);
// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FTextField/extendedTextFields/FPlusgiroTextField/FPlusgiroTextField.vue?vue&type=script&lang=ts&




/* harmony default export */ var FPlusgiroTextFieldvue_type_script_lang_ts_ = (FTextField.extend({
  name: "FPlusgiroTextField",
  mixins: [TranslationMixin],
  mounted: function mounted() {
    var inputElement = getInputElement(this);
    logic_["ValidationService"].addValidatorsToElement(inputElement, {
      maxLength: {
        length: 11
      },
      plusgiro: {}
    }, true);
    inputElement.setAttribute("inputmode", "numeric");
    inputElement.setAttribute("maxlength", "16");
  },
  data: function data() {
    return {
      defaultText: this.$t("fkui.plusgiroTextField.label", "Plusgironummer")
    };
  },
  props: {
    formatter: {
      type: Function,
      required: false,
      default: logic_["parsePlusgiro"]
    }
  }
}));
// CONCATENATED MODULE: ./src/components/FTextField/extendedTextFields/FPlusgiroTextField/FPlusgiroTextField.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FPlusgiroTextField_FPlusgiroTextFieldvue_type_script_lang_ts_ = (FPlusgiroTextFieldvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FTextField/extendedTextFields/FPlusgiroTextField/FPlusgiroTextField.vue
var FPlusgiroTextField_render, FPlusgiroTextField_staticRenderFns




/* normalize component */

var FPlusgiroTextField_component = normalizeComponent(
  FPlusgiroTextField_FPlusgiroTextFieldvue_type_script_lang_ts_,
  FPlusgiroTextField_render,
  FPlusgiroTextField_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FPlusgiroTextField = (FPlusgiroTextField_component.exports);
// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FTextField/extendedTextFields/FPostalCodeTextField/FPostalCodeTextField.vue?vue&type=script&lang=ts&




/* harmony default export */ var FPostalCodeTextFieldvue_type_script_lang_ts_ = (FTextField.extend({
  name: "FPostalCodeTextField",
  mixins: [TranslationMixin],
  mounted: function mounted() {
    var inputElement = getInputElement(this);
    logic_["ValidationService"].addValidatorsToElement(inputElement, {
      maxLength: {
        length: 13
      },
      postalCode: {}
    }, true);
    inputElement.setAttribute("inputmode", "numeric");
    inputElement.setAttribute("maxlength", "15");
  },
  data: function data() {
    return {
      defaultText: this.$t("fkui.postalCodeTextField.label", "Postnummer"),
      discreteDescriptionText: this.$t("fkui.postalCodeTextField.example", "(123 45)"),
      discreteDescriptionScreenReaderText: this.$t("fkui.common.formatDescription", "Formatbeskrivning")
    };
  },
  props: {
    formatter: {
      type: Function,
      required: false,
      default: logic_["parsePostalCode"]
    }
  }
}));
// CONCATENATED MODULE: ./src/components/FTextField/extendedTextFields/FPostalCodeTextField/FPostalCodeTextField.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FPostalCodeTextField_FPostalCodeTextFieldvue_type_script_lang_ts_ = (FPostalCodeTextFieldvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FTextField/extendedTextFields/FPostalCodeTextField/FPostalCodeTextField.vue
var FPostalCodeTextField_render, FPostalCodeTextField_staticRenderFns




/* normalize component */

var FPostalCodeTextField_component = normalizeComponent(
  FPostalCodeTextField_FPostalCodeTextFieldvue_type_script_lang_ts_,
  FPostalCodeTextField_render,
  FPostalCodeTextField_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FPostalCodeTextField = (FPostalCodeTextField_component.exports);
// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FTextField/extendedTextFields/FPercentTextField/FPercentTextField.vue?vue&type=script&lang=ts&





/* harmony default export */ var FPercentTextFieldvue_type_script_lang_ts_ = (FTextField.extend({
  name: "FPercentTextField",
  mixins: [TranslationMixin],
  mounted: function mounted() {
    var inputElement = getInputElement(this);
    inputElement.setAttribute("inputmode", "numeric");
    inputElement.setAttribute("maxlength", "20");
    logic_["ValidationService"].addValidatorsToElement(inputElement, {
      percent: {},
      minValue: {
        minValue: 0
      },
      maxValue: {
        maxValue: 999
      }
    }, true);
  },
  data: function data() {
    return {
      defaultText: this.$t("fkui.percentTextField.label", "Procent")
    };
  },
  props: {
    /**
     * The number of decimals to format number as.
     */
    decimals: {
      type: [Number],
      required: false,
      default: undefined
    },
    formatter: {
      type: Function,
      required: false,
      default: function _default(modelValue) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return Object(logic_["formatPercent"])(modelValue, this.decimals);
      }
    },
    parser: {
      type: Function,
      required: false,
      default: logic_["parsePercent"]
    }
  }
}));
// CONCATENATED MODULE: ./src/components/FTextField/extendedTextFields/FPercentTextField/FPercentTextField.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FPercentTextField_FPercentTextFieldvue_type_script_lang_ts_ = (FPercentTextFieldvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FTextField/extendedTextFields/FPercentTextField/FPercentTextField.vue
var FPercentTextField_render, FPercentTextField_staticRenderFns




/* normalize component */

var FPercentTextField_component = normalizeComponent(
  FPercentTextField_FPercentTextFieldvue_type_script_lang_ts_,
  FPercentTextField_render,
  FPercentTextField_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FPercentTextField = (FPercentTextField_component.exports);
// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FTextField/extendedTextFields/FOrganisationsnummerTextField/FOrganisationsnummerTextField.vue?vue&type=script&lang=ts&




/* harmony default export */ var FOrganisationsnummerTextFieldvue_type_script_lang_ts_ = (FTextField.extend({
  name: "FOrganisationsnummerTextField",
  mixins: [TranslationMixin],
  mounted: function mounted() {
    var inputElement = getInputElement(this);
    logic_["ValidationService"].addValidatorsToElement(inputElement, {
      maxLength: {
        length: 11
      },
      organisationsnummer: {}
    }, true);
    inputElement.setAttribute("inputmode", "numeric");
    inputElement.setAttribute("maxlength", "20");
  },
  data: function data() {
    return {
      defaultText: this.$t("fkui.organisationsnummerTextField.label", "Organisationsnummer"),
      discreteDescriptionText: this.$t("fkui.organisationsnummerTextField.example", "(999999-9999)"),
      discreteDescriptionScreenReaderText: this.$t("fkui.common.formatDescription", "Formatbeskrivning")
    };
  },
  props: {
    formatter: {
      type: Function,
      required: false,
      default: logic_["parseOrganisationsnummer"]
    }
  }
}));
// CONCATENATED MODULE: ./src/components/FTextField/extendedTextFields/FOrganisationsnummerTextField/FOrganisationsnummerTextField.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FOrganisationsnummerTextField_FOrganisationsnummerTextFieldvue_type_script_lang_ts_ = (FOrganisationsnummerTextFieldvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FTextField/extendedTextFields/FOrganisationsnummerTextField/FOrganisationsnummerTextField.vue
var FOrganisationsnummerTextField_render, FOrganisationsnummerTextField_staticRenderFns




/* normalize component */

var FOrganisationsnummerTextField_component = normalizeComponent(
  FOrganisationsnummerTextField_FOrganisationsnummerTextFieldvue_type_script_lang_ts_,
  FOrganisationsnummerTextField_render,
  FOrganisationsnummerTextField_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FOrganisationsnummerTextField = (FOrganisationsnummerTextField_component.exports);
// CONCATENATED MODULE: ./src/components/FTextField/extendedTextFields/index.ts












// CONCATENATED MODULE: ./src/components/FTextField/index.ts


// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@babel/runtime/helpers/esm/typeof.js







function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}
// CONCATENATED MODULE: ./src/components/FSortFilterDataset/FSortFilterSorter.ts




function sort(list, sortAttribute, ascending) {
  return list.sort(function (item1, item2) {
    return compare(item1, item2, sortAttribute, ascending);
  });
} // eslint-disable-next-line complexity

function compare(item1, item2, attribute, ascending) {
  var value1 = item1[attribute];
  var value2 = item2[attribute];

  if (!Object(logic_["isSet"])(value1) || !Object(logic_["isSet"])(value2)) {
    // Null values are always unsorted at the end of the list
    return nullCompare(value1, value2);
  }

  if (typeof value1 === "string" && typeof value2 === "string") {
    return fixOrder(value1.localeCompare(value2), ascending);
  }

  if (typeof value1 === "number" && typeof value2 === "number") {
    return fixOrder(numberCompare(value1, value2), ascending);
  }

  if (typeof value1 === "boolean" && typeof value2 === "boolean") {
    return fixOrder(booleanCompare(value1, value2), ascending);
  }

  if (_typeof(value1) !== _typeof(value2)) {
    throw Error("Sorting is not supported for rows containing different types (attribute '".concat(attribute, "')"));
  }

  throw Error("Sorting is only supported for types number, string and boolean (attribute '".concat(attribute, "')"));
} // This is used instead of list.reverse to keep null values
// at the end of the list and in unsorted order


function fixOrder(order, ascending) {
  return ascending ? order : order - order * 2;
}

function booleanCompare(value1, value2) {
  if (value1 === value2) {
    return 0;
  } else if (value1 > value2) {
    return 1;
  }

  return -1;
}

function numberCompare(value1, value2) {
  return value1 - value2;
}

function nullCompare(value1, value2) {
  if (!Object(logic_["isSet"])(value1) && !Object(logic_["isSet"])(value2)) {
    return 0;
  } else if (!Object(logic_["isSet"])(value1)) {
    return 1;
  }

  return -1;
}
// EXTERNAL MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__("62c8");

// CONCATENATED MODULE: ./src/components/FSortFilterDataset/FSortFilterFilter.ts













function includesAllSearchTerms(item, filterAttributes, searchTerms) {
  var values = filterAttributes.map(function (it) {
    var value = item[it];
    return Object(logic_["isSet"])(value) ? value.toString().toLocaleLowerCase() : undefined;
  }).filter(Boolean);

  var _loop_1 = function _loop_1(searchTerm) {
    var match = values.find(function (it) {
      return it === null || it === void 0 ? void 0 : it.includes(searchTerm);
    });

    if (!match) {
      return {
        value: false
      };
    }
  };

  for (var _i = 0, searchTerms_1 = searchTerms; _i < searchTerms_1.length; _i++) {
    var searchTerm = searchTerms_1[_i];

    var state_1 = _loop_1(searchTerm);

    if (_typeof(state_1) === "object") return state_1.value;
  }

  return true;
}

function filter(list, filterAttributes, searchString) {
  searchString = searchString.trim();

  if (searchString.trim() === "") {
    return list;
  }

  var searchTerms = searchString.split(/\s+/).map(function (word) {
    return word.toLocaleLowerCase();
  });
  return list.filter(function (item) {
    return includesAllSearchTerms(item, filterAttributes, searchTerms);
  });
}
// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FSortFilterDataset/FSortFilterDataset.vue?vue&type=script&lang=ts&







var FSortFilterDatasetvue_type_script_lang_ts_spreadArray = undefined && undefined.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};










/* harmony default export */ var FSortFilterDatasetvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: "FSortFilterDataset",
  components: {
    FSelectField: FSelectField,
    FTextField: FTextField,
    FIcon: FIcon,
    IFlex: IFlex,
    IFlexItem: IFlexItem
  },
  mixins: [TranslationMixin],
  provide: function provide() {
    var _this = this;

    return {
      sort: function sort(attribute, ascending) {
        var foundAttribute = _this.sortOrders.find(function (item) {
          return item.attribute === attribute && item.ascending === ascending;
        });

        if (foundAttribute) {
          _this.sortAttribute = foundAttribute;
        } else {
          _this.sortAttribute = {
            attribute: "",
            ascending: false
          };
        }

        _this.sortFilterData();
      },
      registerCallbackOnSort: function registerCallbackOnSort(callback) {
        _this.tableCallbackOnSort = callback;
      },
      registerCallbackOnMount: function registerCallbackOnMount(callback) {
        _this.tableCallbackSortableColumns = callback;
      }
    };
  },
  props: {
    /**
     * The data that you wish to sort or filter.
     */
    data: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },

    /**
     * All the attributes you want to enable sorting for and the corresponding name to display in the dropdown.
     * Structured as `{attributeName: "Name for dropdown", secondAttributeName: "Name for dropdown"}`
     */
    sortableAttributes: {
      type: Object,
      required: true
    },

    /**
     * If set the data will be sorted by this attribute by default.
     */
    defaultSortAttribute: {
      type: String,
      required: false,
      default: function _default() {
        return "";
      }
    },

    /**
     * Show/hides the sort dropdown.
     */
    showSort: {
      type: Boolean,
      required: false,
      default: true
    },

    /**
     * Show/hides the filter input.
     */
    showFilter: {
      type: Boolean,
      required: false,
      default: true
    },

    /**
     * Set placeholder text in filter input field.
     * Default is textkey "fkuiSortSearchDataset.placeholder.filter"
     */
    placeholderFilter: {
      type: String,
      required: false,
      default: TranslationMixin.methods.$t("fkuiSortSearchDataset.placeholder.filter", "Sök")
    },

    /**
     * The order the data will be sorted by if defaultSortAttribute has been set.
     */
    defaultSortAscending: {
      type: Boolean,
      required: false,
      default: function _default() {
        return true;
      }
    }
  },
  data: function data() {
    return {
      searchAriaLive: "",
      searchString: "",
      sortAttribute: {
        attribute: "",
        ascending: false
      },
      sortFilterResult: [],
      tableCallbackOnSort: function tableCallbackOnSort() {
        return;
      },
      tableCallbackSortableColumns: function tableCallbackSortableColumns() {
        return;
      }
    };
  },
  computed: {
    showClearButton: function showClearButton() {
      return this.searchString.length > 0;
    },
    sortOrders: function sortOrders() {
      var _this = this;

      var arr = [];
      var id = 0;
      Object.keys(this.sortableAttributes).forEach(function (key) {
        arr.push({
          attribute: key,
          name: _this.sortableAttributes[key],
          ascendingName: _this.$t("fkuiSortFilterDataset.label.ascending", "stigande"),
          ascending: true,
          id: id++
        });
        arr.push({
          attribute: key,
          name: _this.sortableAttributes[key],
          ascendingName: _this.$t("fkuiSortFilterDataset.label.descending", "fallande"),
          ascending: false,
          id: id++
        });
      });
      return arr;
    },
    filterAttributes: function filterAttributes() {
      return Object.keys(this.sortableAttributes);
    }
  },
  watch: {
    data: {
      immediate: true,
      handler: function handler() {
        var _this = this;

        if (this.defaultSortAttribute !== "") {
          var foundAttribute = this.sortOrders.find(function (item) {
            return item.attribute === _this.defaultSortAttribute && item.ascending === _this.defaultSortAscending;
          });

          if (foundAttribute) {
            this.sortAttribute = foundAttribute;
          }
        }

        this.sortFilterData();
      }
    }
  },
  created: function created() {
    this.debouncedFilterResultset = Object(logic_["debounce"])(this.filterResultset, 250).bind(this);
  },
  mounted: function mounted() {
    this.tableCallbackSortableColumns(Object.keys(this.sortableAttributes));
  },
  methods: {
    sortFilterData: function sortFilterData() {
      var _this = this;

      var filteredData = filter(this.data, this.filterAttributes, this.searchString);

      if (this.sortAttribute.attribute === "") {
        this.sortFilterResult = filteredData;
      } else {
        this.sortFilterResult = sort(FSortFilterDatasetvue_type_script_lang_ts_spreadArray([], filteredData, true), this.sortAttribute.attribute, this.sortAttribute.ascending);
      } // Await slot mount, otherwise if defaultSortAttribute is used the slot doesn't have time to register tableCallbackOnSort before this is called.


      this.$nextTick(function () {
        _this.tableCallbackOnSort(_this.sortAttribute.attribute, _this.sortAttribute.ascending);
      });
      /**
       * Emitted when the data is sorted.
       * @event datasetSorted
       * @param sortFilterResult - The sorted data.
       * @type {ListArray}
       */

      this.$emit("datasetSorted", this.sortFilterResult);
    },
    onChangeSortAttribute: function onChangeSortAttribute() {
      this.sortFilterData();
    },
    onSearchInput: function onSearchInput(event) {
      this.searchString = event.target.value;
      this.debouncedFilterResultset();
    },
    onSearchBlur: function onSearchBlur() {
      this.searchAriaLive = "";
    },
    onClickClearSearch: function onClickClearSearch() {
      this.searchString = "";
      this.filterResultset();
      this.searchAriaLive = "xx";
      var input = this.$el.querySelector(".text-field--inline input");

      if (input) {
        Object(logic_["focus"])(input);
      }
    },
    debouncedFilterResultset: function debouncedFilterResultset() {// debounce method created in create()
    },
    filterResultset: function filterResultset() {
      this.sortFilterData();

      if (this.searchString === "") {
        this.searchAriaLive = this.$t("fkuiSortFilterDataset.arialive.empty", "Sök redigera Sök tom");
      } else {
        this.searchAriaLive = this.$t("fkuiSortFilterDataset.arialive.search", "Din s\xF6kning p\xE5 \"{{ search }}\" gav {{ result }} tr\xE4ffar.", {
          result: this.sortFilterResult.length,
          search: this.searchString
        });
      }
    }
  }
}));
// CONCATENATED MODULE: ./src/components/FSortFilterDataset/FSortFilterDataset.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FSortFilterDataset_FSortFilterDatasetvue_type_script_lang_ts_ = (FSortFilterDatasetvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FSortFilterDataset/FSortFilterDataset.vue





/* normalize component */

var FSortFilterDataset_component = normalizeComponent(
  FSortFilterDataset_FSortFilterDatasetvue_type_script_lang_ts_,
  FSortFilterDatasetvue_type_template_id_1d84218c_render,
  FSortFilterDatasetvue_type_template_id_1d84218c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FSortFilterDataset = (FSortFilterDataset_component.exports);
// CONCATENATED MODULE: ./src/components/FSortFilterDataset/index.ts


// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FDataTable/FDataTable.vue?vue&type=script&lang=ts&


















var FDataTablevue_type_script_lang_ts_Vue = external_commonjs_vue_commonjs2_vue_root_Vue_default.a;
/* harmony default export */ var FDataTablevue_type_script_lang_ts_ = (FDataTablevue_type_script_lang_ts_Vue.extend({
  name: "FDataTable",
  components: {
    FIcon: FIcon
  },
  mixins: [TranslationMixin],
  provide: function provide() {
    var _this = this;

    return {
      addColumn: function addColumn(column) {
        if (column.type === "action") {
          throw new Error("Cannot use action column in FDataTable component");
        }

        _this.columns = FTableColumnData_addColumn(_this.columns, column);
      },
      setVisibilityColumn: function setVisibilityColumn(id, visible) {
        FTableColumnData_setVisibilityColumn(_this.columns, id, visible);
      },
      cellRole: function cellRole() {
        return null;
      }
    };
  },
  inject: FSortFilterDatasetInjected,
  inheritAttrs: false,
  props: {
    /**
     * Need an emptyRow in order to display headers if rows prop is empty.
     * This prop will be used for setting up headers if complex objects are being used, see "RowHeadingExample".
     */
    emptyRow: {
      type: Object,
      default: function _default() {
        return {};
      }
    },

    /**
     * The rows to be listed.
     * The rows will be listed in the given array order.
     */
    rows: {
      type: Array,
      required: true
    },

    /**
     * Unique attribute in rows.
     */
    keyAttribute: {
      type: String,
      required: true
    },

    /**
     * If `true` alternating rows will use a different background color.
     */
    striped: {
      type: Boolean,
      default: false
    },

    /**
     * Enable scrolling inside table.
     *
     * Can be one of the following values:
     *
     * - `"horizontal"`: Enables horizontal scrolling
     * - `"vertical"`: Enables vertical scrolling
     * - `"both"`: Enables scrolling in both directions
     * - `"none"`: Disables scrolling (default)
     */
    scroll: {
      type: String,
      default: "none",
      validator: function validator(value) {
        var types = Object.values(TableScroll);
        return types.includes(value);
      }
    }
  },
  data: function data() {
    return {
      columns: []
    };
  },
  computed: {
    hasCaption: function hasCaption() {
      return hasSlot(this, "caption");
    },
    tableClasses: function tableClasses() {
      var classes = [];

      if (this.striped) {
        classes.push("table--striped");
      }

      return classes;
    },
    isEmpty: function isEmpty() {
      return this.rows.length === 0;
    },
    visibleColumns: function visibleColumns() {
      return this.columns.filter(function (col) {
        return col.visible;
      });
    },
    hasInitiateColumns: function hasInitiateColumns() {
      return this.columns.length > 0;
    },
    wrapperClasses: function wrapperClasses() {
      return tableScrollClasses(this.scroll);
    },
    tabindex: function tabindex() {
      return this.scroll !== TableScroll.NONE ? 0 : undefined;
    }
  },
  mounted: function mounted() {
    try {
      var defaultSlot = this.$scopedSlots["default"];

      if (defaultSlot) {
        defaultSlot({
          row: this.emptyRow
        });
      }
    } catch (error) {
      if (error instanceof Error && error.message.match(/Cannot read.*undefined.*/)) {
        var message = "Table requires \"emptyRow\" prop to be set when using nestled objects in \"FTableColumn\" default slot, see documentation.";
        throw new logic_["DecoratedError"](message, error);
      } else {
        throw error;
      }
    }

    this.registerCallbackOnSort(this.callbackOnSort);
    this.registerCallbackOnMount(this.callbackSortableColumns);
  },
  methods: {
    rowKey: function rowKey(item) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      var key = item[this.keyAttribute];

      if (typeof key === "undefined") {
        throw new Error("Key attribute [".concat(this.keyAttribute, "]' is missing in row"));
      }

      return key;
    },
    columnClasses: function columnClasses(column) {
      var classes = ["table__column", "table__column--".concat(column.type), column.size];

      if (column.sortable) {
        classes.push("table__column--sortable");
      }

      return classes;
    },
    iconClasses: function iconClasses(column) {
      return getSortableIconClasses(column);
    },
    iconName: function iconName(column) {
      return getSortableIconName(column);
    },
    onClickColumnHeader: function onClickColumnHeader(column) {
      if (!column.sortable) {
        return;
      }

      var columnName = column.name;

      if (column.sort === FTableColumnSort.DESCENDING) {
        columnName = "";
        column.sort = FTableColumnSort.UNSORTED;
      }

      this.sort(columnName, column.sort !== FTableColumnSort.ASCENDING);
    },
    callbackOnSort: function callbackOnSort(columnName, ascending) {
      updateSortOrder(this.columns, columnName, ascending);
    },
    callbackSortableColumns: function callbackSortableColumns(columnNames) {
      setSortableColumns(this.columns, columnNames);
    },
    escapeNewlines: function escapeNewlines(value) {
      return value.replace(/\n/g, "<br/>");
    }
  }
}));
// CONCATENATED MODULE: ./src/components/FDataTable/FDataTable.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FDataTable_FDataTablevue_type_script_lang_ts_ = (FDataTablevue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FDataTable/FDataTable.vue





/* normalize component */

var FDataTable_component = normalizeComponent(
  FDataTable_FDataTablevue_type_script_lang_ts_,
  FDataTablevue_type_template_id_2e97f4d7_render,
  FDataTablevue_type_template_id_2e97f4d7_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FDataTable = (FDataTable_component.exports);
// CONCATENATED MODULE: ./src/components/FDataTable/index.ts

// CONCATENATED MODULE: ./src/components/FDatepicker/types/index.ts

// CONCATENATED MODULE: ./src/components/FDatepicker/index.ts


// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FExpand/FExpand.vue?vue&type=template&id=8e49a100&
var FExpandvue_type_template_id_8e49a100_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{on:{"enter":_vm.enter,"after-enter":_vm.afterEnter,"leave":_vm.leave}},[_vm._t("default",null,{"height":_vm.height})],2)}
var FExpandvue_type_template_id_8e49a100_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/FExpand/FExpand.vue?vue&type=template&id=8e49a100&

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FExpand/FExpand.vue?vue&type=script&lang=ts&


/**
 * Level: Beta
 */

/* harmony default export */ var FExpandvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: "FExpand",
  data: function data() {
    return {
      height: 0,
      initialStyle: {
        overflow: "hidden",
        transition: "height 400ms cubic-bezier(0.46, 0.03, 0.52, 0.96)"
      },
      hiddenStyle: {
        height: "auto",
        position: "absolute",
        visibility: "hidden"
      },
      visibleStyle: {
        width: "",
        position: "",
        visibility: "",
        height: "0px"
      },
      openedStyle: {
        height: "auto"
      }
    };
  },
  methods: {
    enter: function enter(element) {
      var _this = this;

      Object.assign(element.style, this.initialStyle);
      Object.assign(element.style, this.hiddenStyle);
      element.style.width = getComputedStyle(element).width;
      var height = getComputedStyle(element).height;
      Object.assign(element.style, this.visibleStyle); // Force redraw

      getComputedStyle(element).height;
      setTimeout(function () {
        _this.height = parseInt(height, 10);
        element.style.height = height;
      });
    },
    afterEnter: function afterEnter(element) {
      Object.assign(element.style, this.openedStyle);
    },
    leave: function leave(element) {
      var _this = this;

      var height = getComputedStyle(element).height;
      element.style.height = height; // Force redraw

      getComputedStyle(element).height;
      setTimeout(function () {
        Object.assign(element.style, _this.visibleStyle);
      });
    }
  }
}));
// CONCATENATED MODULE: ./src/components/FExpand/FExpand.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FExpand_FExpandvue_type_script_lang_ts_ = (FExpandvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FExpand/FExpand.vue





/* normalize component */

var FExpand_component = normalizeComponent(
  FExpand_FExpandvue_type_script_lang_ts_,
  FExpandvue_type_template_id_8e49a100_render,
  FExpandvue_type_template_id_8e49a100_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FExpand = (FExpand_component.exports);
// CONCATENATED MODULE: ./src/components/FExpand/index.ts

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FExpandablePanel/FExpandablePanel.vue?vue&type=template&id=0648b26c&
var FExpandablePanelvue_type_template_id_0648b26c_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"expandable-panel",class:_vm.expandedClass},[_c(_vm.headerTag,{tag:"component",staticClass:"expandable-panel__heading"},[_c('button',_vm._g(_vm._b({attrs:{"type":"button","aria-expanded":String(_vm.expanded),"aria-controls":_vm.id},on:{"click":_vm.onClickHeadingButton}},'button',_vm.attrs,false),_vm.listeners),[_c('span',{staticClass:"expandable-panel__icon"},[_c('span',{staticClass:"icon-stack"},[_c('f-icon',{attrs:{"name":"dash"}}),_vm._v(" "),_c('f-icon',{attrs:{"name":"dash"}})],1)]),_vm._v(" "),_vm._t("title"),_vm._v(" "),(_vm.haveNotifications)?_c('span',{staticClass:"expandable-panel__notification",attrs:{"title":_vm.$t('fkuiExpandablePanelNotificationTitle', _vm.defaultNotificationTitle, { count: _vm.notifications })}},[_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.screenReaderNotificationText))]),_vm._v(" "),_c('f-icon',{attrs:{"name":"bell"}})],1):_vm._e()],2)]),_vm._v(" "),_c('f-expand',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.expanded),expression:"expanded"}],staticClass:"expandable-panel__content",attrs:{"id":_vm.id}},[_c('div',{staticClass:"expandable-panel__body"},[_vm._t("default")],2),_vm._v(" "),(_vm.hasOutsideSlot)?_c('div',{staticClass:"expandable-panel__outside"},[_vm._t("outside")],2):_vm._e()])])],1)}
var FExpandablePanelvue_type_template_id_0648b26c_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/FExpandablePanel/FExpandablePanel.vue?vue&type=template&id=0648b26c&

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FExpandablePanel/FExpandablePanel.vue?vue&type=script&lang=ts&








var FExpandablePanelvue_type_script_lang_ts_assign = undefined && undefined.__assign || function () {
  FExpandablePanelvue_type_script_lang_ts_assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return FExpandablePanelvue_type_script_lang_ts_assign.apply(this, arguments);
};







/**
 * Level: Draft
 */

/* harmony default export */ var FExpandablePanelvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: "FExpandablePanel",
  components: {
    FIcon: FIcon,
    FExpand: FExpand
  },
  mixins: [TranslationMixin],
  inheritAttrs: false,
  props: {
    /**
     * Toggle expanded/collapsed state
     */
    expanded: {
      type: Boolean,
      required: false,
      default: false
    },

    /**
     * Element to render for the header element inside the expandable panel.
     * 'h1', 'h2', 'h3', 'h4', 'h5' and 'h6' is valid.
     */
    headerTag: {
      default: "h2",
      required: false,
      validator: function validator(value) {
        return ["h1", "h2", "h3", "h4", "h5", "h6"].includes(value);
      }
    },

    /**
     * The id for the content id attribute.
     * If the prop is not set the id will be generated.
     */
    id: {
      type: String,
      required: false,
      default: function _default() {
        return logic_["ElementIdService"].generateElementId();
      }
    },

    /**
     * Number of notifications present in panel.
     *
     * If set to zero (default) no notification badge will be displayed.
     */
    notifications: {
      type: Number,
      required: false,
      default: 0
    },
    screenReaderNotificationTemplate: {
      type: String,
      required: false,
      default: "Du har %VALUE% notifieringar."
    }
  },
  computed: {
    attrs: function attrs() {
      return FExpandablePanelvue_type_script_lang_ts_assign({}, this.$attrs);
    },

    /* eslint-disable-next-line @typescript-eslint/ban-types */
    listeners: function listeners() {
      return FExpandablePanelvue_type_script_lang_ts_assign({}, this.$listeners);
    },
    expandedClass: function expandedClass() {
      return this.expanded ? "expandable-panel--expanded" : "expandable-panel--collapsed";
    },
    hasOutsideSlot: function hasOutsideSlot() {
      return hasSlot(this, "outside");
    },
    haveNotifications: function haveNotifications() {
      return this.notifications > 0;
    },
    screenReaderNotificationText: function screenReaderNotificationText() {
      return "".concat(this.screenReaderNotificationTemplate.replace("%VALUE%", this.notifications.toString()));
    },
    defaultNotificationTitle: function defaultNotificationTitle() {
      return "{{ count }} notifiering".concat(this.notifications > 1 ? "ar" : "");
    }
  },
  methods: {
    onClickHeadingButton: function onClickHeadingButton(event) {
      /**
       * Emitted when panel heading is clicked.
       * @type {MouseEvent}
       */
      this.$emit("toggle", event);
    }
  }
}));
// CONCATENATED MODULE: ./src/components/FExpandablePanel/FExpandablePanel.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FExpandablePanel_FExpandablePanelvue_type_script_lang_ts_ = (FExpandablePanelvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FExpandablePanel/FExpandablePanel.vue





/* normalize component */

var FExpandablePanel_component = normalizeComponent(
  FExpandablePanel_FExpandablePanelvue_type_script_lang_ts_,
  FExpandablePanelvue_type_template_id_0648b26c_render,
  FExpandablePanelvue_type_template_id_0648b26c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FExpandablePanel = (FExpandablePanel_component.exports);
// CONCATENATED MODULE: ./src/components/FExpandablePanel/index.ts

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FExpandableParagraph/FExpandableParagraph.vue?vue&type=template&id=cef1f8b2&
var FExpandableParagraphvue_type_template_id_cef1f8b2_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"expandable-paragraph",class:[_vm.expandedClass, _vm.listClass]},[_c('div',{class:_vm.relatedClass},[_c(_vm.headerTag,{tag:"component",staticClass:"expandable-paragraph__heading",class:_vm.headerVisualClass},[_c('button',_vm._g(_vm._b({staticClass:"expandable-paragraph__button",attrs:{"type":"button","aria-expanded":String(_vm.expanded),"aria-controls":_vm.id},on:{"click":_vm.onClickMinimize}},'button',_vm.attrs,false),_vm.listeners),[_c('span',{staticClass:"expandable-paragraph__icon"},[_c('span',{staticClass:"icon-stack"},[_c('f-icon',{attrs:{"name":"dash"}}),_vm._v(" "),_c('f-icon',{attrs:{"name":"dash"}})],1)]),_vm._v(" "),_vm._t("title")],2)]),_vm._v(" "),(_vm.hasRelatedSlot)?_c('div',{staticClass:"expandable-paragraph__related-information"},[_vm._t("related")],2):_vm._e()],1),_vm._v(" "),_c('f-expand',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.expanded),expression:"expanded"}],staticClass:"expandable-paragraph__container",attrs:{"id":_vm.id}},[_c('div',{staticClass:"expandable-paragraph__content"},[_vm._t("default")],2),_vm._v(" "),(!_vm.list)?_c('div',{staticClass:"expandable-paragraph__separator"}):_vm._e()])])],1)}
var FExpandableParagraphvue_type_template_id_cef1f8b2_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/FExpandableParagraph/FExpandableParagraph.vue?vue&type=template&id=cef1f8b2&

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FExpandableParagraph/FExpandableParagraph.vue?vue&type=script&lang=ts&



var FExpandableParagraphvue_type_script_lang_ts_assign = undefined && undefined.__assign || function () {
  FExpandableParagraphvue_type_script_lang_ts_assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return FExpandableParagraphvue_type_script_lang_ts_assign.apply(this, arguments);
};






/**
 * Level: Draft
 */

/* harmony default export */ var FExpandableParagraphvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: "FExpandableParagraph",
  components: {
    FIcon: FIcon,
    FExpand: FExpand
  },
  inheritAttrs: false,
  props: {
    /**
     * Toggle expanded/collapsed state
     */
    expanded: {
      type: Boolean,
      required: false,
      default: false
    },

    /**
     * Element to render for the button elmement
     * 'span', 'h1', 'h2', 'h3', 'h4', 'h5' and 'h6' is valid.
     */
    headerTag: {
      default: "span",
      required: false,
      validator: function validator(value) {
        return ["h1", "h2", "h3", "h4", "h5", "h6", "span"].includes(value);
      }
    },

    /**
     * Visual header size for the button element.
     * 'h1', 'h2', 'h3', 'h4', 'h5' and 'h6' is valid.
     * If not used, the default styling will be h4
     */
    headerVisualTag: {
      type: String,
      default: "",
      required: false,
      validator: function validator(value) {
        return ["", "h1", "h2", "h3", "h4", "h5", "h6"].includes(value);
      }
    },

    /**
     * Toggle list style of component
     */
    list: {
      type: Boolean,
      default: false,
      required: false
    },

    /**
     * The id for the content id attribute.
     * If the prop is not set the id will be generated.
     */
    id: {
      type: String,
      required: false,
      default: function _default() {
        return logic_["ElementIdService"].generateElementId();
      }
    }
  },
  computed: {
    attrs: function attrs() {
      return FExpandableParagraphvue_type_script_lang_ts_assign({}, this.$attrs);
    },

    /* eslint-disable-next-line @typescript-eslint/ban-types */
    listeners: function listeners() {
      return FExpandableParagraphvue_type_script_lang_ts_assign({}, this.$listeners);
    },
    expandedClass: function expandedClass() {
      return this.expanded ? "expandable-paragraph--open" : "expandable-paragraph--closed";
    },
    listClass: function listClass() {
      return this.list ? "expandable-paragraph--list" : "";
    },
    relatedClass: function relatedClass() {
      return this.hasRelatedSlot ? "expandable-paragraph--related-information" : "";
    },
    hasRelatedSlot: function hasRelatedSlot() {
      return hasSlot(this, "related");
    },
    headerVisualClass: function headerVisualClass() {
      return "heading--".concat(this.headerVisualTag || "h4");
    }
  },
  methods: {
    onClickMinimize: function onClickMinimize(event) {
      /**
       * Emitted when heading is clicked.
       * @type {MouseEvent}
       */
      this.$emit("toggle", event);
    }
  }
}));
// CONCATENATED MODULE: ./src/components/FExpandableParagraph/FExpandableParagraph.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FExpandableParagraph_FExpandableParagraphvue_type_script_lang_ts_ = (FExpandableParagraphvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FExpandableParagraph/FExpandableParagraph.vue





/* normalize component */

var FExpandableParagraph_component = normalizeComponent(
  FExpandableParagraph_FExpandableParagraphvue_type_script_lang_ts_,
  FExpandableParagraphvue_type_template_id_cef1f8b2_render,
  FExpandableParagraphvue_type_template_id_cef1f8b2_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FExpandableParagraph = (FExpandableParagraph_component.exports);
// CONCATENATED MODULE: ./src/components/FExpandableParagraph/index.ts

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FFileItem/FFileItem.vue?vue&type=template&id=5398e176&
var FFileItemvue_type_template_id_5398e176_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"file-item"},[_c('div',{staticClass:"file-item__row"},[_c('a',_vm._g(_vm._b({staticClass:"button button--discrete file-item__file-open",attrs:{"type":"button"}},'a',_vm.attrs,false),_vm.listeners),[_c('div',{staticClass:"icon-stack button__icon icon-stack--new-window"},[_c('f-icon',{attrs:{"name":"new-window"}}),_vm._v(" "),_c('f-icon',{attrs:{"name":_vm.iconName}})],1),_vm._v(" "),_c('span',{staticClass:"file-item__file-name"},[_vm._v(_vm._s(_vm.fileName))])]),_vm._v(" "),_vm._t("row")],2),_vm._v(" "),_vm._t("default"),_vm._v(" "),(_vm.isMimeTypeChanged)?_c('div',{staticClass:"file-item__change-info"},[_vm._v(_vm._s(_vm.mimeTypeChangedText))]):_vm._e(),_vm._v(" "),_c('hr',{staticClass:"file-item__separator"})],2)}
var FFileItemvue_type_template_id_5398e176_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/FFileItem/FFileItem.vue?vue&type=template&id=5398e176&

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FFileItem/FFileItem.vue?vue&type=script&lang=ts&






var FFileItemvue_type_script_lang_ts_assign = undefined && undefined.__assign || function () {
  FFileItemvue_type_script_lang_ts_assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return FFileItemvue_type_script_lang_ts_assign.apply(this, arguments);
};





/* default icon used when no mimetype matches */

var DEFAULT_ICON = "file";
/* map mimetype -> icon */

var iconMap = {
  "image/*": "pic",
  "application/msword": "doc",
  "application/pdf": "pdf",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "doc",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.template": "doc"
};
/**
 * Level: Beta
 */

/* harmony default export */ var FFileItemvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: "FFileItem",
  components: {
    FIcon: FIcon
  },
  inheritAttrs: false,
  props: {
    /**
     * The id for the input id attribute.
     * The id for the label for attribute.
     * If the prop is not set a random value will be generated.
     */
    id: {
      type: String,
      required: false,
      default: function _default() {
        return logic_["ElementIdService"].generateElementId();
      }
    },

    /**
     * The file name.
     */
    fileName: {
      type: String,
      required: true
    },

    /**
     * The mime type, can be changed if i.e server change the name.
     */
    mimeType: {
      type: String,
      required: false,
      default: undefined
    },

    /**
     * The name of the file uploaded
     */
    originalMimeType: {
      type: String,
      required: false,
      default: undefined
    },

    /**
     * If file name changed, this info will be displayed, placeholder %before% and %after% will be replaced with originalMimeType and mimeType
     */
    changedMimeTypeText: {
      type: String,
      required: false,
      default: "(%before% ändrad till %after%)"
    }
  },
  computed: {
    attrs: function attrs() {
      return FFileItemvue_type_script_lang_ts_assign(FFileItemvue_type_script_lang_ts_assign({
        target: "_blank"
      }, this.$attrs), {
        id: this.id
      });
    },

    /* eslint-disable-next-line @typescript-eslint/ban-types */
    listeners: function listeners() {
      return FFileItemvue_type_script_lang_ts_assign({}, this.$listeners);
    },
    isMimeTypeChanged: function isMimeTypeChanged() {
      return Object(logic_["isSet"])(this.originalMimeType) && this.originalMimeType !== this.mimeType;
    },
    mimeTypeChangedText: function mimeTypeChangedText() {
      var originalMimeType = (this.originalMimeType || "").split("/").pop() || "";
      var currentMimeType = (this.mimeType || "").split("/").pop() || "";
      var localChangedMimeTypeText = this.changedMimeTypeText;
      return localChangedMimeTypeText.replace("%before%", originalMimeType).replace("%after%", currentMimeType);
    },
    iconName: function iconName() {
      var mimeType = this.mimeType;
      /* use default icon when mimetype is empty/missing */

      if (!mimeType) {
        return DEFAULT_ICON;
      }
      /* search literal match */


      if (iconMap[mimeType]) {
        return iconMap[mimeType];
      }
      /* search with subtype wildcard, e.g. image/* */


      var p = mimeType.split("/", 1);
      var wildcard = [p[0], "*"].join("/");

      if (iconMap[wildcard]) {
        return iconMap[wildcard];
      }
      /* default to file */


      return DEFAULT_ICON;
    }
  }
}));
// CONCATENATED MODULE: ./src/components/FFileItem/FFileItem.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FFileItem_FFileItemvue_type_script_lang_ts_ = (FFileItemvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FFileItem/FFileItem.vue





/* normalize component */

var FFileItem_component = normalizeComponent(
  FFileItem_FFileItemvue_type_script_lang_ts_,
  FFileItemvue_type_template_id_5398e176_render,
  FFileItemvue_type_template_id_5398e176_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FFileItem = (FFileItem_component.exports);
// CONCATENATED MODULE: ./src/components/FFileItem/index.ts

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FFileSelector/FFileSelector.vue?vue&type=template&id=f2f78698&
var FFileSelectorvue_type_template_id_f2f78698_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"file-selector"},[_c('input',_vm._g(_vm._b({ref:"file-selector",attrs:{"type":"file"},on:{"click":_vm.resetFileSelector}},'input',_vm.attrs,false),_vm.listeners)),_vm._v(" "),_c('label',{staticClass:"button button--discrete",class:_vm.labelClass,attrs:{"role":"button","for":_vm.id,"aria-hidden":"true"}},[_c('f-icon',{staticClass:"button__icon",attrs:{"name":"paper-clip"}}),_vm._v(" "),_vm._t("default")],2)])}
var FFileSelectorvue_type_template_id_f2f78698_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/FFileSelector/FFileSelector.vue?vue&type=template&id=f2f78698&

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FFileSelector/FFileSelector.vue?vue&type=script&lang=ts&


var FFileSelectorvue_type_script_lang_ts_assign = undefined && undefined.__assign || function () {
  FFileSelectorvue_type_script_lang_ts_assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return FFileSelectorvue_type_script_lang_ts_assign.apply(this, arguments);
};




/**
 * Level: Beta
 */

/* harmony default export */ var FFileSelectorvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: "FFileSelector",
  components: {
    FIcon: FIcon
  },
  inheritAttrs: false,
  model: {
    prop: "files",
    event: "change"
  },
  props: {
    /**
     * The id for the input id attribute.
     * The id for the label for attribute.
     * If the prop is not set a random value will be generated.
     */
    id: {
      type: String,
      required: false,
      default: function _default() {
        return logic_["ElementIdService"].generateElementId();
      }
    }
  },
  computed: {
    attrs: function attrs() {
      return FFileSelectorvue_type_script_lang_ts_assign(FFileSelectorvue_type_script_lang_ts_assign({}, this.$attrs), {
        id: this.id
      });
    },

    /* eslint-disable-next-line @typescript-eslint/ban-types */
    listeners: function listeners() {
      var _this = this;

      return FFileSelectorvue_type_script_lang_ts_assign(FFileSelectorvue_type_script_lang_ts_assign({}, this.$listeners), {
        change: function change(event) {
          if (event.target instanceof HTMLInputElement) {
            /**
             * V-model event.
             *
             * @event input
             * @type {FileList}
             */
            _this.$emit("change", event.target.files);
          }
        }
      });
    },
    labelClass: function labelClass() {
      return this.attrs["disabled"] ? "disabled" : "enabled";
    },
    labelId: function labelId() {
      return "".concat(this.id, "_label");
    }
  },
  methods: {
    resetFileSelector: function resetFileSelector() {
      var input = this.$refs["file-selector"];
      input.value = "";
    }
  }
}));
// CONCATENATED MODULE: ./src/components/FFileSelector/FFileSelector.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FFileSelector_FFileSelectorvue_type_script_lang_ts_ = (FFileSelectorvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FFileSelector/FFileSelector.vue





/* normalize component */

var FFileSelector_component = normalizeComponent(
  FFileSelector_FFileSelectorvue_type_script_lang_ts_,
  FFileSelectorvue_type_template_id_f2f78698_render,
  FFileSelectorvue_type_template_id_f2f78698_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FFileSelector = (FFileSelector_component.exports);
// CONCATENATED MODULE: ./src/components/FFileSelector/index.ts

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FForm/FForm.vue?vue&type=template&id=45cf243c&
var FFormvue_type_template_id_45cf243c_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',_vm._g(_vm._b({staticClass:"form",attrs:{"novalidate":""},on:{"component-validity":_vm.onComponentValidity}},'form',_vm.attrs,false),_vm.listeners),[(_vm.displayError && _vm.isSubmitted && _vm.hasError)?_c('f-message-box',{attrs:{"tabindex":"-1","type":"error"}},[_vm._t("error-message",null,null,{ slotClass: _vm.errorMessageSlotClass }),_vm._v(" "),_c('nav',[_c('f-error-list',{attrs:{"items":_vm.componentsWithErrors}})],1)],2):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var FFormvue_type_template_id_45cf243c_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/FForm/FForm.vue?vue&type=template&id=45cf243c&

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FMessageBox/FMessageBox.vue?vue&type=template&id=26270186&
var FMessageBoxvue_type_template_id_26270186_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message-box",class:[_vm.messageBoxType, _vm.bannerType]},[_c('span',{staticClass:"message-box__icon"},[_c('span',{staticClass:"icon-stack",class:_vm.stackTypeClass},[_c('f-icon',{class:_vm.classType,attrs:{"name":_vm.symbol}}),_vm._v(" "),_c('f-icon',{class:_vm.classIcon,attrs:{"name":_vm.sign}})],1)]),_vm._v(" "),(_vm.provideScreenReaderContext)?_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.screenReaderContext()))]):_vm._e(),_vm._v(" "),_vm._t("default",null,null,{ headingSlotClass: _vm.headingClass })],2)}
var FMessageBoxvue_type_template_id_26270186_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/FMessageBox/FMessageBox.vue?vue&type=template&id=26270186&

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FMessageBox/FMessageBox.vue?vue&type=script&lang=ts&




var FMessageBoxvue_type_script_lang_ts_iconClasses = {
  success: {
    symbol: "success",
    sign: "",
    screenReaderContextKey: "fkuiMessageBoxScreenReaderContextSuccess",
    screenReaderContextDefault: "Meddelande"
  },
  warning: {
    symbol: "circle",
    sign: "alert",
    screenReaderContextKey: "fkuiMessageBoxScreenReaderContextWarning",
    screenReaderContextDefault: "Varningsmeddelande"
  },
  error: {
    symbol: "triangle",
    sign: "alert",
    screenReaderContextKey: "fkuiMessageBoxScreenReaderContextError",
    screenReaderContextDefault: "Felmeddelande"
  },
  info: {
    symbol: "circle",
    sign: "i",
    screenReaderContextKey: "fkuiMessageBoxScreenReaderContextInfo",
    screenReaderContextDefault: "Informationsmeddelande"
  }
};
/* harmony default export */ var FMessageBoxvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: "FMessageBox",
  components: {
    FIcon: FIcon
  },
  props: {
    /**
     * Type of message-box. 'success', 'error', 'warning' and 'info' is valid.
     * */
    type: {
      type: String,
      required: true,
      validator: function validator(value) {
        // The value must match one of these strings
        return ["success", "warning", "error", "info"].includes(value);
      }
    },

    /**
     * If message-box should be a banner.
     * If prop is not used message-box will have default styling.
     */
    banner: {
      type: Boolean,
      required: false
    },

    /**
     * It is important to provide a context for a screenreader, similar to a modal that initally outputs it is a dialog.
     * Type-specific screenreader context is output by default in this component.
     * By setting this property to false no context will be output.
     * Note that by doing this, it is the applications responsiblity to provide a clear context.
     */
    provideScreenReaderContext: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data: function data() {
    return {
      headingClass: ["message-box__heading"]
    };
  },
  computed: {
    messageBoxType: function messageBoxType() {
      return "message-box--".concat(this.type);
    },
    bannerType: function bannerType() {
      return this.banner ? "message-box--banner" : "";
    },
    classType: function classType() {
      return "icon__".concat(this.type);
    },
    classIcon: function classIcon() {
      return FMessageBoxvue_type_script_lang_ts_iconClasses[this.type].symbol === "circle" && FMessageBoxvue_type_script_lang_ts_iconClasses[this.type].sign === "alert" ? "icon__exclamation" : "";
    },
    stackTypeClass: function stackTypeClass() {
      return "icon-stack--".concat(this.type);
    },
    symbol: function symbol() {
      return FMessageBoxvue_type_script_lang_ts_iconClasses[this.type].symbol;
    },
    sign: function sign() {
      return FMessageBoxvue_type_script_lang_ts_iconClasses[this.type].sign;
    }
  },
  methods: {
    screenReaderContext: function screenReaderContext() {
      return logic_["TranslationService"].provider.translate(FMessageBoxvue_type_script_lang_ts_iconClasses[this.type].screenReaderContextKey, FMessageBoxvue_type_script_lang_ts_iconClasses[this.type].screenReaderContextDefault);
    }
  }
}));
// CONCATENATED MODULE: ./src/components/FMessageBox/FMessageBox.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FMessageBox_FMessageBoxvue_type_script_lang_ts_ = (FMessageBoxvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FMessageBox/FMessageBox.vue





/* normalize component */

var FMessageBox_component = normalizeComponent(
  FMessageBox_FMessageBoxvue_type_script_lang_ts_,
  FMessageBoxvue_type_template_id_26270186_render,
  FMessageBoxvue_type_template_id_26270186_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FMessageBox = (FMessageBox_component.exports);
// CONCATENATED MODULE: ./src/components/FMessageBox/index.ts

// CONCATENATED MODULE: ./src/components/FForm/FFormProvide.ts






var setRef = Symbol("setRef");
var getRef = Symbol("getRef");
var setIsOpen = Symbol("setIsOpen");
function createFFormProvideOptions(vm) {
  var _a;

  var components = vm.components;

  if (Object(logic_["isSet"])(components)) {
    return _a = {}, _a[setRef] = function (id, data) {
      vm.$set(components, id, new logic_["Reference"](data));
    }, _a[getRef] = function (id) {
      return components[id];
    }, _a[setIsOpen] = function (id, isOpen) {
      Object.entries(components).forEach(function (_a) {
        var component = _a[1];
        return component.ref.isOpen = false;
      });
      components[id].ref.isOpen = isOpen;
    }, _a;
  }

  return {};
}
// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FForm/FForm.vue?vue&type=script&lang=ts&















var FFormvue_type_script_lang_ts_assign = undefined && undefined.__assign || function () {
  FFormvue_type_script_lang_ts_assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return FFormvue_type_script_lang_ts_assign.apply(this, arguments);
};

var FFormvue_type_script_lang_ts_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var FFormvue_type_script_lang_ts_generator = undefined && undefined.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};







/* harmony default export */ var FFormvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: "FForm",
  components: {
    FMessageBox: FMessageBox,
    FErrorList: FErrorList
  },
  provide: function provide() {
    return createFFormProvideOptions(this);
  },
  inheritAttrs: false,
  props: {
    /**
     * The id for the form id attribute.
     * If the prop is not set a random value will be generated.
     */
    id: {
      type: String,
      required: false,
      default: function _default() {
        return logic_["ElementIdService"].generateElementId();
      }
    },

    /**
     * If the error-message slot and the invalid elements list
     * should be displayed.
     */
    displayError: {
      type: Boolean,
      default: true
    },

    /**
     * If invalid fields at submit this tells how the scroll to the error
     * field should occur. The default, "center", centres the error information
     * vertically. Allowed value is also "top" which scrolls such that the error
     * informations top is at the top of the viewport.
     */
    errorScroll: {
      type: String,
      default: "center",
      validator: function validator(value) {
        return ["center", "top"].includes(value);
      }
    }
  },
  data: function data() {
    return {
      errorMessageSlotClass: ["message-box__heading"],
      components: {}
    };
  },
  computed: {
    attrs: function attrs() {
      return FFormvue_type_script_lang_ts_assign(FFormvue_type_script_lang_ts_assign({}, this.$attrs), {
        id: this.id
      });
    },

    /* eslint-disable-next-line @typescript-eslint/ban-types */
    listeners: function listeners() {
      var _this = this;
      /* eslint-disable-next-line @typescript-eslint/ban-types */


      var listeners = FFormvue_type_script_lang_ts_assign({}, this.$listeners); // ? Merge submit listeners


      if (listeners.submit) {
        var submit_1 = listeners.submit;

        listeners.submit = function (event) {
          return FFormvue_type_script_lang_ts_awaiter(_this, void 0, void 0, function () {
            var isValid;
            return FFormvue_type_script_lang_ts_generator(this, function (_a) {
              switch (_a.label) {
                case 0:
                  return [4
                  /*yield*/
                  , this.onSubmit(event)];

                case 1:
                  isValid = _a.sent();

                  if (isValid) {
                    if (Array.isArray(submit_1)) {
                      submit_1.forEach(function (submitFunction) {
                        return submitFunction(event);
                      });
                    } else {
                      submit_1(event);
                    }
                  }

                  return [2
                  /*return*/
                  ];
              }
            });
          });
        };
      } else {
        listeners.submit = this.onSubmit;
      }

      return listeners;
    },
    numberOfTimesSubmitted: function numberOfTimesSubmitted() {
      var componentsValues = Object.values(this.components);
      var numberOfTimesSubmittedArray = componentsValues.map(function (component) {
        return component.ref.numberOfTimesSubmitted;
      });
      return componentsValues.length === 0 ? 0 : Math.max.apply(Math, numberOfTimesSubmittedArray);
    },
    isSubmitted: function isSubmitted() {
      return this.numberOfTimesSubmitted > 0;
    },
    hasError: function hasError() {
      if (Object.values(this.components).length === 0) {
        return false;
      } else {
        return Object.values(this.components).some(function (component) {
          return component.ref.isValid === false;
        });
      }
    },
    componentsWithErrors: function componentsWithErrors() {
      var sortedComponents = sortComponentsWithErrorsOnDOMOrder(this.components);
      return sortedComponents.map(function (c) {
        return c.ref;
      });
    },
    needsErrorScroll: function needsErrorScroll() {
      return this.errorScroll !== "center";
    }
  },
  methods: {
    focusDomElement: function focusDomElement() {
      return FFormvue_type_script_lang_ts_awaiter(this, void 0, Promise, function () {
        var messageBoxError;
        return FFormvue_type_script_lang_ts_generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , this.$nextTick()];

            case 1:
              _a.sent();

              messageBoxError = this.$el.querySelector(".message-box--error");

              if (messageBoxError) {
                Object(logic_["focus"])(messageBoxError, {
                  scrollToTop: this.needsErrorScroll
                });
              }

              return [2
              /*return*/
              ];
          }
        });
      });
    },
    focusFallbackElement: function focusFallbackElement() {
      return FFormvue_type_script_lang_ts_awaiter(this, void 0, Promise, function () {
        var element, invalidElement;
        return FFormvue_type_script_lang_ts_generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , this.$nextTick()];

            case 1:
              _a.sent();

              element = this.$el.querySelector(".form-step__header");
              invalidElement = this.$el.querySelector(":invalid");

              if (element) {
                Object(logic_["focus"])(element, {
                  scrollToTop: this.needsErrorScroll
                });
              } else if (invalidElement) {
                Object(logic_["focus"])(invalidElement, {
                  force: true,
                  scrollToTop: this.needsErrorScroll
                });
              }

              return [2
              /*return*/
              ];
          }
        });
      });
    },
    onSubmit: function onSubmit(event) {
      return FFormvue_type_script_lang_ts_awaiter(this, void 0, Promise, function () {
        var _this = this;

        return FFormvue_type_script_lang_ts_generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              event.preventDefault();
              Object.values(this.components).forEach(function (component) {
                _this.$set(component.ref, "numberOfTimesSubmitted", component.ref.numberOfTimesSubmitted + 1);

                if (!isFormStepReference(component)) {
                  logic_["ValidationService"].setTouched(component.ref.id);
                }
              });
              return [4
              /*yield*/
              , cleanUpElements(this)];

            case 1:
              _a.sent();

              return [4
              /*yield*/
              , logic_["ValidationService"].validateAllElements(this.id)];

            case 2:
              _a.sent();

              if (this.displayError) {
                this.focusDomElement();
              } else {
                // ! TODO: Focus on first invalid FormStep error list.
                this.focusFallbackElement();
              }

              return [2
              /*return*/
              , this.hasError === false];
          }
        });
      });
    },
    onComponentValidity: function onComponentValidity(event) {
      return FFormvue_type_script_lang_ts_awaiter(this, void 0, Promise, function () {
        var reference;
        return FFormvue_type_script_lang_ts_generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              reference = new logic_["Reference"]({
                id: event.detail.elementId,
                focusElementId: event.detail.focusElementId,
                title: event.detail.errorMessage,
                isValid: event.detail.isValid,
                numberOfTimesSubmitted: this.numberOfTimesSubmitted
              });
              this.$set(this.components, event.detail.elementId, reference); // required for components not within formsteps

              return [4
              /*yield*/
              , cleanUpElements(this)];

            case 1:
              // required for components not within formsteps
              _a.sent();

              return [2
              /*return*/
              ];
          }
        });
      });
    }
  }
}));
// CONCATENATED MODULE: ./src/components/FForm/FForm.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FForm_FFormvue_type_script_lang_ts_ = (FFormvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FForm/FForm.vue





/* normalize component */

var FForm_component = normalizeComponent(
  FForm_FFormvue_type_script_lang_ts_,
  FFormvue_type_template_id_45cf243c_render,
  FFormvue_type_template_id_45cf243c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FForm = (FForm_component.exports);
// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FForm/FFormStep.vue?vue&type=template&id=9b0e4dd0&
var FFormStepvue_type_template_id_9b0e4dd0_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f-validation-group',_vm._b({key:_vm.validationGroupKey,staticClass:"form-step",attrs:{"stop-propagation":true},model:{value:(_vm.groupValidity),callback:function ($$v) {_vm.groupValidity=$$v},expression:"groupValidity"}},'f-validation-group',_vm.attrs,false),[_c('div',{staticClass:"form-step__header",attrs:{"tabindex":"-1","role":"group"}},[_vm._t("header",null,null,Object.assign({}, {slotClass: _vm.headerSlotClass}, _vm.self.ref, {toggleIsOpen: _vm.toggleIsOpen})),_vm._v(" "),(_vm.self.ref.isValid)?_c('f-icon',{staticClass:"form-step__check",attrs:{"name":"success"}}):_vm._e()],2),_vm._v(" "),(_vm.displayErrorList)?_c('div',{staticClass:"form-step__error",attrs:{"id":_vm.stepErrorId,"tabindex":"-1","role":"group"}},[_c('nav',[_c('f-error-list',{attrs:{"bullets":true,"items":_vm.componentsWithError,"before-navigate":_vm.beforeNavigateToError},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._t("error-message",function(){return [_vm._v("\n                            "+_vm._s(_vm.defaultErrorMessage)+"\n                        ")]})]},proxy:true}],null,true)})],1)]):_vm._e(),_vm._v(" "),_c('div',{on:{"component-validity":_vm.onComponentValidity}},[_vm._t("default",null,null,Object.assign({}, _vm.self.ref, {isSubmitted: _vm.isSubmitted, toggleIsOpen: _vm.toggleIsOpen})),_vm._v(" "),(_vm.hasArrow)?_c('span',{staticClass:"form-step__arrow"}):_vm._e()],2)])}
var FFormStepvue_type_template_id_9b0e4dd0_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/FForm/FFormStep.vue?vue&type=template&id=9b0e4dd0&

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FForm/FFormStep.vue?vue&type=script&lang=ts&












var FFormStepvue_type_script_lang_ts_assign = undefined && undefined.__assign || function () {
  FFormStepvue_type_script_lang_ts_assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return FFormStepvue_type_script_lang_ts_assign.apply(this, arguments);
};

var FFormStepvue_type_script_lang_ts_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var FFormStepvue_type_script_lang_ts_generator = undefined && undefined.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};








/**
 * Level: Beta
 */

/* harmony default export */ var FFormStepvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: "FFormStep",
  components: {
    FIcon: FIcon,
    FValidationGroup: FValidationGroup,
    FErrorList: FErrorList
  },
  mixins: [TranslationMixin],
  inject: {
    setRef: setRef,
    getRef: getRef,
    setIsOpen: setIsOpen
  },
  inheritAttrs: false,
  props: {
    /**
     * The id for the root div id attribute.
     * If the prop is not set a random value will be generated.
     */
    id: {
      type: String,
      required: true,
      default: function _default() {
        return logic_["ElementIdService"].generateElementId();
      }
    },

    /**
     * If the form step should have a bottom arrow.
     * It is recommended to remove the arrow for the last step with `:has-arrow="false"`.
     */
    hasArrow: {
      type: Boolean,
      default: true
    },

    /**
     * If the form step is the last step.
     * If set to true the form step will have a bigger bottom margin.
     */
    isLastStep: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      self: new logic_["Reference"]({
        isOpen: false,
        numberOfTimesSubmitted: 0,
        isAnyFieldTouched: false,
        isValid: true,
        id: this.id,
        focusElementId: "".concat(this.id, "-error"),
        title: ""
      }),
      hasBeenValid: false,
      isOpenedClosed: false,
      headerSlotClass: ["form-step__title"],
      stepErrorId: "".concat(this.id, "-error"),
      groupValidity: {
        isValid: false,
        componentsWithError: [],
        componentCount: 0
      }
    };
  },
  computed: {
    attrs: function attrs() {
      return FFormStepvue_type_script_lang_ts_assign(FFormStepvue_type_script_lang_ts_assign({}, this.$attrs), {
        id: this.id,
        class: {
          "form-step--complete": this.self.ref.isValid,
          "form-step--last-step": this.isLastStep
        }
      });
    },
    defaultErrorMessage: function defaultErrorMessage() {
      return this.$t("fkui.formstep.errorlist.title", "Oj, du har glömt att fylla i något. Gå till:");
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    injected: function injected() {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      return this;
    },
    isSubmitted: function isSubmitted() {
      return this.self.ref.numberOfTimesSubmitted > 0;
    },
    componentsWithError: function componentsWithError() {
      return this.groupValidity.componentsWithError.map(function (c) {
        return {
          id: c.elementId,
          focusElementId: c.focusElementId,
          title: c.errorMessage
        };
      });
    },
    hasError: function hasError() {
      return this.groupValidity.componentsWithError.length > 0;
    },
    displayErrorList: function displayErrorList() {
      return (this.isOpenedClosed || this.hasBeenValid || this.isSubmitted) && this.hasError;
    },
    validationGroupKey: function validationGroupKey() {
      return "".concat(this.id, "-group");
    }
  },
  watch: {
    "self.ref.numberOfTimesSubmitted": {
      handler: function handler() {
        logic_["ValidationService"].setSubmitted(this.$el);
        logic_["ValidationService"].validateAllElements(this.id);
      }
    },
    groupValidity: {
      immediate: true,
      handler: function handler() {
        this.self.ref.isValid = this.groupValidity.isValid;

        if (this.hasBeenValid === false) {
          this.hasBeenValid = this.groupValidity.isValid;
        }
      }
    }
  },
  mounted: function mounted() {
    return FFormStepvue_type_script_lang_ts_awaiter(this, void 0, Promise, function () {
      return FFormStepvue_type_script_lang_ts_generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.$nextTick()];

          case 1:
            _a.sent();

            this.loadSelf();
            this.injected.setRef(this.id, this.self.ref);
            this.loadSelf();
            this.updateSelfRefTitle();
            return [2
            /*return*/
            ];
        }
      });
    });
  },
  beforeUpdate: function beforeUpdate() {
    this.updateSelfRefTitle();
  },
  methods: {
    updateSelfRefTitle: function updateSelfRefTitle() {
      var firstSlotClass = this.headerSlotClass[0];
      var headerElement = this.$el.querySelector(".".concat(firstSlotClass));

      if (headerElement && headerElement.textContent) {
        this.self.ref.title = headerElement.textContent;
      }
    },
    loadSelf: function loadSelf() {
      var ref = this.injected.getRef(this.id);
      Object.assign(this.self, ref);
    },
    focusDomElement: function focusDomElement() {
      return FFormStepvue_type_script_lang_ts_awaiter(this, void 0, Promise, function () {
        var formStepError, formStepHeader;
        return FFormStepvue_type_script_lang_ts_generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , this.$nextTick()];

            case 1:
              _a.sent();

              if (this.hasError && this.self.ref.isAnyFieldTouched) {
                formStepError = this.$el.querySelector(".form-step__error");

                if (formStepError) {
                  Object(logic_["focus"])(formStepError);
                }
              } else {
                formStepHeader = this.$el.querySelector(".form-step__header");

                if (formStepHeader) {
                  Object(logic_["focus"])(formStepHeader);
                }
              }

              return [2
              /*return*/
              ];
          }
        });
      });
    },
    beforeNavigateToError: function beforeNavigateToError() {
      return FFormStepvue_type_script_lang_ts_awaiter(this, void 0, Promise, function () {
        return FFormStepvue_type_script_lang_ts_generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              this.injected.setIsOpen(this.id, true);
              return [4
              /*yield*/
              , this.$nextTick()];

            case 1:
              _a.sent();

              return [2
              /*return*/
              ];
          }
        });
      });
    },

    /**
     * Toggle if open or closed.
     * If another form step is open then it will be closed.
     * @public
     */
    toggleIsOpen: function toggleIsOpen() {
      this.injected.setIsOpen(this.id, !this.self.ref.isOpen); // ? If any field is touched and form step was opened and closed.

      if (this.self.ref.isAnyFieldTouched && this.self.ref.isOpen === false) {
        if (this.isOpenedClosed === false) {
          this.isOpenedClosed = true;
        }

        logic_["ValidationService"].setTouched(this.$el);
        logic_["ValidationService"].validateAllElements(this.id);
      }

      this.focusDomElement();
    },
    onComponentValidity: function onComponentValidity(event) {
      var hasReceivedValidOrErrorEvent = event.detail.validityMode === "VALID" || event.detail.validityMode === "ERROR";

      if (hasReceivedValidOrErrorEvent && this.self.ref.isOpen) {
        this.self.ref.isAnyFieldTouched = true;
      }
    }
  }
}));
// CONCATENATED MODULE: ./src/components/FForm/FFormStep.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FForm_FFormStepvue_type_script_lang_ts_ = (FFormStepvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FForm/FFormStep.vue





/* normalize component */

var FFormStep_component = normalizeComponent(
  FForm_FFormStepvue_type_script_lang_ts_,
  FFormStepvue_type_template_id_9b0e4dd0_render,
  FFormStepvue_type_template_id_9b0e4dd0_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FFormStep = (FFormStep_component.exports);
// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FForm/FFormStepButton.vue?vue&type=template&id=724b08f6&
var FFormStepButtonvue_type_template_id_724b08f6_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g(_vm._b({staticClass:"button button--margin-bottom-0",attrs:{"type":"button","aria-expanded":String(_vm.isOpen),"data-form-step-button":""}},'button',_vm.attrs,false),_vm.$listeners),[(_vm.isOpen)?[_c('f-icon',{staticClass:"button__icon",attrs:{"name":"success"}}),_vm._v("\n        "+_vm._s(_vm.$t("fkuiFormStepButtonClose", "OK"))+"\n    ")]:[_c('f-icon',{staticClass:"button__icon",attrs:{"name":"pen"}}),_vm._v("\n        "+_vm._s(_vm.isAnyFieldTouched ? _vm.$t("fkuiFormStepButtonEdit", "Ändra") : _vm.$t("fkuiFormStepButtonOpen", "Fyll i"))+"\n    ")],_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.additionalScreenreaderText))])],2)}
var FFormStepButtonvue_type_template_id_724b08f6_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/FForm/FFormStepButton.vue?vue&type=template&id=724b08f6&

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FForm/FFormStepButton.vue?vue&type=script&lang=ts&


var FFormStepButtonvue_type_script_lang_ts_assign = undefined && undefined.__assign || function () {
  FFormStepButtonvue_type_script_lang_ts_assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return FFormStepButtonvue_type_script_lang_ts_assign.apply(this, arguments);
};





/**
 * Level: Ready
 */

/* harmony default export */ var FFormStepButtonvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: "FFormStepButton",
  components: {
    FIcon: FIcon
  },
  mixins: [TranslationMixin],
  inheritAttrs: false,
  model: {
    prop: "sr-only"
  },
  props: {
    /**
     * If the id is not set a random value will be generated.
     */
    id: {
      type: String,
      required: false,
      default: function _default() {
        return logic_["ElementIdService"].generateElementId();
      }
    },
    isOpen: Boolean,
    isAnyFieldTouched: Boolean,
    additionalScreenreaderText: {
      type: String,
      required: false,
      default: ""
    }
  },
  computed: {
    attrs: function attrs() {
      return FFormStepButtonvue_type_script_lang_ts_assign(FFormStepButtonvue_type_script_lang_ts_assign({}, this.$attrs), {
        id: this.id
      });
    }
  }
}));
// CONCATENATED MODULE: ./src/components/FForm/FFormStepButton.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FForm_FFormStepButtonvue_type_script_lang_ts_ = (FFormStepButtonvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FForm/FFormStepButton.vue





/* normalize component */

var FFormStepButton_component = normalizeComponent(
  FForm_FFormStepButtonvue_type_script_lang_ts_,
  FFormStepButtonvue_type_template_id_724b08f6_render,
  FFormStepButtonvue_type_template_id_724b08f6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FFormStepButton = (FFormStepButton_component.exports);
// CONCATENATED MODULE: ./src/components/FForm/index.ts





// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FList/FList.vue?vue&type=template&id=7e6d280c&
var FListvue_type_template_id_7e6d280c_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.selectable)?_c('ul',{staticClass:"list",attrs:{"title":_vm.title}},[_vm._l((_vm.items),function(item){return _c('li',{key:_vm.itemKey(item),staticClass:"list__item"},[_c('div',{ref:"listItemPanes",refInFor:true,staticClass:"list__item__itempane"},[_vm._t("default",null,null,{ item: item })],2)])}),_vm._v(" "),(_vm.isEmpty)?_c('li',{staticClass:"list__item"},[_c('div',{staticClass:"list__item__itempane"},[_vm._t("empty",function(){return [_c('em',[_vm._v(_vm._s(_vm.$t("fkuiListEmpty", "Listan är tom")))])]})],2)]):_vm._e()],2):_c('ul',{ref:"ulElement",staticClass:"list list--hover",attrs:{"tabindex":"0","title":_vm.title}},[_vm._l((_vm.items),function(item,index){return _c('li',{key:_vm.itemKey(item),staticClass:"list__item",class:_vm.itemClasses(item),attrs:{"id":_vm.getItemId(item),"aria-labelledby":_vm.getItemId(item),"tabindex":"0"},on:{"keydown":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.onItemKeyDown($event, item)},"focus":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.onItemFocus.apply(null, arguments)},"blur":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.onItemBlur.apply(null, arguments)}}},[_c('div',{staticClass:"list__item__selectpane",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.onSelect(item)}}},[_c('f-checkbox-group-field',{staticClass:"list__item__selectpane__input",attrs:{"value":true,"checked":_vm.isSelected(item)},on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.onSelect(item)}}},[_c('span',{staticClass:"sr-only",attrs:{"id":_vm.getAriaLabelledbyId(item)}},[_vm._t("screenreader",null,null,{ item: item })],2)])],1),_vm._v(" "),_c('div',{ref:"listItemPanes",refInFor:true,staticClass:"list__item__itempane",on:{"click":function($event){return _vm.onItemClick($event, index, item)}}},[_vm._t("default",null,null,{ item: item })],2)])}),_vm._v(" "),(_vm.isEmpty)?_c('li',{staticClass:"list__item"},[_c('div',{staticClass:"list__item__itempane"},[_vm._t("empty",function(){return [_c('em',[_vm._v(_vm._s(_vm.$t("fkuiListEmpty", "Listan är tom")))])]})],2)]):_vm._e()],2)}
var FListvue_type_template_id_7e6d280c_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/FList/FList.vue?vue&type=template&id=7e6d280c&

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FList/FList.vue?vue&type=script&lang=ts&












var FListvue_type_script_lang_ts_Vue = external_commonjs_vue_commonjs2_vue_root_Vue_default.a;
/**
 * Level: Ready
 */

/* harmony default export */ var FListvue_type_script_lang_ts_ = (FListvue_type_script_lang_ts_Vue.extend({
  name: "FList",
  components: {
    FCheckboxGroupField: FCheckboxGroupField
  },
  mixins: [TranslationMixin],
  inject: ActivateItemInjected,
  model: {
    prop: "value",
    event: "update"
  },
  props: {
    /**
     * The items to be listed.
     * The items will be listed in the given array order.
     */
    items: {
      type: Array,
      required: true
    },

    /**
     * Unique attribute in items.
     * V-for directive in vue requires a unique key to
     * be able to optimize reuse of components.
     */
    keyAttribute: {
      type: String,
      required: true
    },

    /**
     * If `true` the list will be selectable.
     * @see 'select' and 'unselect' events.
     */
    selectable: {
      type: Boolean,
      default: false
    },

    /**
     * Set title for accessibility.
     */
    title: {
      type: String,
      required: true
    },

    /**
     * V-model will bind to value containing selected items.
     */
    value: {
      type: Array,
      required: false,
      default: function _default() {
        return undefined;
      }
    },

    /**
     * Unique item id that will be used instead of the automatically generated one.
     */
    elementId: {
      type: String,
      default: function _default() {
        return logic_["ElementIdService"].generateElementId();
      }
    }
  },
  data: function data() {
    return {
      selectedItems: [],
      activeItem: ""
    };
  },
  computed: {
    isEmpty: function isEmpty() {
      return this.items.length === 0;
    },
    ariaActiveDescendant: function ariaActiveDescendant() {
      return this.activeItem ? this.getItemId(this.activeItem) : undefined;
    }
  },
  watch: {
    items: {
      immediate: true,
      handler: function handler() {
        this.updateSelectedItemsFromVModel();
      }
    },
    value: {
      immediate: true,
      handler: function handler() {
        this.updateSelectedItemsFromVModel();
      }
    }
  },
  mounted: function mounted() {
    if (this.selectable) {
      if (!this.$scopedSlots["screenreader"]) {
        throw Error('Slot "screenreader" is required when having "selectable" option.');
      }

      this.registerCallbackAfterItemAdd(this.callbackAfterItemAdd);
      this.registerCallbackBeforeItemDelete(this.callbackBeforeItemDelete);
    }
  },
  methods: {
    getLiElements: function getLiElements() {
      var ulElement = getElementFromVueRef(this.$refs["ulElement"]);
      return Array.from(ulElement.children);
    },
    itemKey: function itemKey(item) {
      var key = item[this.keyAttribute];

      if (typeof key === "undefined") {
        throw new Error("Key attribute [".concat(this.keyAttribute, "]' is missing in item"));
      }

      return key;
    },
    isSelected: function isSelected(item) {
      return includeItem(item, this.selectedItems, this.keyAttribute);
    },
    itemClasses: function itemClasses(item) {
      return {
        "list__item--selected": this.isSelected(item),
        "list__item--active": itemEquals(this.activeItem, item, this.keyAttribute)
      };
    },
    getAriaSelected: function getAriaSelected(item) {
      return String(itemEquals(this.activeItem, item, this.keyAttribute));
    },
    onSelect: function onSelect(item) {
      var _this = this;

      if (includeItem(item, this.selectedItems, this.keyAttribute)) {
        this.selectedItems = this.selectedItems.filter(function (i) {
          return !itemEquals(i, item, _this.keyAttribute);
        });
        /**
         * Emitted when item is unselected.
         *
         * @event unselect
         * @param item
         * @type {ListItem}
         * @param selectedItems
         * @type {ListArray}
         *
         */

        this.$emit("unselect", item);
      } else {
        this.selectedItems.push(item);
        /**
         * Emitted when item is selected.
         *
         * @event select
         * @param item
         * @type {ListItem}
         * @param selectedItems
         * @type {ListArray}
         */

        this.$emit("select", item);
      }

      this.updateVModelWithSelectedItems();
      this.$forceUpdate();
    },
    setActiveItem: function setActiveItem(item) {
      if (!itemEquals(item, this.activeItem, this.keyAttribute)) {
        this.activeItem = item;
        /**
         * Emitted when item is activated, i.e. clicked
         *
         * @event change
         * @param item
         * @type {ListItem}
         */

        this.$emit("change", this.activeItem);
      }
    },
    onItemClick: function onItemClick(event, index, item) {
      this.setActiveItem(item);
    },
    updateVModelWithSelectedItems: function updateVModelWithSelectedItems() {
      if (this.value) {
        /**
         * V-model event to update value properity.
         * @event update
         */
        this.$emit("update", this.selectedItems);
      }
    },
    updateSelectedItemsFromVModel: function updateSelectedItemsFromVModel() {
      var _this = this;

      if (Array.isArray(this.value)) {
        // Remove old selected items that may not exists in items.
        this.selectedItems = this.value.filter(function (item) {
          return includeItem(item, _this.items, _this.keyAttribute);
        });
      } else {
        this.selectedItems = [];
      }
    },

    /* eslint-disable-next-line complexity */
    onItemKeyDown: function onItemKeyDown(event, item) {
      switch (event.key) {
        case "Up":
        case "Down":
        case "ArrowUp":
        case "ArrowDown":
          event.preventDefault();
          handleKeyboardFocusNavigation(event.key, event.target, this.getLiElements());
          break;

        case " ":
        case "Spacebar":
          event.preventDefault();
          this.setActiveItem(item);
          break;
      }
    },
    // Unique id to connect aria-labelledby with readonly label
    getAriaLabelledbyId: function getAriaLabelledbyId(item) {
      return "".concat(this.elementId, "_").concat(this.itemKey(item));
    },
    // Unique id to connect aria-labelledby with readonly label
    getItemId: function getItemId(item) {
      return "".concat(this.elementId, "_item_").concat(this.itemKey(item));
    },
    // Focus effect is done with box-shadow.
    // By setting position to relative the
    // item and box-shadow is drawn with a higher z-index,
    // thus no focus border under other list items.
    onItemFocus: function onItemFocus(event) {
      if (event && event.target) {
        event.target.style.position = "relative";
      }
    },
    onItemBlur: function onItemBlur(event) {
      if (event && event.target) {
        event.target.style.position = "static";
      }
    },
    callbackAfterItemAdd: function callbackAfterItemAdd(item) {
      this.setActiveItem(item);
    },
    callbackBeforeItemDelete: function callbackBeforeItemDelete(item) {
      if (this.items.length === 0) {
        return;
      }

      var targetIndex = this.items.indexOf(item) - 1;

      if (targetIndex < 0 && this.items.length > 1) {
        targetIndex = 1;
      } else if (targetIndex < 0) {
        targetIndex = 0;
      }

      this.setActiveItem(this.items[targetIndex]);

      if (this.getLiElements()[targetIndex]) {
        this.getLiElements()[targetIndex].focus();
      }
    }
  }
}));
// CONCATENATED MODULE: ./src/components/FList/FList.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FList_FListvue_type_script_lang_ts_ = (FListvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FList/FList.vue





/* normalize component */

var FList_component = normalizeComponent(
  FList_FListvue_type_script_lang_ts_,
  FListvue_type_template_id_7e6d280c_render,
  FListvue_type_template_id_7e6d280c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FList = (FList_component.exports);
// CONCATENATED MODULE: ./src/components/FList/index.ts

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FLoader/FLoader.vue?vue&type=template&id=54265dcc&
var FLoadervue_type_template_id_54265dcc_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"loader",class:{ 'loader--overlay': _vm.overlay }},[_c('div',{staticClass:"loader__backdrop"},[_c('div',{staticClass:"loader__wrapper",class:{ 'loader--delay': _vm.delay }},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2)]),_vm._v(" "),_c('div',{staticClass:"loader__wait-text",class:{ 'loader--delay': _vm.delay },attrs:{"tabindex":"-1"}},[_c('span',{attrs:{"role":"alert","aria-live":"assertive"}},[_vm._t("default",function(){return [_vm._v("Vänligen vänta")]})],2)])])])])}
var FLoadervue_type_template_id_54265dcc_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader__spinner-1 loader__spinner"},[_c('div',{staticClass:"loader__spinner-1-circle1 loader__circle loader__circle--1"}),_vm._v(" "),_c('div',{staticClass:"loader__spinner-1-circle2 loader__circle loader__circle--2"}),_vm._v(" "),_c('div',{staticClass:"loader__spinner-1-circle3 loader__circle loader__circle--3"}),_vm._v(" "),_c('div',{staticClass:"loader__spinner-1-circle4 loader__circle loader__circle--4"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader__spinner-2 loader__spinner"},[_c('div',{staticClass:"loader__spinner-2-circle1 loader__circle loader__circle--1"}),_vm._v(" "),_c('div',{staticClass:"loader__spinner-2-circle2 loader__circle loader__circle--2"}),_vm._v(" "),_c('div',{staticClass:"loader__spinner-2-circle3 loader__circle loader__circle--3"}),_vm._v(" "),_c('div',{staticClass:"loader__spinner-2-circle4 loader__circle loader__circle--4"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader__spinner-3 loader__spinner"},[_c('div',{staticClass:"loader__spinner-3-circle1 loader__circle loader__circle--1"}),_vm._v(" "),_c('div',{staticClass:"loader__spinner-3-circle2 loader__circle loader__circle--2"}),_vm._v(" "),_c('div',{staticClass:"loader__spinner-3-circle3 loader__circle loader__circle--3"}),_vm._v(" "),_c('div',{staticClass:"loader__spinner-3-circle4 loader__circle loader__circle--4"})])}]


// CONCATENATED MODULE: ./src/components/FLoader/FLoader.vue?vue&type=template&id=54265dcc&

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FLoader/FLoader.vue?vue&type=script&lang=ts&










var FLoadervue_type_script_lang_ts_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var FLoadervue_type_script_lang_ts_generator = undefined && undefined.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};



/**
 * Level: Produktionsklar
 */

/* harmony default export */ var FLoadervue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: "FLoader",
  inheritAttrs: false,
  props: {
    /* Aria-live must always be visible, hence v-if on component levelis not possible, therefore we use show-prop */

    /**
     * Determine if the loader is visible or not
     */
    show: {
      type: Boolean,
      required: true,
      default: false
    },

    /**
     * Displays a darkgrey overlay behind the loader
     */
    overlay: {
      type: Boolean,
      required: false,
      default: false
    },

    /**
     * Delay the loader icon and text by 1 second
     */
    delay: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      oldFocus: undefined
    };
  },
  watch: {
    show: function show(_show) {
      if (_show) {
        this.openLoader();
      } else {
        this.closeLoader();
      }
    }
  },
  mounted: function mounted() {
    if (this.show) {
      this.openLoader();
    }
  },
  methods: {
    listener: function listener() {
      var _a;

      return FLoadervue_type_script_lang_ts_awaiter(this, void 0, Promise, function () {
        return FLoadervue_type_script_lang_ts_generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , this.$nextTick()];

            case 1:
              _b.sent();

              (_a = this.$el.querySelector(".loader__wait-text")) === null || _a === void 0 ? void 0 : _a.focus();
              return [2
              /*return*/
              ];
          }
        });
      });
    },
    openLoader: function openLoader() {
      return FLoadervue_type_script_lang_ts_awaiter(this, void 0, void 0, function () {
        return FLoadervue_type_script_lang_ts_generator(this, function (_a) {
          if (this.overlay) {
            Object(logic_["saveFocus"])(document);
            this.listener();
            Object(logic_["addFocusListener"])(Object(logic_["findTabbableElements"])(document), this.listener);
          }

          return [2
          /*return*/
          ];
        });
      });
    },
    closeLoader: function closeLoader() {
      if (this.overlay) {
        Object(logic_["removeFocusListener"])(Object(logic_["findTabbableElements"])(document), this.listener);
        Object(logic_["restoreFocus"])();
      }
    }
  }
}));
// CONCATENATED MODULE: ./src/components/FLoader/FLoader.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FLoader_FLoadervue_type_script_lang_ts_ = (FLoadervue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FLoader/FLoader.vue





/* normalize component */

var FLoader_component = normalizeComponent(
  FLoader_FLoadervue_type_script_lang_ts_,
  FLoadervue_type_template_id_54265dcc_render,
  FLoadervue_type_template_id_54265dcc_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FLoader = (FLoader_component.exports);
// CONCATENATED MODULE: ./src/components/FLoader/index.ts

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FOffline/FOffline.vue?vue&type=template&id=3a588392&
var FOfflinevue_type_template_id_3a588392_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"offline__wrapper",attrs:{"role":_vm.role}},[(!_vm.isOnline)?_c('div',{staticClass:"offline"},[_c('span',{staticClass:"offline__icon"},[_c('span',{staticClass:"icon-stack icon-stack--error"},[_c('f-icon',{attrs:{"name":"triangle"}}),_vm._v(" "),_c('f-icon',{attrs:{"name":"alert"}})],1)]),_vm._v(" "),_c('p',{staticClass:"offline__content"},[_vm._t("default",function(){return [_vm._v(" Det verkar som att du inte har någon internetuppkoppling just nu ")]})],2)]):_vm._e(),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isOnline),expression:"isOnline"}],staticClass:"sr-only",attrs:{"aria-hidden":String(_vm.shouldNotRead)}},[_vm._v("Din internetuppkoppling fungerar igen")])])}
var FOfflinevue_type_template_id_3a588392_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/FOffline/FOffline.vue?vue&type=template&id=3a588392&

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FOffline/FOffline.vue?vue&type=script&lang=ts&



var EVENTS = ["online", "offline"];
/**
 * Level: Ready
 */

/* harmony default export */ var FOfflinevue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: "FOffline",
  components: {
    FIcon: FIcon
  },
  data: function data() {
    return {
      isOnline: navigator.onLine || false,
      role: "none",
      shouldNotRead: true
    };
  },
  created: function created() {
    var _this = this;

    EVENTS.forEach(function (event) {
      window.addEventListener(event, _this.updateOnlineStatus);
    });
  },
  beforeDestroy: function beforeDestroy() {
    var _this = this;

    EVENTS.forEach(function (event) {
      window.removeEventListener(event, _this.updateOnlineStatus);
    });
  },
  methods: {
    updateOnlineStatus: function updateOnlineStatus(event) {
      switch (event.type) {
        case "online":
          this.shouldNotRead = false;
          this.isOnline = true;
          break;

        case "offline":
          this.shouldNotRead = true;
          this.isOnline = false;
          break;

        default:
          this.shouldNotRead = true;
          this.isOnline = false;
          break;
      }

      this.role = "alert";
    }
  }
}));
// CONCATENATED MODULE: ./src/components/FOffline/FOffline.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FOffline_FOfflinevue_type_script_lang_ts_ = (FOfflinevue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FOffline/FOffline.vue





/* normalize component */

var FOffline_component = normalizeComponent(
  FOffline_FOfflinevue_type_script_lang_ts_,
  FOfflinevue_type_template_id_3a588392_render,
  FOfflinevue_type_template_id_3a588392_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FOffline = (FOffline_component.exports);
// CONCATENATED MODULE: ./src/components/FOffline/index.ts




function mountFOffline(message) {
  var offlineID = "f-offline-component";
  var fOffline = document.querySelector("#".concat(offlineID));

  if (fOffline) {
    fOffline.remove();
  } // eslint-disable-next-line no-new


  var component = new external_commonjs_vue_commonjs2_vue_root_Vue_default.a({
    components: {
      FOffline: FOffline
    },
    render: function render(createElement) {
      if (Object(logic_["isEmpty"])(message)) {
        return createElement("FOffline", {
          attrs: {
            id: offlineID
          }
        });
      }

      return createElement("FOffline", {
        attrs: {
          id: offlineID
        }
      }, message);
    }
  });
  var bodyElement = document.body;
  var firstChild = bodyElement.firstChild;
  var instance = component.$mount();
  bodyElement.insertBefore(instance.$el, firstChild);
}
// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FOutputField/FOutputField.vue?vue&type=template&id=2671cd42&
var FOutputFieldvue_type_template_id_2671cd42_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"output-field"},[_c('f-label',{attrs:{"for":_vm.id},scopedSlots:_vm._u([{key:"default",fn:function(){return [_vm._t("label")]},proxy:true},{key:"tooltip",fn:function(){return [_vm._t("tooltip")]},proxy:true}],null,true)}),_vm._v(" "),_c('output',_vm._g(_vm._b({staticClass:"output-field__output"},'output',_vm.attrs,false),_vm.$listeners),[_vm._t("default")],2)],1)}
var FOutputFieldvue_type_template_id_2671cd42_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/FOutputField/FOutputField.vue?vue&type=template&id=2671cd42&

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FOutputField/FOutputField.vue?vue&type=script&lang=ts&


var FOutputFieldvue_type_script_lang_ts_assign = undefined && undefined.__assign || function () {
  FOutputFieldvue_type_script_lang_ts_assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return FOutputFieldvue_type_script_lang_ts_assign.apply(this, arguments);
};




/**
 * Level: Beta
 */

/* harmony default export */ var FOutputFieldvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: "FOutputField",
  components: {
    FLabel: FLabel
  },
  inheritAttrs: false,
  props: {
    /**
     * The id for the output id attribute.
     * The id for the label for attribute.
     * If the prop is not set a random value will be generated.
     */
    id: {
      type: String,
      required: false,
      default: function _default() {
        return logic_["ElementIdService"].generateElementId();
      }
    }
  },
  computed: {
    attrs: function attrs() {
      return FOutputFieldvue_type_script_lang_ts_assign(FOutputFieldvue_type_script_lang_ts_assign({}, this.$attrs), {
        id: this.id
      });
    }
  }
}));
// CONCATENATED MODULE: ./src/components/FOutputField/FOutputField.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FOutputField_FOutputFieldvue_type_script_lang_ts_ = (FOutputFieldvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FOutputField/FOutputField.vue





/* normalize component */

var FOutputField_component = normalizeComponent(
  FOutputField_FOutputFieldvue_type_script_lang_ts_,
  FOutputFieldvue_type_template_id_2671cd42_render,
  FOutputFieldvue_type_template_id_2671cd42_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FOutputField = (FOutputField_component.exports);
// CONCATENATED MODULE: ./src/components/FOutputField/index.ts

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FPageHeader/FPageHeader.vue?vue&type=template&id=9af017c8&
var FPageHeadervue_type_template_id_9af017c8_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-header__root"},[(_vm.skipLink)?_c('nav',[_c('i-skip-link',{attrs:{"href":_vm.skipLinkHref}},[_vm._t("skip-link-text")],2)],1):_vm._e(),_vm._v(" "),_c('header',{ref:"header",staticClass:"page-header"},[_c('div',{staticClass:"page-header__logo"},[_vm._t("logo",function(){return [(_vm.hasRouterLink)?_c('router-link',{attrs:{"to":{ name: _vm.routerLinkName, path: _vm.routerLinkPath }}},[_c('span',{class:_vm.logoClass,attrs:{"aria-label":_vm.altLogoText,"role":"img"}})]):_c('span',{class:_vm.logoClass,attrs:{"aria-label":_vm.altLogoText,"role":"img"}})]})],2),_vm._v(" "),_c(_vm.headerTag,{tag:"component",staticClass:"page-header__app-name"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"page-header__right"},[_c('div',{staticClass:"page-header__right-slot"},[_vm._t("right")],2)])],1)])}
var FPageHeadervue_type_template_id_9af017c8_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/FPageHeader/FPageHeader.vue?vue&type=template&id=9af017c8&

// CONCATENATED MODULE: ./src/components/FPageHeader/get-alt-text.ts

function getAltLogoText(hasRouterLink, routerLinkLabel, t) {
  var srStdLogoAltText = t("fkuiPageHeaderLogoAltText", "Försäkringskassan");
  var srStdRouterLinkLabel = t("fkuiPageHeaderRouterLinkLabel", "gå till startsidan");

  if (hasRouterLink && routerLinkLabel !== "") {
    return "".concat(srStdLogoAltText, " ").concat(routerLinkLabel);
  } else if (hasRouterLink) {
    return "".concat(srStdLogoAltText, ", ").concat(srStdRouterLinkLabel);
  } else {
    return srStdLogoAltText;
  }
}
// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FPageHeader/FPageHeader.vue?vue&type=script&lang=ts&





/* harmony default export */ var FPageHeadervue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: "FPageHeader",
  components: {
    ISkipLink: ISkipLink
  },
  mixins: [TranslationMixin],
  inheritAttrs: true,
  props: {
    /** Setting the logo sizes small, large or responsive. */
    logoSize: {
      type: String,
      default: "responsive",
      required: false,
      validator: function validator(value) {
        return ["small", "large", "responsive"].includes(value);
      }
    },

    /**
     * Render skiplink.
     */
    skipLink: {
      type: Boolean,
      required: false,
      default: false
    },

    /**
     * Target for skiplink.
     */
    skipLinkHref: {
      type: String,
      required: false,
      default: "#applicationlayout-main-content"
    },

    /**
     * HTML element type for header.
     */
    headerTag: {
      default: "span",
      required: false,
      validator: function validator(value) {
        return ["span", "h1"].includes(value);
      }
    },

    /**
     *  Target for router-link via path.
     *  (Behaviour from using both name and path in combination is undefined.)
     */
    routerLinkPath: {
      type: String,
      required: false,
      default: ""
    },

    /**
     *  Target for router-link via name.
     *  (Behaviour from using both name and path in combination is undefined.)
     */
    routerLinkName: {
      type: String,
      required: false,
      default: ""
    },

    /**
     *  Label to override the router-link label when router-link is present.
     */
    routerLinkLabel: {
      type: String,
      required: false,
      default: ""
    }
  },
  computed: {
    logoClass: function logoClass() {
      return "page-header__logo--".concat(this.logoSize);
    },
    hasRouterLink: function hasRouterLink() {
      return Boolean(this.routerLinkName || this.routerLinkPath);
    },
    altLogoText: function altLogoText() {
      return getAltLogoText(this.hasRouterLink, this.routerLinkLabel, this.$t);
    }
  }
}));
// CONCATENATED MODULE: ./src/components/FPageHeader/FPageHeader.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FPageHeader_FPageHeadervue_type_script_lang_ts_ = (FPageHeadervue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FPageHeader/FPageHeader.vue





/* normalize component */

var FPageHeader_component = normalizeComponent(
  FPageHeader_FPageHeadervue_type_script_lang_ts_,
  FPageHeadervue_type_template_id_9af017c8_render,
  FPageHeadervue_type_template_id_9af017c8_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FPageHeader = (FPageHeader_component.exports);
// CONCATENATED MODULE: ./src/components/FPageHeader/index.ts

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FProgressbar/FProgressbar.vue?vue&type=template&id=fab116da&
var FProgressbarvue_type_template_id_fab116da_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress"},[_c('span',{staticClass:"progress__meter",class:_vm.progressBarClass,style:(_vm.cssWidth),attrs:{"role":"progressbar","aria-label":_vm.ariaLabel,"aria-valuemin":"0","aria-valuemax":"100","aria-valuenow":_vm.progressValueNow,"aria-valuetext":_vm.progressText}},[_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.progressText))])])])}
var FProgressbarvue_type_template_id_fab116da_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/FProgressbar/FProgressbar.vue?vue&type=template&id=fab116da&

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FProgressbar/FProgressbar.vue?vue&type=script&lang=ts&







var MIN_VALUE = 0;
var MAX_VALUE = 100;

function FProgressbarvue_type_script_lang_ts_clamp(val) {
  return Math.round(Math.min(Math.max(val || 0, MIN_VALUE), MAX_VALUE));
}
/**
 * Level: Beta
 */


/* harmony default export */ var FProgressbarvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: "FProgressbar",
  props: {
    /**
     * Sets the progress. Higher value indicates further progress. Value must be in range 0-100.
     */
    value: {
      type: Number,
      required: true,
      validator: function validator(value) {
        return value >= MIN_VALUE && value <= MAX_VALUE;
      }
    },

    /**
     * Text that the screenreader will read, the actual value will be replaced with %VALUE%  e.g  You have uploaded %VALUE% percent
     */
    valueText: {
      type: String,
      required: false,
      default: "Du har slutfört %VALUE% %."
    },
    ariaLabel: {
      type: String,
      required: true
    }
  },
  computed: {
    progressValueNow: function progressValueNow() {
      return FProgressbarvue_type_script_lang_ts_clamp(this.value);
    },
    isFinished: function isFinished() {
      return this.progressValueNow === MAX_VALUE;
    },
    isInProgress: function isInProgress() {
      return this.progressValueNow > MIN_VALUE && this.progressValueNow < MAX_VALUE;
    },
    isPending: function isPending() {
      return this.progressValueNow === MIN_VALUE;
    },
    cssWidth: function cssWidth() {
      return "width: ".concat(this.progressValueNow, "%");
    },
    progressBarClass: function progressBarClass() {
      return "".concat(this.isInProgress ? "progress__meter--inprogress" : "", " ").concat(this.isPending ? "progress__meter--pending" : "", " ").concat(this.isFinished ? "progress__meter--finished" : "");
    },
    progressText: function progressText() {
      return "".concat(this.valueText.replace("%VALUE%", this.progressValueNow.toString()));
    }
  }
}));
// CONCATENATED MODULE: ./src/components/FProgressbar/FProgressbar.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FProgressbar_FProgressbarvue_type_script_lang_ts_ = (FProgressbarvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FProgressbar/FProgressbar.vue





/* normalize component */

var FProgressbar_component = normalizeComponent(
  FProgressbar_FProgressbarvue_type_script_lang_ts_,
  FProgressbarvue_type_template_id_fab116da_render,
  FProgressbarvue_type_template_id_fab116da_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FProgressbar = (FProgressbar_component.exports);
// CONCATENATED MODULE: ./src/components/FProgressbar/index.ts

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FRadioGroup/FRadioGroupField.vue?vue&type=template&id=94722bf4&
var FRadioGroupFieldvue_type_template_id_94722bf4_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"radio-button",class:_vm.disabledClass,on:{"validity":_vm.onValidity}},[_c('input',_vm._g(_vm._b({staticClass:"radio-button__input",attrs:{"type":"radio"}},'input',_vm.attrs,false),_vm.listeners)),_vm._v(" "),_c('label',{staticClass:"radio-button__label",attrs:{"for":_vm.attrs.id}},[_vm._t("default")],2)])}
var FRadioGroupFieldvue_type_template_id_94722bf4_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/FRadioGroup/FRadioGroupField.vue?vue&type=template&id=94722bf4&

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FRadioGroup/FRadioGroupField.vue?vue&type=script&lang=ts&














var FRadioGroupFieldvue_type_script_lang_ts_assign = undefined && undefined.__assign || function () {
  FRadioGroupFieldvue_type_script_lang_ts_assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return FRadioGroupFieldvue_type_script_lang_ts_assign.apply(this, arguments);
};

var FRadioGroupFieldvue_type_script_lang_ts_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var FRadioGroupFieldvue_type_script_lang_ts_generator = undefined && undefined.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};



 // ! Boolean must be last so that empty string ('') is not parsed as true, see: https://github.com/vuejs/vue/blob/81e1e47cabbd479e2a285f03120944f1efffe749/test/unit/features/options/props.spec.js#L516.

var FRadioGroupFieldvue_type_script_lang_ts_anyType = [String, Object, Array, Number, Date, Boolean];
/* harmony default export */ var FRadioGroupFieldvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: "FRadioGroupField",
  inject: {
    radioGroupName: {
      default: undefined
    },
    getFieldsetLabelText: {
      default: function _default() {
        return "";
      }
    }
  },
  inheritAttrs: false,
  model: {
    prop: "checked",
    event: "change"
  },
  props: {
    /**
     * The id for the input id attribute.
     * The id for the label for attribute.
     * If the prop is not set a random value will be generated.
     */
    id: {
      type: String,
      required: false,
      default: function _default() {
        return logic_["ElementIdService"].generateElementId();
      }
    },

    /**
     * The value for the input checked attribute.
     * @model
     */
    // ? The rule is disabled so that the `checked` prop can be undefined or null.
    // eslint-disable-next-line vue/require-default-prop
    checked: {
      type: FRadioGroupFieldvue_type_script_lang_ts_anyType,
      required: false
    },

    /**
     * The value for the input.
     * @model
     */
    value: {
      type: FRadioGroupFieldvue_type_script_lang_ts_anyType,
      required: true
    }
  },
  data: function data() {
    return {
      validity: {
        validityMode: "INITIAL"
      }
    };
  },
  computed: {
    attrs: function attrs() {
      return FRadioGroupFieldvue_type_script_lang_ts_assign(FRadioGroupFieldvue_type_script_lang_ts_assign({}, this.$attrs), {
        id: this.id,
        value: this.value,
        checked: this.value === this.checked,
        name: this.radioGroupName || this.$attrs.name
      });
    },

    /* eslint-disable-next-line @typescript-eslint/ban-types */
    listeners: function listeners() {
      var _this = this;

      return FRadioGroupFieldvue_type_script_lang_ts_assign(FRadioGroupFieldvue_type_script_lang_ts_assign({}, this.$listeners), {
        change: function change(event) {
          if (event.target instanceof HTMLInputElement) {
            /**
             * V-model event.
             *
             * @event change
             * @type {anyType}
             */
            _this.$emit("change", _this.value);
          }
        },
        input: function input(event) {
          // ? Force focus on Mac + Safari
          event.target.focus();
        }
      });
    },
    disabledClass: function disabledClass() {
      var disabled = this.$attrs.disabled;
      return Object(logic_["isSet"])(disabled) && disabled !== false ? "disabled" : "";
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    injected: function injected() {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      return this;
    }
  },
  methods: {
    onValidity: function onValidity(_a) {
      var detail = _a.detail;
      return FRadioGroupFieldvue_type_script_lang_ts_awaiter(this, void 0, Promise, function () {
        var errorMessage, labelText, element;
        return FRadioGroupFieldvue_type_script_lang_ts_generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              if (detail.target !== this.$el.querySelector("input")) {
                return [2
                /*return*/
                ];
              }

              this.$set(this, "validity", detail);
              return [4
              /*yield*/
              , this.$nextTick()];

            case 1:
              _b.sent();

              errorMessage = "";

              if (this.$scopedSlots.default) {
                labelText = this.injected.getFieldsetLabelText();

                if (labelText) {
                  errorMessage = "".concat(labelText, " ").concat(getTextFromScopedSlot(this.$scopedSlots.default));
                } else {
                  errorMessage = "".concat(getTextFromScopedSlot(this.$scopedSlots.default));
                }
              }

              element = this.$el.querySelector("#".concat(detail.elementId));

              if (element) {
                dispatchComponentValidityEvent(element, FRadioGroupFieldvue_type_script_lang_ts_assign(FRadioGroupFieldvue_type_script_lang_ts_assign({}, detail), {
                  errorMessage: errorMessage,
                  focusElementId: detail.elementId
                }));
              }

              return [2
              /*return*/
              ];
          }
        });
      });
    }
  }
}));
// CONCATENATED MODULE: ./src/components/FRadioGroup/FRadioGroupField.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FRadioGroup_FRadioGroupFieldvue_type_script_lang_ts_ = (FRadioGroupFieldvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FRadioGroup/FRadioGroupField.vue





/* normalize component */

var FRadioGroupField_component = normalizeComponent(
  FRadioGroup_FRadioGroupFieldvue_type_script_lang_ts_,
  FRadioGroupFieldvue_type_template_id_94722bf4_render,
  FRadioGroupFieldvue_type_template_id_94722bf4_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FRadioGroupField = (FRadioGroupField_component.exports);
// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FRadioGroup/FRadioGroup.vue?vue&type=template&id=60c7da0c&
var FRadioGroupvue_type_template_id_60c7da0c_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f-fieldset',_vm._g(_vm._b({class:_vm.fieldsetClass,attrs:{"label-class":"radio-button-group__label","content-class":"radio-button-group__content"},scopedSlots:_vm._u([{key:"label",fn:function(){return [_vm._t("label")]},proxy:true},{key:"tooltip",fn:function(){return [_vm._t("tooltip")]},proxy:true},{key:"description",fn:function(ref){
var descriptionClass = ref.descriptionClass;
var discreteDescriptionClass = ref.discreteDescriptionClass;
return [_vm._t("description",null,null,{ descriptionClass: descriptionClass, discreteDescriptionClass: discreteDescriptionClass })]}},{key:"error-message",fn:function(){return [_vm._t("error-message")]},proxy:true}],null,true)},'f-fieldset',_vm.attrs,false),_vm.$listeners),[_vm._v(" "),_vm._v(" "),_vm._v(" "),_vm._v(" "),_vm._t("default",null,null,{ indentClass: _vm.indentClass })],2)}
var FRadioGroupvue_type_template_id_60c7da0c_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/FRadioGroup/FRadioGroup.vue?vue&type=template&id=60c7da0c&

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FRadioGroup/FRadioGroup.vue?vue&type=script&lang=ts&



var FRadioGroupvue_type_script_lang_ts_assign = undefined && undefined.__assign || function () {
  FRadioGroupvue_type_script_lang_ts_assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return FRadioGroupvue_type_script_lang_ts_assign.apply(this, arguments);
};




/* harmony default export */ var FRadioGroupvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: "FRadioGroup",
  components: {
    FFieldset: FFieldset
  },
  provide: function provide() {
    return {
      radioGroupName: this.name
    };
  },
  inheritAttrs: false,
  props: {
    /**
     * The id for the fieldset id attribute.
     * If the prop is not set the id will be generated.
     */
    id: {
      type: String,
      required: false,
      default: function _default() {
        return logic_["ElementIdService"].generateElementId();
      }
    },

    /**
     * The name of the radio group.
     * The radio group fields in the group will use the same name.
     */
    name: {
      type: String,
      required: true
    },

    /**
     * If radio buttons should be aligned horizontally.
     * If the prop is not set the radio buttons will be aligned vertically.
     * @default false
     */
    isHorizontal: {
      type: Boolean,
      required: false
    }
  },
  data: function data() {
    return {
      indentClass: ["radio-button-group__indent"]
    };
  },
  computed: {
    attrs: function attrs() {
      return FRadioGroupvue_type_script_lang_ts_assign(FRadioGroupvue_type_script_lang_ts_assign({}, this.$attrs), {
        id: this.id,
        name: this.name
      });
    },
    fieldsetClass: function fieldsetClass() {
      return {
        "radio-button-group": true,
        "radio-button-group--horizontal": this.isHorizontal
      };
    }
  }
}));
// CONCATENATED MODULE: ./src/components/FRadioGroup/FRadioGroup.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FRadioGroup_FRadioGroupvue_type_script_lang_ts_ = (FRadioGroupvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FRadioGroup/FRadioGroup.vue





/* normalize component */

var FRadioGroup_component = normalizeComponent(
  FRadioGroup_FRadioGroupvue_type_script_lang_ts_,
  FRadioGroupvue_type_template_id_60c7da0c_render,
  FRadioGroupvue_type_template_id_60c7da0c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FRadioGroup = (FRadioGroup_component.exports);
// CONCATENATED MODULE: ./src/components/FRadioGroup/index.ts


// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FStaticField/FStaticField.vue?vue&type=template&id=4c545c34&
var FStaticFieldvue_type_template_id_4c545c34_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"output-field"},[_c('f-label',{scopedSlots:_vm._u([{key:"default",fn:function(){return [_vm._t("label")]},proxy:true},{key:"tooltip",fn:function(){return [_vm._t("tooltip")]},proxy:true}],null,true)}),_vm._v(" "),_c('p',{staticClass:"output-field__output"},[_vm._t("default")],2)],1)}
var FStaticFieldvue_type_template_id_4c545c34_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/FStaticField/FStaticField.vue?vue&type=template&id=4c545c34&

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FStaticField/FStaticField.vue?vue&type=script&lang=ts&


/**
 * Level: Beta
 */

/* harmony default export */ var FStaticFieldvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: "FStaticField",
  components: {
    FLabel: FLabel
  }
}));
// CONCATENATED MODULE: ./src/components/FStaticField/FStaticField.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FStaticField_FStaticFieldvue_type_script_lang_ts_ = (FStaticFieldvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FStaticField/FStaticField.vue





/* normalize component */

var FStaticField_component = normalizeComponent(
  FStaticField_FStaticFieldvue_type_script_lang_ts_,
  FStaticFieldvue_type_template_id_4c545c34_render,
  FStaticFieldvue_type_template_id_4c545c34_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FStaticField = (FStaticField_component.exports);
// CONCATENATED MODULE: ./src/components/FStaticField/index.ts

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FInteractiveTable/FInteractiveTable.vue?vue&type=template&id=7b6a15e2&
var FInteractiveTablevue_type_template_id_7b6a15e2_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.wrapperClasses},[_c('table',{staticClass:"table",class:_vm.tableClasses,attrs:{"role":"grid","tabindex":"0"}},[(_vm.hasCaption)?_c('caption',[_vm._t("caption")],2):_vm._e(),_vm._v(" "),_c('colgroup',[(_vm.selectable)?_c('col',{staticClass:"table__column--shrink"}):_vm._e(),_vm._v(" "),_vm._l((_vm.columns),function(column){return _c('col',{key:column.index,class:column.size})})],2),_vm._v(" "),_c('thead',[_c('tr',{staticClass:"table__row"},[(_vm.selectable)?_c('th',{attrs:{"scope":"col","role":"columnheader"}},[_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.$t("fkuiTableSelect", "Markera")))])]):_vm._e(),_vm._v(" "),_vm._l((_vm.visibleColumns),function(column){return _c('th',_vm._g({key:column.index,class:_vm.columnClasses(column),attrs:{"role":"columnheader","scope":"col"}},column.sortable ? { click: function () { return _vm.onClickColumnHeader(column); } } : {}),[_c('span',{domProps:{"innerHTML":_vm._s(_vm.escapeNewlines(column.title))}}),_vm._v(" "),(column.sortable)?_c('f-icon',{class:_vm.iconClasses(column),attrs:{"name":_vm.iconName(column)}}):_vm._e(),_vm._v(" "),(column.description)?_c('span',{staticClass:"table__column__description"},[_vm._v(_vm._s(column.description))]):_vm._e()],1)})],2)]),_vm._v(" "),_c('tbody',{ref:"tbodyElement"},[_vm._l((_vm.rows),function(row,index){return _c('tr',{key:_vm.rowKey(row),class:_vm.rowClasses(row),attrs:{"aria-label":_vm.rowDescription(row),"tabindex":"0"},on:{"keydown":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.onKeydown($event, index)},"click":function($event){return _vm.onClick($event, row)}}},[(_vm.selectable)?_c('td',[_c('f-checkbox-group-field',{staticClass:"table__input",attrs:{"value":true,"checked":_vm.isSelected(row)},on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.onSelect(row)}}},[(_vm.hasCheckboxDescription)?_c('span',{staticClass:"sr-only"},[_vm._t("checkbox-description",null,null,{ row: row })],2):_vm._e()])],1):_vm._e(),_vm._v(" "),_vm._t("default",null,null,{ row: row })],2)}),_vm._v(" "),(!_vm.hasInitiateColumns)?_c('tr',[_vm._t("default",null,null,{ row: _vm.emptyRow })],2):_vm._e(),_vm._v(" "),(_vm.isEmpty)?[_c('tr',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"hidden":""}},[_vm._t("default",null,null,{ row: _vm.emptyRow })],2),_vm._v(" "),_c('tr',[_c('td',{staticClass:"table__column table__column--action",attrs:{"colspan":_vm.nbOfColumns}},[_vm._t("empty",function(){return [_vm._v(_vm._s(_vm.$t("fkuiTableEmpty", "Tabellen är tom")))]})],2)])]:_vm._e()],2)])])}
var FInteractiveTablevue_type_template_id_7b6a15e2_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/FInteractiveTable/FInteractiveTable.vue?vue&type=template&id=7b6a15e2&

// EXTERNAL MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/core-js/modules/es.object.from-entries.js
var es_object_from_entries = __webpack_require__("e8b2");

// CONCATENATED MODULE: ./src/components/FInteractiveTable/FTableKeybindings.ts


var keybindings = Object.fromEntries([["Up", focusTrAbove], ["Down", focusTrBelow], ["ArrowUp", focusTrAbove], ["ArrowDown", focusTrBelow], [" ", activateRow], ["Spacebar", activateRow]]);
function focusTrAbove(current) {
  if (current > 0) {
    this.tr[current - 1].focus();
  } else {
    this.tr[this.tr.length - 1].focus();
  }
}
function focusTrBelow(current) {
  if (current < this.tr.length - 1) {
    this.tr[current + 1].focus();
  } else {
    this.tr[0].focus();
  }
}
function activateRow(current) {
  var row = this.rows[current];
  var element = this.tr[current];
  this.activate(row, element);
}
function FTableKeybindings_onKeydown(event, current) {
  var fn = keybindings[event.key];

  if (fn) {
    event.preventDefault();
    fn.call(this, current);
  }
}
// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FInteractiveTable/FInteractiveTable.vue?vue&type=script&lang=ts&















var FInteractiveTablevue_type_script_lang_ts_assign = undefined && undefined.__assign || function () {
  FInteractiveTablevue_type_script_lang_ts_assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return FInteractiveTablevue_type_script_lang_ts_assign.apply(this, arguments);
};

var FInteractiveTablevue_type_script_lang_ts_spreadArray = undefined && undefined.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};












function forceRepaintIE11(target) {
  if (navigator.userAgent.includes("Trident")) {
    target.style.display = "none";
    target.offsetHeight;
    target.style.removeProperty("display");
  }
}

var FInteractiveTablevue_type_script_lang_ts_Vue = external_commonjs_vue_commonjs2_vue_root_Vue_default.a;
/* harmony default export */ var FInteractiveTablevue_type_script_lang_ts_ = (FInteractiveTablevue_type_script_lang_ts_Vue.extend({
  name: "FInteractiveTable",
  components: {
    FCheckboxGroupField: FCheckboxGroupField,
    FIcon: FIcon
  },
  mixins: [TranslationMixin],
  provide: function provide() {
    var _this = this;

    return {
      addColumn: function addColumn(column) {
        _this.columns = FTableColumnData_addColumn(_this.columns, column);
      },
      setVisibilityColumn: function setVisibilityColumn(id, visible) {
        FTableColumnData_setVisibilityColumn(_this.columns, id, visible);
      },
      cellRole: function cellRole() {
        return "gridcell";
      }
    };
  },
  inject: FInteractiveTablevue_type_script_lang_ts_assign(FInteractiveTablevue_type_script_lang_ts_assign({}, FSortFilterDatasetInjected), ActivateItemInjected),
  inheritAttrs: false,
  model: {
    prop: "value",
    event: "update"
  },
  props: {
    /**
     * Need an emptyRow in order to display headers if rows prop is empty.
     * This prop will be used for setting up headers if complex objects are being used, see "RowHeadingExample".
     */
    emptyRow: {
      type: Object,
      default: function _default() {
        return {};
      }
    },

    /**
     * The rows to be listed.
     * The rows will be listed in the given array order.
     */
    rows: {
      type: Array,
      required: true
    },

    /**
     * If `true` hovering over a row will be highlighted
     */
    hover: {
      type: Boolean,
      default: false
    },

    /**
     * Unique attribute in rows.
     */
    keyAttribute: {
      type: String,
      required: true
    },

    /**
     * If `true` the table rows will be selectable.
     * @see 'select' and 'unselect' events.
     */
    selectable: {
      type: Boolean,
      default: false
    },

    /**
     * If `true` alternating rows will use a different background color.
     */
    striped: {
      type: Boolean,
      default: false
    },

    /**
     * Enable scrolling inside table.
     *
     * Can be one of the following values:
     *
     * - `"horizontal"`: Enables horizontal scrolling
     * - `"vertical"`: Enables vertical scrolling
     * - `"both"`: Enables scrolling in both directions
     * - `"none"`: Disables scrolling (default)
     */
    scroll: {
      type: String,
      default: "none",
      validator: function validator(value) {
        var types = Object.values(TableScroll);
        return types.includes(value);
      }
    },

    /**
     * V-model will bind to value containing selected rows.
     */
    value: {
      type: Array,
      required: false,
      default: function _default() {
        return undefined;
      }
    }
  },
  data: function data() {
    return {
      activeRow: null,
      columns: [],
      selectedRows: [],
      tr: []
    };
  },
  computed: {
    hasCaption: function hasCaption() {
      return hasSlot(this, "caption");
    },
    hasCheckboxDescription: function hasCheckboxDescription() {
      var slot = this.$scopedSlots["checkbox-description"];
      return Object(logic_["isSet"])(slot);
    },
    hasInitiateColumns: function hasInitiateColumns() {
      return this.columns.length > 0;
    },
    isEmpty: function isEmpty() {
      return this.rows.length === 0;
    },
    visibleColumns: function visibleColumns() {
      return this.columns.filter(function (col) {
        return col.visible;
      });
    },
    tableClasses: function tableClasses() {
      var classes = [];

      if (this.selectable) {
        classes.push("table--selectable");
      }

      if (this.hover) {
        classes.push("table--hover");
      }

      if (this.striped) {
        classes.push("table--striped");
      }

      return classes;
    },
    wrapperClasses: function wrapperClasses() {
      return tableScrollClasses(this.scroll);
    },
    nbOfColumns: function nbOfColumns() {
      if (this.selectable) {
        return this.columns.length + 1;
      }

      return this.columns.length;
    }
  },
  watch: {
    rows: {
      immediate: true,
      handler: function handler() {
        var _this = this;

        if (this.value) {
          // Remove old selected rows that may not exists in rows.
          this.selectedRows = this.value.filter(function (row) {
            return includeItem(row, _this.rows, _this.keyAttribute);
          });
        }
      }
    }
  },
  updated: function updated() {
    var tbodyElement = this.$refs["tbodyElement"];
    var trElements = [].slice.call(tbodyElement.children);
    this.tr = trElements;
  },
  mounted: function mounted() {
    try {
      var defaultSlot = this.$scopedSlots["default"];

      if (defaultSlot) {
        defaultSlot({
          row: this.emptyRow
        });
      }
    } catch (error) {
      if (error instanceof Error && error.message.match(/Cannot read.*undefined.*/)) {
        var message = "Table requires \"emptyRow\" prop to be set when using nestled objects in \"FTableColumn\" default slot, see documentation.";
        throw new logic_["DecoratedError"](message, error);
      } else {
        throw error;
      }
    }

    this.registerCallbackOnSort(this.callbackOnSort);
    this.registerCallbackOnMount(this.callbackSortableColumns);
    this.registerCallbackAfterItemAdd(this.callbackAfterItemAdd);
    this.registerCallbackBeforeItemDelete(this.callbackBeforeItemDelete);
  },
  methods: {
    isActive: function isActive(row) {
      return itemEquals(row, this.activeRow, this.keyAttribute);
    },
    isSelected: function isSelected(row) {
      return includeItem(row, this.selectedRows, this.keyAttribute);
    },
    onKeydown: function onKeydown(event, index) {
      FTableKeybindings_onKeydown.call(this, event, index);
    },
    onClick: function onClick(event, row) {
      var target = event.target;
      var isRelevant = ["TD", "TH"].includes(target.nodeName);

      if (isRelevant) {
        /* get <tr> element */
        var parent = target.parentElement;
        this.activate(row, parent);
      }
    },
    activate: function activate(row, tr) {
      if (!itemEquals(row, this.activeRow, this.keyAttribute)) {
        /**
         * Emitted when row is activated.
         *
         * @event change
         * @param row
         * @type {ListItem}
         */
        this.$emit("change", row);
        this.activeRow = row;

        if (tr) {
          /* ie11: force focus on <tr> instead of <td> */
          tr.focus();
          /* ie11 also needs to force repaint or the outline will not
           * be rendered properly */

          var td = tr.children[0];
          forceRepaintIE11(td);
        }
      }
    },
    rowDescription: function rowDescription(row) {
      var slot = this.$scopedSlots["row-description"];
      return renderSlotText(slot, {
        row: row
      });
    },
    onSelect: function onSelect(row) {
      var _this = this;

      if (includeItem(row, this.selectedRows, this.keyAttribute)) {
        this.selectedRows = this.selectedRows.filter(function (i) {
          return !itemEquals(i, row, _this.keyAttribute);
        });
        /**
         * Emitted when row is unselected.
         *
         * @event unselect
         * @param row
         * @type {ListItem}
         */

        this.$emit("unselect", row);
      } else {
        this.selectedRows.push(row);
        /**
         * Emitted when row is selected.
         *
         * @event select
         * @param row
         * @type {ListItem}
         * @param selectedRows
         * @type {ListArray}
         */

        this.$emit("select", row);
      }

      this.updateVModelWithSelectedRows();
      this.$forceUpdate();
    },
    updateVModelWithSelectedRows: function updateVModelWithSelectedRows() {
      if (this.value) {
        /**
         * V-model event to update value properity.
         * @event update
         */
        this.$emit("update", this.selectedRows);
      }
    },
    rowClasses: function rowClasses(row) {
      var active = this.isActive(row) ? ["table__row--active"] : [];
      var selected = this.isSelected(row) ? ["table__row--selected"] : [];
      return FInteractiveTablevue_type_script_lang_ts_spreadArray(FInteractiveTablevue_type_script_lang_ts_spreadArray(["table__row"], active, true), selected, true);
    },
    rowKey: function rowKey(row) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      var key = row[this.keyAttribute];

      if (typeof key === "undefined") {
        throw new Error("Key attribute [".concat(this.keyAttribute, "]' is missing in row"));
      }

      return key;
    },
    columnClasses: function columnClasses(column) {
      var sortable = column.sortable ? ["table__column--sortable"] : [];
      return FInteractiveTablevue_type_script_lang_ts_spreadArray(FInteractiveTablevue_type_script_lang_ts_spreadArray(["table__column", "table__column--".concat(column.type)], sortable, true), [column.size], false);
    },
    iconClasses: function iconClasses(column) {
      return getSortableIconClasses(column);
    },
    iconName: function iconName(column) {
      return getSortableIconName(column);
    },
    onClickColumnHeader: function onClickColumnHeader(column) {
      if (!column.sortable) {
        return;
      }

      var columnName = column.name;

      if (column.sort === FTableColumnSort.DESCENDING) {
        columnName = "";
        column.sort = FTableColumnSort.UNSORTED;
      }

      this.sort(columnName, column.sort !== FTableColumnSort.ASCENDING);
    },
    callbackOnSort: function callbackOnSort(columnName, ascending) {
      updateSortOrder(this.columns, columnName, ascending);
    },
    callbackSortableColumns: function callbackSortableColumns(columnNames) {
      setSortableColumns(this.columns, columnNames);
    },
    callbackAfterItemAdd: function callbackAfterItemAdd(item) {
      this.activate(item, null);
    },
    callbackBeforeItemDelete: function callbackBeforeItemDelete(item) {
      if (this.rows.length === 0) {
        return;
      } // Activate the item above the deleted one if it exists


      var targetIndex = this.rows.indexOf(item) - 1;

      if (targetIndex < 0 && this.rows.length > 1) {
        targetIndex = 1;
      } else if (targetIndex < 0) {
        targetIndex = 0;
      }

      this.activate(this.rows[targetIndex], this.tr[targetIndex]);
    },
    escapeNewlines: function escapeNewlines(value) {
      return value.replace(/\n/g, "<br/>");
    }
  }
}));
// CONCATENATED MODULE: ./src/components/FInteractiveTable/FInteractiveTable.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FInteractiveTable_FInteractiveTablevue_type_script_lang_ts_ = (FInteractiveTablevue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FInteractiveTable/FInteractiveTable.vue





/* normalize component */

var FInteractiveTable_component = normalizeComponent(
  FInteractiveTable_FInteractiveTablevue_type_script_lang_ts_,
  FInteractiveTablevue_type_template_id_7b6a15e2_render,
  FInteractiveTablevue_type_template_id_7b6a15e2_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FInteractiveTable = (FInteractiveTable_component.exports);
// CONCATENATED MODULE: ./src/components/FInteractiveTable/index.ts

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FTextareaField/FTextareaField.vue?vue&type=template&id=7a28b58c&
var FTextareaFieldvue_type_template_id_7a28b58c_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"textarea-field",class:_vm.validityClass},[_c('f-label',{attrs:{"for":_vm.id},scopedSlots:_vm._u([{key:"default",fn:function(){return [_vm._t("default")]},proxy:true},{key:"tooltip",fn:function(){return [_vm._t("tooltip")]},proxy:true},{key:"description",fn:function(ref){
var descriptionClass = ref.descriptionClass;
var discreteDescriptionClass = ref.discreteDescriptionClass;
return [_vm._t("description",null,null,{ descriptionClass: descriptionClass, discreteDescriptionClass: discreteDescriptionClass })]}},{key:"error-message",fn:function(){return [_vm._t("error-message",function(){return [(_vm.hasError)?[_vm._v(_vm._s(_vm.validity.validationMessage))]:_vm._e()]})]},proxy:true}],null,true)}),_vm._v(" "),(_vm.softLimit)?_c('f-label',{attrs:{"for":_vm.id,"aria-live":"polite"},scopedSlots:_vm._u([{key:"description",fn:function(ref){
var descriptionClass = ref.descriptionClass;
return [(_vm.showCharactersLeftWarning)?_c('span',{class:descriptionClass},[_vm._v("\n                    "+_vm._s(_vm.charactersLeftWarningInterpolated)+"\n                ")]):_vm._e()]}}],null,false,3616451302)}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"textarea-field__icon-wrapper"},[_c('textarea',_vm._g(_vm._b({staticClass:"textarea-field__textarea",attrs:{"disabled":_vm.disabled},on:{"validity":_vm.onValidity,"pending-validity":_vm.onPendingValidity}},'textarea',_vm.attrs,false),_vm.listeners)),_vm._v(" "),(_vm.isValid)?_c('f-icon',{staticClass:"textarea-field__icon",class:_vm.scrollbarClass,attrs:{"name":"success"}}):_vm._e()],1)],1)}
var FTextareaFieldvue_type_template_id_7a28b58c_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/FTextareaField/FTextareaField.vue?vue&type=template&id=7a28b58c&

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FTextareaField/FTextareaField.vue?vue&type=script&lang=ts&








var FTextareaFieldvue_type_script_lang_ts_assign = undefined && undefined.__assign || function () {
  FTextareaFieldvue_type_script_lang_ts_assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return FTextareaFieldvue_type_script_lang_ts_assign.apply(this, arguments);
};







/* harmony default export */ var FTextareaFieldvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: "FTextareaField",
  components: {
    FLabel: FLabel,
    FIcon: FIcon
  },
  inheritAttrs: false,
  model: {
    prop: "value",
    event: "input"
  },
  props: {
    /**
     * The id for the input id attribute.
     * The id for the label for attribute.
     * If the prop is not set a random value will be generated.
     */
    id: {
      type: String,
      required: false,
      default: function _default() {
        return logic_["ElementIdService"].generateElementId();
      }
    },

    /**
     * The value for the input.
     * If the prop is not set undefined will be used.
     * @model
     */
    value: {
      type: String,
      required: false,
      default: undefined
    },

    /**
     * The number of characters for when the "characters left" warning should be shown.
     * A value of 100 means that when 100 or less characters is left the warning is shown.
     * If softLimit is used, then maxlength is required.
     * If the prop is not set undefined will be used, which means that no warning will be shown.
     */
    softLimit: {
      type: Number,
      required: false,
      default: undefined
    },

    /**
     * The maximum amount of characters permitted in the textarea.
     * If the prop is not set undefined will be used, which means unlimited.
     */
    maxlength: {
      type: Number,
      required: false,
      default: undefined
    },

    /**
     * The string that should be shown in the "characters left" warning.
     * Must contain the word %charactersLeft% which is used to interpolate the number of characters left into the warning string.
     * If the prop is not set "Antal tecken kvar: %charactersLeft%" will be used.
     */
    charactersLeftWarning: {
      type: String,
      required: false,
      default: "Antal tecken kvar: %charactersLeft%"
    },

    /**
     * Specifies that the component should be disabled, i.e. unusable.
     */
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      validity: {
        validityMode: "INITIAL"
      },
      hasScroll: false
    };
  },
  computed: {
    attrs: function attrs() {
      return FTextareaFieldvue_type_script_lang_ts_assign(FTextareaFieldvue_type_script_lang_ts_assign({
        rows: 4
      }, this.$attrs), {
        id: this.id,
        value: this.value,
        maxlength: this.maxlength
      });
    },

    /* eslint-disable-next-line @typescript-eslint/ban-types */
    listeners: function listeners() {
      var _this = this;

      return FTextareaFieldvue_type_script_lang_ts_assign(FTextareaFieldvue_type_script_lang_ts_assign({}, this.$listeners), {
        input: function input(event) {
          if (event.target instanceof HTMLTextAreaElement) {
            /**
             * V-model event.
             *
             * @event input
             * @type {string}
             */
            _this.$emit("input", event.target.value);

            _this.isTextareaScrollable();
          }
        }
      });
    },
    isValid: function isValid() {
      return this.validity.validityMode === "VALID";
    },
    hasError: function hasError() {
      return this.validity.validityMode === "ERROR";
    },
    validityClass: function validityClass() {
      var _a;

      return _a = {}, _a["textarea-field--valid"] = this.isValid, _a["textarea-field--error"] = this.hasError, _a;
    },
    charactersLeft: function charactersLeft() {
      if (this.value) {
        return this.maxlength - this.value.length;
      } else {
        return this.maxlength;
      }
    },
    showCharactersLeftWarning: function showCharactersLeftWarning() {
      return Object(logic_["isSet"])(this.softLimit) && Object(logic_["isSet"])(this.value) && this.value.length >= this.maxlength - this.softLimit;
    },
    charactersLeftWarningInterpolated: function charactersLeftWarningInterpolated() {
      return "".concat(this.charactersLeftWarning.replace("%charactersLeft%", this.charactersLeft.toString()));
    },
    scrollbarClass: function scrollbarClass() {
      return {
        "textarea-field__icon--scroll": this.hasScroll
      };
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (Object(logic_["isSet"])(this.softLimit) && !Object(logic_["isSet"])(this.maxlength)) {
      throw new Error("You must pass a maxlength");
    }

    window.addEventListener("resize", Object(logic_["debounce"])(function () {
      if (_this.isValid || _this.hasError) {
        _this.isTextareaScrollable();
      }
    }, 200));
  },
  methods: {
    onValidity: function onValidity(_a) {
      var detail = _a.detail;
      this.$set(this, "validity", detail);
      var errorMessage = "";

      if (this.$scopedSlots.default) {
        errorMessage = getTextFromScopedSlot(this.$scopedSlots.default);
      }

      var element = this.$el.querySelector("#".concat(detail.elementId));

      if (element) {
        dispatchComponentValidityEvent(element, FTextareaFieldvue_type_script_lang_ts_assign(FTextareaFieldvue_type_script_lang_ts_assign({}, detail), {
          errorMessage: errorMessage,
          focusElementId: detail.elementId
        }));
      }
    },
    isTextareaScrollable: function isTextareaScrollable() {
      var textAreaField = this.$el.querySelector(".textarea-field__textarea");

      if (textAreaField) {
        this.hasScroll = textAreaField.scrollHeight > textAreaField.clientHeight;
        var hasThinMobileScrollbar = textAreaField.offsetWidth - textAreaField.scrollWidth < 10;

        if (this.hasScroll && hasThinMobileScrollbar) {
          this.hasScroll = false;
        }
      }
    },
    onPendingValidity: function onPendingValidity() {
      this.validity.validityMode = "INITIAL";
    }
  }
}));
// CONCATENATED MODULE: ./src/components/FTextareaField/FTextareaField.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FTextareaField_FTextareaFieldvue_type_script_lang_ts_ = (FTextareaFieldvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FTextareaField/FTextareaField.vue





/* normalize component */

var FTextareaField_component = normalizeComponent(
  FTextareaField_FTextareaFieldvue_type_script_lang_ts_,
  FTextareaFieldvue_type_template_id_7a28b58c_render,
  FTextareaFieldvue_type_template_id_7a28b58c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FTextareaField = (FTextareaField_component.exports);
// CONCATENATED MODULE: ./src/components/FTextareaField/index.ts

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FTooltip/FTooltip.vue?vue&type=template&id=6be2d6ef&
var FTooltipvue_type_template_id_6be2d6ef_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tooltip"},[_c('div',{staticClass:"tooltip__container"},[_c('button',{staticClass:"tooltip__button",attrs:{"type":"button","aria-expanded":String(_vm.isOpen)},on:{"click":_vm.onClickToggle}},[_c('span',{staticClass:"icon-stack icon-stack--tooltip"},[_c('f-icon',{attrs:{"name":"circle"}}),_vm._v(" "),_c('f-icon',{attrs:{"name":"i"}}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.screenReaderText))])],1)]),_vm._v(" "),_c('f-expand',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var height = ref.height;
return [(_vm.isOpen)?_c('div',[_c('div',{staticClass:"tooltip__content-wrapper",attrs:{"tabindex":"-1","aria-hidden":!_vm.isOpen}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isOpen),expression:"isOpen"}],staticClass:"tooltip__arrow tooltip__arrow--animation"}),_vm._v(" "),_c('div',{staticClass:"tooltip__content"},[_c('div',{staticClass:"tooltip__body"},[_c(_vm.headerTag,{tag:"component",staticClass:"tooltip__header"},[_vm._t("header")],2),_vm._v(" "),_vm._t("body")],2),_vm._v(" "),_c('i-flex',{attrs:{"float":"right"}},[_c('i-flex-item',{attrs:{"shrink":""}},[_c('button',{staticClass:"button button--discrete-inverted",attrs:{"type":"button","tabindex":_vm.getTabindexBasedOnSlotHeight(height),"aria-hidden":_vm.isSlotHeightLargerThanViewportHeight(height)},on:{"click":_vm.onClickToggle}},[_c('span',[_vm._v(_vm._s(_vm.closeButtonText))]),_vm._v(" "),_c('f-icon',{staticClass:"button__icon",attrs:{"name":"close"}})],1)])],1)],1),_vm._v(" "),(_vm.isSlotHeightLargerThanViewportHeight(height))?_c('i-flex',{attrs:{"float":"right"}},[_c('i-flex-item',{attrs:{"shrink":""}},[_c('button',{staticClass:"button button--discrete button--discrete--black",attrs:{"type":"button"},on:{"click":_vm.onClickToggle}},[_c('span',[_vm._v(_vm._s(_vm.closeButtonText))]),_vm._v(" "),_c('f-icon',{staticClass:"button__icon",attrs:{"name":"close"}})],1)])],1):_vm._e()],1)]):_vm._e()]}}],null,true)})],1)])}
var FTooltipvue_type_template_id_6be2d6ef_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/FTooltip/FTooltip.vue?vue&type=template&id=6be2d6ef&

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FTooltip/FTooltip.vue?vue&type=script&lang=ts&






/* harmony default export */ var FTooltipvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: "FTooltip",
  components: {
    FExpand: FExpand,
    FIcon: FIcon,
    IFlex: IFlex,
    IFlexItem: IFlexItem
  },
  props: {
    /**
     * Screen reader text for toggle button
     */
    screenReaderText: {
      type: String,
      required: true,
      default: undefined
    },

    /**
     * Close button text
     */
    closeButtonText: {
      type: String,
      required: true
    },

    /**
     * Element to render for the header element inside the tooltip.
     * 'div', 'span', 'h1', 'h2', 'h3', 'h4', 'h5' and 'h6' is valid.
     */
    headerTag: {
      default: "div",
      required: false,
      validator: function validator(value) {
        return ["div", "span", "h1", "h2", "h3", "h4", "h5", "h6"].includes(value);
      }
    }
  },
  data: function data() {
    return {
      isOpen: false
    };
  },
  computed: {
    windowInnerHeight: function windowInnerHeight() {
      return window.innerHeight;
    }
  },
  mounted: function mounted() {
    var _this = this;

    window.addEventListener("resize", function () {
      if (_this.isOpen) {
        _this.positionArrow();
      }
    });
  },
  methods: {
    /**
     * Gets called when the user interacts with the toggle button
     *
     * @private
     */
    onClickToggle: function onClickToggle() {
      var _this = this;

      this.isOpen = !this.isOpen;

      if (!this.isOpen) {
        var button = this.$el.querySelector(".tooltip__button");

        if (button) {
          Object(logic_["focus"])(button);
        }
      }

      this.$nextTick(function () {
        _this.positionArrow();
      });
    },
    positionArrow: function positionArrow() {
      var button = this.$el.querySelector(".tooltip__button");
      var arrow = this.$el.querySelector(".tooltip__arrow");
      var content = this.$el.querySelector(".tooltip__content-wrapper");
      var borderSize = 2;

      if (button && arrow && content) {
        var buttonOffsetLeft = button.offsetLeft - content.offsetLeft;
        var relativeOffset = buttonOffsetLeft - borderSize + button.getBoundingClientRect().width / 2;
        arrow.style.left = "".concat(relativeOffset, "px");
      }
    },
    isSlotHeightLargerThanViewportHeight: function isSlotHeightLargerThanViewportHeight(height) {
      return height > window.innerHeight;
    },
    getTabindexBasedOnSlotHeight: function getTabindexBasedOnSlotHeight(height) {
      return this.isSlotHeightLargerThanViewportHeight(height) ? -1 : false;
    }
  }
}));
// CONCATENATED MODULE: ./src/components/FTooltip/FTooltip.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FTooltip_FTooltipvue_type_script_lang_ts_ = (FTooltipvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FTooltip/FTooltip.vue





/* normalize component */

var FTooltip_component = normalizeComponent(
  FTooltip_FTooltipvue_type_script_lang_ts_,
  FTooltipvue_type_template_id_6be2d6ef_render,
  FTooltipvue_type_template_id_6be2d6ef_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FTooltip = (FTooltip_component.exports);
// CONCATENATED MODULE: ./src/components/FTooltip/index.ts

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FTranslationSelect/FTranslationSelect.vue?vue&type=template&id=55df8513&
var FTranslationSelectvue_type_template_id_55df8513_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f-select-field',{attrs:{"value":_vm.language},on:{"change":_vm.onChangeSetLanguage},scopedSlots:_vm._u([{key:"label",fn:function(){return [_vm._v(" Visningsspråk ")]},proxy:true}])},[_vm._v(" "),_vm._l((_vm.languages),function(lang){return _c('option',{key:lang,domProps:{"value":lang}},[_vm._v(_vm._s(lang))])})],2)}
var FTranslationSelectvue_type_template_id_55df8513_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/FTranslationSelect/FTranslationSelect.vue?vue&type=template&id=55df8513&

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FTranslationSelect/FTranslationSelect.vue?vue&type=script&lang=ts&



var LOCAL_STORAGE_LANGUAGE_KEY = "debugLanguage";
/* harmony default export */ var FTranslationSelectvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: "FTranslationSelect",
  components: {
    FSelectField: FSelectField
  },
  props: {
    /**
     * An array of language codes that should be available to choose from.
     * Default is ['cimode', 'sv'].
     */
    languages: {
      type: Array,
      required: false,
      default: function _default() {
        return ["cimode", "sv"];
      }
    }
  },
  data: function data() {
    return {
      language: logic_["TranslationService"].provider.currentLanguage
    };
  },
  beforeCreate: function beforeCreate() {
    var language = localStorage.getItem(LOCAL_STORAGE_LANGUAGE_KEY) || "sv";
    logic_["TranslationService"].provider.changeLanguage(language);
  },
  mounted: function mounted() {
    this.language = logic_["TranslationService"].provider.currentLanguage;
    this.setLocalStorage();
  },
  methods: {
    setLocalStorage: function setLocalStorage() {
      localStorage.setItem(LOCAL_STORAGE_LANGUAGE_KEY, this.language);
    },
    onChangeSetLanguage: function onChangeSetLanguage(value) {
      logic_["TranslationService"].provider.changeLanguage(value);
      this.language = logic_["TranslationService"].provider.currentLanguage;
      this.setLocalStorage();
      window.location.reload();
    }
  }
}));
// CONCATENATED MODULE: ./src/components/FTranslationSelect/FTranslationSelect.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FTranslationSelect_FTranslationSelectvue_type_script_lang_ts_ = (FTranslationSelectvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FTranslationSelect/FTranslationSelect.vue





/* normalize component */

var FTranslationSelect_component = normalizeComponent(
  FTranslationSelect_FTranslationSelectvue_type_script_lang_ts_,
  FTranslationSelectvue_type_template_id_55df8513_render,
  FTranslationSelectvue_type_template_id_55df8513_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FTranslationSelect = (FTranslationSelect_component.exports);
// CONCATENATED MODULE: ./src/components/FTranslationSelect/index.ts

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FWizard/FWizard.vue?vue&type=template&id=11a941d4&
var FWizardvue_type_template_id_11a941d4_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wizard"},[_vm._t("default")],2)}
var FWizardvue_type_template_id_11a941d4_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/FWizard/FWizard.vue?vue&type=template&id=11a941d4&

// CONCATENATED MODULE: ./src/components/FWizard/FWizardApi.ts







var FWizardApiInjected = ["register", "unregister", "getStepCount", "openStep", "openNext", "cancel", "inheritedProps"];

function reindex(dst) {
  dst.sort(function (a, b) {
    return Object(logic_["documentOrderComparator"])(a.element, b.element);
  });

  for (var i = 0; i < dst.length; i++) {
    dst[i].stepNumber = i + 1;
  }
}
/**
 * Add a step to step list.
 *
 * @internal
 */


function addStep(dst, key, element) {
  var index = dst.findIndex(function (it) {
    return it.key === key;
  });

  if (index >= 0) {
    throw new Error("An FWizardStep with key \"".concat(key.toString(), "\" is already registered, refusing to register multiple steps with same key."));
  }

  var step = {
    key: key,
    element: element,
    stepNumber: -1
    /* updated by reindex() later */
    ,
    isOpen: false,
    currentOpen: -1
  };
  dst.push(step);
  reindex(dst);
  return step;
}
/**
 * Remove a step from step list.
 *
 * @internal
 */

function removeStep(dst, key) {
  var index = dst.findIndex(function (it) {
    return it.key === key;
  });

  if (index >= 0) {
    dst.splice(index, 1);
    reindex(dst);
  }
}
// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FWizard/FWizard.vue?vue&type=script&lang=ts&












var FWizardvue_type_script_lang_ts_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var FWizardvue_type_script_lang_ts_generator = undefined && undefined.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};



var FWizardvue_type_script_lang_ts_Vue = external_commonjs_vue_commonjs2_vue_root_Vue_default.a;
/* harmony default export */ var FWizardvue_type_script_lang_ts_ = (FWizardvue_type_script_lang_ts_Vue.extend({
  name: "FWizard",
  provide: function provide() {
    var wizard = this; // eslint-disable-line consistent-this, @typescript-eslint/no-this-alias

    var inheritedProps = {
      get headerTag() {
        return wizard.headerTag;
      },

      get disableInitialFocus() {
        return wizard.disableInitialFocus;
      }

    };
    return {
      register: this.register,
      unregister: this.unregister,
      getStepCount: this.getStepCount,
      openStep: this.openStep,
      openNext: this.openNext,
      cancel: this.cancel,
      inheritedProps: inheritedProps
    };
  },
  inheritAttrs: true,
  model: {
    event: "change",
    prop: "currentKey"
  },
  props: {
    currentKey: {
      type: String,
      default: null
    },

    /**
     * Element to render for the header element inside the wizard steps.
     */
    headerTag: {
      required: true,
      validator: function validator(value) {
        return ["h1", "h2", "h3", "h4", "h5", "h6"].includes(value);
      }
    },

    /**
     * When the first wizard step is registered, it is opened and focused by default.
     * Set this property to disable that behaviour.
     */
    disableInitialFocus: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      steps: []
    };
  },
  computed: {
    anyOpen: function anyOpen() {
      return Boolean(this.getCurrentOpen());
    }
  },
  watch: {
    currentKey: {
      handler: function handler() {
        var _this = this;

        if (!this.currentKey) {
          return;
        }

        var step = this.steps.find(function (it) {
          return it.key === _this.currentKey;
        });

        if (!step) {
          throw new Error("Failed to open step \"".concat(this.currentKey, "\""));
        }

        if (!step.isOpen) {
          this.openStep(step);
        }
      }
    }
  },
  methods: {
    register: function register(key, element) {
      var step = addStep(this.steps, key, element);

      if (this.currentKey !== null) {
        if (step.key === this.currentKey) {
          this.doOpen(step.stepNumber);
        }
      } else {
        /* open this step if this is the first step being added */
        if (this.steps.length === 1) {
          this.doOpen(step.stepNumber);
        }
      }

      var current = this.getCurrentOpen();
      step.currentOpen = current ? current.stepNumber : -1;
      return step;
    },
    unregister: function unregister(key) {
      removeStep(this.steps, key);
    },
    getStepCount: function getStepCount() {
      return this.steps.length;
    },
    getCurrentOpen: function getCurrentOpen() {
      var _a;

      return (_a = this.steps.find(function (it) {
        return it.isOpen;
      })) !== null && _a !== void 0 ? _a : null;
    },
    openStep: function openStep(step) {
      this.doOpen(step.stepNumber);
    },
    openNext: function openNext(step) {
      return FWizardvue_type_script_lang_ts_awaiter(this, void 0, Promise, function () {
        var current, next;
        return FWizardvue_type_script_lang_ts_generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              current = step.stepNumber;
              next = current + 1;
              if (!(next > this.steps.length)) return [3
              /*break*/
              , 2];
              return [4
              /*yield*/
              , this.doOpen(-1)];

            case 1:
              _a.sent();
              /**
               * Emitted when wizard is finished, i.e.
               * user pressing 'Fortsätt' button in last step.
               */


              this.$emit("completed");
              return [3
              /*break*/
              , 4];

            case 2:
              return [4
              /*yield*/
              , this.doOpen(next)];

            case 3:
              _a.sent();

              _a.label = 4;

            case 4:
              return [2
              /*return*/
              ];
          }
        });
      });
    },
    doOpen: function doOpen(open) {
      return FWizardvue_type_script_lang_ts_awaiter(this, void 0, Promise, function () {
        var stepToClose, _i, _a, step, step;

        return FWizardvue_type_script_lang_ts_generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              stepToClose = this.steps.find(function (it) {
                return it.isOpen;
              });

              if (stepToClose) {
                stepToClose.isOpen = false;
              }
              /**
               * Ensure opened step is closed first with animation
               * before opening next step
               */


              return [4
              /*yield*/
              , this.$nextTick()];

            case 1:
              /**
               * Ensure opened step is closed first with animation
               * before opening next step
               */
              _b.sent();

              for (_i = 0, _a = this.steps; _i < _a.length; _i++) {
                step = _a[_i];
                step.isOpen = step.stepNumber === open;
                step.currentOpen = open;
              }

              if (open >= 0) {
                step = this.steps[open - 1];
                this.$emit("change", step.key);
              } else {
                this.$emit("change", null);
              }

              return [2
              /*return*/
              ];
          }
        });
      });
    },
    cancel: function cancel() {
      /**
       * Emitted when wizard is canceled, i.e.
       * user pressing 'Avbryt' button.
       */
      this.$emit("cancel");
    }
  }
}));
// CONCATENATED MODULE: ./src/components/FWizard/FWizard.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FWizard_FWizardvue_type_script_lang_ts_ = (FWizardvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FWizard/FWizard.vue





/* normalize component */

var FWizard_component = normalizeComponent(
  FWizard_FWizardvue_type_script_lang_ts_,
  FWizardvue_type_template_id_11a941d4_render,
  FWizardvue_type_template_id_11a941d4_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FWizard = (FWizard_component.exports);
// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b23c5ef-vue-loader-template"}!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FWizard/FWizardStep.vue?vue&type=template&id=1a948d26&
var FWizardStepvue_type_template_id_1a948d26_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wizard-step",class:_vm.cssClass,attrs:{"aria-current":_vm.isOpen ? 'step' : undefined}},[_c('div',{ref:"header",staticClass:"wizard-step__header",attrs:{"role":"group","tabindex":"-1"}},[_c('i-flex',[_c('i-flex-item',{attrs:{"align":"bottom","shrink":"","aria-hidden":"true"}},[_c('div',{staticClass:"wizard-step__header__line-up"}),_vm._v(" "),_c('div',{staticClass:"icon-stack"},[_c('f-icon',{attrs:{"name":"circle"}}),_vm._v(" "),_c('f-icon',{attrs:{"name":"success"}}),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.stepNumber))])],1),_vm._v(" "),_c('div',{staticClass:"wizard-step__header__line-down"})]),_vm._v(" "),_c('i-flex-item',{attrs:{"align":"bottom","grow":""}},[(_vm.isOpen)?[_vm._t("step-of",function(){return [_c('span',{staticClass:"wizard-step__header__step-of",attrs:{"aria-hidden":"true"}},[_vm._v(_vm._s(_vm.defaultCurrentStepInformation))])]},null,{ headerClass: 'wizard-step__header__step-of', stepNumber: _vm.stepNumber, totalSteps: _vm.totalSteps })]:_vm._e(),_vm._v(" "),_c('i-flex',{staticClass:"wizard-step__header__title-container"},[_c('i-flex-item',{attrs:{"align":"center"}},[(_vm.showLink)?_c('a',{staticClass:"anchor wizard-step__header__title",attrs:{"aria-expanded":"false","role":"button","href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.open.apply(null, arguments)},"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }$event.preventDefault();return _vm.open.apply(null, arguments)}}},[_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.defaultCurrentStepInformation)+" ")]),_vm._v("\n                            "+_vm._s(_vm.title)+"\n                            "),_c('span',{staticClass:"sr-only"},[_vm._v(" "+_vm._s(_vm.$t("fkui.wizardstep.finishedstep", "Avklarat steg")))])]):_c(_vm.inheritedProps.headerTag,{tag:"component",staticClass:"wizard-step__header__title"},[_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.defaultCurrentStepInformation)+" ")]),_vm._v("\n                            "+_vm._s(_vm.title)+"\n                            "),(_vm.isPending)?_c('span',{staticClass:"sr-only"},[_vm._v("\n                                 "+_vm._s(_vm.$t("fkui.wizardstep.pending", "Inaktivt"))+"\n                            ")]):_vm._e()])],1)],1),_vm._v(" "),_c('div',{staticClass:"wizard-step__header__line-adjustment"})],2)],1)],1),_vm._v(" "),_c('i-animate-expand',{key:_vm.animationId,staticClass:"wizard-step__connector",attrs:{"opacity":false,"expanded":_vm.isOpen,"before-animation":_vm.beforeAnimation,"after-animation":_vm.afterAnimation}},[_c('i-validation-form',{staticClass:"wizard-step-body",attrs:{"id":_vm.formId,"before-submit":_vm.beforeNext,"use-error-list":_vm.useErrorList},on:{"submit":_vm.onSubmit},scopedSlots:_vm._u([{key:"error-message",fn:function(){return [_vm._t("error-message",function(){return [_vm._v("\n                    "+_vm._s(_vm.$t("fkui.wizardstep.errorlist.title", "Oj, du har glömt att fylla i något. Gå till:"))+"\n                ")]})]},proxy:true},{key:"default",fn:function(){return [_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"button-group"},[_c('button',{staticClass:"button button--primary button-group__item",attrs:{"data-test":"submit-button","data-disabled":_vm.ignoreClick ? 'true' : 'false',"type":"submit"}},[_vm._t("next-button-text",function(){return [(_vm.isFinalStep)?[_vm._v("\n                                "+_vm._s(_vm.$t("fkui.wizardstep.nextbutton.finaltext", "Gå vidare och granska"))+"\n                            ")]:[_vm._v("\n                                "+_vm._s(_vm.$t("fkui.wizardstep.nextbutton.text", "Fortsätt"))+"\n                                "),_c('span',{staticClass:"sr-only"},[_vm._v("\n                                     "+_vm._s(_vm.$t("fkui.wizardstep.nextbutton.srtext", "till nästa steg"))+"\n                                ")])]]})],2),_vm._v(" "),_c('button',{staticClass:"button button--secondary button-group__item",attrs:{"data-test":"cancel-button","type":"button"},on:{"click":_vm.onCancel}},[_vm._v("\n                        Avbryt\n                    ")])])]},proxy:true}],null,true)})],1)],1)}
var FWizardStepvue_type_template_id_1a948d26_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/FWizard/FWizardStep.vue?vue&type=template&id=1a948d26&

// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--14-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/babel-loader/lib!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-2!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/cache-loader/dist/cjs.js??ref--1-0!/ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/vue-loader/lib??vue-loader-options!./src/components/FWizard/FWizardStep.vue?vue&type=script&lang=ts&










var FWizardStepvue_type_script_lang_ts_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var FWizardStepvue_type_script_lang_ts_generator = undefined && undefined.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};








var SCROLL_DURATION = 500;
var FWizardStepvue_type_script_lang_ts_Vue = external_commonjs_vue_commonjs2_vue_root_Vue_default.a;
/**
 * Shared variable to keep track if another step has
 * initated a scrolling that is ongoing.
 * @see beforeAnimation-method .
 */

var ongoingScrollPromise = undefined;
/* harmony default export */ var FWizardStepvue_type_script_lang_ts_ = (FWizardStepvue_type_script_lang_ts_Vue.extend({
  name: "FWizardStep",
  components: {
    IAnimateExpand: IAnimateExpand,
    IFlex: IFlex,
    IFlexItem: IFlexItem,
    IValidationForm: IValidationForm,
    FIcon: FIcon
  },
  mixins: [TranslationMixin],
  inject: FWizardApiInjected,
  inheritAttrs: true,
  props: {
    title: {
      type: String,
      required: true
    },

    /**
     * Supply this function in order to run actions before navigating to the next step.
     *
     * It is possible to cancel the navigation by returning `BeforeNextAction.CANCEL`.
     * When cancelled, the consumer is responsible to indicate why this happened.
     *
     * Note that `FWizardStep` already checks validity of contained fields using `v-validation`
     * before allowing navigation to the next step.
     */
    beforeNext: {
      type: Function,
      required: false,
      default: function _default() {
        /* do nothing */
      }
    },

    /**
     * Include the error list component.
     */
    useErrorList: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data: function data() {
    return {
      step: {},
      validity: {
        isValid: true,
        componentsWithError: [],
        componentCount: 0
      },
      isOpenedFirstTime: true,
      ignoreClick: false
    };
  },
  computed: {
    defaultCurrentStepInformation: function defaultCurrentStepInformation() {
      return this.$t("fkui.wizardstep.currentstep", "Steg {{ stepNumber }} av {{ totalSteps }}", {
        stepNumber: this.stepNumber,
        totalSteps: this.totalSteps
      });
    },
    formId: function formId() {
      return "".concat(String(this.step.key), "-form");
    },
    animationId: function animationId() {
      return "".concat(String(this.step.key), "-animation");
    },
    isOpen: function isOpen() {
      return this.step.isOpen;
    },
    isPending: function isPending() {
      var _a = this.step,
          currentOpen = _a.currentOpen,
          stepNumber = _a.stepNumber;
      return currentOpen >= 0 && currentOpen < stepNumber;
    },
    isFinalStep: function isFinalStep() {
      return this.stepNumber === this.totalSteps;
    },
    showLink: function showLink() {
      return !this.isOpen && !this.isPending;
    },
    stepNumber: function stepNumber() {
      return this.step.stepNumber;
    },
    totalSteps: function totalSteps() {
      return this.getStepCount();
    },
    cssClass: function cssClass() {
      if (this.isOpen) {
        return "wizard-step--open";
      }

      if (this.isPending) {
        return "wizard-step--pending";
      }

      return "wizard-step--done";
    }
  },
  mounted: function mounted() {
    if (!this.$vnode.key) {
      throw new Error("FWizardStep requires key to be set");
    }

    this.step = this.register(this.$vnode.key, this.$el);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.$vnode.key) {
      this.unregister(this.$vnode.key);
    }
  },
  methods: {
    open: function open() {
      this.openStep(this.step);
    },
    onSubmit: function onSubmit() {
      return FWizardStepvue_type_script_lang_ts_awaiter(this, void 0, Promise, function () {
        return FWizardStepvue_type_script_lang_ts_generator(this, function (_a) {
          if (this.ignoreClick) {
            return [2
            /*return*/
            ];
          }

          this.openNext(this.step);
          return [2
          /*return*/
          ];
        });
      });
    },
    onCancel: function onCancel() {
      /* injected from FWizard */
      this.cancel();
    },

    /**
     * Scroll down before animation starts.
     */
    beforeAnimation: function beforeAnimation(open) {
      return FWizardStepvue_type_script_lang_ts_awaiter(this, void 0, Promise, function () {
        var headerElement;
        return FWizardStepvue_type_script_lang_ts_generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , this.$nextTick()];

            case 1:
              _a.sent();

              this.ignoreClick = true;
              if (!!open) return [3
              /*break*/
              , 4];
              headerElement = getHTMLElementFromVueRef(this.$refs["header"]);
              if (!!logic_["DomUtils"].isVisibleInViewport(headerElement)) return [3
              /*break*/
              , 3];
              ongoingScrollPromise = logic_["DomUtils"].scrollTo(headerElement, {
                duration: SCROLL_DURATION,
                offset: 10
              });
              return [4
              /*yield*/
              , ongoingScrollPromise];

            case 2:
              _a.sent();

              _a.label = 3;

            case 3:
              return [3
              /*break*/
              , 6];

            case 4:
              if (!ongoingScrollPromise) return [3
              /*break*/
              , 6]; // Don't start animation in opening step before the scroll (initiated by closing step) is finished.

              return [4
              /*yield*/
              , ongoingScrollPromise];

            case 5:
              // Don't start animation in opening step before the scroll (initiated by closing step) is finished.
              _a.sent();

              _a.label = 6;

            case 6:
              return [2
              /*return*/
              ];
          }
        });
      });
    },
    afterAnimation: function afterAnimation(open) {
      return FWizardStepvue_type_script_lang_ts_awaiter(this, void 0, Promise, function () {
        var headerElement;
        return FWizardStepvue_type_script_lang_ts_generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              if (!open) {
                return [2
                /*return*/
                ];
              }

              this.ignoreClick = false; // Skip focus once for first step when `disableInitialFocus` is set

              if (this.isOpenedFirstTime) {
                this.isOpenedFirstTime = false;

                if (this.inheritedProps.disableInitialFocus && this.stepNumber === 1) {
                  return [2
                  /*return*/
                  ];
                }
              }

              headerElement = getHTMLElementFromVueRef(this.$refs["header"]);
              return [4
              /*yield*/
              , this.$nextTick()];

            case 1:
              _a.sent();

              if (!!logic_["DomUtils"].isVisibleInViewport(headerElement)) return [3
              /*break*/
              , 3];
              return [4
              /*yield*/
              , logic_["DomUtils"].scrollTo(headerElement, {
                duration: SCROLL_DURATION,
                offset: 10
              })];

            case 2:
              _a.sent();

              _a.label = 3;

            case 3:
              logic_["DomUtils"].focus(headerElement);
              return [2
              /*return*/
              ];
          }
        });
      });
    }
  }
}));
// CONCATENATED MODULE: ./src/components/FWizard/FWizardStep.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FWizard_FWizardStepvue_type_script_lang_ts_ = (FWizardStepvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/FWizard/FWizardStep.vue





/* normalize component */

var FWizardStep_component = normalizeComponent(
  FWizard_FWizardStepvue_type_script_lang_ts_,
  FWizardStepvue_type_template_id_1a948d26_render,
  FWizardStepvue_type_template_id_1a948d26_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FWizardStep = (FWizardStep_component.exports);
// CONCATENATED MODULE: ./src/components/FWizard/action.ts

// CONCATENATED MODULE: ./src/components/FWizard/index.ts



// CONCATENATED MODULE: ./src/components/index.ts



































// CONCATENATED MODULE: ./src/index.ts






// CONCATENATED MODULE: /ci/agent_workspace/workspace/_Sjalvbetjaning_FKUI_fkui_master/node_modules/@vue/cli-service/lib/commands/build/entry-lib-no-default.js




/***/ }),

/***/ "dda8":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__("201b"),
    stubFalse = __webpack_require__("0e30");

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("6984")(module)))

/***/ }),

/***/ "de02":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("70b7");

module.exports = uncurryThis([].slice);


/***/ }),

/***/ "defa":
/***/ (function(module, exports, __webpack_require__) {

var IS_DENO = __webpack_require__("d560");
var IS_NODE = __webpack_require__("f117");

module.exports = !IS_DENO && !IS_NODE
  && typeof window == 'object'
  && typeof document == 'object';


/***/ }),

/***/ "df6f":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("70b7");
var isCallable = __webpack_require__("3ce8");
var store = __webpack_require__("c607");

var functionToString = uncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ "df8c":
/***/ (function(module, exports, __webpack_require__) {

var call = __webpack_require__("b546");
var anObject = __webpack_require__("157c");
var isCallable = __webpack_require__("3ce8");
var classof = __webpack_require__("6a61");
var regexpExec = __webpack_require__("42c5");

var $TypeError = TypeError;

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (isCallable(exec)) {
    var result = call(exec, R, S);
    if (result !== null) anObject(result);
    return result;
  }
  if (classof(R) === 'RegExp') return call(regexpExec, R, S);
  throw $TypeError('RegExp#exec called on incompatible receiver');
};


/***/ }),

/***/ "e03e":
/***/ (function(module, exports, __webpack_require__) {

var userAgent = __webpack_require__("64e4");

module.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent);


/***/ }),

/***/ "e129":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


/***/ }),

/***/ "e29f":
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ "e2e2":
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__("09b2"),
    nativeKeys = __webpack_require__("3ad3");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),

/***/ "e3e5":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("bf10"),
    root = __webpack_require__("201b");

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),

/***/ "e3f6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__("b7fb").charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};


/***/ }),

/***/ "e3f8":
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__("fa8a"),
    Map = __webpack_require__("a9e0"),
    MapCache = __webpack_require__("872c");

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),

/***/ "e437":
/***/ (function(module, exports, __webpack_require__) {

var userAgent = __webpack_require__("64e4");

var firefox = userAgent.match(/firefox\/(\d+)/i);

module.exports = !!firefox && +firefox[1];


/***/ }),

/***/ "e51c":
/***/ (function(module, exports) {

var Queue = function () {
  this.head = null;
  this.tail = null;
};

Queue.prototype = {
  add: function (item) {
    var entry = { item: item, next: null };
    if (this.head) this.tail.next = entry;
    else this.head = entry;
    this.tail = entry;
  },
  get: function () {
    var entry = this.head;
    if (entry) {
      this.head = entry.next;
      if (this.tail === entry) this.tail = null;
      return entry.item;
    }
  }
};

module.exports = Queue;


/***/ }),

/***/ "e556":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("e902");

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ "e672":
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__("daaf"),
    isMasked = __webpack_require__("f6f6"),
    isObject = __webpack_require__("b5061"),
    toSource = __webpack_require__("735f");

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),

/***/ "e697":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("bf10");

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),

/***/ "e7a0":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es-x/no-symbol -- required for testing */
var V8_VERSION = __webpack_require__("4fed");
var fails = __webpack_require__("72df");

// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});


/***/ }),

/***/ "e8b2":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("6b1d");
var iterate = __webpack_require__("b578");
var createProperty = __webpack_require__("dac6");

// `Object.fromEntries` method
// https://github.com/tc39/proposal-object-from-entries
$({ target: 'Object', stat: true }, {
  fromEntries: function fromEntries(iterable) {
    var obj = {};
    iterate(iterable, function (k, v) {
      createProperty(obj, k, v);
    }, { AS_ENTRIES: true });
    return obj;
  }
});


/***/ }),

/***/ "e8e5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $forEach = __webpack_require__("d054").forEach;
var arrayMethodIsStrict = __webpack_require__("7f8a");

var STRICT_METHOD = arrayMethodIsStrict('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
module.exports = !STRICT_METHOD ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es-x/no-array-prototype-foreach -- safe
} : [].forEach;


/***/ }),

/***/ "e902":
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__("a4fc");

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ "e942":
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),

/***/ "e94e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("d4cb");
var global = __webpack_require__("f498");
var uncurryThis = __webpack_require__("70b7");
var isForced = __webpack_require__("ebac");
var defineBuiltIn = __webpack_require__("ef30");
var hasOwn = __webpack_require__("7a25");
var inheritIfRequired = __webpack_require__("8fa9");
var isPrototypeOf = __webpack_require__("fb9b");
var isSymbol = __webpack_require__("cfd1");
var toPrimitive = __webpack_require__("083f");
var fails = __webpack_require__("72df");
var getOwnPropertyNames = __webpack_require__("65d0").f;
var getOwnPropertyDescriptor = __webpack_require__("185a").f;
var defineProperty = __webpack_require__("abdf").f;
var thisNumberValue = __webpack_require__("5ba0");
var trim = __webpack_require__("61ad").trim;

var NUMBER = 'Number';
var NativeNumber = global[NUMBER];
var NumberPrototype = NativeNumber.prototype;
var TypeError = global.TypeError;
var arraySlice = uncurryThis(''.slice);
var charCodeAt = uncurryThis(''.charCodeAt);

// `ToNumeric` abstract operation
// https://tc39.es/ecma262/#sec-tonumeric
var toNumeric = function (value) {
  var primValue = toPrimitive(value, 'number');
  return typeof primValue == 'bigint' ? primValue : toNumber(primValue);
};

// `ToNumber` abstract operation
// https://tc39.es/ecma262/#sec-tonumber
var toNumber = function (argument) {
  var it = toPrimitive(argument, 'number');
  var first, third, radix, maxCode, digits, length, index, code;
  if (isSymbol(it)) throw TypeError('Cannot convert a Symbol value to a number');
  if (typeof it == 'string' && it.length > 2) {
    it = trim(it);
    first = charCodeAt(it, 0);
    if (first === 43 || first === 45) {
      third = charCodeAt(it, 2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (charCodeAt(it, 1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal of /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal of /^0o[0-7]+$/i
        default: return +it;
      }
      digits = arraySlice(it, 2);
      length = digits.length;
      for (index = 0; index < length; index++) {
        code = charCodeAt(digits, index);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

// `Number` constructor
// https://tc39.es/ecma262/#sec-number-constructor
if (isForced(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'))) {
  var NumberWrapper = function Number(value) {
    var n = arguments.length < 1 ? 0 : NativeNumber(toNumeric(value));
    var dummy = this;
    // check on 1..constructor(foo) case
    return isPrototypeOf(NumberPrototype, dummy) && fails(function () { thisNumberValue(dummy); })
      ? inheritIfRequired(Object(n), dummy, NumberWrapper) : n;
  };
  for (var keys = DESCRIPTORS ? getOwnPropertyNames(NativeNumber) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES2015 (in case, if modules with ES2015 Number statics required before):
    'EPSILON,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,isFinite,isInteger,isNaN,isSafeInteger,parseFloat,parseInt,' +
    // ESNext
    'fromString,range'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (hasOwn(NativeNumber, key = keys[j]) && !hasOwn(NumberWrapper, key)) {
      defineProperty(NumberWrapper, key, getOwnPropertyDescriptor(NativeNumber, key));
    }
  }
  NumberWrapper.prototype = NumberPrototype;
  NumberPrototype.constructor = NumberWrapper;
  defineBuiltIn(global, NUMBER, NumberWrapper, { constructor: true });
}


/***/ }),

/***/ "ea26":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("72df");
var createPropertyDescriptor = __webpack_require__("9618");

module.exports = !fails(function () {
  var error = Error('a');
  if (!('stack' in error)) return true;
  // eslint-disable-next-line es-x/no-object-defineproperty -- safe
  Object.defineProperty(error, 'stack', createPropertyDescriptor(1, 7));
  return error.stack !== 7;
});


/***/ }),

/***/ "eba0":
/***/ (function(module, exports, __webpack_require__) {

var call = __webpack_require__("b546");
var isCallable = __webpack_require__("3ce8");
var isObject = __webpack_require__("7526");

var $TypeError = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  throw $TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "ebac":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("72df");
var isCallable = __webpack_require__("3ce8");

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ "ed2b":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("7d53");
var create = __webpack_require__("82e8");
var defineProperty = __webpack_require__("abdf").f;

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  defineProperty(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ "ee58":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es-x/no-object-getownpropertynames -- safe */
var classof = __webpack_require__("6a61");
var toIndexedObject = __webpack_require__("378c");
var $getOwnPropertyNames = __webpack_require__("65d0").f;
var arraySlice = __webpack_require__("d1b2");

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return $getOwnPropertyNames(it);
  } catch (error) {
    return arraySlice(windowNames);
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && classof(it) == 'Window'
    ? getWindowNames(it)
    : $getOwnPropertyNames(toIndexedObject(it));
};


/***/ }),

/***/ "ef14":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("6b1d");
var uncurryThis = __webpack_require__("70b7");
var IndexedObject = __webpack_require__("83a6");
var toIndexedObject = __webpack_require__("378c");
var arrayMethodIsStrict = __webpack_require__("7f8a");

var un$Join = uncurryThis([].join);

var ES3_STRINGS = IndexedObject != Object;
var STRICT_METHOD = arrayMethodIsStrict('join', ',');

// `Array.prototype.join` method
// https://tc39.es/ecma262/#sec-array.prototype.join
$({ target: 'Array', proto: true, forced: ES3_STRINGS || !STRICT_METHOD }, {
  join: function join(separator) {
    return un$Join(toIndexedObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),

/***/ "ef1f":
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__("3cec");
var defineBuiltIn = __webpack_require__("ef30");
var toString = __webpack_require__("5268");

// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  defineBuiltIn(Object.prototype, 'toString', toString, { unsafe: true });
}


/***/ }),

/***/ "ef30":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("3ce8");
var definePropertyModule = __webpack_require__("abdf");
var makeBuiltIn = __webpack_require__("2ce5");
var defineGlobalProperty = __webpack_require__("4499");

module.exports = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable(value)) makeBuiltIn(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};


/***/ }),

/***/ "ef42":
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__("5b4b"),
    stubArray = __webpack_require__("5f84");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),

/***/ "eff8":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("0e19"),
    isLength = __webpack_require__("b742"),
    isObjectLike = __webpack_require__("b4b4");

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ "f117":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("6a61");
var global = __webpack_require__("f498");

module.exports = classof(global.process) == 'process';


/***/ }),

/***/ "f19a":
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ "f297":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("f498");
var NativePromiseConstructor = __webpack_require__("367f");
var isCallable = __webpack_require__("3ce8");
var isForced = __webpack_require__("ebac");
var inspectSource = __webpack_require__("df6f");
var wellKnownSymbol = __webpack_require__("7d53");
var IS_BROWSER = __webpack_require__("defa");
var IS_DENO = __webpack_require__("d560");
var IS_PURE = __webpack_require__("0e93");
var V8_VERSION = __webpack_require__("4fed");

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
var SPECIES = wellKnownSymbol('species');
var SUBCLASSING = false;
var NATIVE_PROMISE_REJECTION_EVENT = isCallable(global.PromiseRejectionEvent);

var FORCED_PROMISE_CONSTRUCTOR = isForced('Promise', function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(NativePromiseConstructor);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(NativePromiseConstructor);
  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions
  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
  // We need Promise#{ catch, finally } in the pure version for preventing prototype pollution
  if (IS_PURE && !(NativePromisePrototype['catch'] && NativePromisePrototype['finally'])) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (!V8_VERSION || V8_VERSION < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
    // Detect correctness of subclassing with @@species support
    var promise = new NativePromiseConstructor(function (resolve) { resolve(1); });
    var FakePromise = function (exec) {
      exec(function () { /* empty */ }, function () { /* empty */ });
    };
    var constructor = promise.constructor = {};
    constructor[SPECIES] = FakePromise;
    SUBCLASSING = promise.then(function () { /* empty */ }) instanceof FakePromise;
    if (!SUBCLASSING) return true;
  // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  } return !GLOBAL_CORE_JS_PROMISE && (IS_BROWSER || IS_DENO) && !NATIVE_PROMISE_REJECTION_EVENT;
});

module.exports = {
  CONSTRUCTOR: FORCED_PROMISE_CONSTRUCTOR,
  REJECTION_EVENT: NATIVE_PROMISE_REJECTION_EVENT,
  SUBCLASSING: SUBCLASSING
};


/***/ }),

/***/ "f2bf":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("f498");
var isObject = __webpack_require__("7526");

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ "f38f":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable no-unused-vars -- required for functions `.length` */
var $ = __webpack_require__("6b1d");
var global = __webpack_require__("f498");
var apply = __webpack_require__("d54f");
var wrapErrorConstructorWithCause = __webpack_require__("8ba6");

var WEB_ASSEMBLY = 'WebAssembly';
var WebAssembly = global[WEB_ASSEMBLY];

var FORCED = Error('e', { cause: 7 }).cause !== 7;

var exportGlobalErrorCauseWrapper = function (ERROR_NAME, wrapper) {
  var O = {};
  O[ERROR_NAME] = wrapErrorConstructorWithCause(ERROR_NAME, wrapper, FORCED);
  $({ global: true, constructor: true, arity: 1, forced: FORCED }, O);
};

var exportWebAssemblyErrorCauseWrapper = function (ERROR_NAME, wrapper) {
  if (WebAssembly && WebAssembly[ERROR_NAME]) {
    var O = {};
    O[ERROR_NAME] = wrapErrorConstructorWithCause(WEB_ASSEMBLY + '.' + ERROR_NAME, wrapper, FORCED);
    $({ target: WEB_ASSEMBLY, stat: true, constructor: true, arity: 1, forced: FORCED }, O);
  }
};

// https://github.com/tc39/proposal-error-cause
exportGlobalErrorCauseWrapper('Error', function (init) {
  return function Error(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('EvalError', function (init) {
  return function EvalError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('RangeError', function (init) {
  return function RangeError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('ReferenceError', function (init) {
  return function ReferenceError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('SyntaxError', function (init) {
  return function SyntaxError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('TypeError', function (init) {
  return function TypeError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('URIError', function (init) {
  return function URIError(message) { return apply(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('CompileError', function (init) {
  return function CompileError(message) { return apply(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('LinkError', function (init) {
  return function LinkError(message) { return apply(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('RuntimeError', function (init) {
  return function RuntimeError(message) { return apply(init, this, arguments); };
});


/***/ }),

/***/ "f3b8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__("b7fb").charAt;
var toString = __webpack_require__("2a3e");
var InternalStateModule = __webpack_require__("cdcd");
var defineIterator = __webpack_require__("2df4");

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: toString(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = charAt(string, index);
  state.index += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ "f3e4":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("3ce8");

var $String = String;
var $TypeError = TypeError;

module.exports = function (argument) {
  if (typeof argument == 'object' || isCallable(argument)) return argument;
  throw $TypeError("Can't set " + $String(argument) + ' as a prototype');
};


/***/ }),

/***/ "f3f8":
/***/ (function(module, exports, __webpack_require__) {

var UA = __webpack_require__("64e4");

module.exports = /MSIE|Trident/.test(UA);


/***/ }),

/***/ "f498":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es-x/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("7d15")))

/***/ }),

/***/ "f522":
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__("24da");

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),

/***/ "f6f6":
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__("dca0");

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),

/***/ "f72d":
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__("daaf"),
    isLength = __webpack_require__("b742");

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ "f8a5":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("6b1d");
var toObject = __webpack_require__("37d1");
var nativeKeys = __webpack_require__("0c47");
var fails = __webpack_require__("72df");

var FAILS_ON_PRIMITIVES = fails(function () { nativeKeys(1); });

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return nativeKeys(toObject(it));
  }
});


/***/ }),

/***/ "f9f5":
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__("e697");

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),

/***/ "fa46":
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__("abdf").f;
var hasOwn = __webpack_require__("7a25");
var wellKnownSymbol = __webpack_require__("7d53");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn(target, TO_STRING_TAG)) {
    defineProperty(target, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};


/***/ }),

/***/ "fa8a":
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__("f19a"),
    listCacheDelete = __webpack_require__("930a"),
    listCacheGet = __webpack_require__("e556"),
    listCacheHas = __webpack_require__("0a87"),
    listCacheSet = __webpack_require__("2f33");

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ "fa8c":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("f498");
var DOMIterables = __webpack_require__("130d");
var DOMTokenListPrototype = __webpack_require__("95e4");
var forEach = __webpack_require__("e8e5");
var createNonEnumerableProperty = __webpack_require__("5b12");

var handlePrototype = function (CollectionPrototype) {
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
    createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
  } catch (error) {
    CollectionPrototype.forEach = forEach;
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  if (DOMIterables[COLLECTION_NAME]) {
    handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype);
  }
}

handlePrototype(DOMTokenListPrototype);


/***/ }),

/***/ "fb9b":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("70b7");

module.exports = uncurryThis({}.isPrototypeOf);


/***/ }),

/***/ "fbf7":
/***/ (function(module, exports) {

// a string of all valid unicode whitespaces
module.exports = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),

/***/ "feca":
/***/ (function(module, exports, __webpack_require__) {

var toPrimitive = __webpack_require__("083f");
var isSymbol = __webpack_require__("cfd1");

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};


/***/ }),

/***/ "ff3b":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("d4cb");
var fails = __webpack_require__("72df");

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = DESCRIPTORS && fails(function () {
  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});


/***/ }),

/***/ "ff7d":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("0e19"),
    isObjectLike = __webpack_require__("b4b4");

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ "ff89":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("72df");
var isCallable = __webpack_require__("3ce8");
var create = __webpack_require__("82e8");
var getPrototypeOf = __webpack_require__("0e39");
var defineBuiltIn = __webpack_require__("ef30");
var wellKnownSymbol = __webpack_require__("7d53");
var IS_PURE = __webpack_require__("0e93");

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es-x/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = IteratorPrototype == undefined || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype[ITERATOR].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};
else if (IS_PURE) IteratorPrototype = create(IteratorPrototype);

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable(IteratorPrototype[ITERATOR])) {
  defineBuiltIn(IteratorPrototype, ITERATOR, function () {
    return this;
  });
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ })

/******/ });
//# sourceMappingURL=FKUIVue.common.js.map